
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire75b1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire75b1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("826sP", function(module, exports) {






// Flickity main
/* eslint-disable max-params */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("Vqjah")), (parcelRequire("g64Da")), (parcelRequire("9VjL6")), (parcelRequire("joA3V")), (parcelRequire("gGbXz")), (parcelRequire("b5pmx")));
    else {
        // browser global
        let _Flickity = window1.Flickity;
        window1.Flickity = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
    /* eslint-enable max-params */ // vars
    const { getComputedStyle: getComputedStyle, console: console } = window1;
    let { jQuery: jQuery } = window1;
    // -------------------------- Flickity -------------------------- //
    // globally unique identifiers
    let GUID = 0;
    // internal store of all Flickity intances
    let instances = {};
    function Flickity(element, options) {
        let queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error(`Bad element for Flickity: ${queryElement || element}`);
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.flickityGUID) {
            let instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
        }
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = {
            ...this.constructor.defaults
        };
        this.option(options);
        // kick things off
        this._create();
    }
    Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: 'center',
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075,
        friction: 0.28,
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
    };
    // hash of methods triggered on _create()
    Flickity.create = {};
    let proto = Flickity.prototype;
    // inherit EventEmitter
    Object.assign(proto, EvEmitter.prototype);
    proto._create = function() {
        let { resize: resize, watchCSS: watchCSS, rightToLeft: rightToLeft } = this.options;
        // add id for Flickity.data
        let id = this.guid = ++GUID;
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.beginMargin = rightToLeft ? 'marginRight' : 'marginLeft';
        this.endMargin = rightToLeft ? 'marginLeft' : 'marginRight';
        // create viewport & slider
        this.viewport = document.createElement('div');
        this.viewport.className = 'flickity-viewport';
        this._createSlider();
        // used for keyboard navigation
        this.focusableElems = [
            this.element
        ];
        if (resize || watchCSS) window1.addEventListener('resize', this);
        // add listeners from on option
        for(let eventName in this.options.on){
            let listener = this.options.on[eventName];
            this.on(eventName, listener);
        }
        for(let method in Flickity.create)Flickity.create[method].call(this);
        if (watchCSS) this.watchCSS();
        else this.activate();
    };
    /**
 * set options
 * @param {Object} opts - options to extend
 */ proto.option = function(opts) {
        Object.assign(this.options, opts);
    };
    proto.activate = function() {
        if (this.isActive) return;
        this.isActive = true;
        this.element.classList.add('flickity-enabled');
        if (this.options.rightToLeft) this.element.classList.add('flickity-rtl');
        this.getSize();
        // move initial cell elements so they can be loaded as cells
        let cellElems = this._filterFindCellElements(this.element.children);
        this.slider.append(...cellElems);
        this.viewport.append(this.slider);
        this.element.append(this.viewport);
        // get cells from children
        this.reloadCells();
        if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener('keydown', this);
        }
        this.emitEvent('activate');
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent('ready');
    };
    // slider positions the cells
    proto._createSlider = function() {
        // slider element does all the positioning
        let slider = document.createElement('div');
        slider.className = 'flickity-slider';
        this.slider = slider;
    };
    proto._filterFindCellElements = function(elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };
    // goes through all children
    proto.reloadCells = function() {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
    };
    /**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */ proto._makeCells = function(elems) {
        let cellElems = this._filterFindCellElements(elems);
        // create new Cells for collection
        return cellElems.map((cellElem)=>new Cell(cellElem));
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    };
    // positions all cells
    proto.positionCells = function() {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
    };
    /**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */ proto._positionCells = function(index) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        let cellX = 0;
        // get cellX
        if (index > 0) {
            let startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        this.cells.slice(index).forEach((cell)=>{
            cell.x = cellX;
            this._renderCellPosition(cell, cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        });
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    proto._renderCellPosition = function(cell, x) {
        // render position of cell with in slider
        let sideOffset = this.options.rightToLeft ? -1 : 1;
        let renderX = x * sideOffset;
        if (this.options.percentPosition) renderX *= this.size.innerWidth / cell.size.width;
        let positionValue = this.getPositionValue(renderX);
        cell.element.style.transform = `translateX( ${positionValue} )`;
    };
    /**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */ proto._sizeCells = function(cells) {
        cells.forEach((cell)=>cell.getSize());
    };
    // --------------------------  -------------------------- //
    proto.updateSlides = function() {
        this.slides = [];
        if (!this.cells.length) return;
        let { beginMargin: beginMargin, endMargin: endMargin } = this;
        let slide = new Slide(beginMargin, endMargin, this.cellAlign);
        this.slides.push(slide);
        let canCellFit = this._getCanCellFit();
        this.cells.forEach((cell, i)=>{
            // just add cell if first cell in slide
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }
            let slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[endMargin]);
            if (canCellFit(i, slideWidth)) slide.addCell(cell);
            else {
                // doesn't fit, new slide
                slide.updateTarget();
                slide = new Slide(beginMargin, endMargin, this.cellAlign);
                this.slides.push(slide);
                slide.addCell(cell);
            }
        });
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };
    proto._getCanCellFit = function() {
        let { groupCells: groupCells } = this.options;
        if (!groupCells) return ()=>false;
        if (typeof groupCells == 'number') {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            let number = parseInt(groupCells, 10);
            return (i)=>i % number !== 0;
        }
        // default, group by width of slide
        let percent = 1;
        // parse '75%
        let percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
        if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
        let groupWidth = (this.size.innerWidth + 1) * percent;
        return (i, slideWidth)=>slideWidth <= groupWidth;
    };
    // alias _init for jQuery plugin .flickity()
    proto._init = proto.reposition = function() {
        this.positionCells();
        this.positionSliderAtSelected();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    let cellAlignShorthands = {
        left: 0,
        center: 0.5,
        right: 1
    };
    proto.setCellAlign = function() {
        let { cellAlign: cellAlign, rightToLeft: rightToLeft } = this.options;
        let shorthand = cellAlignShorthands[cellAlign];
        this.cellAlign = shorthand !== undefined ? shorthand : cellAlign;
        if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
    };
    proto.setGallerySize = function() {
        if (!this.options.setGallerySize) return;
        let height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
        this.viewport.style.height = `${height}px`;
    };
    proto._updateWrapShiftCells = function() {
        // update isWrapping
        this.isWrapping = this.getIsWrapping();
        // only for wrap-around
        if (!this.isWrapping) return;
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        let beforeGapX = this.cursorPosition;
        let lastIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        let afterGapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
    };
    proto.getIsWrapping = function() {
        let { wrapAround: wrapAround } = this.options;
        if (!wrapAround || this.slides.length < 2) return false;
        if (wrapAround !== 'fill') return true;
        // check that slides can fit
        let gapWidth = this.slideableWidth - this.size.innerWidth;
        if (gapWidth > this.size.innerWidth) return true; // gap * 2x big, all good
        // check that content width - shifting cell is bigger than viewport width
        for (let cell of this.cells){
            if (cell.size.outerWidth > gapWidth) return false;
        }
        return true;
    };
    proto._getGapCells = function(gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        let cells = [];
        while(gapX > 0){
            let cell = this.cells[cellIndex];
            if (!cell) break;
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };
    // ----- contain & wrap ----- //
    // contain cell targets so no excess sliding
    proto._containSlides = function() {
        let isContaining = this.options.contain && !this.isWrapping && this.cells.length;
        if (!isContaining) return;
        let contentWidth = this.slideableWidth - this.getLastCell().size[this.endMargin];
        // content is less than gallery size
        let isContentSmaller = contentWidth < this.size.innerWidth;
        if (isContentSmaller) // all cells fit inside gallery
        this.slides.forEach((slide)=>{
            slide.target = contentWidth * this.cellAlign;
        });
        else {
            // contain to bounds
            let beginBound = this.cursorPosition + this.cells[0].size[this.beginMargin];
            let endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach((slide)=>{
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            });
        }
    };
    // ----- events ----- //
    /**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        let emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? '.flickity' : '';
            let $event = type;
            if (event) {
                // create jQuery event
                let jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };
    const unidraggerEvents = [
        'dragStart',
        'dragMove',
        'dragEnd',
        'pointerDown',
        'pointerMove',
        'pointerEnd',
        'staticClick'
    ];
    let _emitEvent = proto.emitEvent;
    proto.emitEvent = function(eventName, args) {
        if (eventName === 'staticClick') {
            // add cellElem and cellIndex args to staticClick
            let clickedCell = this.getParentCell(args[0].target);
            let cellElem = clickedCell && clickedCell.element;
            let cellIndex = clickedCell && this.cells.indexOf(clickedCell);
            args = args.concat(cellElem, cellIndex);
        }
        // do regular thing
        _emitEvent.call(this, eventName, args);
        // duck-punch in jQuery events for Unidragger events
        let isUnidraggerEvent = unidraggerEvents.includes(eventName);
        if (!isUnidraggerEvent || !jQuery || !this.$element) return;
        eventName += this.options.namespaceJQueryEvents ? '.flickity' : '';
        let event = args.shift(0);
        let jQEvent = new jQuery.Event(event);
        jQEvent.type = eventName;
        this.$element.trigger(jQEvent, args);
    };
    // -------------------------- select -------------------------- //
    /**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */ proto.select = function(index, isWrap, isInstant) {
        if (!this.isActive) return;
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.isWrapping || isWrap) index = utils.modulo(index, this.slides.length);
        // bail if invalid index
        if (!this.slides[index]) return;
        let prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) this.positionSliderAtSelected();
        else this.startAnimation();
        if (this.options.adaptiveHeight) this.setGallerySize();
        // events
        this.dispatchEvent('select', null, [
            index
        ]);
        // change event if new index
        if (index !== prevIndex) this.dispatchEvent('change', null, [
            index
        ]);
    };
    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function(index) {
        if (!this.isWrapping) return;
        const { selectedIndex: selectedIndex, slideableWidth: slideableWidth, slides: { length: length } } = this;
        // shift index for wrap, do not wrap dragSelect
        if (!this.isDragSelect) {
            let wrapIndex = utils.modulo(index, length);
            // go to shortest
            let delta = Math.abs(wrapIndex - selectedIndex);
            let backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
            let forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);
            if (backWrapDelta < delta) index += length;
            else if (forewardWrapDelta < delta) index -= length;
        }
        // wrap position so slider is within normal area
        if (index < 0) this.x -= slideableWidth;
        else if (index >= length) this.x += slideableWidth;
    };
    proto.previous = function(isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };
    proto.next = function(isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };
    proto.updateSelectedSlide = function() {
        let slide = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide) return;
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };
    proto.unselectSelectedSlide = function() {
        if (this.selectedSlide) this.selectedSlide.unselect();
    };
    proto.selectInitialIndex = function() {
        let initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
        }
        // select with selector string
        if (initialIndex && typeof initialIndex == 'string') {
            let cell = this.queryCell(initialIndex);
            if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
            }
        }
        let index = 0;
        // select with number
        if (initialIndex && this.slides[initialIndex]) index = initialIndex;
        // select instantly
        this.select(index, false, true);
    };
    /**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */ proto.selectCell = function(value, isWrap, isInstant) {
        // get cell
        let cell = this.queryCell(value);
        if (!cell) return;
        let index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };
    proto.getCellSlideIndex = function(cell) {
        // get index of slide that has cell
        let cellSlide = this.slides.find((slide)=>slide.cells.includes(cell));
        return this.slides.indexOf(cellSlide);
    };
    // -------------------------- get cells -------------------------- //
    /**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */ proto.getCell = function(elem) {
        // loop through cells to get the one that matches
        for (let cell of this.cells){
            if (cell.element === elem) return cell;
        }
    };
    /**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */ proto.getCells = function(elems) {
        elems = utils.makeArray(elems);
        return elems.map((elem)=>this.getCell(elem)).filter(Boolean);
    };
    /**
 * get cell elements
 * @returns {Array} cellElems
 */ proto.getCellElements = function() {
        return this.cells.map((cell)=>cell.element);
    };
    /**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */ proto.getParentCell = function(elem) {
        // first check if elem is cell
        let cell = this.getCell(elem);
        if (cell) return cell;
        // try to get parent cell elem
        let closest = elem.closest('.flickity-slider > *');
        return this.getCell(closest);
    };
    /**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */ proto.getAdjacentCellElements = function(adjCount, index) {
        if (!adjCount) return this.selectedSlide.getCellElements();
        index = index === undefined ? this.selectedIndex : index;
        let len = this.slides.length;
        if (1 + adjCount * 2 >= len) return this.getCellElements(); // get all
        let cellElems = [];
        for(let i = index - adjCount; i <= index + adjCount; i++){
            let slideIndex = this.isWrapping ? utils.modulo(i, len) : i;
            let slide = this.slides[slideIndex];
            if (slide) cellElems = cellElems.concat(slide.getCellElements());
        }
        return cellElems;
    };
    /**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */ proto.queryCell = function(selector) {
        if (typeof selector == 'number') // use number as index
        return this.cells[selector];
        // do not select invalid selectors from hash: #123, #/. #791
        let isSelectorString = typeof selector == 'string' && !selector.match(/^[#.]?[\d/]/);
        if (isSelectorString) // use string as selector, get element
        selector = this.element.querySelector(selector);
        // get cell from element
        return this.getCell(selector);
    };
    // -------------------------- events -------------------------- //
    proto.uiChange = function() {
        this.emitEvent('uiChange');
    };
    // ----- resize ----- //
    proto.onresize = function() {
        this.watchCSS();
        this.resize();
    };
    utils.debounceMethod(Flickity, 'onresize', 150);
    proto.resize = function() {
        // #1177 disable resize behavior when animating or dragging for iOS 15
        if (!this.isActive || this.isAnimating || this.isDragging) return;
        this.getSize();
        // wrap values
        if (this.isWrapping) this.x = utils.modulo(this.x, this.slideableWidth);
        this.positionCells();
        this._updateWrapShiftCells();
        this.setGallerySize();
        this.emitEvent('resize');
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        let selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };
    // watches the :after property, activates/deactivates
    proto.watchCSS = function() {
        if (!this.options.watchCSS) return;
        let afterContent = getComputedStyle(this.element, ':after').content;
        // activate if :after { content: 'flickity' }
        if (afterContent.includes('flickity')) this.activate();
        else this.deactivate();
    };
    // ----- keydown ----- //
    // go previous/next if left/right keys pressed
    proto.onkeydown = function(event) {
        let { activeElement: activeElement } = document;
        let handler = Flickity.keyboardHandlers[event.key];
        // only work if element is in focus
        if (!this.options.accessibility || !activeElement || !handler) return;
        let isFocused = this.focusableElems.some((elem)=>activeElement === elem);
        if (isFocused) handler.call(this);
    };
    Flickity.keyboardHandlers = {
        ArrowLeft: function() {
            this.uiChange();
            let leftMethod = this.options.rightToLeft ? 'next' : 'previous';
            this[leftMethod]();
        },
        ArrowRight: function() {
            this.uiChange();
            let rightMethod = this.options.rightToLeft ? 'previous' : 'next';
            this[rightMethod]();
        }
    };
    // ----- focus ----- //
    proto.focus = function() {
        this.element.focus({
            preventScroll: true
        });
    };
    // -------------------------- destroy -------------------------- //
    // deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
        if (!this.isActive) return;
        this.element.classList.remove('flickity-enabled');
        this.element.classList.remove('flickity-rtl');
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach((cell)=>cell.destroy());
        this.viewport.remove();
        // move child elements back into element
        this.element.append(...this.slider.children);
        if (this.options.accessibility) {
            this.element.removeAttribute('tabIndex');
            this.element.removeEventListener('keydown', this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent('deactivate');
    };
    proto.destroy = function() {
        this.deactivate();
        window1.removeEventListener('resize', this);
        this.allOff();
        this.emitEvent('destroy');
        if (jQuery && this.$element) jQuery.removeData(this.element, 'flickity');
        delete this.element.flickityGUID;
        delete instances[this.guid];
    };
    // -------------------------- prototype -------------------------- //
    Object.assign(proto, animatePrototype);
    // -------------------------- extras -------------------------- //
    /**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */ Flickity.data = function(elem) {
        elem = utils.getQueryElement(elem);
        if (elem) return instances[elem.flickityGUID];
    };
    utils.htmlInit(Flickity, 'flickity');
    let { jQueryBridget: jQueryBridget } = window1;
    if (jQuery && jQueryBridget) jQueryBridget('flickity', Flickity, jQuery);
    // set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function(jq) {
        jQuery = jq;
    };
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    return Flickity;
});

});
parcelRegister("Vqjah", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != 'undefined' ? window : module.exports, function() {
    function EvEmitter() {}
    let proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners){
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});

parcelRegister("g64Da", function(module, exports) {
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */ (function(window1, factory) {
    if (module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        let num = parseFloat(value);
        // not a percent like '100%', and a number
        let isValid = value.indexOf('%') == -1 && !isNaN(num);
        return isValid && num;
    }
    // -------------------------- measurements -------------------------- //
    let measurements = [
        'paddingLeft',
        'paddingRight',
        'paddingTop',
        'paddingBottom',
        'marginLeft',
        'marginRight',
        'marginTop',
        'marginBottom',
        'borderLeftWidth',
        'borderRightWidth',
        'borderTopWidth',
        'borderBottomWidth'
    ];
    let measurementsLength = measurements.length;
    function getZeroSize() {
        let size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        measurements.forEach((measurement)=>{
            size[measurement] = 0;
        });
        return size;
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        // use querySeletor if elem is string
        if (typeof elem == 'string') elem = document.querySelector(elem);
        // do not proceed on non-objects
        let isElement = elem && typeof elem == 'object' && elem.nodeType;
        if (!isElement) return;
        let style = getComputedStyle(elem);
        // if hidden, everything is 0
        if (style.display == 'none') return getZeroSize();
        let size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        let isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';
        // get all measurements
        measurements.forEach((measurement)=>{
            let value = style[measurement];
            let num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        });
        let paddingWidth = size.paddingLeft + size.paddingRight;
        let paddingHeight = size.paddingTop + size.paddingBottom;
        let marginWidth = size.marginLeft + size.marginRight;
        let marginHeight = size.marginTop + size.marginBottom;
        let borderWidth = size.borderLeftWidth + size.borderRightWidth;
        let borderHeight = size.borderTopWidth + size.borderBottomWidth;
        // overwrite width and height if we can get it from style
        let styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingWidth + borderWidth);
        let styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBox ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});

parcelRegister("9VjL6", function(module, exports) {
/**
 * Fizzy UI utils v3.0.0
 * MIT license
 */ (function(global, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(global);
    else // browser global
    global.fizzyUIUtils = factory(global);
})(module.exports, function factory(global) {
    let utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        return Object.assign(a, b);
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        let index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (elem.matches(selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == 'string') return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        return elems// check that elem is an actual element
        .filter((elem)=>elem instanceof HTMLElement).reduce((ffElems, elem)=>{
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return ffElems;
            }
            // filter & find items if we have a selector
            // filter
            if (elem.matches(selector)) ffElems.push(elem);
            // find children
            let childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            ffElems = ffElems.concat(...childElems);
            return ffElems;
        }, []);
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        let method = _class.prototype[methodName];
        let timeoutName = methodName + 'Timeout';
        _class.prototype[methodName] = function() {
            clearTimeout(this[timeoutName]);
            let args = arguments;
            this[timeoutName] = setTimeout(()=>{
                method.apply(this, args);
                delete this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(onDocReady) {
        let readyState = document.readyState;
        if (readyState == 'complete' || readyState == 'interactive') // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(onDocReady);
        else document.addEventListener('DOMContentLoaded', onDocReady);
    };
    // ----- htmlInit ----- //
    // http://bit.ly/3oYLusc
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + '-' + $2;
        }).toLowerCase();
    };
    let console = global.console;
    // allow user to initialize classes via [data-namespace] or .js-namespace class
    // htmlInit( Widget, 'widgetName' )
    // options are parsed from data-namespace-options
    utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            let dashedNamespace = utils.toDashed(namespace);
            let dataAttr = 'data-' + dashedNamespace;
            let dataAttrElems = document.querySelectorAll(`[${dataAttr}]`);
            let jQuery = global.jQuery;
            [
                ...dataAttrElems
            ].forEach((elem)=>{
                let attr = elem.getAttribute(dataAttr);
                let options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error(`Error parsing ${dataAttr} on ${elem.className}: ${error}`);
                    return;
                }
                // initialize
                let instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});

parcelRegister("joA3V", function(module, exports) {

// Flickity.Cell
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("g64Da")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Cell = factory(window1.getSize);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(getSize) {
    const cellClassName = 'flickity-cell';
    function Cell(elem) {
        this.element = elem;
        this.element.classList.add(cellClassName);
        this.x = 0;
        this.unselect();
    }
    let proto = Cell.prototype;
    proto.destroy = function() {
        // reset style
        this.unselect();
        this.element.classList.remove(cellClassName);
        this.element.style.transform = '';
        this.element.removeAttribute('aria-hidden');
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    proto.select = function() {
        this.element.classList.add('is-selected');
        this.element.removeAttribute('aria-hidden');
    };
    proto.unselect = function() {
        this.element.classList.remove('is-selected');
        this.element.setAttribute('aria-hidden', 'true');
    };
    proto.remove = function() {
        this.element.remove();
    };
    return Cell;
});

});

parcelRegister("gGbXz", function(module, exports) {
// slide
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory();
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Slide = factory();
    }
})(typeof window != 'undefined' ? window : module.exports, function factory() {
    function Slide(beginMargin, endMargin, cellAlign) {
        this.beginMargin = beginMargin;
        this.endMargin = endMargin;
        this.cellAlign = cellAlign;
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }
    let proto = Slide.prototype;
    proto.addCell = function(cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length === 1) {
            this.x = cell.x; // x comes from first cell
            this.firstMargin = cell.size[this.beginMargin];
        }
    };
    proto.updateTarget = function() {
        let lastCell = this.getLastCell();
        let lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
        let slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.select = function() {
        this.cells.forEach((cell)=>cell.select());
    };
    proto.unselect = function() {
        this.cells.forEach((cell)=>cell.unselect());
    };
    proto.getCellElements = function() {
        return this.cells.map((cell)=>cell.element);
    };
    return Slide;
});

});

parcelRegister("b5pmx", function(module, exports) {

// animate
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("9VjL6")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.animatePrototype = factory(window1.fizzyUIUtils);
    }
})(typeof window != 'undefined' ? window : module.exports, function factory(utils) {
    // -------------------------- animate -------------------------- //
    let proto = {};
    proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };
    proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        let previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) requestAnimationFrame(()=>this.animate());
    };
    proto.positionSlider = function() {
        let x = this.x;
        // wrap position around
        if (this.isWrapping) {
            x = utils.modulo(x, this.slideableWidth) - this.slideableWidth;
            this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
    };
    proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        if (this.options.rightToLeft) x = -x;
        let translateX = this.getPositionValue(x);
        // use 3D transforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ? `translate3d(${translateX},0,0)` : `translateX(${translateX})`;
    };
    proto.dispatchScrollEvent = function() {
        let firstSlide = this.slides[0];
        if (!firstSlide) return;
        let positionX = -this.x - firstSlide.target;
        let progress = positionX / this.slidesWidth;
        this.dispatchEvent('scroll', null, [
            progress,
            positionX
        ]);
    };
    proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };
    proto.getPositionValue = function(position) {
        if (this.options.percentPosition) // percent position, round to 2 digits, like 12.34%
        return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
        else // pixel positioning
        return Math.round(position) + 'px';
    };
    proto.settle = function(previousX) {
        // keep track of frames where x hasn't moved
        let isResting = !this.isPointerDown && Math.round(this.x * 100) === Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent('settle', null, [
                this.selectedIndex
            ]);
        }
    };
    proto.shiftWrapCells = function(x) {
        // shift before cells
        let beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        let afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };
    proto._shiftCells = function(cells, gap, shift) {
        cells.forEach((cell)=>{
            let cellShift = gap > 0 ? shift : 0;
            this._wrapShiftCell(cell, cellShift);
            gap -= cell.size.outerWidth;
        });
    };
    proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) return;
        cells.forEach((cell)=>this._wrapShiftCell(cell, 0));
    };
    // @param {Integer} shift - 0, 1, or -1
    proto._wrapShiftCell = function(cell, shift) {
        this._renderCellPosition(cell, cell.x + this.slideableWidth * shift);
    };
    // -------------------------- physics -------------------------- //
    proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };
    proto.applyForce = function(force) {
        this.velocity += force;
    };
    proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
    };
    proto.getRestingPosition = function() {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };
    proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        // change the position to drag position by applying force
        let dragVelocity = this.dragX - this.x;
        let dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };
    proto.applySelectedAttraction = function() {
        // do not attract if pointer down or no slides
        let dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        let distance = this.selectedSlide.target * -1 - this.x;
        let force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };
    return proto;
});

});


parcelRegister("l95kq", function(module, exports) {



// drag
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("826sP")), (parcelRequire("90HKd")), (parcelRequire("9VjL6")));
    else // browser global
    window1.Flickity = factory(window1, window1.Flickity, window1.Unidragger, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, Flickity, Unidragger, utils) {
    // ----- defaults ----- //
    Object.assign(Flickity.defaults, {
        draggable: '>1',
        dragThreshold: 3
    });
    // -------------------------- drag prototype -------------------------- //
    let proto = Flickity.prototype;
    Object.assign(proto, Unidragger.prototype); // inherit Unidragger
    proto.touchActionValue = '';
    // --------------------------  -------------------------- //
    Flickity.create.drag = function() {
        this.on('activate', this.onActivateDrag);
        this.on('uiChange', this._uiChangeDrag);
        this.on('deactivate', this.onDeactivateDrag);
        this.on('cellChange', this.updateDraggable);
        this.on('pointerDown', this.handlePointerDown);
        this.on('pointerUp', this.handlePointerUp);
        this.on('pointerDown', this.handlePointerDone);
        this.on('dragStart', this.handleDragStart);
        this.on('dragMove', this.handleDragMove);
        this.on('dragEnd', this.handleDragEnd);
        this.on('staticClick', this.handleStaticClick);
    // TODO updateDraggable on resize? if groupCells & slides change
    };
    proto.onActivateDrag = function() {
        this.handles = [
            this.viewport
        ];
        this.bindHandles();
        this.updateDraggable();
    };
    proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove('is-draggable');
    };
    proto.updateDraggable = function() {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable === '>1') this.isDraggable = this.slides.length > 1;
        else this.isDraggable = this.options.draggable;
        this.element.classList.toggle('is-draggable', this.isDraggable);
    };
    proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    };
    // -------------------------- pointer events -------------------------- //
    proto.handlePointerDown = function(event) {
        if (!this.isDraggable) {
            // proceed for staticClick
            this.bindActivePointerEvents(event);
            return;
        }
        let isTouchStart = event.type === 'touchstart';
        let isTouchPointer = event.pointerType === 'touch';
        let isFocusNode = event.target.matches('input, textarea, select');
        if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
        if (!isFocusNode) this.focus();
        // blur
        if (document.activeElement !== this.element) document.activeElement.blur();
        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add('is-pointer-down');
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window1.addEventListener('scroll', this);
        this.bindActivePointerEvents(event);
    };
    // ----- move ----- //
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };
    // ----- up ----- //
    proto.handlePointerUp = function() {
        delete this.isTouchScrolling;
        this.viewport.classList.remove('is-pointer-down');
    };
    proto.handlePointerDone = function() {
        window1.removeEventListener('scroll', this);
        delete this.pointerDownScroll;
    };
    // -------------------------- dragging -------------------------- //
    proto.handleDragStart = function() {
        if (!this.isDraggable) return;
        this.dragStartPosition = this.x;
        this.startAnimation();
        window1.removeEventListener('scroll', this);
    };
    proto.handleDragMove = function(event, pointer, moveVector) {
        if (!this.isDraggable) return;
        event.preventDefault();
        this.previousDragX = this.dragX;
        // reverse if right-to-left
        let direction = this.options.rightToLeft ? -1 : 1;
        // wrap around move. #589
        if (this.isWrapping) moveVector.x %= this.slideableWidth;
        let dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.isWrapping) {
            // slow drag
            let originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            let endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
    };
    proto.handleDragEnd = function() {
        if (!this.isDraggable) return;
        let { freeScroll: freeScroll } = this.options;
        if (freeScroll) this.isFreeScrolling = true;
        // set selectedIndex based on where flick will end up
        let index = this.dragEndRestingSelect();
        if (freeScroll && !this.isWrapping) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            let restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!freeScroll && index === this.selectedIndex) // boost selection if selected index has not changed
        index += this.dragEndBoostSelect();
        delete this.previousDragX;
        // apply selection
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.isWrapping;
        this.select(index);
        delete this.isDragSelect;
    };
    proto.dragEndRestingSelect = function() {
        let restingX = this.getRestingPosition();
        // how far away from selected slide
        let distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        let positiveResting = this._getClosestResting(restingX, distance, 1);
        let negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
    };
    /**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */ proto._getClosestResting = function(restingX, distance, increment) {
        let index = this.selectedIndex;
        let minDistance = Infinity;
        let condition = this.options.contain && !this.isWrapping ? // if containing, keep going if distance is equal to minDistance
        (dist, minDist)=>dist <= minDist : (dist, minDist)=>dist < minDist;
        while(condition(distance, minDistance)){
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };
    /**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */ proto.getSlideDistance = function(x, index) {
        let len = this.slides.length;
        // wrap around if at least 2 slides
        let isWrapAround = this.options.wrapAround && len > 1;
        let slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        let slide = this.slides[slideIndex];
        if (!slide) return null;
        // add distance for wrap-around slides
        let wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };
    proto.dragEndBoostSelect = function() {
        // do not boost if no previousDragX or dragMoveTime
        if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
        new Date() - this.dragMoveTime > 100) return 0;
        let distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        let delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) // boost to next if moving towards the right, and positive velocity
        return 1;
        else if (distance < 0 && delta < 0) // boost to previous if moving towards the left, and negative velocity
        return -1;
        return 0;
    };
    // ----- scroll ----- //
    proto.onscroll = function() {
        let scroll = getScrollPosition();
        let scrollMoveX = this.pointerDownScroll.x - scroll.x;
        let scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) this.pointerDone();
    };
    // ----- utils ----- //
    function getScrollPosition() {
        return {
            x: window1.pageXOffset,
            y: window1.pageYOffset
        };
    }
    // -----  ----- //
    return Flickity;
});

});
parcelRegister("90HKd", function(module, exports) {

/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("Vqjah")));
    else // browser global
    window1.Unidragger = factory(window1, window1.EvEmitter);
})(typeof window != 'undefined' ? window : module.exports, function factory(window1, EvEmitter) {
    function Unidragger() {}
    // inherit EvEmitter
    let proto = Unidragger.prototype = Object.create(EvEmitter.prototype);
    // ----- bind start ----- //
    // trigger handler methods for events
    proto.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    let startEvent, activeEvents;
    if ('ontouchstart' in window1) {
        // HACK prefer Touch Events as you can preventDefault on touchstart to
        // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
        startEvent = 'touchstart';
        activeEvents = [
            'touchmove',
            'touchend',
            'touchcancel'
        ];
    } else if (window1.PointerEvent) {
        // Pointer Events
        startEvent = 'pointerdown';
        activeEvents = [
            'pointermove',
            'pointerup',
            'pointercancel'
        ];
    } else {
        // mouse events
        startEvent = 'mousedown';
        activeEvents = [
            'mousemove',
            'mouseup'
        ];
    }
    // prototype so it can be overwriteable by Flickity
    proto.touchActionValue = 'none';
    proto.bindHandles = function() {
        this._bindHandles('addEventListener', this.touchActionValue);
    };
    proto.unbindHandles = function() {
        this._bindHandles('removeEventListener', '');
    };
    /**
 * Add or remove start event
 * @param {String} bindMethod - addEventListener or removeEventListener
 * @param {String} touchAction - value for touch-action CSS property
 */ proto._bindHandles = function(bindMethod, touchAction) {
        this.handles.forEach((handle)=>{
            handle[bindMethod](startEvent, this);
            handle[bindMethod]('click', this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window1.PointerEvent) handle.style.touchAction = touchAction;
        });
    };
    proto.bindActivePointerEvents = function() {
        activeEvents.forEach((eventName)=>{
            window1.addEventListener(eventName, this);
        });
    };
    proto.unbindActivePointerEvents = function() {
        activeEvents.forEach((eventName)=>{
            window1.removeEventListener(eventName, this);
        });
    };
    // ----- event handler helpers ----- //
    // trigger method with matching pointer
    proto.withPointer = function(methodName, event) {
        if (event.pointerId === this.pointerIdentifier) this[methodName](event, event);
    };
    // trigger method with matching touch
    proto.withTouch = function(methodName, event) {
        let touch;
        for (let changedTouch of event.changedTouches)if (changedTouch.identifier === this.pointerIdentifier) touch = changedTouch;
        if (touch) this[methodName](event, touch);
    };
    // ----- start event ----- //
    proto.onmousedown = function(event) {
        this.pointerDown(event, event);
    };
    proto.ontouchstart = function(event) {
        this.pointerDown(event, event.changedTouches[0]);
    };
    proto.onpointerdown = function(event) {
        this.pointerDown(event, event);
    };
    // nodes that have text fields
    const cursorNodes = [
        'TEXTAREA',
        'INPUT',
        'SELECT',
        'OPTION'
    ];
    // input types that do not have text fields
    const clickTypes = [
        'radio',
        'checkbox',
        'button',
        'submit',
        'image',
        'file'
    ];
    /**
 * any time you set `event, pointer` it refers to:
 * @param {Event} event
 * @param {Event | Touch} pointer
 */ proto.pointerDown = function(event, pointer) {
        // dismiss multi-touch taps, right clicks, and clicks on text fields
        let isCursorNode = cursorNodes.includes(event.target.nodeName);
        let isClickType = clickTypes.includes(event.target.type);
        let isOkayElement = !isCursorNode || isClickType;
        let isOkay = !this.isPointerDown && !event.button && isOkayElement;
        if (!isOkay) return;
        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
        pointer.pointerId : pointer.identifier;
        // track position for move
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        this.bindActivePointerEvents();
        this.emitEvent('pointerDown', [
            event,
            pointer
        ]);
    };
    // ----- move ----- //
    proto.onmousemove = function(event) {
        this.pointerMove(event, event);
    };
    proto.onpointermove = function(event) {
        this.withPointer('pointerMove', event);
    };
    proto.ontouchmove = function(event) {
        this.withTouch('pointerMove', event);
    };
    proto.pointerMove = function(event, pointer) {
        let moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        this.emitEvent('pointerMove', [
            event,
            pointer,
            moveVector
        ]);
        // start drag if pointer has moved far enough to start drag
        let isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
        if (isDragStarting) this.dragStart(event, pointer);
        if (this.isDragging) this.dragMove(event, pointer, moveVector);
    };
    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };
    // ----- drag ----- //
    proto.dragStart = function(event, pointer) {
        this.isDragging = true;
        this.isPreventingClicks = true; // set flag to prevent clicks
        this.emitEvent('dragStart', [
            event,
            pointer
        ]);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        this.emitEvent('dragMove', [
            event,
            pointer,
            moveVector
        ]);
    };
    // ----- end ----- //
    proto.onmouseup = function(event) {
        this.pointerUp(event, event);
    };
    proto.onpointerup = function(event) {
        this.withPointer('pointerUp', event);
    };
    proto.ontouchend = function(event) {
        this.withTouch('pointerUp', event);
    };
    proto.pointerUp = function(event, pointer) {
        this.pointerDone();
        this.emitEvent('pointerUp', [
            event,
            pointer
        ]);
        if (this.isDragging) this.dragEnd(event, pointer);
        else // pointer didn't move enough for drag to start
        this.staticClick(event, pointer);
    };
    proto.dragEnd = function(event, pointer) {
        this.isDragging = false; // reset flag
        // re-enable clicking async
        setTimeout(()=>delete this.isPreventingClicks);
        this.emitEvent('dragEnd', [
            event,
            pointer
        ]);
    };
    // triggered on pointer up & pointer cancel
    proto.pointerDone = function() {
        this.isPointerDown = false;
        delete this.pointerIdentifier;
        this.unbindActivePointerEvents();
        this.emitEvent('pointerDone');
    };
    // ----- cancel ----- //
    proto.onpointercancel = function(event) {
        this.withPointer('pointerCancel', event);
    };
    proto.ontouchcancel = function(event) {
        this.withTouch('pointerCancel', event);
    };
    proto.pointerCancel = function(event, pointer) {
        this.pointerDone();
        this.emitEvent('pointerCancel', [
            event,
            pointer
        ]);
    };
    // ----- click ----- //
    // handle all clicks and prevent clicks when dragging
    proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
    };
    // triggered after pointer down & up with no/tiny movement
    proto.staticClick = function(event, pointer) {
        // ignore emulated mouse up clicks
        let isMouseup = event.type === 'mouseup';
        if (isMouseup && this.isIgnoringMouseUp) return;
        this.emitEvent('staticClick', [
            event,
            pointer
        ]);
        // set flag for emulated clicks 300ms after touchend
        if (isMouseup) {
            this.isIgnoringMouseUp = true;
            // reset flag after 400ms
            setTimeout(()=>{
                delete this.isIgnoringMouseUp;
            }, 400);
        }
    };
    // -----  ----- //
    return Unidragger;
});

});


parcelRegister("8pMCu", function(module, exports) {

// prev/next buttons
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("826sP")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity) {
    const svgURI = 'http://www.w3.org/2000/svg';
    // -------------------------- PrevNextButton -------------------------- //
    function PrevNextButton(increment, direction, arrowShape) {
        this.increment = increment;
        this.direction = direction;
        this.isPrevious = increment === 'previous';
        this.isLeft = direction === 'left';
        this._create(arrowShape);
    }
    PrevNextButton.prototype._create = function(arrowShape) {
        // properties
        let element = this.element = document.createElement('button');
        element.className = `flickity-button flickity-prev-next-button ${this.increment}`;
        let label = this.isPrevious ? 'Previous' : 'Next';
        // prevent button from submitting form https://stackoverflow.com/a/10836076/182183
        element.setAttribute('type', 'button');
        element.setAttribute('aria-label', label);
        // init as disabled
        this.disable();
        // create arrow
        let svg = this.createSVG(label, arrowShape);
        element.append(svg);
    };
    PrevNextButton.prototype.createSVG = function(label, arrowShape) {
        let svg = document.createElementNS(svgURI, 'svg');
        svg.setAttribute('class', 'flickity-button-icon');
        svg.setAttribute('viewBox', '0 0 100 100');
        // add title #1189
        let title = document.createElementNS(svgURI, 'title');
        title.append(label);
        // add path
        let path = document.createElementNS(svgURI, 'path');
        let pathMovements = getArrowMovements(arrowShape);
        path.setAttribute('d', pathMovements);
        path.setAttribute('class', 'arrow');
        // rotate arrow
        if (!this.isLeft) path.setAttribute('transform', 'translate(100, 100) rotate(180)');
        svg.append(title, path);
        return svg;
    };
    // get SVG path movmement
    function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == 'string') return shape;
        let { x0: x0, x1: x1, x2: x2, x3: x3, y1: y1, y2: y2 } = shape;
        // create movement string
        return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x2}, ${y2 + 50}
    L ${x3}, 50
    L ${x2}, ${50 - y2}
    L ${x1}, ${50 - y1}
    Z`;
    }
    // -----  ----- //
    PrevNextButton.prototype.enable = function() {
        this.element.removeAttribute('disabled');
    };
    PrevNextButton.prototype.disable = function() {
        this.element.setAttribute('disabled', true);
    };
    // -------------------------- Flickity prototype -------------------------- //
    Object.assign(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    });
    Flickity.create.prevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        let { rightToLeft: rightToLeft, arrowShape: arrowShape } = this.options;
        let prevDirection = rightToLeft ? 'right' : 'left';
        let nextDirection = rightToLeft ? 'left' : 'right';
        this.prevButton = new PrevNextButton('previous', prevDirection, arrowShape);
        this.nextButton = new PrevNextButton('next', nextDirection, arrowShape);
        this.focusableElems.push(this.prevButton.element);
        this.focusableElems.push(this.nextButton.element);
        this.handlePrevButtonClick = ()=>{
            this.uiChange();
            this.previous();
        };
        this.handleNextButtonClick = ()=>{
            this.uiChange();
            this.next();
        };
        this.on('activate', this.activatePrevNextButtons);
        this.on('select', this.updatePrevNextButtons);
    };
    let proto = Flickity.prototype;
    proto.updatePrevNextButtons = function() {
        let lastIndex = this.slides.length ? this.slides.length - 1 : 0;
        this.updatePrevNextButton(this.prevButton, 0);
        this.updatePrevNextButton(this.nextButton, lastIndex);
    };
    proto.updatePrevNextButton = function(button, disabledIndex) {
        // enable is wrapAround and at least 2 slides
        if (this.isWrapping && this.slides.length > 1) {
            button.enable();
            return;
        }
        let isEnabled = this.selectedIndex !== disabledIndex;
        button[isEnabled ? 'enable' : 'disable']();
        // if disabling button that is focused,
        // shift focus to element to maintain keyboard accessibility
        let isDisabledFocused = !isEnabled && document.activeElement === button.element;
        if (isDisabledFocused) this.focus();
    };
    proto.activatePrevNextButtons = function() {
        this.prevButton.element.addEventListener('click', this.handlePrevButtonClick);
        this.nextButton.element.addEventListener('click', this.handleNextButtonClick);
        this.element.append(this.prevButton.element, this.nextButton.element);
        this.on('deactivate', this.deactivatePrevNextButtons);
    };
    proto.deactivatePrevNextButtons = function() {
        this.prevButton.element.remove();
        this.nextButton.element.remove();
        this.prevButton.element.removeEventListener('click', this.handlePrevButtonClick);
        this.nextButton.element.removeEventListener('click', this.handleNextButtonClick);
        this.off('deactivate', this.deactivatePrevNextButtons);
    };
    // --------------------------  -------------------------- //
    Flickity.PrevNextButton = PrevNextButton;
    return Flickity;
});

});

parcelRegister("19umk", function(module, exports) {


// page dots
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("826sP")), (parcelRequire("9VjL6")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    // -------------------------- PageDots -------------------------- //
    function PageDots() {
        // create holder element
        this.holder = document.createElement('div');
        this.holder.className = 'flickity-page-dots';
        // create dots, array of elements
        this.dots = [];
    }
    PageDots.prototype.setDots = function(slidesLength) {
        // get difference between number of slides and number of dots
        let delta = slidesLength - this.dots.length;
        if (delta > 0) this.addDots(delta);
        else if (delta < 0) this.removeDots(-delta);
    };
    PageDots.prototype.addDots = function(count) {
        let newDots = new Array(count).fill().map((item, i)=>{
            let dot = document.createElement('button');
            dot.setAttribute('type', 'button');
            let num = i + 1 + this.dots.length;
            dot.className = 'flickity-page-dot';
            dot.textContent = `View slide ${num}`;
            return dot;
        });
        this.holder.append(...newDots);
        this.dots = this.dots.concat(newDots);
    };
    PageDots.prototype.removeDots = function(count) {
        // remove from this.dots collection
        let removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach((dot)=>dot.remove());
    };
    PageDots.prototype.updateSelected = function(index) {
        // remove selected class on previous
        if (this.selectedDot) {
            this.selectedDot.classList.remove('is-selected');
            this.selectedDot.removeAttribute('aria-current');
        }
        // don't proceed if no dots
        if (!this.dots.length) return;
        this.selectedDot = this.dots[index];
        this.selectedDot.classList.add('is-selected');
        this.selectedDot.setAttribute('aria-current', 'step');
    };
    Flickity.PageDots = PageDots;
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pageDots: true
    });
    Flickity.create.pageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots();
        this.handlePageDotsClick = this.onPageDotsClick.bind(this);
        // events
        this.on('activate', this.activatePageDots);
        this.on('select', this.updateSelectedPageDots);
        this.on('cellChange', this.updatePageDots);
        this.on('resize', this.updatePageDots);
        this.on('deactivate', this.deactivatePageDots);
    };
    let proto = Flickity.prototype;
    proto.activatePageDots = function() {
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
        this.pageDots.holder.addEventListener('click', this.handlePageDotsClick);
        this.element.append(this.pageDots.holder);
    };
    proto.onPageDotsClick = function(event) {
        let index = this.pageDots.dots.indexOf(event.target);
        if (index === -1) return; // only dot clicks
        this.uiChange();
        this.select(index);
    };
    proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected(this.selectedIndex);
    };
    proto.updatePageDots = function() {
        this.pageDots.dots.forEach((dot)=>{
            utils.removeFrom(this.focusableElems, dot);
        });
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
    };
    proto.deactivatePageDots = function() {
        this.pageDots.holder.remove();
        this.pageDots.holder.removeEventListener('click', this.handlePageDotsClick);
    };
    // -----  ----- //
    Flickity.PageDots = PageDots;
    return Flickity;
});

});

parcelRegister("csKO1", function(module, exports) {

// player & autoPlay
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("826sP")));
    else // browser global
    factory(window1.Flickity);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity) {
    // -------------------------- Player -------------------------- //
    function Player(autoPlay, onTick) {
        this.autoPlay = autoPlay;
        this.onTick = onTick;
        this.state = 'stopped';
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    // start play
    Player.prototype.play = function() {
        if (this.state === 'playing') return;
        // do not play if page is hidden, start playing when page is visible
        let isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener('visibilitychange', this.onVisibilityPlay);
            return;
        }
        this.state = 'playing';
        // listen to visibility change
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        // start ticking
        this.tick();
    };
    Player.prototype.tick = function() {
        // do not tick if not playing
        if (this.state !== 'playing') return;
        // default to 3 seconds
        let time = typeof this.autoPlay == 'number' ? this.autoPlay : 3000;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(()=>{
            this.onTick();
            this.tick();
        }, time);
    };
    Player.prototype.stop = function() {
        this.state = 'stopped';
        this.clear();
        // remove visibility change event
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    };
    Player.prototype.clear = function() {
        clearTimeout(this.timeout);
    };
    Player.prototype.pause = function() {
        if (this.state === 'playing') {
            this.state = 'paused';
            this.clear();
        }
    };
    Player.prototype.unpause = function() {
        // re-start play if paused
        if (this.state === 'paused') this.play();
    };
    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
        let isPageHidden = document.hidden;
        this[isPageHidden ? 'pause' : 'unpause']();
    };
    Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener('visibilitychange', this.onVisibilityPlay);
    };
    // -------------------------- Flickity -------------------------- //
    Object.assign(Flickity.defaults, {
        pauseAutoPlayOnHover: true
    });
    Flickity.create.player = function() {
        this.player = new Player(this.options.autoPlay, ()=>{
            this.next(true);
        });
        this.on('activate', this.activatePlayer);
        this.on('uiChange', this.stopPlayer);
        this.on('pointerDown', this.stopPlayer);
        this.on('deactivate', this.deactivatePlayer);
    };
    let proto = Flickity.prototype;
    proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener('mouseenter', this);
    };
    // Player API, don't hate the ... thanks I know where the door is
    proto.playPlayer = function() {
        this.player.play();
    };
    proto.stopPlayer = function() {
        this.player.stop();
    };
    proto.pausePlayer = function() {
        this.player.pause();
    };
    proto.unpausePlayer = function() {
        this.player.unpause();
    };
    proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener('mouseenter', this);
    };
    // ----- mouseenter/leave ----- //
    // pause auto-play on hover
    proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener('mouseleave', this);
    };
    // resume auto-play on hover off
    proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener('mouseleave', this);
    };
    // -----  ----- //
    Flickity.Player = Player;
    return Flickity;
});

});

parcelRegister("jnS8l", function(module, exports) {


// add, remove cell
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("826sP")), (parcelRequire("9VjL6")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    // append cells to a document fragment
    function getCellsFragment(cells) {
        let fragment = document.createDocumentFragment();
        cells.forEach((cell)=>fragment.appendChild(cell.element));
        return fragment;
    }
    // -------------------------- add/remove cell prototype -------------------------- //
    let proto = Flickity.prototype;
    /**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */ proto.insert = function(elems, index) {
        let cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        let len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        let fragment = getCellsFragment(cells);
        // append to slider
        let isAppend = index === len;
        if (isAppend) this.slider.appendChild(fragment);
        else {
            let insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) // prepend, add to start
        this.cells = cells.concat(this.cells);
        else if (isAppend) // append, add to end
        this.cells = this.cells.concat(cells);
        else {
            // insert in this.cells
            let endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index);
        this.positionSliderAtSelected();
    };
    proto.append = function(elems) {
        this.insert(elems, this.cells.length);
    };
    proto.prepend = function(elems) {
        this.insert(elems, 0);
    };
    /**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */ proto.remove = function(elems) {
        let cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        let minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach((cell)=>{
            cell.remove();
            let index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
        });
        this.cellChange(minCellIndex);
        this.positionSliderAtSelected();
    };
    /**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */ proto.cellSizeChange = function(elem) {
        let cell = this.getCell(elem);
        if (!cell) return;
        cell.getSize();
        let index = this.cells.indexOf(cell);
        this.cellChange(index);
    // do not position slider after lazy load
    };
    /**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 */ proto.cellChange = function(changedCellIndex) {
        let prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._updateWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex, try to maintain position & select previous selected element
        let cell = this.getCell(prevSelectedElem);
        if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent('cellChange', [
            changedCellIndex
        ]);
        // position slider
        this.select(this.selectedIndex);
    };
    // -----  ----- //
    return Flickity;
});

});

parcelRegister("b1HnG", function(module, exports) {


// lazyload
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("826sP")), (parcelRequire("9VjL6")));
    else // browser global
    factory(window1.Flickity, window1.fizzyUIUtils);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, utils) {
    const lazyAttr = 'data-flickity-lazyload';
    const lazySrcAttr = `${lazyAttr}-src`;
    const lazySrcsetAttr = `${lazyAttr}-srcset`;
    const imgSelector = `img[${lazyAttr}], img[${lazySrcAttr}], ` + `img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;
    Flickity.create.lazyLoad = function() {
        this.on('select', this.lazyLoad);
        this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
    };
    let proto = Flickity.prototype;
    proto.lazyLoad = function() {
        let { lazyLoad: lazyLoad } = this.options;
        if (!lazyLoad) return;
        // get adjacent cells, use lazyLoad option for adjacent count
        let adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
        // lazy load images
        this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach((img)=>new LazyLoader(img, this.handleLazyLoadComplete));
    };
    function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.matches('img')) {
            let cellAttr = cellElem.getAttribute(lazyAttr);
            let cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
            let cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
            if (cellAttr || cellSrcAttr || cellSrcsetAttr) return cellElem;
        }
        // select lazy images in cell
        return [
            ...cellElem.querySelectorAll(imgSelector)
        ];
    }
    proto.onLazyLoadComplete = function(img, event) {
        let cell = this.getParentCell(img);
        let cellElem = cell && cell.element;
        this.cellSizeChange(cellElem);
        this.dispatchEvent('lazyLoad', event, cellElem);
    };
    // -------------------------- LazyLoader -------------------------- //
    /**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Function} onComplete - callback function
 */ function LazyLoader(img, onComplete) {
        this.img = img;
        this.onComplete = onComplete;
        this.load();
    }
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    LazyLoader.prototype.load = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        // get src & srcset
        let src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
        let srcset = this.img.getAttribute(lazySrcsetAttr);
        // set src & serset
        this.img.src = src;
        if (srcset) this.img.setAttribute('srcset', srcset);
        // remove attr
        this.img.removeAttribute(lazyAttr);
        this.img.removeAttribute(lazySrcAttr);
        this.img.removeAttribute(lazySrcsetAttr);
    };
    LazyLoader.prototype.onload = function(event) {
        this.complete(event, 'flickity-lazyloaded');
    };
    LazyLoader.prototype.onerror = function(event) {
        this.complete(event, 'flickity-lazyerror');
    };
    LazyLoader.prototype.complete = function(event, className) {
        // unbind events
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
        let mediaElem = this.img.parentNode.matches('picture') ? this.img.parentNode : this.img;
        mediaElem.classList.add(className);
        this.onComplete(this.img, event);
    };
    // -----  ----- //
    Flickity.LazyLoader = LazyLoader;
    return Flickity;
});

});

parcelRegister("ijip1", function(module, exports) {


// imagesloaded
(function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory((parcelRequire("826sP")), (parcelRequire("gWrO8")));
    else // browser global
    factory(window1.Flickity, window1.imagesLoaded);
})(typeof window != 'undefined' ? window : module.exports, function factory(Flickity, imagesLoaded) {
    Flickity.create.imagesLoaded = function() {
        this.on('activate', this.imagesLoaded);
    };
    Flickity.prototype.imagesLoaded = function() {
        if (!this.options.imagesLoaded) return;
        let onImagesLoadedProgress = (instance, image)=>{
            let cell = this.getParentCell(image.img);
            this.cellSizeChange(cell && cell.element);
            if (!this.options.freeScroll) this.positionSliderAtSelected();
        };
        imagesLoaded(this.slider).on('progress', onImagesLoadedProgress);
    };
    return Flickity;
});

});
parcelRegister("gWrO8", function(module, exports) {

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    // universal module definition
    if (module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("Vqjah")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== 'undefined' ? window : module.exports, function factory(window1, EvEmitter) {
    let $ = window1.jQuery;
    let console = window1.console;
    // -------------------------- helpers -------------------------- //
    // turn element or nodeList into an array
    function makeArray(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        let queryElem = elem;
        if (typeof elem == 'string') queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        // shift arguments if no options set
        if (typeof options == 'function') onAlways = options;
        else Object.assign(this.options, options);
        if (onAlways) this.on('always', onAlways);
        this.getImages();
        // add jQuery Deferred object
        if ($) this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    const elementNodeTypes = [
        1,
        9,
        11
    ];
    /**
 * @param {Node} elem
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName === 'IMG') this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        let { nodeType: nodeType } = elem;
        if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
        let childImgs = elem.querySelectorAll('img');
        // concat childElems to filterFound array
        for (let img of childImgs)this.addImage(img);
        // get child background images
        if (typeof this.options.background == 'string') {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children)this.addElementBackgroundImages(child);
        }
    };
    const reURL = /url\((['"])?(.*?)\1\)/gi;
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        let style = getComputedStyle(elem);
        // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        if (!style) return;
        // get url inside url("...")
        let matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            let url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        let loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        let background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        /* eslint-disable-next-line func-style */ let onProgress = (image, elem, message)=>{
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(()=>{
                this.progress(image, elem, message);
            });
        };
        this.images.forEach(function(loadingImage) {
            loadingImage.once('progress', onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent('progress', [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount === this.images.length) this.complete();
        if (this.options.debug && console) console.log(`progress: ${message}`, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        let eventName = this.hasAnyBroken ? 'fail' : 'done';
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent('always', [
            this
        ]);
        if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        // add crossOrigin attribute. #204
        if (this.img.crossOrigin) this.proxyImage.crossOrigin = this.img.crossOrigin;
        this.proxyImage.addEventListener('load', this);
        this.proxyImage.addEventListener('error', this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        let { parentNode: parentNode } = this.img;
        // emit progress with parent <picture> or self <img>
        let elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
        this.emitEvent('progress', [
            this,
            elem,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        let method = 'on' + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, 'onload');
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, 'onerror');
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener('load', this);
        this.proxyImage.removeEventListener('error', this);
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener('load', this);
        this.img.addEventListener('error', this);
        this.img.src = this.url;
        // check if image is already complete
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, 'naturalWidth');
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener('load', this);
        this.img.removeEventListener('error', this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent('progress', [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});

});


var $4eae0a726ab50395$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $4eae0a726ab50395$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $4eae0a726ab50395$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $4eae0a726ab50395$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


var $6466308c71ced2f5$exports = {};
/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */ 







if ($6466308c71ced2f5$exports) {
    const Flickity = (parcelRequire("826sP"));
    (parcelRequire("l95kq"));
    (parcelRequire("8pMCu"));
    (parcelRequire("19umk"));
    (parcelRequire("csKO1"));
    (parcelRequire("jnS8l"));
    (parcelRequire("b1HnG"));
    (parcelRequire("ijip1"));
    $6466308c71ced2f5$exports = Flickity;
}


/*! License details at fancyapps.com/license */ /*! License details at fancyapps.com/license */ /*! License details at fancyapps.com/license */ const $bc360f0f1dfbc749$export$844ec244b1367d54 = (t)=>"string" == typeof t;


/*! License details at fancyapps.com/license */ const $556b1b852427b8a8$export$8ee0fc9ee280b4ee = (n)=>n && null !== n && n instanceof Element && "nodeType" in n;


/*! License details at fancyapps.com/license */ const $af9ab31d2acb78ba$export$2bb74740c4e19def = function(e) {
    if (!(e && e instanceof Element && e.offsetParent)) return !1;
    const n = e.scrollHeight > e.clientHeight, t = window.getComputedStyle(e).overflowY, o = -1 !== t.indexOf("hidden"), i = -1 !== t.indexOf("visible");
    return n && !o && !i;
}, $af9ab31d2acb78ba$export$e41e80160bed5714 = function(t, o) {
    return !t || t === document.body || o && t === o ? null : $af9ab31d2acb78ba$export$2bb74740c4e19def(t) ? t : $af9ab31d2acb78ba$export$e41e80160bed5714(t.parentElement, o);
};


/*! License details at fancyapps.com/license */ const $8a814a110db3ad66$export$b368690db5627d91 = function(e) {
    var t = (new DOMParser).parseFromString(e, "text/html").body;
    if (t.childElementCount > 1) {
        for(var n = document.createElement("div"); t.firstChild;)n.appendChild(t.firstChild);
        return n;
    }
    let r = t.firstChild;
    return !r || r instanceof HTMLElement ? r : ((n = document.createElement("div")).appendChild(r), n);
};


/*! License details at fancyapps.com/license */ const $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4 = function(t = 0, n = 0, a = 0) {
    return Math.max(Math.min(n, a), t);
};


/*! License details at fancyapps.com/license */ 
/*! License details at fancyapps.com/license */ /*! License details at fancyapps.com/license */ const $343f588d0e79d7b3$export$53b83ca8eaab0383 = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t);


function $7491d1993ab51186$var$e(e) {
    return (0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(e) || Array.isArray(e);
}
function $7491d1993ab51186$export$248d38f6296296c5(t, r) {
    const o = Object.keys(t), c = Object.keys(r);
    return o.length === c.length && o.every((o)=>{
        const c = t[o], i = r[o];
        return "function" == typeof c ? `${c}` == `${i}` : $7491d1993ab51186$var$e(c) && $7491d1993ab51186$var$e(i) ? $7491d1993ab51186$export$248d38f6296296c5(c, i) : c === i;
    });
}


const $4397b247ae6d78b1$var$e = function(n) {
    for (const t of $4397b247ae6d78b1$var$s)t.getState() === $4397b247ae6d78b1$export$7f967bab4408cae2.Running && t.tick($4397b247ae6d78b1$var$a ? n - $4397b247ae6d78b1$var$a : 0);
    $4397b247ae6d78b1$var$a = n, $4397b247ae6d78b1$var$u = window.requestAnimationFrame($4397b247ae6d78b1$var$e);
};
var $4397b247ae6d78b1$export$7f967bab4408cae2, $4397b247ae6d78b1$var$o, $4397b247ae6d78b1$export$b4fa0e08d7ac6a23;
!function(n) {
    n[n.Initializing = 0] = "Initializing", n[n.Running = 1] = "Running", n[n.Paused = 2] = "Paused", n[n.Completed = 3] = "Completed", n[n.Destroyed = 4] = "Destroyed";
}($4397b247ae6d78b1$export$7f967bab4408cae2 || ($4397b247ae6d78b1$export$7f967bab4408cae2 = {})), function(n) {
    n[n.Spring = 0] = "Spring", n[n.Ease = 1] = "Ease";
}($4397b247ae6d78b1$var$o || ($4397b247ae6d78b1$var$o = {})), function(n) {
    n[n.Loop = 0] = "Loop", n[n.Reverse = 1] = "Reverse";
}($4397b247ae6d78b1$export$b4fa0e08d7ac6a23 || ($4397b247ae6d78b1$export$b4fa0e08d7ac6a23 = {}));
const $4397b247ae6d78b1$var$s = new Set;
let $4397b247ae6d78b1$var$u = null, $4397b247ae6d78b1$var$a = 0;
function $4397b247ae6d78b1$export$208a41d6b4e37b97() {
    let a = $4397b247ae6d78b1$export$7f967bab4408cae2.Initializing, f = $4397b247ae6d78b1$var$o.Ease, l = 0, g = 0, p = $4397b247ae6d78b1$export$208a41d6b4e37b97.Easings.Linear, m = 500, d = 0, b = 0, S = 0, h = 0, y = 1 / 0, E = .01, R = .01, M = !1, j = {}, w = null, v = {}, O = {}, C = {}, L = 0, I = 0, D = $4397b247ae6d78b1$export$b4fa0e08d7ac6a23.Loop, z = $4397b247ae6d78b1$export$208a41d6b4e37b97.Easings.Linear;
    const N = new Map;
    function V(n, ...t) {
        for (const e of N.get(n) || [])e(...t);
    }
    function q(n) {
        return g = 0, n ? w = setTimeout(()=>{
            x();
        }, n) : x(), F;
    }
    function x() {
        a = $4397b247ae6d78b1$export$7f967bab4408cae2.Running, V("start", v, O);
    }
    function A() {
        if (a = $4397b247ae6d78b1$export$7f967bab4408cae2.Completed, C = {}, V("end", v), a === $4397b247ae6d78b1$export$7f967bab4408cae2.Completed) {
            if (l < L) {
                if (l++, D === $4397b247ae6d78b1$export$b4fa0e08d7ac6a23.Reverse) {
                    const n = Object.assign({}, j);
                    j = Object.assign({}, O), O = n;
                }
                q(I);
            } else l = 0;
        }
        return F;
    }
    const F = {
        getState: function() {
            return a;
        },
        easing: function(n) {
            return p = n, f = $4397b247ae6d78b1$var$o.Ease, C = {}, F;
        },
        duration: function(n) {
            return m = n, F;
        },
        spring: function(n = {}) {
            f = $4397b247ae6d78b1$var$o.Spring;
            const t = {
                velocity: 0,
                mass: 1,
                tension: 170,
                friction: 26,
                restDelta: .1,
                restSpeed: .1,
                maxSpeed: 1 / 0,
                clamp: !0
            }, { velocity: e, mass: i, tension: r, friction: s, restDelta: u, restSpeed: a, maxSpeed: c, clamp: l } = Object.assign(Object.assign({}, t), n);
            return d = e, b = i, S = r, h = s, R = u, E = a, y = c, M = l, C = {}, F;
        },
        isRunning: function() {
            return a === $4397b247ae6d78b1$export$7f967bab4408cae2.Running;
        },
        isSpring: function() {
            return f === $4397b247ae6d78b1$var$o.Spring;
        },
        from: function(n) {
            return v = Object.assign({}, n), F;
        },
        to: function(n) {
            return O = n, F;
        },
        repeat: function(n, t = 0, e = $4397b247ae6d78b1$export$b4fa0e08d7ac6a23.Loop, i) {
            return L = n, I = t, D = e, z = i || p, F;
        },
        on: function(n, t) {
            var e, i;
            return e = n, i = t, N.set(e, [
                ...N.get(e) || [],
                i
            ]), F;
        },
        off: function(n, t) {
            var e, i;
            return e = n, i = t, N.has(e) && N.set(e, N.get(e).filter((n)=>n !== i)), F;
        },
        start: function(n) {
            return a = $4397b247ae6d78b1$export$7f967bab4408cae2.Initializing, j = Object.assign({}, v), (0, $7491d1993ab51186$export$248d38f6296296c5)(j, O) || ($4397b247ae6d78b1$var$s.add(this), $4397b247ae6d78b1$var$u || ($4397b247ae6d78b1$var$u = window.requestAnimationFrame($4397b247ae6d78b1$var$e)), q(n)), F;
        },
        pause: function() {
            return w && (clearTimeout(w), w = null), a === $4397b247ae6d78b1$export$7f967bab4408cae2.Running && (a = $4397b247ae6d78b1$export$7f967bab4408cae2.Paused, V("pause", v)), F;
        },
        end: A,
        tick: function(e) {
            e > 50 && (e = 50), g += e;
            let s = 0, u = !1;
            if (a !== $4397b247ae6d78b1$export$7f967bab4408cae2.Running) return F;
            if (f === $4397b247ae6d78b1$var$o.Ease) {
                s = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(0, g / m, 1), u = 1 === s;
                const t = D === $4397b247ae6d78b1$export$b4fa0e08d7ac6a23.Reverse ? z : p;
                for(const n in v)v[n] = j[n] + (O[n] - j[n]) * t(s);
            }
            if (f === $4397b247ae6d78b1$var$o.Spring) {
                const t = .001 * e;
                let i = 0;
                for(const e in v){
                    const o = O[e];
                    let r = v[e];
                    if ("number" != typeof o || isNaN(o) || "number" != typeof r || isNaN(r)) continue;
                    if (Math.abs(o - r) <= R) {
                        v[e] = o, C[e] = 0;
                        continue;
                    }
                    C[e] || ("object" == typeof d && "number" == typeof d[e] ? C[e] = d[e] : C[e] = "number" == typeof d ? d : 0);
                    let s = C[e];
                    s = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(-1 * Math.abs(y), s, Math.abs(y));
                    const u = s * b * h;
                    s += ((r > o ? -1 : 1) * (Math.abs(o - r) * S) - u) / b * t, r += s * t;
                    const a = v[e] > o ? r < o : r > o;
                    let c = Math.abs(s) < E && Math.abs(o - r) <= R;
                    M && a && (c = !0), c ? (r = o, s = 0) : i++, v[e] = r, C[e] = s;
                }
                u = !i;
            }
            const c = Object.assign({}, O);
            return V("step", v, j, O, s), u && a === $4397b247ae6d78b1$export$7f967bab4408cae2.Running && (0, $7491d1993ab51186$export$248d38f6296296c5)(O, c) && (a = $4397b247ae6d78b1$export$7f967bab4408cae2.Completed, A()), F;
        },
        getStartValues: function() {
            return j;
        },
        getCurrentValues: function() {
            return v;
        },
        getCurrentVelocities: function() {
            return C;
        },
        getEndValues: function() {
            return O;
        },
        destroy: function() {
            a = $4397b247ae6d78b1$export$7f967bab4408cae2.Destroyed, w && (clearTimeout(w), w = null), j = v = O = {}, $4397b247ae6d78b1$var$s.delete(this);
        }
    };
    return F;
}
$4397b247ae6d78b1$export$208a41d6b4e37b97.destroy = ()=>{
    for (const n of $4397b247ae6d78b1$var$s)n.destroy();
    $4397b247ae6d78b1$var$u && (cancelAnimationFrame($4397b247ae6d78b1$var$u), $4397b247ae6d78b1$var$u = null);
}, $4397b247ae6d78b1$export$208a41d6b4e37b97.Easings = {
    Linear: function(n) {
        return n;
    },
    EaseIn: function(n) {
        return 0 === n ? 0 : Math.pow(2, 10 * n - 10);
    },
    EaseOut: function(n) {
        return 1 === n ? 1 : 1 - Math.pow(2, -10 * n);
    },
    EaseInOut: function(n) {
        return 0 === n ? 0 : 1 === n ? 1 : n < .5 ? Math.pow(2, 20 * n - 10) / 2 : (2 - Math.pow(2, -20 * n + 10)) / 2;
    }
};


/*! License details at fancyapps.com/license */ function $d1d67bf17d8c2ed0$export$6385f9b89f59465f(e) {
    const t = [], n = "undefined" != typeof TouchEvent && e instanceof TouchEvent ? e.touches : e instanceof MouseEvent && "mouseup" !== e.type ? [
        e
    ] : [];
    for (const e of n)t.push({
        x: e.clientX,
        y: e.clientY,
        ts: Date.now()
    });
    return t;
}
function $d1d67bf17d8c2ed0$export$1ae15396032099be(e) {
    const t = [], n = "undefined" != typeof TouchEvent && e instanceof TouchEvent ? e.changedTouches : e instanceof MouseEvent ? [
        e
    ] : [];
    for (const e of n)t.push({
        x: e.clientX,
        y: e.clientY,
        ts: Date.now()
    });
    return t;
}
function $d1d67bf17d8c2ed0$export$b820caf342892892(e) {
    const t = e[0], n = e[1] || t;
    return {
        x: (t.x + n.x) / 2,
        y: (t.y + n.y) / 2,
        ts: n.ts
    };
}
function $d1d67bf17d8c2ed0$export$79376507b09a66f(e) {
    const t = e[0], n = e[1] || e[0];
    return t && n ? -1 * Math.sqrt((n.x - t.x) * (n.x - t.x) + (n.y - t.y) * (n.y - t.y)) : 0;
}
const $d1d67bf17d8c2ed0$var$s = (e)=>{
    e.cancelable && e.preventDefault();
}, $d1d67bf17d8c2ed0$var$i = {
    passive: !1
}, $d1d67bf17d8c2ed0$var$c = {
    panThreshold: 5,
    swipeThreshold: 3,
    ignore: [
        "textarea",
        "input",
        "select",
        "[contenteditable]",
        "[data-selectable]",
        "[data-draggable]"
    ]
};
let $d1d67bf17d8c2ed0$var$a = !1, $d1d67bf17d8c2ed0$var$r = !0;
const $d1d67bf17d8c2ed0$export$1f911e2d31b2843e = (u, l)=>{
    let d, f, h, v = Object.assign(Object.assign({}, $d1d67bf17d8c2ed0$var$c), l), p = [], m = [], E = [], g = !1, w = !1, y = !1, T = 0, b = 0, M = 0, x = 0, L = 0, P = 0, D = 0, X = 0, Y = 0, j = [], k = 0, R = 0;
    const z = new Map;
    function A(e) {
        const t = $d1d67bf17d8c2ed0$export$79376507b09a66f(m), n = $d1d67bf17d8c2ed0$export$79376507b09a66f(E), s = t && n ? t / n : 0, i = Math.abs(D) > Math.abs(X) ? D : X, c = {
            srcEvent: d,
            isPanRecognized: g,
            isSwipeRecognized: w,
            firstTouch: p,
            previousTouch: E,
            currentTouch: m,
            deltaX: M,
            deltaY: x,
            offsetX: L,
            offsetY: P,
            velocityX: D,
            velocityY: X,
            velocity: i,
            angle: Y,
            axis: h,
            scale: s,
            center: f
        };
        for (const t of z.get(e) || [])t(c);
    }
    function O(e) {
        const t = Date.now();
        j = j.filter((e)=>!e.ts || e.ts > t - 100), e && j.push(e);
    }
    function S() {
        if (D = 0, X = 0, j.length > 3) {
            const e = j[0], t = j[j.length - 1];
            if (e && t) {
                const n = t.x - e.x, o = t.y - e.y, s = e.ts && t.ts ? t.ts - e.ts : 0;
                s > 0 && (D = Math.abs(n) > 3 ? n / (s / 30) : 0, X = Math.abs(o) > 3 ? o / (s / 30) : 0);
            }
        }
    }
    function q(t) {
        if (t instanceof MouseEvent) {
            if ($d1d67bf17d8c2ed0$var$a) return;
        } else $d1d67bf17d8c2ed0$var$a = !0;
        const o = t.composedPath()[0], i = v.ignore.join(",");
        if (o.matches(i) || o.closest(i)) return;
        if ("undefined" != typeof MouseEvent && t instanceof MouseEvent && (!t.buttons || 0 !== t.button)) return;
        t instanceof MouseEvent && $d1d67bf17d8c2ed0$var$s(t);
        const c = Date.now(), r = c - (T || c);
        y = r > 0 && r <= 250, T = c, clearTimeout(k), d = t, t instanceof MouseEvent && (window.addEventListener("mousemove", C), window.addEventListener("mouseup", I)), window.addEventListener("blur", B), m = $d1d67bf17d8c2ed0$export$6385f9b89f59465f(t), p = [
            ...m
        ], E = [], b = m.length, f = $d1d67bf17d8c2ed0$export$b820caf342892892(m), 1 === b && (g = !1, w = !1), b && O($d1d67bf17d8c2ed0$export$b820caf342892892(m)), A("start");
    }
    function C(t) {
        var s;
        if (!p.length) return;
        if (t.defaultPrevented) return;
        d = t, E = [
            ...m
        ], m = $d1d67bf17d8c2ed0$export$6385f9b89f59465f(t), b = m.length, f = $d1d67bf17d8c2ed0$export$b820caf342892892(m);
        const i = f, c = $d1d67bf17d8c2ed0$export$b820caf342892892(E);
        if (M = i.x - c.x, x = i.y - c.y, O(i), S(), A("move"), m.length > 1) {
            const e = $d1d67bf17d8c2ed0$export$79376507b09a66f(m), t = $d1d67bf17d8c2ed0$export$79376507b09a66f(E);
            Math.abs(e - t) >= .1 && A("pinch");
        }
        if (!g && p.length) {
            const e = $d1d67bf17d8c2ed0$export$b820caf342892892(p);
            L = i.x - e.x, P = i.y - e.y, g = Math.abs(L) > v.panThreshold || Math.abs(P) > v.panThreshold, g && ($d1d67bf17d8c2ed0$var$r = !1, clearTimeout(R), R = 0, Y = Math.abs(180 * Math.atan2(P, L) / Math.PI), h = Y > 45 && Y < 135 ? "y" : "x", p = [
                ...m
            ], E = [
                ...m
            ], null === (s = window.getSelection()) || void 0 === s || s.removeAllRanges(), A("panstart"));
        }
        g && (M || x) && A("pan");
    }
    function I(o) {
        if (d = o, !p.length) return;
        const s = $d1d67bf17d8c2ed0$export$6385f9b89f59465f(o), i = $d1d67bf17d8c2ed0$export$1ae15396032099be(o);
        if (b = s.length, f = $d1d67bf17d8c2ed0$export$b820caf342892892(i), i.length && O($d1d67bf17d8c2ed0$export$b820caf342892892(i)), S(), E = [
            ...m
        ], m = [
            ...s
        ], p = [
            ...s
        ], s.length > 0) A("end"), g = !1, w = !1, j = [];
        else {
            const e = v.swipeThreshold;
            (Math.abs(D) > e || Math.abs(X) > e) && (w = !0), g && A("panend"), w && A("swipe"), g || w || (A("tap"), y ? A("doubleTap") : k = setTimeout(function() {
                A("singleTap");
            }, 250)), A("end"), F();
        }
    }
    function B() {
        clearTimeout(k), F(), g && A("panend"), A("end");
    }
    function F() {
        g = !1, w = !1, y = !1, b = 0, j = [], m = [], E = [], p = [], M = 0, x = 0, L = 0, P = 0, D = 0, X = 0, Y = 0, h = void 0, window.removeEventListener("mousemove", C), window.removeEventListener("mouseup", I), window.removeEventListener("blur", B), $d1d67bf17d8c2ed0$var$r || R || (R = setTimeout(()=>{
            $d1d67bf17d8c2ed0$var$r = !0, R = 0;
        }, 100));
    }
    function G(e) {
        const t = e.target;
        $d1d67bf17d8c2ed0$var$a = !1, t && !e.defaultPrevented && ($d1d67bf17d8c2ed0$var$r || ($d1d67bf17d8c2ed0$var$s(e), e.stopPropagation()));
    }
    const H = {
        init: function() {
            if (u) return u.addEventListener("click", G, $d1d67bf17d8c2ed0$var$i), u.addEventListener("mousedown", q, $d1d67bf17d8c2ed0$var$i), u.addEventListener("touchstart", q, $d1d67bf17d8c2ed0$var$i), u.addEventListener("touchmove", C, $d1d67bf17d8c2ed0$var$i), u.addEventListener("touchend", I), u.addEventListener("touchcancel", I), H;
        },
        on: function(e, t) {
            return function(e, t) {
                z.set(e, [
                    ...z.get(e) || [],
                    t
                ]);
            }(e, t), H;
        },
        off: function(e, t) {
            return z.has(e) && z.set(e, z.get(e).filter((e)=>e !== t)), H;
        },
        isPointerDown: ()=>b > 0,
        destroy: function() {
            clearTimeout(k), clearTimeout(R), R = 0, u && (u.removeEventListener("click", G, $d1d67bf17d8c2ed0$var$i), u.removeEventListener("mousedown", q, $d1d67bf17d8c2ed0$var$i), u.removeEventListener("touchstart", q, $d1d67bf17d8c2ed0$var$i), u.removeEventListener("touchmove", C, $d1d67bf17d8c2ed0$var$i), u.removeEventListener("touchend", I), u.removeEventListener("touchcancel", I)), u = null, F();
        }
    };
    return H;
};
$d1d67bf17d8c2ed0$export$1f911e2d31b2843e.isClickAllowed = ()=>$d1d67bf17d8c2ed0$var$r;


/*! License details at fancyapps.com/license */ const $2a547cbb739153ad$export$30568d076ec2f42 = {
    IMAGE_ERROR: "This image couldn't be loaded. <br /> Please try again later.",
    MOVE_UP: "Move up",
    MOVE_DOWN: "Move down",
    MOVE_LEFT: "Move left",
    MOVE_RIGHT: "Move right",
    ZOOM_IN: "Zoom in",
    ZOOM_OUT: "Zoom out",
    TOGGLE_FULL: "Toggle zoom level",
    TOGGLE_1TO1: "Toggle zoom level",
    ITERATE_ZOOM: "Toggle zoom level",
    ROTATE_CCW: "Rotate counterclockwise",
    ROTATE_CW: "Rotate clockwise",
    FLIP_X: "Flip horizontally",
    FLIP_Y: "Flip vertically",
    RESET: "Reset"
};


/*! License details at fancyapps.com/license */ const $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3 = (s, t = "")=>{
    s && s.classList && t.split(" ").forEach((t)=>{
        t && s.classList.add(t);
    });
};


const $d05bed9ea06f74d2$var$f = (e)=>{
    e.cancelable && e.preventDefault();
}, $d05bed9ea06f74d2$var$d = (e, t = 1e4)=>(e = parseFloat(e + "") || 0, Math.round((e + Number.EPSILON) * t) / t);
var $d05bed9ea06f74d2$export$9520bccbaf78266, $d05bed9ea06f74d2$export$97fb49bddd4ef65d;
!function(e) {
    e.Reset = "reset", e.Zoom = "zoom", e.ZoomIn = "zoomIn", e.ZoomOut = "zoomOut", e.ZoomTo = "zoomTo", e.ToggleCover = "toggleCover", e.ToggleFull = "toggleFull", e.ToggleMax = "toggleMax", e.IterateZoom = "iterateZoom", e.Pan = "pan", e.Swipe = "swipe", e.Move = "move", e.MoveLeft = "moveLeft", e.MoveRight = "moveRight", e.MoveUp = "moveUp", e.MoveDown = "moveDown", e.RotateCCW = "rotateCCW", e.RotateCW = "rotateCW", e.FlipX = "flipX", e.FlipY = "flipY";
}($d05bed9ea06f74d2$export$9520bccbaf78266 || ($d05bed9ea06f74d2$export$9520bccbaf78266 = {})), function(e) {
    e.Cover = "cover", e.Full = "full", e.Max = "max";
}($d05bed9ea06f74d2$export$97fb49bddd4ef65d || ($d05bed9ea06f74d2$export$97fb49bddd4ef65d = {}));
const $d05bed9ea06f74d2$export$15463f5204f2871f = {
    x: 0,
    y: 0,
    scale: 1,
    angle: 0,
    flipX: 1,
    flipY: 1
}, $d05bed9ea06f74d2$var$p = {
    bounds: !0,
    classes: {
        container: "f-panzoom",
        wrapper: "f-panzoom__wrapper",
        content: "f-panzoom__content",
        viewport: "f-panzoom__viewport"
    },
    clickAction: $d05bed9ea06f74d2$export$9520bccbaf78266.ToggleFull,
    dblClickAction: !1,
    gestures: {},
    height: "auto",
    l10n: (0, $2a547cbb739153ad$export$30568d076ec2f42),
    maxScale: 4,
    minScale: 1,
    mouseMoveFactor: 1,
    panMode: "drag",
    protected: !1,
    singleClickAction: !1,
    spinnerTpl: '<div class="f-spinner"></div>',
    wheelAction: $d05bed9ea06f74d2$export$9520bccbaf78266.Zoom,
    width: "auto"
};
let $d05bed9ea06f74d2$var$v, $d05bed9ea06f74d2$var$b = 0, $d05bed9ea06f74d2$var$y = 0, $d05bed9ea06f74d2$var$x = 0;
const $d05bed9ea06f74d2$export$b704d075ddd20210 = (c, h = {}, w = {})=>{
    let M, E, T, k, L, j, O, A = 0, C = Object.assign(Object.assign({}, $d05bed9ea06f74d2$var$p), h), S = {}, F = Object.assign({}, $d05bed9ea06f74d2$export$15463f5204f2871f), Z = Object.assign({}, $d05bed9ea06f74d2$export$15463f5204f2871f);
    const X = [];
    function Y(e) {
        let t = C[e];
        return t && "function" == typeof t ? t(ge) : t;
    }
    const P = new Map;
    function I(e, ...t) {
        const n = [
            ...P.get(e) || []
        ];
        C.on && n.push(C.on[e]);
        for (const e of n)e && e instanceof Function && e(ge, ...t);
        "*" !== e && I("*", e, ...t);
    }
    function R(e) {
        if (3 !== A) return;
        const t = e.target;
        if ((0, $af9ab31d2acb78ba$export$e41e80160bed5714)(t)) return;
        const i = Date.now(), a = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(e, t) {
            return Math.abs(t) > Math.abs(e) ? t : e;
        }), s = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(-1, a, 1);
        I("wheel", e, s);
        const l = Y("wheelAction");
        if (!l) return;
        if (e.defaultPrevented) return;
        const r = Z.scale;
        let c = r * (s > 0 ? 1.5 : .5);
        if (l === $d05bed9ea06f74d2$export$9520bccbaf78266.Zoom) {
            const t = Math.abs(e.deltaY) < 100 && Math.abs(e.deltaX) < 100;
            if (i - $d05bed9ea06f74d2$var$y < (t ? 200 : 45)) return void $d05bed9ea06f74d2$var$f(e);
            $d05bed9ea06f74d2$var$y = i;
            const n = V(), a = K();
            if ($d05bed9ea06f74d2$var$d(c) < $d05bed9ea06f74d2$var$d(n) && $d05bed9ea06f74d2$var$d(r) <= $d05bed9ea06f74d2$var$d(n) ? ($d05bed9ea06f74d2$var$x += Math.abs(s), c = n) : $d05bed9ea06f74d2$var$d(c) > $d05bed9ea06f74d2$var$d(a) && $d05bed9ea06f74d2$var$d(r) >= $d05bed9ea06f74d2$var$d(a) ? ($d05bed9ea06f74d2$var$x += Math.abs(s), c = a) : ($d05bed9ea06f74d2$var$x = 0, c = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(n, c, a)), $d05bed9ea06f74d2$var$x > 7) return;
        }
        switch($d05bed9ea06f74d2$var$f(e), l){
            case $d05bed9ea06f74d2$export$9520bccbaf78266.Pan:
                ne(l, {
                    srcEvent: e,
                    deltaX: 2 * -e.deltaX,
                    deltaY: 2 * -e.deltaY
                });
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.Zoom:
                ne($d05bed9ea06f74d2$export$9520bccbaf78266.ZoomTo, {
                    srcEvent: e,
                    scale: c,
                    center: {
                        x: e.clientX,
                        y: e.clientY
                    }
                });
                break;
            default:
                ne(l, {
                    srcEvent: e
                });
        }
    }
    function z(e) {
        var n, i;
        const o = e.composedPath()[0];
        if (!(0, $d1d67bf17d8c2ed0$export$1f911e2d31b2843e).isClickAllowed()) return;
        if (!(0, $556b1b852427b8a8$export$8ee0fc9ee280b4ee)(o) || e.defaultPrevented) return;
        if (!(null == c ? void 0 : c.contains(o))) return;
        if (o.hasAttribute("disabled") || o.hasAttribute("aria-disabled")) return;
        const a = o.closest("[data-panzoom-action]"), s = null === (n = null == a ? void 0 : a.dataset) || void 0 === n ? void 0 : n.panzoomAction, l = (null === (i = null == a ? void 0 : a.dataset) || void 0 === i ? void 0 : i.panzoomValue) || "";
        if (s) {
            switch(s){
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ZoomTo:
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ZoomIn:
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ZoomOut:
                    ne(s, {
                        scale: parseFloat(l || "") || void 0
                    });
                    break;
                case $d05bed9ea06f74d2$export$9520bccbaf78266.MoveLeft:
                case $d05bed9ea06f74d2$export$9520bccbaf78266.MoveRight:
                    ne(s, {
                        deltaX: parseFloat(l || "") || void 0
                    });
                    break;
                case $d05bed9ea06f74d2$export$9520bccbaf78266.MoveUp:
                case $d05bed9ea06f74d2$export$9520bccbaf78266.MoveDown:
                    ne(s, {
                        deltaY: parseFloat(l || "") || void 0
                    });
                    break;
                default:
                    ne(s);
            }
            return;
        }
        if (!(null == M ? void 0 : M.contains(o))) return;
        const u = {
            srcEvent: e
        };
        if (ne(Y("clickAction"), u), Y("dblClickAction")) {
            const e = Date.now(), t = e - ($d05bed9ea06f74d2$var$b || e);
            $d05bed9ea06f74d2$var$b = e, t > 0 && t <= 250 ? ($d05bed9ea06f74d2$var$v && (clearTimeout($d05bed9ea06f74d2$var$v), $d05bed9ea06f74d2$var$v = void 0), ne(Y("dblClickAction"), u)) : $d05bed9ea06f74d2$var$v = setTimeout(()=>{
                ne(Y("singleClickAction"), u);
            }, 250);
        }
    }
    function D(e) {
        if (O = e, !_()) return;
        if (3 !== A || F.scale <= 1 || Z.scale <= 1) return;
        if (((null == M ? void 0 : M.dataset.animationName) || "").indexOf("zoom") > -1) return;
        const t = B(Z.scale);
        if (!t) return;
        const { x: n, y: i } = t;
        ne($d05bed9ea06f74d2$export$9520bccbaf78266.Pan, {
            deltaX: n - Z.x,
            deltaY: i - Z.y
        });
    }
    function H() {
        var e;
        c && (c.classList.remove("is-loading"), null === (e = c.querySelector(".f-spinner")) || void 0 === e || e.remove());
    }
    function W() {
        if (!c || !M) return;
        if (E instanceof HTMLImageElement && (!E.complete || !E.naturalWidth)) return H(), A = 2, null == M || M.classList.add("has-error"), void I("error");
        I("loaded");
        const { width: e, height: t } = $();
        E && (E.setAttribute("width", e + ""), E.setAttribute("height", t + "")), M && (M.classList.remove("has-error"), M.setAttribute("width", e + ""), M.setAttribute("height", t + ""), M.style.aspectRatio = `${e / t || ""}`), L = (0, $4397b247ae6d78b1$export$208a41d6b4e37b97)().on("start", (e, t)=>{
            Z = Object.assign(Object.assign({}, $d05bed9ea06f74d2$export$15463f5204f2871f), t), void 0 !== t.angle && (t.angle = 90 * Math.round(t.angle / 90)), void 0 !== t.flipX && (t.flipX = t.flipX > 0 ? 1 : -1), void 0 !== t.flipY && (t.flipY = t.flipY > 0 ? 1 : -1), te(), I("animationStart");
        }).on("pause", (e)=>{
            Z = Object.assign(Object.assign({}, $d05bed9ea06f74d2$export$15463f5204f2871f), e);
        }).on("step", (e)=>{
            if (3 !== A) return;
            if (!L) return;
            if (!c || !c.parentElement) return void L.end();
            if (F = Object.assign(Object.assign({}, $d05bed9ea06f74d2$export$15463f5204f2871f), e), _() || !Y("bounds") || (null == k ? void 0 : k.isPointerDown()) || Z.scale > F.scale || Z.scale < U()) return void ie();
            const t = Q(Z.scale);
            let n = !1, i = !1, a = !1, s = !1;
            F.x < t.x[0] && (n = !0), F.x > t.x[1] && (i = !0), F.y < t.y[0] && (s = !0), F.y > t.y[1] && (a = !0);
            let l = !1, r = !1, u = !1, f = !1;
            Z.x < t.x[0] && (l = !0), Z.x > t.x[1] && (r = !0), Z.y < t.y[0] && (f = !0), Z.y > t.y[1] && (u = !0);
            let d = !1;
            (i && r || n && l) && (Z.x = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(t.x[0], Z.x, t.x[1]), d = !0), (a && u || s && f) && (Z.y = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(t.y[0], Z.y, t.y[1]), d = !0), d && L.spring({
                tension: 94,
                friction: 17,
                maxSpeed: 555 * Z.scale,
                restDelta: .1,
                restSpeed: .1,
                velocity: L.getCurrentVelocities()
            }).from(F).to(Z).start(), ie();
        }).on("end", ()=>{
            ee(), (null == L ? void 0 : L.isRunning()) || (te(), I("animationEnd"));
        }), function() {
            const e = Y("gestures");
            e && T && E && (k = (0, $d1d67bf17d8c2ed0$export$1f911e2d31b2843e)(T, e).on("start", (e)=>{
                if (!L) return;
                const t = e.srcEvent;
                _() || ((F.scale > 1 || e.currentTouch.length > 1) && (null == t || t.stopPropagation(), L.pause()), 1 === e.currentTouch.length && I("touchStart"));
            }).on("move", (e)=>{
                _() || (1 !== Z.scale || e.currentTouch.length > 1) && (e.srcEvent.preventDefault(), e.srcEvent.stopPropagation());
            }).on("pan", (e)=>{
                if (_()) return;
                const t = e.srcEvent;
                (1 !== Z.scale || e.currentTouch.length > 1) && ($d05bed9ea06f74d2$var$f(t), ne($d05bed9ea06f74d2$export$9520bccbaf78266.Pan, e));
            }).on("swipe", (e)=>{
                _() || Z.scale > 1 && ne($d05bed9ea06f74d2$export$9520bccbaf78266.Swipe, e);
            }).on("tap", (e)=>{
                I("click", e);
            }).on("singleTap", (e)=>{
                I("singleClick", e);
            }).on("doubleTap", (e)=>{
                I("dblClick", e);
            }).on("pinch", (e)=>{
                _() || (e.scale > U() ? ne($d05bed9ea06f74d2$export$9520bccbaf78266.ZoomIn, e) : e.scale < U() ? ne($d05bed9ea06f74d2$export$9520bccbaf78266.ZoomOut, e) : ne($d05bed9ea06f74d2$export$9520bccbaf78266.Pan, e));
            }).on("end", (e)=>{
                _() || (e.currentTouch.length ? (e.srcEvent.stopPropagation(), $d05bed9ea06f74d2$var$f(e.srcEvent), null == L || L.end()) : (te(), ee(), I("touchEnd")));
            }).init());
        }(), T && (T.addEventListener("wheel", R, {
            passive: !1
        }), X.push(()=>{
            null == T || T.removeEventListener("wheel", R, {
                passive: !1
            });
        })), null == c || c.addEventListener("click", z), null === document || void 0 === document || document.addEventListener("mousemove", D), X.push(()=>{
            null == c || c.removeEventListener("click", z), null === document || void 0 === document || document.removeEventListener("mousemove", D);
        });
        const n = Object.assign(Object.assign({}, Y("startPos") || {}), {
            scale: U()
        });
        if (F = Object.assign(Object.assign({}, $d05bed9ea06f74d2$export$15463f5204f2871f), n), Z = Object.assign(Object.assign({}, $d05bed9ea06f74d2$export$15463f5204f2871f), n), _()) {
            const e = B(Z.scale);
            if (e) {
                const { x: t, y: n } = e;
                F.x = t, F.y = n, Z.x = t, Z.y = n;
            }
        }
        A = 3, ie(), te(), I("ready"), requestAnimationFrame(()=>{
            H(), T && (T.style.visibility = "");
        });
    }
    function q() {
        const e = {
            top: 0,
            left: 0,
            width: 0,
            height: 0
        };
        if (M) {
            const t = M.getBoundingClientRect();
            Z.angle % 180 == 90 ? (e.top = t.top + .5 * t.height - .5 * t.width, e.left = t.left + .5 * t.width - .5 * t.height, e.width = t.height, e.height = t.width) : (e.top = t.top, e.left = t.left, e.width = t.width, e.height = t.height);
        }
        return e;
    }
    function $() {
        let t = Y("width"), n = Y("height");
        if (E && "auto" === t) {
            const e = E.getAttribute("width");
            t = e ? parseFloat(e + "") : void 0 !== E.dataset.width ? parseFloat(E.dataset.width + "") : T instanceof HTMLImageElement ? T.naturalWidth : E instanceof HTMLImageElement ? E.naturalWidth : E.getBoundingClientRect().width;
        } else t = (0, $bc360f0f1dfbc749$export$844ec244b1367d54)(t) ? parseFloat(t) : t;
        if (E && "auto" === n) {
            const e = E.getAttribute("height");
            n = e ? parseFloat(e + "") : void 0 !== E.dataset.height ? parseFloat(E.dataset.height + "") : T instanceof HTMLImageElement ? T.naturalHeight : E instanceof HTMLImageElement ? E.naturalHeight : E.getBoundingClientRect().height;
        } else n = (0, $bc360f0f1dfbc749$export$844ec244b1367d54)(n) ? parseFloat(n) : n;
        return {
            width: t,
            height: n
        };
    }
    function _() {
        return "mousemove" === Y("panMode") && matchMedia("(hover: hover)").matches;
    }
    function B(e) {
        const t = O || Y("event"), n = null == M ? void 0 : M.getBoundingClientRect();
        if (!t || !n || e <= 1) return {
            x: 0,
            y: 0
        };
        const i = (t.clientX || 0) - n.left, a = (t.clientY || 0) - n.top, s = n.width, l = n.height, r = Q(e);
        if (e > 1) {
            const t = Y("mouseMoveFactor");
            t > 1 && (e *= t);
        }
        let c = s * e, u = l * e, f = .5 * (c - s) - i / s * 100 / 100 * (c - s), d = .5 * (u - l) - a / l * 100 / 100 * (u - l);
        return f = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(r.x[0], f, r.x[1]), d = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(r.y[0], d, r.y[1]), {
            x: f,
            y: d
        };
    }
    function N(e = "base") {
        if (!c) return 1;
        const t = c.getBoundingClientRect(), n = q(), { width: i, height: a } = $(), s = (e)=>{
            if ("number" == typeof e) return e;
            switch(e){
                case "min":
                case "base":
                    return 1;
                case "cover":
                    return Math.max(t.height / n.height, t.width / n.width) || 1;
                case "full":
                case "max":
                    {
                        const e = Z.angle % 180 == 90 ? a : i;
                        return e && n.width ? e / n.width : 1;
                    }
            }
        }, l = Y("minScale"), r = Y("maxScale"), u = Math.min(s("full"), s(l)), f = "number" == typeof r ? s("full") * r : Math.min(s("full"), s(r));
        switch(e){
            case "min":
                return u;
            case "base":
                return (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(u, 1, f);
            case "cover":
                return s("cover");
            case "full":
                return Math.min(f, s("full"));
            case "max":
                return f;
        }
    }
    function V() {
        return N("min");
    }
    function U() {
        return N("base");
    }
    function G() {
        return N("cover");
    }
    function J() {
        return N("full");
    }
    function K() {
        return N("max");
    }
    function Q(e) {
        const t = {
            x: [
                0,
                0
            ],
            y: [
                0,
                0
            ]
        }, n = null == c ? void 0 : c.getBoundingClientRect();
        if (!n) return t;
        const i = q(), o = n.width, a = n.height;
        let s = i.width, l = i.height, r = e = void 0 === e ? Z.scale : e, u = e;
        if (_() && e > 1) {
            const t = Y("mouseMoveFactor");
            t > 1 && (s * e > o + .01 && (r *= t), l * e > a + .01 && (u *= t));
        }
        return s *= r, l *= u, e > 1 && (s > o && (t.x[0] = .5 * (o - s), t.x[1] = .5 * (s - o)), t.x[0] -= .5 * (i.left - n.left), t.x[1] -= .5 * (i.left - n.left), t.x[0] -= .5 * (i.left + i.width - n.right), t.x[1] -= .5 * (i.left + i.width - n.right), l > a && (t.y[0] = .5 * (a - l), t.y[1] = .5 * (l - a)), t.y[0] -= .5 * (i.top - n.top), t.y[1] -= .5 * (i.top - n.top), t.y[0] -= .5 * (i.top + i.height - n.bottom), t.y[1] -= .5 * (i.top + i.height - n.bottom)), t;
    }
    function ee() {
        if (!Y("bounds")) return;
        if (3 !== A) return;
        if (!(null == c ? void 0 : c.parentElement)) return;
        if (!L) return;
        const e = V(), t = K(), n = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(e, Z.scale, t);
        if (Z.scale < e - .01 || Z.scale > t + .01) return void ne($d05bed9ea06f74d2$export$9520bccbaf78266.ZoomTo, {
            scale: n
        });
        if (L.isRunning()) return;
        if (null == k ? void 0 : k.isPointerDown()) return;
        const i = Q(n);
        Z.x < i.x[0] || Z.x > i.x[1] || Z.y < i.y[0] || Z.y > i.y[1] ? (Z.x = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(i.x[0], Z.x, i.x[1]), Z.y = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(i.y[0], Z.y, i.y[1]), L.spring({
            tension: 170,
            friction: 17,
            restDelta: .001,
            restSpeed: .001,
            maxSpeed: 1 / 0,
            velocity: L.getCurrentVelocities()
        }), L.from(F).to(Z).start()) : ie();
    }
    function te() {
        if (!c || !c.parentElement || !M) return;
        const e = ce(), t = ue(), n = fe(), i = de(), o = ae(), a = se();
        M.classList.toggle("is-fullsize", i), M.classList.toggle("is-expanded", n), M.classList.toggle("is-dragging", t), M.classList.toggle("can-drag", e), M.classList.toggle("will-zoom-in", o), M.classList.toggle("will-zoom-out", a);
        const s = le(), l = re(), r = 3 !== A;
        for (const e of (null == c ? void 0 : c.querySelectorAll("[data-panzoom-action]")) || []){
            const t = e.dataset.panzoomAction;
            let n = !1;
            if (r) n = !0;
            else switch(t){
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ZoomIn:
                    s || (n = !0);
                    break;
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ZoomOut:
                    l || (n = !0);
                    break;
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ToggleFull:
                    s || l || (n = !0);
                    const t1 = e.querySelector("g");
                    t1 && (t1.style.display = i ? "none" : "");
                    break;
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ToggleCover:
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ToggleMax:
                    s || l || (n = !0);
            }
            n ? (e.setAttribute("aria-disabled", ""), e.setAttribute("tabindex", "-1")) : (e.removeAttribute("aria-disabled"), e.removeAttribute("tabindex"));
        }
    }
    function ne(e, t) {
        var n;
        if (!c || !E || !L) return;
        if (e === $d05bed9ea06f74d2$export$9520bccbaf78266.Swipe && Math.abs(L.getCurrentVelocities().scale) > .01) return;
        let i = Object.assign({}, Z), a = Q(_() ? Z.scale : F.scale);
        const r = L.getCurrentVelocities(), u = q(), f = ((null === (n = (t = t || {}).currentTouch) || void 0 === n ? void 0 : n.length) || 0) > 1, d = t.velocityX || 0, h = t.velocityY || 0;
        let p = t.center;
        !p && t.srcEvent && (p = (0, $d1d67bf17d8c2ed0$export$b820caf342892892)((0, $d1d67bf17d8c2ed0$export$1ae15396032099be)(t.srcEvent)));
        let v = t.deltaX || 0, b = t.deltaY || 0;
        switch(e){
            case $d05bed9ea06f74d2$export$9520bccbaf78266.MoveRight:
                v = t.deltaX || 100;
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.MoveLeft:
                v = t.deltaX || -100;
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.MoveUp:
                b = t.deltaY || -100;
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.MoveDown:
                b = t.deltaY || 100;
        }
        let y = [];
        switch(e){
            case $d05bed9ea06f74d2$export$9520bccbaf78266.Reset:
                Z = Object.assign({}, $d05bed9ea06f74d2$export$15463f5204f2871f), Z.scale = U();
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.Pan:
            case $d05bed9ea06f74d2$export$9520bccbaf78266.Move:
            case $d05bed9ea06f74d2$export$9520bccbaf78266.MoveLeft:
            case $d05bed9ea06f74d2$export$9520bccbaf78266.MoveRight:
            case $d05bed9ea06f74d2$export$9520bccbaf78266.MoveUp:
            case $d05bed9ea06f74d2$export$9520bccbaf78266.MoveDown:
                if (null == k ? void 0 : k.isPointerDown()) {
                    let e = 1, t = 1;
                    Z.x <= a.x[0] && d <= 0 && (e = Math.max(.01, 1 - Math.abs(1 / u.width * Math.abs(Z.x - a.x[0]))), e *= .2), Z.x >= a.x[1] && d >= 0 && (e = Math.max(.01, 1 - Math.abs(1 / u.width * Math.abs(Z.x - a.x[1]))), e *= .2), Z.y <= a.y[0] && h <= 0 && (t = Math.max(.01, 1 - Math.abs(1 / u.height * Math.abs(Z.y - a.y[0]))), t *= .2), Z.y >= a.y[1] && h >= 0 && (t = Math.max(.01, 1 - Math.abs(1 / u.height * Math.abs(Z.y - a.y[1]))), t *= .2), Z.x += v * e, Z.y += b * t;
                } else Z.x = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(a.x[0], Z.x + v, a.x[1]), Z.y = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(a.y[0], Z.y + b, a.y[1]);
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.Swipe:
                const e1 = (e = 0)=>Math.sign(e) * Math.pow(Math.abs(e), 1.5);
                Z.x += (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(-1000, e1(d), 1e3), Z.y += (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(-1000, e1(h), 1e3), h && !d && (Z.x = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(a.x[0], Z.x, a.x[1])), !h && d && (Z.y = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(a.y[0], Z.y, a.y[1])), r.x = d, r.y = h;
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.ZoomTo:
                Z.scale = t.scale || 1;
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.ZoomIn:
                Z.scale = Z.scale * (t.scale || 2), f || (Z.scale = Math.min(Z.scale, K()));
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.ZoomOut:
                Z.scale = Z.scale * (t.scale || .5), f || (Z.scale = Math.max(Z.scale, V()));
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.ToggleCover:
                y = [
                    U(),
                    G()
                ];
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.ToggleFull:
                y = [
                    U(),
                    J()
                ];
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.ToggleMax:
                y = [
                    U(),
                    K()
                ];
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.IterateZoom:
                y = [
                    U(),
                    J(),
                    K()
                ];
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.Zoom:
                const n1 = J();
                Z.scale >= n1 - .05 ? Z.scale = U() : Z.scale = Math.min(n1, Z.scale * (t.scale || 2));
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.RotateCW:
                Z.angle += 90;
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.RotateCCW:
                Z.angle -= 90;
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.FlipX:
                Z.flipX *= -1;
                break;
            case $d05bed9ea06f74d2$export$9520bccbaf78266.FlipY:
                Z.flipY *= -1;
        }
        if (void 0 !== F.angle && Math.abs(F.angle) >= 360 && (Z.angle -= 360 * Math.floor(F.angle / 360), F.angle -= 360 * Math.floor(F.angle / 360)), y.length) {
            const e = y.findIndex((e)=>e > Z.scale + 1e-4);
            Z.scale = y[e] || y[0];
        }
        if (f && (Z.scale = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(V() * (f ? .8 : 1), Z.scale, K() * (f ? 1.6 : 1))), _()) {
            const e = B(Z.scale);
            if (e) {
                const { x: t, y: n } = e;
                Z.x = t, Z.y = n;
            }
        } else if (Z.scale !== i.scale) {
            let e = 0, t = 0;
            if (p) e = p.x, t = p.y;
            else {
                const n = c.getBoundingClientRect();
                e = n.x + .5 * n.width, t = n.y + .5 * n.height;
            }
            let n = e - u.left, s = t - u.top;
            n -= .5 * u.width, s -= .5 * u.height;
            const l = (n - i.x) / i.scale, r = (s - i.y) / i.scale;
            Z.x = n - l * Z.scale, Z.y = s - r * Z.scale, !f && Y("bounds") && (a = Q(Z.scale), Z.x = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(a.x[0], Z.x, a.x[1]), Z.y = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(a.y[0], Z.y, a.y[1]));
        }
        if (e === $d05bed9ea06f74d2$export$9520bccbaf78266.Swipe) {
            let e = 94, t = 17, n = 500 * Z.scale, i = r;
            L.spring({
                tension: e,
                friction: t,
                maxSpeed: n,
                restDelta: .1,
                restSpeed: .1,
                velocity: i
            });
        } else e === $d05bed9ea06f74d2$export$9520bccbaf78266.Pan || f ? L.spring({
            tension: 750,
            friction: 17,
            restDelta: .01,
            restSpeed: .01,
            maxSpeed: 1
        }) : L.spring({
            tension: 170,
            friction: 17,
            restDelta: .001,
            restSpeed: .001,
            maxSpeed: 1 / 0,
            velocity: r
        });
        e === $d05bed9ea06f74d2$export$9520bccbaf78266.Reset && 0 === t.velocity ? F = Object.assign({}, Z) : L.from(F).to(Z).start(), I("action", e);
    }
    function ie() {
        if (!M || !E) return;
        if (E instanceof HTMLImageElement) {
            const { width: e, height: t } = $();
            M.style.maxWidth = `min(${e}px, 100%)`, M.style.maxHeight = `min(${t}px, 100%)`;
        }
        let { x: e, y: t, scale: n, angle: i, flipX: o, flipY: a } = F;
        const s = function() {
            const e = q(), t = e.width, n = e.height, { width: i, height: o } = $();
            if (!c) return {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                scale: 0,
                flipX: 0,
                flipY: 0,
                angle: 0,
                fitWidth: t,
                fitHeight: n,
                fullWidth: i,
                fullHeight: o
            };
            let { x: a, y: s, scale: l, angle: r, flipX: u, flipY: f } = F, d = 1 / J(), g = i, h = o, m = F.scale * d, p = Z.scale * d;
            const v = Math.max(t, n), b = Math.min(t, n);
            i > o ? (g = v, h = b) : (g = b, h = v);
            m = i > o ? v * l / i || 1 : v * l / o || 1;
            let y = g ? i * p : 0, x = h ? o * p : 0;
            return a = a + .5 * g - .5 * y, s = s + .5 * h - .5 * x, {
                x: a,
                y: s,
                width: y,
                height: x,
                scale: g && h ? i * m / y : 0,
                flipX: u,
                flipY: f,
                angle: r,
                fitWidth: t,
                fitHeight: n,
                fullWidth: i,
                fullHeight: o
            };
        }();
        if (M && s) {
            const { x: e, y: t, width: n, height: o, scale: a, flipX: l, flipY: r } = s;
            let c = `translate(${$d05bed9ea06f74d2$var$d(e)}px, ${$d05bed9ea06f74d2$var$d(t)}px)`;
            c += 1 !== l || 1 !== r ? ` scaleX(${$d05bed9ea06f74d2$var$d(a * l)}) scaleY(${$d05bed9ea06f74d2$var$d(a * r)})` : ` scale(${$d05bed9ea06f74d2$var$d(a)})`, 0 !== i && (c += ` rotate(${i}deg)`), T && (T.style.width = `${$d05bed9ea06f74d2$var$d(n)}px`, T.style.height = `${$d05bed9ea06f74d2$var$d(o)}px`, T.style.transform = `${c}`);
        }
        I("render");
    }
    function oe() {
        let e = Z.scale;
        const t = Y("clickAction");
        let n = U();
        if (t) {
            let i = [];
            switch(t){
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ZoomIn:
                    n = 2 * e;
                    break;
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ZoomOut:
                    n = .5 * e;
                    break;
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ToggleCover:
                    i = [
                        U(),
                        G()
                    ];
                    break;
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ToggleFull:
                    i = [
                        U(),
                        J()
                    ];
                    break;
                case $d05bed9ea06f74d2$export$9520bccbaf78266.ToggleMax:
                    i = [
                        U(),
                        K()
                    ];
                    break;
                case $d05bed9ea06f74d2$export$9520bccbaf78266.IterateZoom:
                    i = [
                        U(),
                        J(),
                        K()
                    ];
                    break;
                case $d05bed9ea06f74d2$export$9520bccbaf78266.Zoom:
                    const t1 = J();
                    n = e >= t1 - .05 ? U() : Math.min(t1, 2 * e);
            }
            if (i.length) {
                const t = i.findIndex((t)=>t > e + 1e-4);
                n = i[t] || U();
            }
        }
        return n = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(V(), n, K()), n;
    }
    function ae() {
        return 3 === A && oe() > Z.scale;
    }
    function se() {
        return 3 === A && oe() < Z.scale;
    }
    function le() {
        return 3 === A && Z.scale < K();
    }
    function re() {
        return 3 === A && Z.scale > V();
    }
    function ce() {
        return 3 === A && fe() && !!k && !_();
    }
    function ue() {
        return 3 === A && (null == k ? void 0 : k.isPointerDown()) && !_();
    }
    function fe() {
        return 3 === A && Z.scale > U();
    }
    function de() {
        return 3 === A && Z.scale >= J();
    }
    const ge = {
        canDrag: ce,
        canZoomIn: le,
        canZoomOut: re,
        destroy: function() {
            I("destroy");
            for (const e of Object.values(S))null == e || e.destroy(ge);
            for (const e of X)e();
            return M && (M.style.aspectRatio = "", M.style.maxWidth = "", M.style.maxHeight = ""), T && (T.style.width = "", T.style.height = "", T.style.transform = ""), M = void 0, E = void 0, T = void 0, F = Object.assign({}, $d05bed9ea06f74d2$export$15463f5204f2871f), Z = Object.assign({}, $d05bed9ea06f74d2$export$15463f5204f2871f), null == L || L.destroy(), L = void 0, null == k || k.destroy(), k = void 0, A = 4, ge;
        },
        emit: I,
        execute: ne,
        getBoundaries: Q,
        getContainer: function() {
            return c;
        },
        getFullDim: $,
        getGestures: function() {
            return k;
        },
        getMousemovePos: B,
        getOptions: function() {
            return C;
        },
        getScale: N,
        getState: function() {
            return A;
        },
        getTransform: function(e) {
            return !0 === e ? Z : F;
        },
        getTween: function() {
            return L;
        },
        getViewport: function() {
            return T;
        },
        getWrapper: function() {
            return M;
        },
        init: function() {
            return A = 0, I("init"), function() {
                for (const [e, t] of Object.entries(Object.assign(Object.assign({}, w), C.plugins || {})))if (e && !S[e] && t instanceof Function) {
                    const n = t();
                    n.init(ge), S[e] = n;
                }
                I("initPlugins");
            }(), function() {
                if (!c) return;
                const e = Object.assign(Object.assign({}, $d05bed9ea06f74d2$var$p.classes), Y("classes"));
                if ((0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(c, e.container), E = c.querySelector("." + e.content), !E) return;
                E.setAttribute("draggable", "false"), M = c.querySelector("." + e.wrapper), M || (M = document.createElement("div"), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(M, e.wrapper), E.insertAdjacentElement("beforebegin", M), M.insertAdjacentElement("afterbegin", E));
                if (!(E instanceof HTMLImageElement || E instanceof HTMLPictureElement)) return;
                if (T = c.querySelector("." + e.viewport), !T) {
                    T = document.createElement("div"), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(T, e.viewport);
                    const t = E.cloneNode(!0);
                    t.classList.remove("is-lazyloading"), t.classList.remove("is-lazyloaded"), T.insertAdjacentElement("afterbegin", t), M.insertAdjacentElement("beforeend", T);
                }
                E instanceof HTMLPictureElement && (E = E.querySelector("img"));
                T instanceof HTMLPictureElement && (T = T.querySelector("img"));
                if (T.style.visibility = "hidden", Y("protected")) {
                    T.addEventListener("contextmenu", (e)=>{
                        e.preventDefault();
                    });
                    const e = document.createElement("div");
                    (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(e, "f-panzoom__protected"), T.appendChild(e);
                }
                I("initLayout");
            }(), function() {
                if (!c || !(E && E instanceof HTMLImageElement)) return;
                A = 1, c.classList.add("is-loading"), I("loading");
                const e = ()=>{
                    E && E instanceof HTMLImageElement && E.decode().then(()=>{
                        requestAnimationFrame(()=>{
                            W();
                        });
                    }).catch(()=>{
                        W();
                    });
                };
                if (E.src && E.complete) return void e();
                (function() {
                    if (!c) return;
                    if (null == c ? void 0 : c.querySelector(".f-spinner")) return;
                    const e = Y("spinnerTpl"), t = (0, $8a814a110db3ad66$export$b368690db5627d91)(e);
                    t && (t.classList.add("f-spinner"), c.classList.add("is-loading"), null == M || M.insertAdjacentElement("afterbegin", t));
                })(), E.addEventListener("load", e, !1), E.addEventListener("error", e, !1), X.push(()=>{
                    null == E || E.removeEventListener("load", e, !1), null == E || E.removeEventListener("error", e, !1);
                });
            }(), function() {
                if (c && M && !j) {
                    let e = null;
                    j = new ResizeObserver(()=>{
                        e || (e = requestAnimationFrame(()=>{
                            c && c.parentElement && 3 === A && (te(), ee(), I("refresh")), e = null;
                        }));
                    }), j.observe(M), X.push(()=>{
                        null == j || j.disconnect(), j = void 0, e && (cancelAnimationFrame(e), e = null);
                    });
                }
            }(), ge;
        },
        isDragging: ue,
        isExpanded: fe,
        isFullsize: de,
        localize: function(e, t = []) {
            const n = Y("l10n") || {};
            e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t)=>n[t] || e);
            for(let n = 0; n < t.length; n++)e = e.split(t[n][0]).join(t[n][1]);
            return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
        },
        off: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])P.has(n) && P.set(n, P.get(n).filter((e)=>e !== t));
            return ge;
        },
        on: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])P.set(n, [
                ...P.get(n) || [],
                t
            ]);
            return ge;
        },
        version: "6.0.26",
        willZoomIn: ae,
        willZoomOut: se
    };
    return ge;
};
$d05bed9ea06f74d2$export$b704d075ddd20210.l10n = {
    en_EN: (0, $2a547cbb739153ad$export$30568d076ec2f42)
}, $d05bed9ea06f74d2$export$b704d075ddd20210.getDefaults = ()=>$d05bed9ea06f74d2$var$p;


/*! License details at fancyapps.com/license */ 



/*! License details at fancyapps.com/license */ const $5c81ea22da36f72d$export$2b0209f2592da03b = (e, o)=>{
    let t = [];
    return e.childNodes.forEach((e)=>{
        e.nodeType !== Node.ELEMENT_NODE || o && !e.matches(o) || t.push(e);
    }), t;
};


/*! License details at fancyapps.com/license */ 
const $d183dc8f1ac8b27e$export$8b58be045bf06082 = (t, ...e)=>{
    const n = e.length;
    for(let c = 0; c < n; c++){
        const n = e[c] || {};
        Object.entries(n).forEach(([e, n])=>{
            const c = Array.isArray(n) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: c
            }), (0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(n) ? Object.assign(t[e], $d183dc8f1ac8b27e$export$8b58be045bf06082(t[e], n)) : Array.isArray(n) ? Object.assign(t, {
                [e]: [
                    ...n
                ]
            }) : Object.assign(t, {
                [e]: n
            });
        });
    }
    return t;
};


/*! License details at fancyapps.com/license */ 
const $f4b601cd4abee47d$export$871de8747c9eaa88 = function(t = 0, n = 0, r = 0, c = 0, m = 0, p = !1) {
    const s = (t - n) / (r - n) * (m - c) + c;
    return p ? c < m ? (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(c, s, m) : (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(m, s, c) : s;
};





/*! License details at fancyapps.com/license */ const $0139cdb5d63893b2$export$c2255604a80b4506 = (s, t = "")=>{
    s && s.classList && t.split(" ").forEach((t)=>{
        t && s.classList.remove(t);
    });
};


/*! License details at fancyapps.com/license */ const $6148d53608c1432f$export$4a80062ca50b57c7 = (s, t = "", c)=>{
    s && s.classList && t.split(" ").forEach((t)=>{
        t && s.classList.toggle(t, c || !1);
    });
};




/*! License details at fancyapps.com/license */ 
const $ff9fa40b857caa63$export$30568d076ec2f42 = Object.assign(Object.assign({}, (0, $2a547cbb739153ad$export$30568d076ec2f42)), {
    ERROR: "Something went wrong. <br /> Please try again later.",
    NEXT: "Next page",
    PREV: "Previous page",
    GOTO: "Go to page #%d",
    DOWNLOAD: "Download",
    TOGGLE_FULLSCREEN: "Toggle full-screen mode",
    TOGGLE_EXPAND: "Toggle full-size mode",
    TOGGLE_THUMBS: "Toggle thumbnails",
    TOGGLE_AUTOPLAY: "Toggle slideshow"
});


const $9b8ac375a20c1e65$var$g = (e)=>{
    e.cancelable && e.preventDefault();
}, $9b8ac375a20c1e65$var$m = {
    adaptiveHeight: !1,
    center: !0,
    classes: {
        container: "f-carousel",
        isEnabled: "is-enabled",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        hasAdaptiveHeight: "has-adaptive-height",
        viewport: "f-carousel__viewport",
        slide: "f-carousel__slide",
        isSelected: "is-selected"
    },
    dragFree: !1,
    enabled: !0,
    errorTpl: '<div class="f-html">{{ERROR}}</div>',
    fill: !1,
    infinite: !0,
    initialPage: 0,
    l10n: (0, $ff9fa40b857caa63$export$30568d076ec2f42),
    rtl: !1,
    slides: [],
    slidesPerPage: "auto",
    spinnerTpl: '<div class="f-spinner"></div>',
    transition: "fade",
    tween: {
        clamp: !0,
        mass: 1,
        tension: 160,
        friction: 25,
        restDelta: 1,
        restSpeed: 1,
        velocity: 0
    },
    vertical: !1
};
let $9b8ac375a20c1e65$var$h, $9b8ac375a20c1e65$var$b = 0;
const $9b8ac375a20c1e65$export$144901db2ea8e967 = (p, x = {}, y = {})=>{
    $9b8ac375a20c1e65$var$b++;
    let w, M, S, j, P, L = 0, A = Object.assign({}, $9b8ac375a20c1e65$var$m), T = Object.assign({}, $9b8ac375a20c1e65$var$m), O = {}, R = null, V = null, C = !1, H = !1, D = !1, $ = !1, z = "height", q = 0, F = !0, I = 0, k = 0, B = 0, N = 0, _ = "*", G = [], X = [];
    const Y = new Set;
    let W = [], J = [], K = 0, Q = 0, U = 0;
    function Z(e, ...t) {
        let n = T[e];
        return n && n instanceof Function ? n(He, ...t) : n;
    }
    function ee(e, t = []) {
        const n = Z("l10n") || {};
        e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t)=>n[t] || e);
        for(let n = 0; n < t.length; n++)e = e.split(t[n][0]).join(t[n][1]);
        return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
    }
    const te = new Map;
    function ne(e, ...t) {
        const n = [
            ...te.get(e) || []
        ];
        T.on && n.push(T.on[e]);
        for (const e of n)e && e instanceof Function && e(He, ...t);
        "*" !== e && ne("*", e, ...t);
    }
    function ie() {
        var t, n;
        const i = (0, $d183dc8f1ac8b27e$export$8b58be045bf06082)({}, $9b8ac375a20c1e65$var$m, A);
        (0, $d183dc8f1ac8b27e$export$8b58be045bf06082)(i, $9b8ac375a20c1e65$var$m, A);
        let r = "";
        const l = A.breakpoints || {};
        if (l) for (const [e, t] of Object.entries(l))window.matchMedia(e).matches && (r += e, (0, $d183dc8f1ac8b27e$export$8b58be045bf06082)(i, t));
        if (void 0 === P || r !== P) {
            if (P = r, 0 !== L) {
                let e = null === (n = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === n ? void 0 : n.index;
                void 0 === e && (e = T.initialSlide), i.initialSlide = e, i.slides = [];
                for (const e of G)e.isVirtual && i.slides.push(e);
            }
            Re(), T = i, !1 !== T.enabled && (L = 0, ne("init"), function() {
                for (const [e, t] of Object.entries(Object.assign(Object.assign({}, y), T.plugins || {})))if (e && !O[e] && t instanceof Function) {
                    const n = t();
                    n.init(He, $9b8ac375a20c1e65$export$144901db2ea8e967), O[e] = n;
                }
                ne("initPlugins");
            }(), function() {
                if (!R) return;
                const t = Z("classes") || {};
                (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(R, t.container);
                const n = Z("style");
                if (n && (0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(n)) for (const [e, t] of Object.entries(n))R.style.setProperty(e, t);
                V = R.querySelector(`.${t.viewport}`), V || (V = document.createElement("div"), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(V, t.viewport), V.append(...(0, $5c81ea22da36f72d$export$2b0209f2592da03b)(R, `.${t.slide}`)), R.insertAdjacentElement("afterbegin", V)), R.carousel = He, ne("initLayout");
            }(), function() {
                if (!V) return;
                const e = Z("classes") || {};
                G = [], [
                    ...(0, $5c81ea22da36f72d$export$2b0209f2592da03b)(V, `.${e.slide}`)
                ].forEach((e)=>{
                    e.parentElement && G.push(me(Object.assign({
                        el: e,
                        isVirtual: !1
                    }, e.dataset || {})));
                }), ge(Z("slides"));
                for (const e of G)ne("addSlide", e);
                for (const e of G){
                    const t = e.el;
                    (null == t ? void 0 : t.parentElement) && ((0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(t, T.classes.slide), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(t, e.class), Ae(e), ne("attachSlideEl", e));
                }
                ne("initSlides");
            }(), ye(), function() {
                if (R && (R.addEventListener("click", je, {
                    passive: !1
                }), document.addEventListener("mousemove", oe), !S)) {
                    let e = null;
                    S = new ResizeObserver((t)=>{
                        e || (e = requestAnimationFrame(()=>{
                            !function(e) {
                                var t;
                                if (!R) return;
                                if (0 === L) {
                                    const n = null === (t = e[0]) || void 0 === t ? void 0 : t.contentBoxSize[0], i = (null == n ? void 0 : n.blockSize) || 0, o = (null == n ? void 0 : n.inlineSize) || 0;
                                    return K = i, Q = o, L = 1, (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(R, (Z("classes") || {}).isEnabled), Oe(), M = (0, $4397b247ae6d78b1$export$208a41d6b4e37b97)().on("start", ()=>{
                                        w && w.isPointerDown() || (le(), Oe());
                                    }).on("step", (e)=>{
                                        const t = q;
                                        q = e.pos, q !== t && (F = !1, Oe());
                                    }).on("end", (e)=>{
                                        (null == w ? void 0 : w.isPointerDown()) || (q = e.pos, M && !H && (q < B || q > N) ? M.spring({
                                            clamp: !0,
                                            mass: 1,
                                            tension: 200,
                                            friction: 25,
                                            velocity: 0,
                                            restDelta: 1,
                                            restSpeed: 1
                                        }).from({
                                            pos: q
                                        }).to({
                                            pos: (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(B, q, N)
                                        }).start() : F || (F = !0, ne("settle")));
                                    }), se(), ae(), void ne("ready");
                                }
                                if (1 !== L) return;
                                const n = J.length;
                                ye(), se();
                                const i = R.getBoundingClientRect(), o = i.height, s = i.width;
                                n > 1 && ($ && Math.abs(o - K) < .5 || !$ && Math.abs(s - Q) < .5) || (K = o, Q = s, $ && !o || !$ && !s || R && V && (n === J.length && (null == w ? void 0 : w.isPointerDown()) || (Z("dragFree") && (H || q > B && q < N) ? (le(), Oe()) : Te(I, {
                                    transition: !1
                                }))));
                            }(t), e = null;
                        }));
                    }), S.observe(R);
                }
            }());
        }
    }
    function oe(e) {
        $9b8ac375a20c1e65$var$h = e;
    }
    function se() {
        if (!V) return;
        const e = Z("gestures");
        !1 !== e ? w || (w = (0, $d1d67bf17d8c2ed0$export$1f911e2d31b2843e)(V, e).on("start", (e)=>{
            var t, n;
            if (!M) return;
            const { srcEvent: o } = e;
            $ && (0, $af9ab31d2acb78ba$export$e41e80160bed5714)(o.target), M.pause(), M.getCurrentVelocities().pos = 0;
            const s = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0];
            if (s && Y.has(s.index) && s.el && (q = s.offset || 0, q += (function(e) {
                const t = window.getComputedStyle(e), n = new DOMMatrixReadOnly(t.transform);
                return {
                    width: n.m41 || 0,
                    height: n.m42 || 0
                };
            }(s.el)[z] || 0) * (D && !$ ? 1 : -1)), Me(), !H) (q < B || q > N) && M.spring({
                clamp: !0,
                mass: 1,
                tension: 500,
                friction: 25,
                velocity: (null === (n = M.getCurrentVelocities()) || void 0 === n ? void 0 : n.pos) || 0,
                restDelta: 1,
                restSpeed: 1
            }).from({
                pos: q
            }).to({
                pos: (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(B, q, N)
            }).start();
        }).on("move", (e)=>{
            const { srcEvent: t, axis: n } = e, o = e.srcEvent.target;
            o && (0, $af9ab31d2acb78ba$export$e41e80160bed5714)(o) || (n || (t.stopPropagation(), t.stopImmediatePropagation()), ("y" === n && $ || "x" === n && !$) && ($9b8ac375a20c1e65$var$g(t), t.stopPropagation()));
        }).on("panstart", (e)=>{
            (null == e ? void 0 : e.axis) === ($ ? "y" : "x") && (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(V, "is-dragging");
        }).on("panend", ()=>{
            (0, $0139cdb5d63893b2$export$c2255604a80b4506)(V, "is-dragging");
        }).on("pan", (e)=>{
            var t;
            const { deltaX: n, deltaY: i, currentTouch: o, axis: s } = e;
            if (!M) return;
            if (o.length > 1) return;
            if ("y" === s && !$ || "x" === s && $) return;
            const r = D && !$ ? 1 : -1;
            let l = $ ? i : n, a = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q, c = 1;
            H || (a <= B && l * r < 0 ? (c = Math.max(.01, 1 - Math.abs(1 / fe() * Math.abs(a - B))), c *= .2) : a >= N && l * r > 0 && (c = Math.max(.01, 1 - Math.abs(1 / fe() * Math.abs(a - N))), c *= .2)), a += l * c * r, M.spring({
                clamp: !0,
                mass: 1,
                tension: 700,
                friction: 25,
                velocity: (null === (t = M.getCurrentVelocities()) || void 0 === t ? void 0 : t.pos) || 0,
                restDelta: 1,
                restSpeed: 1
            }).from({
                pos: q
            }).to({
                pos: a
            }).start();
        }).on("end", (e)=>{
            var t, n;
            const { axis: i, velocityX: o, velocityY: s, currentTouch: r } = e, l = J.length, c = Z("dragFree");
            if (r.length > 0 || !M) return;
            if (!l) return;
            const d = Z("vertical") ? s : o;
            let u = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q;
            const f = D && !$ ? 1 : -1;
            if (u += d * (c ? 5 : 1) * f, !H && (d * f <= 0 && u < B || d * f >= 0 && u > N)) {
                let e = 0;
                return Math.abs(d) > 0 && (e = 2 * Math.abs(d), e = Math.min(.3 * fe(), e)), u = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(B + -1 * e, u, N + e), void M.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 380,
                    friction: 25,
                    velocity: -1 * d,
                    restDelta: 1,
                    restSpeed: 1
                }).from({
                    pos: q
                }).to({
                    pos: u
                }).start();
            }
            if (c || (null === (t = O.Autoscroll) || void 0 === t ? void 0 : t.isEnabled())) return void (Math.abs(d) > 10 ? M.spring({
                clamp: !0,
                mass: 1,
                tension: 150,
                friction: 25,
                velocity: -1 * d,
                restDelta: 1,
                restSpeed: 1
            }).from({
                pos: q
            }).to({
                pos: u
            }).start() : M.isRunning() || F || (F = !0, ne("settle")));
            if (!c && !(null === (n = O.Autoscroll) || void 0 === n ? void 0 : n.isEnabled()) && (!e.offsetX && !e.offsetY || "y" === i && !$ || "x" === i && $)) return void Te(I, {
                transition: "tween"
            });
            let v = de(u);
            Math.abs(d) > 10 && v === I && (v += d > 0 ? D && !$ ? 1 : -1 : D && !$ ? -1 : 1), Te(v, {
                transition: "tween",
                tween: {
                    velocity: -1 * d
                }
            });
        }).init()) : w && (w.destroy(), w = void 0);
    }
    function re(e = "*") {
        var t;
        const n = [];
        for (const i of G)("*" === e || i.class && i.class.includes(e) || i.el && (null === (t = i.el) || void 0 === t ? void 0 : t.classList.contains(e))) && n.push(i);
        j = void 0, _ = e, X = [
            ...n
        ];
    }
    function le() {
        if (!M) return;
        const e = de((null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q);
        e !== I && (j = I, I = e, Ae(), ae(), ce(), ne("change", I, j));
    }
    function ae() {
        var e;
        if (!R) return;
        (0, $6148d53608c1432f$export$4a80062ca50b57c7)(V, "is-draggable", !!w && J.length > 0);
        for (const e of R.querySelectorAll("[data-carousel-index]"))e.innerHTML = I + "";
        for (const e of R.querySelectorAll("[data-carousel-page]"))e.innerHTML = I + 1 + "";
        for (const e of R.querySelectorAll("[data-carousel-pages]"))e.innerHTML = J.length + "";
        for (const e of R.querySelectorAll("[data-carousel-go-prev]"))e.toggleAttribute("aria-disabled", !Ve());
        for (const e of R.querySelectorAll("[data-carousel-go-next]"))e.toggleAttribute("aria-disabled", !Ce());
        let t = !1;
        const n = null === (e = J[I]) || void 0 === e ? void 0 : e.slides[0];
        n && (n.downloadSrc || "image" === n.type && n.src) && (t = !0);
        for (const e of R.querySelectorAll("[data-carousel-download]"))e.toggleAttribute("aria-disabled", !t);
    }
    function ce(e) {
        var t;
        if (!R) return;
        e || (e = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0]);
        const n = e.el;
        if (n) for (const t of n.querySelectorAll("[data-slide-index]"))t.innerHTML = e.index + 1 + "";
    }
    function de(e) {
        var t, n, i;
        if (!J.length || !M) return 0;
        const o = ve();
        let s = e;
        H ? s -= Math.floor((e - (null === (t = J[0]) || void 0 === t ? void 0 : t.pos)) / o) * o : s = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(null === (n = J[0]) || void 0 === n ? void 0 : n.pos, e, null === (i = J[J.length - 1]) || void 0 === i ? void 0 : i.pos);
        const r = new Map;
        let l = 0;
        for (const e of J){
            const t = Math.abs(e.pos - s), n = Math.abs(e.pos - s - o), i = Math.abs(e.pos - s + o), a = Math.min(t, n, i);
            r.set(l, a), l++;
        }
        const c = r.size > 0 ? [
            ...r.entries()
        ].reduce((e, t)=>t[1] < e[1] ? t : e) : [
            I,
            0
        ];
        return parseInt(c[0]);
    }
    function ue() {
        return U;
    }
    function fe() {
        return V && V.getBoundingClientRect()[z] || 0;
    }
    function ve(e = !0) {
        return X.reduce((e, t)=>e + t.dim, 0) + (X.length - (H && e ? 0 : 1)) * U;
    }
    function pe(e) {
        const t = ve();
        let n = fe();
        if (!V) return [];
        const i = [];
        if (!t || !n) return [];
        e = void 0 === e ? q : e, H && (e -= Math.floor(e / t) * t);
        let o = 0, s = 0;
        if (C) {
            const e = V.getBoundingClientRect();
            o = Math.abs(e.left), s = Math.abs(window.innerWidth - e.right);
        }
        let r = 0;
        for (let l of X){
            const a = (t = 0)=>{
                i.indexOf(l) > -1 || (l.pos = r - e + t || 0, l.offset + t > e - l.dim - o + .51 && l.offset + t < e + n + s - .51 && i.push(l));
            };
            l.offset = r, H && (a(t), a(-1 * t)), a(), r += l.dim + U;
        }
        return i;
    }
    function ge(e, t) {
        const n = [];
        for (const t of Array.isArray(e) ? e : [
            e
        ]){
            const e = me(Object.assign(Object.assign({}, t), {
                isVirtual: !0
            }));
            n.push(e);
        }
        G.splice(void 0 === t ? G.length : t, 0, ...n), xe();
        for (const e of n)he(e);
        return re(_), n;
    }
    function me(e) {
        return ((0, $bc360f0f1dfbc749$export$844ec244b1367d54)(e) || e instanceof HTMLElement) && (e = {
            html: e
        }), Object.assign({
            index: -1,
            el: void 0,
            class: "",
            isVirtual: !0,
            dim: 0,
            pos: 0,
            offset: 0,
            html: "",
            src: ""
        }, e);
    }
    function he(e) {
        if (!e) return;
        let t = e.el;
        t || (t = document.createElement("div"), e.el = t);
        const n = e.html ? e.html instanceof HTMLElement ? e.html : (0, $8a814a110db3ad66$export$b368690db5627d91)(e.html) : void 0;
        n && ((0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(n, "f-html"), e.htmlEl = n, (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(t, "has-html"), t.append(n), ne("contentReady", e));
    }
    function be(e) {
        if (!V || !e) return;
        let t = e.el;
        if (t) {
            if (t.setAttribute("index", e.index + ""), t.parentElement !== V) {
                let n;
                (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(t, T.classes.slide), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(t, e.class), Ae(e);
                for (const t of G)if (t.index > e.index) {
                    n = t.el;
                    break;
                }
                V.insertBefore(t, n && V.contains(n) ? n : null), ne("attachSlideEl", e);
            }
            return t;
        }
    }
    function Ee(e) {
        const t = null == e ? void 0 : e.el;
        t && (t.remove(), we(t), ne("detachSlideEl", e));
    }
    function xe() {
        for(let e = 0; e < G.length; e++){
            const t = G[e], n = t.el;
            n && (t.index !== e && we(n), n.setAttribute("index", `${e}`)), t.index = e;
        }
    }
    function ye() {
        var e, n, i, o, s;
        if (!R || !V) return;
        D = Z("rtl"), $ = Z("vertical"), z = $ ? "height" : "width";
        const r = Z("classes");
        (0, $6148d53608c1432f$export$4a80062ca50b57c7)(R, r.isLTR, !D), (0, $6148d53608c1432f$export$4a80062ca50b57c7)(R, r.isRTL, D), (0, $6148d53608c1432f$export$4a80062ca50b57c7)(R, r.isHorizontal, !$), (0, $6148d53608c1432f$export$4a80062ca50b57c7)(R, r.isVertical, $), (0, $6148d53608c1432f$export$4a80062ca50b57c7)(R, r.hasAdaptiveHeight, Z("adaptiveHeight")), C = "visible" === window.getComputedStyle(V).getPropertyValue("overflow-" + ($ ? "y" : "x"));
        const l = V.getBoundingClientRect();
        if (!l.width && !l.height) return;
        U = V && parseFloat(getComputedStyle(V).getPropertyValue("--f-carousel-gap")) || 0;
        const d = function() {
            let e = 0;
            if (V) {
                let t = document.createElement("div");
                (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(t, T.classes.slide), V.appendChild(t), e = t.getBoundingClientRect()[z], t.remove(), t = void 0;
            }
            return e;
        }();
        for (const n of X){
            const i = n.el;
            let o = 0;
            if (!n.isVirtual && i && (0, $556b1b852427b8a8$export$8ee0fc9ee280b4ee)(i)) {
                let t = !1;
                i.parentElement && i.parentElement === V || (V.appendChild(i), t = !0), o = i.getBoundingClientRect()[z], t && (null === (e = i.parentElement) || void 0 === e || e.removeChild(i));
            } else o = d;
            n.dim = o;
        }
        if (H = !1, Z("infinite")) {
            H = !0;
            const e = ve();
            let t = fe();
            if (C) {
                const e = V.getBoundingClientRect();
                t += e.left, t += e.right - e.width;
            }
            for(let i = 0; i < X.length; i++){
                const o = (null === (n = X[i]) || void 0 === n ? void 0 : n.dim) + U;
                if (e - o < t && e - o - t < o) {
                    H = !1;
                    break;
                }
            }
        }
        if (function() {
            var e;
            if (!R) return;
            xe();
            const t = fe(), n = ve(!1);
            let i = Z("slidesPerPage");
            i = "auto" === i ? 1 / 0 : parseFloat(i + ""), J = [];
            let o = 0, s = 0;
            for (const n of X)(!J.length || o + n.dim - t > .05 || s >= i) && (J.push({
                index: J.length,
                slides: [],
                dim: 0,
                offset: 0,
                pos: 0
            }), o = 0, s = 0), null === (e = J[J.length - 1]) || void 0 === e || e.slides.push(n), o += n.dim + U, s++;
            const r = Z("center"), l = Z("fill");
            let c = 0;
            for (const e of J){
                e.dim = (e.slides.length - 1) * U;
                for (const t of e.slides)e.dim += t.dim;
                e.offset = c, e.pos = c, !1 !== r && (e.pos -= .5 * (t - e.dim)), l && !H && n > t && (e.pos = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(0, e.pos, n - t)), c += e.dim + U;
            }
            const d = [];
            let u;
            for (const e of J){
                const t = Object.assign({}, e);
                u && t.pos === u.pos ? (u.dim += t.dim, u.slides = [
                    ...u.slides,
                    ...t.slides
                ]) : (u = t, t.index = d.length, d.push(t));
            }
            J = d, ae();
        }(), B = (null === (i = J[0]) || void 0 === i ? void 0 : i.pos) || 0, N = (null === (o = J[J.length - 1]) || void 0 === o ? void 0 : o.pos) || 0, 0 === L) !function() {
            var e;
            j = void 0, I = Z("initialPage");
            const t = Z("initialSlide") || void 0;
            void 0 !== t && (I = He.getPageIndex(t) || 0), I = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(0, I, J.length - 1), q = (null === (e = J[I]) || void 0 === e ? void 0 : e.pos) || 0, k = q;
        }();
        else {
            const e = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q;
            (e < B || e > N) && (I = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(0, I, J.length - 1), k = (null === (s = J[I || 0]) || void 0 === s ? void 0 : s.pos) || 0);
        }
        ne("refresh");
    }
    function we(e) {
        if (!e || !(0, $556b1b852427b8a8$export$8ee0fc9ee280b4ee)(e)) return;
        const n = parseInt(e.getAttribute("index") || "-1");
        let i = "";
        for (const t of Array.from(e.classList)){
            const e = t.match(/^f-(\w+)(Out|In)$/);
            e && e[1] && (i = e[1] + "");
        }
        if (!e || !i) return;
        const o = [
            `f-${i}Out`,
            `f-${i}In`,
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        e.removeEventListener("animationend", Se), (0, $0139cdb5d63893b2$export$c2255604a80b4506)(e, o.join(" ")), Y.delete(n);
    }
    function Me() {
        if (!V) return;
        const e = Y.size;
        for (const e of X)we(e.el);
        Y.clear(), e && Oe();
    }
    function Se(e) {
        "f-" === e.animationName.substring(0, 2) && (we(e.target), Y.size || ((0, $0139cdb5d63893b2$export$c2255604a80b4506)(R, "in-transition"), !F && Math.abs(He.getPosition(!0) - k) < .5 && (F = !0, ne("settle"))), Oe());
    }
    function je(e) {
        var t;
        if (e.defaultPrevented) return;
        const n = e.composedPath()[0];
        if (n.closest("[data-carousel-go-prev]")) return $9b8ac375a20c1e65$var$g(e), void He.prev();
        if (n.closest("[data-carousel-go-next]")) return $9b8ac375a20c1e65$var$g(e), void He.next();
        const i = n.closest("[data-carousel-go-to]");
        if (i) return $9b8ac375a20c1e65$var$g(e), void He.goTo(parseFloat(i.dataset.carouselGoTo || "") || 0);
        if (n.closest("[data-carousel-download]")) {
            $9b8ac375a20c1e65$var$g(e);
            const n = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0];
            if (n && (n.downloadSrc || "image" === n.type && n.src)) {
                const e = n.downloadFilename, t = document.createElement("a"), i = n.downloadSrc || n.src || "";
                t.href = i, t.target = "_blank", t.download = e || i, t.click();
            }
        } else ne("click", e);
    }
    function Pe(e) {
        var t;
        const n = e.el;
        n && (null === (t = n.querySelector(".f-spinner")) || void 0 === t || t.remove());
    }
    function Le(e) {
        var t;
        const n = e.el;
        n && (null === (t = n.querySelector(".f-html.is-error")) || void 0 === t || t.remove(), (0, $0139cdb5d63893b2$export$c2255604a80b4506)(n, "has-error"));
    }
    function Ae(e) {
        var t;
        e || (e = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0]);
        const i = null == e ? void 0 : e.el;
        if (!i) return;
        let o = Z("formatCaption", e);
        void 0 === o && (o = e.caption), o = o || "";
        const s = Z("captionEl");
        if (s && s instanceof HTMLElement) {
            if (e.index !== I) return;
            if ((0, $bc360f0f1dfbc749$export$844ec244b1367d54)(o) && (s.innerHTML = ee(o + "")), o instanceof HTMLElement) {
                if (o.parentElement === s) return;
                s.innerHTML = "", o.parentElement && (o = o.cloneNode(!0)), s.append(o);
            }
            return;
        }
        if (!o) return;
        let r = e.captionEl || i.querySelector(".f-caption");
        !r && o instanceof HTMLElement && o.classList.contains("f-caption") && (r = o), r || (r = document.createElement("div"), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(r, "f-caption"), (0, $bc360f0f1dfbc749$export$844ec244b1367d54)(o) ? r.innerHTML = ee(o + "") : o instanceof HTMLElement && (o.parentElement && (o = o.cloneNode(!0)), r.append(o)));
        const l = `f-caption-${$9b8ac375a20c1e65$var$b}_${e.index}`;
        r.setAttribute("id", l), r.dataset.selectable = "true", (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(i, "has-caption"), i.setAttribute("aria-labelledby", l), e.captionEl = r, i.insertAdjacentElement("beforeend", r);
    }
    function Te(t, i = {}) {
        var o, r;
        let { transition: l, tween: u } = Object.assign({
            transition: T.transition,
            tween: T.tween
        }, i || {});
        if (!R || !M) return;
        const f = J.length;
        if (!f) return;
        if (function(e, t) {
            var i, o, s, r;
            if (!(R && M && t && (0, $bc360f0f1dfbc749$export$844ec244b1367d54)(t) && "tween" !== t)) return !1;
            if ((null === (i = J[I]) || void 0 === i ? void 0 : i.slides.length) > 1) return !1;
            const l = J.length;
            let u = e > I ? 1 : -1;
            e = H ? (e % l + l) % l : (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(0, e, l - 1), D && (u *= -1);
            const f = null === (o = J[I]) || void 0 === o ? void 0 : o.slides[0], v = null == f ? void 0 : f.index, p = null === (s = J[e]) || void 0 === s ? void 0 : s.slides[0], g = null == p ? void 0 : p.index, m = null === (r = J[e]) || void 0 === r ? void 0 : r.pos;
            if (void 0 === g || void 0 === v || v === g || q === m || Math.abs(fe() - ((null == p ? void 0 : p.dim) || 0)) > 1) return !1;
            F = !1, M.pause(), Me(), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(R, "in-transition"), q = k = m;
            const h = be(f), b = be(p);
            return le(), h && (Y.add(v), h.style.transform = "", h.addEventListener("animationend", Se), (0, $0139cdb5d63893b2$export$c2255604a80b4506)(h, T.classes.isSelected), h.removeAttribute("aria-hidden"), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(h, `f-${t}Out to-${u > 0 ? "next" : "prev"}`)), b && (Y.add(g), b.style.transform = "", b.addEventListener("animationend", Se), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(b, T.classes.isSelected), b.removeAttribute("aria-hidden"), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(b, `f-${t}In from-${u > 0 ? "prev" : "next"}`)), Oe(), !0;
        }(t, l)) return;
        t = H ? (t % f + f) % f : (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(0, t, f - 1), k = (null === (o = J[t || 0]) || void 0 === o ? void 0 : o.pos) || 0;
        const v = M.isRunning() ? M.getEndValues().pos : q;
        if (Math.abs(k - v) < 1) return q = k, I !== t && (Ae(), ae(), ce(), j = I, I = t, ne("change", I, j)), Oe(), void (F || (F = !0, ne("settle")));
        if (M.pause(), Me(), H) {
            const e = ve(), t = Math.floor((v - (null === (r = J[0]) || void 0 === r ? void 0 : r.pos)) / e), n = k + t * e;
            k = [
                n + e,
                n,
                n - e
            ].reduce(function(e, t) {
                return Math.abs(t - v) < Math.abs(e - v) ? t : e;
            });
        }
        !1 !== l && (0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(u) ? M.spring((0, $d183dc8f1ac8b27e$export$8b58be045bf06082)({}, T.tween, u)).from({
            pos: q
        }).to({
            pos: k
        }).start() : (q = k, le(), Oe(), F || (F = !0, ne("settle")));
    }
    function Oe() {
        var e;
        if (!R || !V) return;
        const t = J[I];
        W = pe();
        const n = new Set;
        let i;
        const s = [];
        for (const o of X){
            if (o.isVirtual && !Y.has(o.index) && W.indexOf(o) < 0) continue;
            let r = be(o);
            if (!r) continue;
            s.push(o);
            const l = (null === (e = null == t ? void 0 : t.slides) || void 0 === e ? void 0 : e.indexOf(o)) > -1;
            if (l && n.add(r), Z("adaptiveHeight") && l) {
                const e = (r.firstElementChild || r).getBoundingClientRect().height;
                i = null == i ? e : Math.max(i, e);
            }
        }
        V && i && (V.style.height = `${i}px`), [
            ...(0, $5c81ea22da36f72d$export$2b0209f2592da03b)(V, `.${T.classes.slide}`)
        ].forEach((e)=>{
            const t = parseInt(e.getAttribute("index") || "-1"), i = G[t];
            i || e.remove();
            const o = n.has(e);
            if ((0, $6148d53608c1432f$export$4a80062ca50b57c7)(e, T.classes.isSelected, o), o ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", "true"), i.isVirtual && !Y.has(i.index) && W.indexOf(i) < 0) return void Ee(i);
            let s = i.pos ? Math.round(1e4 * i.pos) / 1e4 : 0, l = 0, a = 0, c = 0, d = 0, f = T.setTransform || void 0;
            Y.has(i.index) || (l = $ ? 0 : D ? -1 * s : s, a = $ ? s : 0, c = (0, $f4b601cd4abee47d$export$871de8747c9eaa88)(l, 0, i.dim, 0, 100), d = (0, $f4b601cd4abee47d$export$871de8747c9eaa88)(a, 0, i.dim, 0, 100)), f instanceof Function && !Y.has(i.index) ? f(He, i, {
                x: l,
                y: a,
                xPercent: c,
                yPercent: d
            }) : e.style.transform = l || a ? `translate3d(${c}%, ${d}%,0)` : "";
        }), ne("render", s);
    }
    function Re() {
        var e;
        null == R || R.removeEventListener("click", je), Me(), document.removeEventListener("mousemove", oe), null == S || S.disconnect(), S = void 0;
        for (const n of G)n.el && (0, $556b1b852427b8a8$export$8ee0fc9ee280b4ee)(n.el) && (n.state = void 0, Pe(n), Le(n), Ee(n), n.isVirtual ? (null === (e = n.el) || void 0 === e || e.remove(), n.el = void 0) : (n.el.style.transform = "", null == V || V.appendChild(n.el)));
        for (const e of Object.values(O))null == e || e.destroy();
        O = {}, null == w || w.destroy(), w = void 0, null == M || M.destroy(), M = void 0;
        for (const [e, t] of Object.entries(T.classes || {}))"container" !== e && (0, $0139cdb5d63893b2$export$c2255604a80b4506)(R, t);
        (0, $0139cdb5d63893b2$export$c2255604a80b4506)(V, "is-draggable");
    }
    function Ve() {
        return H || I > 0;
    }
    function Ce() {
        return H || I < J.length - 1;
    }
    const He = {
        add: function(e, t) {
            var n, i;
            let o = q;
            const s = I, r = ve(), l = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q, a = Math.floor((l - (null === (n = J[0]) || void 0 === n ? void 0 : n.pos)) / r), c = ge(e, t);
            for (const e of c)ne("addSlide", e);
            return re(_), ye(), M && (s === I && (o -= a * r), k = (null === (i = J[I || 0]) || void 0 === i ? void 0 : i.pos) || 0, o === k ? q = k : M.spring({
                clamp: !0,
                mass: 1,
                tension: 300,
                friction: 25,
                restDelta: 1,
                restSpeed: 1
            }).from({
                pos: o
            }).to({
                pos: k
            }).start()), Oe(), He;
        },
        canGoPrev: Ve,
        canGoNext: Ce,
        destroy: function() {
            return ne("destroy"), window.removeEventListener("resize", ie), Re(), te.clear(), R = null, J = [], G = [], T = Object.assign({}, $9b8ac375a20c1e65$var$m), O = {}, X = [], P = "", _ = "*", L = 2, He;
        },
        emit: ne,
        filter: function(e = "*") {
            return re(e), ye(), Oe(), ne("filter", e), He;
        },
        getContainer: function() {
            return R;
        },
        getGapDim: ue,
        getGestures: function() {
            return w;
        },
        getLastMouseMove: function() {
            return $9b8ac375a20c1e65$var$h;
        },
        getOption: function(e) {
            return Z(e);
        },
        getOptions: function() {
            return T;
        },
        getPage: function() {
            return J[I];
        },
        getPageIndex: function(e) {
            if (void 0 !== e) {
                for (const t of J || [])for (const n of t.slides)if (n.index === e) return t.index;
                return -1;
            }
            return I;
        },
        getPageProgress: function(e, t) {
            var n;
            void 0 === e && (e = I);
            const i = J[e];
            if (!i) return e > I ? -1 : 1;
            const o = ve(), s = ue();
            let r = i.pos, l = He.getPosition();
            if (H && !0 !== t) {
                const e = Math.floor((l - (null === (n = J[0]) || void 0 === n ? void 0 : n.pos)) / o);
                l -= e * o, r = [
                    r + o,
                    r,
                    r - o
                ].reduce(function(e, t) {
                    return Math.abs(t - l) < Math.abs(e - l) ? t : e;
                });
            }
            return (l - r) / (i.dim + s);
        },
        getPageVisibility: function(e) {
            var t;
            void 0 === e && (e = I);
            const n = J[e];
            if (!n) return e > I ? -1 : 1;
            const i = He.getPosition(), o = fe();
            let s = n.pos;
            if (H) {
                const e = He.getPosition(), n = ve(), i = s + Math.floor((e - (null === (t = J[0]) || void 0 === t ? void 0 : t.pos)) / n) * n;
                s = [
                    i + n,
                    i,
                    i - n
                ].reduce(function(t, n) {
                    return Math.abs(n - e) < Math.abs(t - e) ? n : t;
                });
            }
            return s > i && s + n.dim < i + o ? 1 : s < i ? (s + n.dim - i) / n.dim : s + n.dim > i + o ? (i + o - s) / n.dim : 0;
        },
        getPages: function() {
            return J;
        },
        getPlugins: function() {
            return O;
        },
        getPosition: function(e) {
            var t;
            let n = q;
            if (H && !0 !== e) {
                const e = ve();
                n -= Math.floor((q - (null === (t = J[0]) || void 0 === t ? void 0 : t.pos) || 0) / e) * e;
            }
            return n;
        },
        getSlides: function() {
            return G;
        },
        getState: function() {
            return L;
        },
        getTotalSlideDim: ve,
        getTween: function() {
            return M;
        },
        getViewport: function() {
            return V;
        },
        getViewportDim: fe,
        getVisibleSlides: function(e) {
            return void 0 === e ? W : pe(e);
        },
        goTo: Te,
        hasNavigated: function() {
            return void 0 !== j;
        },
        hideError: Le,
        hideLoading: Pe,
        init: function() {
            if (!p || !(0, $556b1b852427b8a8$export$8ee0fc9ee280b4ee)(p)) throw new Error("No Element found");
            return 0 !== L && (Re(), L = 0), R = p, A = x, window.removeEventListener("resize", ie), A.breakpoints && window.addEventListener("resize", ie), ie(), He;
        },
        isInfinite: function() {
            return H;
        },
        isInTransition: function() {
            return Y.size > 0;
        },
        isRTL: function() {
            return D;
        },
        isSettled: function() {
            return F;
        },
        isVertical: function() {
            return $;
        },
        localize: function(e, t = []) {
            return ee(e, t);
        },
        next: function(e = {}) {
            return Te(I + 1, e), He;
        },
        off: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])te.has(n) && te.set(n, te.get(n).filter((e)=>e !== t));
            return He;
        },
        on: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])te.set(n, [
                ...te.get(n) || [],
                t
            ]);
            return He;
        },
        prev: function(e = {}) {
            return Te(I - 1, e), He;
        },
        remove: function(e) {
            void 0 === e && (e = G.length - 1);
            const t = G[e];
            return t && (ne("removeSlide", t), t.el && (we(t.el), t.el.remove(), t.el = void 0), G.splice(e, 1), re(_), ye(), Oe()), He;
        },
        setPosition: function(e) {
            q = e, le(), Oe();
        },
        showError: function(e, t) {
            Pe(e), Le(e);
            const n = e.el;
            if (n) {
                const i = document.createElement("div");
                (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(i, "f-html"), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(i, "is-error"), i.innerHTML = ee(t || "<p>{{ERROR}}</p>"), e.htmlEl = i, (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(n, "has-html"), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(n, "has-error"), n.insertAdjacentElement("afterbegin", i), ne("contentReady", e);
            }
            return He;
        },
        showLoading: function(e) {
            const t = e.el, n = null == t ? void 0 : t.querySelector(".f-spinner");
            if (!t || n) return He;
            const i = Z("spinnerTpl"), o = (0, $8a814a110db3ad66$export$b368690db5627d91)(i);
            return o && ((0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(o, "f-spinner"), t.insertAdjacentElement("beforeend", o)), He;
        },
        version: "6.0.26"
    };
    return He;
};
$9b8ac375a20c1e65$export$144901db2ea8e967.l10n = {
    en_EN: (0, $ff9fa40b857caa63$export$30568d076ec2f42)
}, $9b8ac375a20c1e65$export$144901db2ea8e967.getDefaults = ()=>$9b8ac375a20c1e65$var$m;


/*! License details at fancyapps.com/license */ 




/*! License details at fancyapps.com/license */ const $71b6a833cd4e8ed4$export$b539ed14f4f9e78 = (t = !0, e = "--f-scrollbar-compensate", s = "--f-body-margin", o = "hide-scrollbar")=>{
    const n = document, r = n.body, l = n.documentElement;
    if (t) {
        if (r.classList.contains(o)) return;
        let t = window.innerWidth - l.getBoundingClientRect().width;
        t < 0 && (t = 0), l.style.setProperty(e, `${t}px`);
        const n = parseFloat(window.getComputedStyle(r).marginRight);
        n && r.style.setProperty(s, `${n}px`), r.classList.add(o);
    } else r.classList.remove(o), r.style.setProperty(s, ""), n.documentElement.style.setProperty(e, "");
};



/*! License details at fancyapps.com/license */ function $b73b213c51fa4dcc$export$71594e8a50f746f4() {
    return !("undefined" == typeof window || !window.document || !window.document.createElement);
}






/*! License details at fancyapps.com/license */ 

/*! License details at fancyapps.com/license */ const $88e8bb7c39366d5a$export$b8b3234b4edfc4c2 = function(n = "", t = "", o = "") {
    return n.split(t).join(o);
};



const $9048b1527748519a$var$a = {
    tpl: (e)=>`<img class="f-panzoom__content" \n    ${e.srcset ? 'data-lazy-srcset="{{srcset}}"' : ""} \n    ${e.sizes ? 'data-lazy-sizes="{{sizes}}"' : ""} \n    data-lazy-src="{{src}}" alt="{{alt}}" />`
}, $9048b1527748519a$export$b7fc409e12a7dcec = ()=>{
    let s;
    function l(t, o) {
        const n = null == s ? void 0 : s.getOptions().Zoomable;
        let i = ((0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(n) ? Object.assign(Object.assign({}, $9048b1527748519a$var$a), n) : $9048b1527748519a$var$a)[t];
        return i && "function" == typeof i && o ? i(o) : i;
    }
    function c() {
        s && (s.on("addSlide", u), s.on("removeSlide", f), s.on("attachSlideEl", m), s.on("click", d), s.on("change", r));
    }
    function r() {
        g();
    }
    function d(e, t) {
        const o = t.target;
        o && !t.defaultPrevented && o.dataset.panzoomAction && p(o.dataset.panzoomAction);
    }
    function u(e, i) {
        if (!s) return;
        const a = i.el;
        if (!a) return;
        const c = i.src || i.lazySrc || "", r = i.alt || i.caption || `Image #${i.index}`, d = i.srcset || i.lazySrcset || "", u = i.sizes || i.lazySizes || "";
        if (c && (0, $bc360f0f1dfbc749$export$844ec244b1367d54)(c) && !i.html && (!i.type || "image" === i.type)) {
            i.type = "image";
            let e = l("tpl", i);
            e = (0, $88e8bb7c39366d5a$export$b8b3234b4edfc4c2)(e, "{{src}}", c + ""), e = (0, $88e8bb7c39366d5a$export$b8b3234b4edfc4c2)(e, "{{alt}}", r + ""), e = (0, $88e8bb7c39366d5a$export$b8b3234b4edfc4c2)(e, "{{srcset}}", d + ""), e = (0, $88e8bb7c39366d5a$export$b8b3234b4edfc4c2)(e, "{{sizes}}", u + ""), a.insertAdjacentHTML("afterbegin", e);
        }
        if (!a.querySelector(".f-panzoom__content")) return;
        const f = i.width && "auto" !== i.width ? parseFloat(i.width + "") : "auto", m = i.height && "auto" !== i.height ? parseFloat(i.height + "") : "auto", p = (0, $d05bed9ea06f74d2$export$b704d075ddd20210)(a, Object.assign({
            width: f,
            height: m,
            classes: {
                container: "f-zoomable"
            },
            event: ()=>null == s ? void 0 : s.getLastMouseMove(),
            spinnerTpl: ()=>(null == s ? void 0 : s.getOption("spinnerTpl")) || ""
        }, l("Panzoom")));
        p.on("*", (e, t, ...o)=>{
            s && ("loading" === t && (i.state = 0), "loaded" === t && (i.state = 1), "error" === t && (i.state = 2, null == s || s.showError(i, "{{IMAGE_ERROR}}")), s.emit(`panzoom:${t}`, i, ...o), "ready" === t && s.emit("contentReady", i), i.index === s.getPageIndex() && g());
        }), i.panzoomRef = p;
    }
    function f(e, t) {
        t.panzoomRef && (t.panzoomRef.destroy(), t.panzoomRef = void 0);
    }
    function m(e, t) {
        const o = t.panzoomRef;
        if (o) switch(o.getState()){
            case 0:
                o.init();
                break;
            case 3:
                o.execute((0, $d05bed9ea06f74d2$export$9520bccbaf78266).Reset, {
                    velocity: 0
                });
        }
    }
    function g() {
        var e;
        const t = null == s ? void 0 : s.getContainer();
        if (!t) return;
        const o = null === (e = null == s ? void 0 : s.getPage()) || void 0 === e ? void 0 : e.slides[0].panzoomRef, n = (null == o ? void 0 : o.canZoomIn()) || !1, a = (null == o ? void 0 : o.canZoomOut()) || !1, l = (null == o ? void 0 : o.isFullsize()) || !1, c = !o || 3 !== (null == o ? void 0 : o.getState());
        for (const e of (null == t ? void 0 : t.querySelectorAll("[data-panzoom-action]")) || []){
            const t = e.dataset.panzoomAction;
            let o = !1;
            if (c) o = !0;
            else switch(t){
                case (0, $d05bed9ea06f74d2$export$9520bccbaf78266).ZoomIn:
                    n || (o = !0);
                    break;
                case (0, $d05bed9ea06f74d2$export$9520bccbaf78266).ZoomOut:
                    a || (o = !0);
                    break;
                case (0, $d05bed9ea06f74d2$export$9520bccbaf78266).ToggleFull:
                    n || a || (o = !0);
                    const t1 = e.querySelector("g");
                    t1 && (t1.style.display = l ? "none" : "");
                    break;
                case (0, $d05bed9ea06f74d2$export$9520bccbaf78266).ToggleCover:
                case (0, $d05bed9ea06f74d2$export$9520bccbaf78266).ToggleMax:
                    n || a || (o = !0);
            }
            o ? (e.setAttribute("aria-disabled", ""), e.setAttribute("tabindex", "-1")) : (e.removeAttribute("aria-disabled"), e.removeAttribute("tabindex"));
        }
    }
    function p(e, ...t) {
        var o;
        null === (o = null == s ? void 0 : s.getPage().slides[0].panzoomRef) || void 0 === o || o.execute(e, ...t);
    }
    return {
        init: function(e) {
            s = e, !1 !== s.getOptions().Zoomable && s.on("initPlugins", c);
        },
        destroy: function() {
            if (s) {
                s.off("addSlide", u), s.off("removeSlide", f), s.off("attachSlideEl", m), s.off("click", d), s.off("change", r);
                for (const e of s.getSlides())f(0, e);
            }
            s = void 0;
        },
        execute: p
    };
};


/*! License details at fancyapps.com/license */ 
const $956d090b1e9b0f09$var$e = {
    syncOnChange: !1,
    syncOnClick: !0,
    syncOnHover: !1
}, $956d090b1e9b0f09$export$2ae15352e0a80063 = ()=>{
    let i, t;
    function o() {
        const t = null == i ? void 0 : i.getOptions().Sync;
        return (0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(t) ? Object.assign(Object.assign({}, $956d090b1e9b0f09$var$e), t) : $956d090b1e9b0f09$var$e;
    }
    function s(n) {
        var e, s, l;
        i && n && (t = n, i.getOptions().classes = Object.assign(Object.assign({}, i.getOptions().classes), {
            isSelected: ""
        }), i.getOptions().initialSlide = (null === (s = null === (e = t.getPage()) || void 0 === e ? void 0 : e.slides[0]) || void 0 === s ? void 0 : s.index) || 0, o().syncOnChange && i.on("change", c), o().syncOnClick && i.on("click", g), o().syncOnHover && (null === (l = i.getViewport()) || void 0 === l || l.addEventListener("mouseover", u)), function() {
            if (!i || !t) return;
            i.on("ready", d), i.on("refresh", a), t.on("change", r), t.on("filter", f);
        }());
    }
    function l() {
        const n = o().target;
        i && n && s(n);
    }
    function d() {
        v();
    }
    function c() {
        var n;
        if (i && t) {
            const e = (null === (n = i.getPage()) || void 0 === n ? void 0 : n.slides) || [], o = t.getPageIndex(e[0].index || 0);
            o > -1 && t.goTo(o, i.hasNavigated() ? void 0 : {
                tween: !1,
                transition: !1
            }), v();
        }
    }
    function r() {
        var n;
        if (i && t) {
            const e = i.getPageIndex((null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0].index) || 0);
            e > -1 && i.goTo(e, t.hasNavigated() ? void 0 : {
                tween: !1,
                transition: !1
            }), v();
        }
    }
    function g(n, e) {
        var o;
        if (!i || !t) return;
        if (null === (o = i.getTween()) || void 0 === o ? void 0 : o.isRunning()) return;
        const s = null == i ? void 0 : i.getOptions().classes.slide;
        if (!s) return;
        const l = s ? e.target.closest(`.${s}`) : null;
        if (l) {
            const n = parseInt(l.getAttribute("index") || "") || 0, e = t.getPageIndex(n);
            t.goTo(e);
        }
    }
    function u(n) {
        i && g(0, n);
    }
    function a() {
        var n;
        if (i && t) {
            const e = i.getPageIndex((null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0].index) || 0);
            e > -1 && i.goTo(e, {
                tween: !1,
                transition: !1
            }), v();
        }
    }
    function f(n, e) {
        i && t && (i.filter(e), r());
    }
    function v() {
        var n, e, o;
        if (!t) return;
        const s = (null === (e = null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0]) || void 0 === e ? void 0 : e.index) || 0;
        for (const n of (null == i ? void 0 : i.getSlides()) || [])null === (o = n.el) || void 0 === o || o.classList.toggle("is-selected", n.index === s);
    }
    return {
        init: function(n) {
            i = n, i.on("initSlides", l);
        },
        destroy: function() {
            var n;
            null == i || i.off("ready", d), null == i || i.off("refresh", a), null == i || i.off("change", c), null == i || i.off("click", g), null === (n = null == i ? void 0 : i.getViewport()) || void 0 === n || n.removeEventListener("mouseover", u), null == t || t.off("change", r), null == t || t.off("filter", f), t = void 0, null == i || i.off("initSlides", l), i = void 0;
        },
        getTarget: function() {
            return t;
        }
    };
};


/*! License details at fancyapps.com/license */ 
const $8debf9aa752fe8dc$var$t = {
    showLoading: !0,
    preload: 1
}, $8debf9aa752fe8dc$var$a = "is-lazyloading", $8debf9aa752fe8dc$var$s = "is-lazyloaded", $8debf9aa752fe8dc$export$6f539aaa4f74fdd1 = ()=>{
    let l;
    function n() {
        const a = null == l ? void 0 : l.getOptions().Lazyload;
        return (0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(a) ? Object.assign(Object.assign({}, $8debf9aa752fe8dc$var$t), a) : $8debf9aa752fe8dc$var$t;
    }
    function o(e) {
        const t = e.el;
        if (!t) return;
        const o = "[data-lazy-src],[data-lazy-srcset],[data-lazy-bg]", i = Array.from(t.querySelectorAll(o));
        t.matches(o) && i.push(t);
        for (const t of i){
            const o = t.dataset.lazySrc, i = t.dataset.lazySrcset, d = t.dataset.lazySizes, r = t.dataset.lazyBg, c = (t instanceof HTMLImageElement || t instanceof HTMLSourceElement) && (o || i), u = t instanceof HTMLElement && r;
            if (!c && !u) continue;
            const f = o || i || r;
            if (f) {
                if (c && f) n().showLoading && (null == l || l.showLoading(e)), t.addEventListener("load", ()=>{
                    null == l || l.hideLoading(e), t instanceof HTMLImageElement ? t.decode().then(()=>{
                        t.classList.remove($8debf9aa752fe8dc$var$a), t.classList.add($8debf9aa752fe8dc$var$s);
                    }) : (t.classList.remove($8debf9aa752fe8dc$var$a), t.classList.add($8debf9aa752fe8dc$var$s)), null == l || l.emit("lazyLoad:loaded", e, t, f);
                }), t.addEventListener("error", ()=>{
                    null == l || l.hideLoading(e), t.classList.remove($8debf9aa752fe8dc$var$a), t.classList.add("has-lazyerror"), null == l || l.emit("lazyLoad:error", e, t, f);
                }), t.classList.add("f-lazyload"), t.classList.add($8debf9aa752fe8dc$var$a), null == l || l.emit("lazyLoad:load", e, t, f), o && (t.src = o), i && (t.srcset = i), d && (t.sizes = d);
                else if (u) {
                    if (!document.body.contains(t)) document.createElement("img").src = r;
                    t.style.backgroundImage = `url('${r}')`;
                }
                delete t.dataset.lazySrc, delete t.dataset.lazySrcset, delete t.dataset.lazySizes, delete t.dataset.lazyBg;
            }
        }
    }
    function i() {
        if (!l) return;
        const e = [
            ...l.getVisibleSlides()
        ], t = n().preload;
        if (t > 0) {
            const a = l.getPosition(), s = l.getViewportDim();
            e.push(...l.getVisibleSlides(a + s * t), ...l.getVisibleSlides(a - s * t));
        }
        for (const t of e)o(t);
    }
    return {
        init: function(e) {
            l = e, l.on("render", i);
        },
        destroy: function() {
            null == l || l.off("render", i), l = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 



const $f028c4ade87b683d$var$r = {
    prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"></path></svg>',
    nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg>'
}, $f028c4ade87b683d$export$b6e350ab9915297a = ()=>{
    let s, i, l;
    function a() {
        const t = null == s ? void 0 : s.getOptions().Arrows;
        return (0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(t) ? Object.assign(Object.assign({}, $f028c4ade87b683d$var$r), t) : $f028c4ade87b683d$var$r;
    }
    function u(e) {
        if (!s) return;
        const o = `<button data-carousel-go-${e} tabindex="0" class="f-button is-arrow is-${e}" title="{{${e.toUpperCase()}}}">` + a()[`${e}Tpl`] + "</button", r = (0, $8a814a110db3ad66$export$b368690db5627d91)(s.localize(o)) || void 0;
        return r && (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(r, a()[`${e}Class`]), r;
    }
    function g() {
        var t;
        null == i || i.remove(), i = void 0, null == l || l.remove(), l = void 0, null === (t = null == s ? void 0 : s.getContainer()) || void 0 === t || t.classList.remove("has-arrows");
    }
    function c() {
        s && !1 !== s.getOptions().Arrows && s.getPages().length > 1 ? (!function() {
            if (!s) return;
            const t = s.getViewport();
            t && (i || (i = u("prev"), i && t.insertAdjacentElement("beforebegin", i)), l || (l = u("next"), l && t.insertAdjacentElement("afterend", l)), (0, $6148d53608c1432f$export$4a80062ca50b57c7)(s.getContainer(), "has-arrows", !(!i && !l)));
        }(), s && (null == i || i.toggleAttribute("aria-disabled", !s.canGoPrev()), null == l || l.toggleAttribute("aria-disabled", !s.canGoNext()))) : g();
    }
    return {
        init: function(t) {
            s = t.on([
                "change",
                "refresh"
            ], c);
        },
        destroy: function() {
            g(), null == s || s.off([
                "change",
                "refresh"
            ], c), s = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 


/*! License details at fancyapps.com/license */ const $f3b1035b8fabf751$export$1a5903fe7331d64a = {
    moveLeft: {
        tpl: '<button data-panzoom-action="moveLeft" class="f-button" title="{{MOVE_LEFT}}"><svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg></button>'
    },
    moveRight: {
        tpl: '<button data-panzoom-action="moveRight" class="f-button" title="{{MOVE_RIGHT}}"><svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg></button>'
    },
    moveUp: {
        tpl: '<button data-panzoom-action="moveUp" class="f-button" title="{{MOVE_UP}}"><svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg></button>'
    },
    moveDown: {
        tpl: '<button data-panzoom-action="moveDown" class="f-button" title="{{MOVE_DOWN}}"><svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg></button>'
    },
    zoomIn: {
        tpl: '<button data-panzoom-action="zoomIn" class="f-button" title="{{ZOOM_IN}}"><svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg></button>'
    },
    zoomOut: {
        tpl: '<button data-panzoom-action="zoomOut" class="f-button" title="{{ZOOM_OUT}}"><svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg></button>'
    },
    toggle1to1: {
        tpl: '<button data-panzoom-action="toggleFull" class="f-button" title="{{TOGGLE_FULL}}"><svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg></button>'
    },
    toggleFull: {
        tpl: '<button data-panzoom-action="toggleFull" class="f-button" title="{{TOGGLE_FULL}}"><svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg></button>'
    },
    rotateCCW: {
        tpl: '<button data-panzoom-action="rotateCCW" class="f-button" title="{{ROTATE_CCW}}"><svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg></button>'
    },
    rotateCW: {
        tpl: '<button data-panzoom-action="rotateCW" class="f-button" title="{{ROTATE_CW}}"><svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg></button>'
    },
    flipX: {
        tpl: '<button data-panzoom-action="flipX" class="f-button" title="{{FLIP_X}}"><svg><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg></button>'
    },
    flipY: {
        tpl: '<button data-panzoom-action="flipY" class="f-button" title="{{FLIP_Y}}"><svg><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg></button>'
    },
    reset: {
        tpl: '<button data-panzoom-action="reset" class="f-button" title="{{RESET}}"><svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg></button>'
    }
};



var $20fc63f0f74f430d$export$68ae38b485887054;
!function(t) {
    t.Left = "left", t.middle = "middle", t.right = "right";
}($20fc63f0f74f430d$export$68ae38b485887054 || ($20fc63f0f74f430d$export$68ae38b485887054 = {}));
const $20fc63f0f74f430d$var$s = Object.assign({
    counter: {
        tpl: '<div class="f-carousel__counter"><span data-carousel-page></span>/<span data-carousel-pages></span></div>'
    },
    download: {
        tpl: '<button data-carousel-download class="f-button" title="{{DOWNLOAD}}"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></button>'
    },
    autoplay: {
        tpl: '<button data-autoplay-action="toggle" class="f-button" title="{{TOGGLE_AUTOPLAY}}"><svg><g><path d="M5 3.5 19 12 5 20.5Z"/></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
    },
    thumbs: {
        tpl: '<button data-thumbs-action="toggle" class="f-button" title="{{TOGGLE_THUMBS}}"><svg><rect width="18" height="14" x="3" y="3" rx="2"/><path d="M4 21h1M9 21h1M14 21h1M19 21h1"/></svg></button>'
    }
}, (0, $f3b1035b8fabf751$export$1a5903fe7331d64a)), $20fc63f0f74f430d$var$a = {
    absolute: !1,
    display: {
        left: [],
        middle: [
            "zoomIn",
            "zoomOut",
            "toggle1to1",
            "rotateCCW",
            "rotateCW",
            "flipX",
            "flipY",
            "reset"
        ],
        right: []
    },
    enabled: "auto",
    items: {}
}, $20fc63f0f74f430d$export$4c260019440d418f = ()=>{
    let i, u;
    function d() {
        const e = null == i ? void 0 : i.getOptions().Toolbar;
        return (0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(e) ? Object.assign(Object.assign({}, $20fc63f0f74f430d$var$a), e) : $20fc63f0f74f430d$var$a;
    }
    function r() {
        var t, a, r;
        if (!(null == i ? void 0 : i.getOptions().Toolbar)) return;
        if (!i || u) return;
        let c = d().enabled;
        if (!c) return;
        let f = d().absolute;
        const g = i.getSlides().length > 1;
        let p = !1, b = !1;
        for (const t of i.getSlides())t.panzoomRef && (p = !0), (t.downloadSrc || "image" === t.type && t.src) && (b = !0);
        let m = (null === (t = i.getPlugins().Thumbs) || void 0 === t ? void 0 : t.isEnabled()) || !1, v = g && i.getPlugins().Autoplay || !1, h = i.getPlugins().Fullscreen && (document.fullscreenEnabled || document.webkitFullscreenEnabled);
        if ("auto" === c && (c = p), !c) return;
        u = document.createElement("div"), u.classList.add("f-carousel__toolbar");
        const j = d().display, y = (0, $d183dc8f1ac8b27e$export$8b58be045bf06082)({}, $20fc63f0f74f430d$var$s, d().items);
        for (const t of [
            "left",
            "middle",
            "right"
        ]){
            const l = j[t] || [], s = document.createElement("div");
            s.classList.add("f-carousel__toolbar__column"), s.classList.add(`is-${t}`);
            for (const t of l){
                let l;
                if ((0, $bc360f0f1dfbc749$export$844ec244b1367d54)(t)) {
                    if ("counter" === t && !g) continue;
                    if ("autoplay" === t && !v) continue;
                    if ((0, $f3b1035b8fabf751$export$1a5903fe7331d64a)[t] && !p) continue;
                    if ("fullscreen" === t && !h) continue;
                    if ("thumbs" === t && !m) continue;
                    if ("download" === t && !b) continue;
                    l = y[t];
                }
                if ("object" == typeof t && (l = t), l && l.tpl) {
                    let t = i.localize(l.tpl);
                    t = t.split("<svg>").join('<svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24">');
                    const e = (0, $8a814a110db3ad66$export$b368690db5627d91)(t);
                    e && ("function" == typeof l.click && i && e.addEventListener("click", (t)=>{
                        t.preventDefault(), t.stopPropagation(), "function" == typeof l.click && i && l.click(i, t);
                    }), s.append(e));
                }
            }
            u.append(s);
        }
        u.childElementCount && (!0 === f && u.classList.add("is-absolute"), null === (a = i.getContainer()) || void 0 === a || a.classList.add("has-toolbar"), null === (r = i.getViewport()) || void 0 === r || r.insertAdjacentElement("beforebegin", u));
    }
    return {
        init: function(t) {
            i = t, i.on("initSlides", r);
        },
        destroy: function() {
            var t;
            null == i || i.off("initSlides", r), null === (t = null == i ? void 0 : i.getContainer()) || void 0 === t || t.classList.remove("has-toolbar"), null == u || u.remove(), u = void 0;
        },
        add: function(t, e) {
            $20fc63f0f74f430d$var$s[t] = e;
        },
        isEnabled: function() {
            return !!u;
        }
    };
};


/*! License details at fancyapps.com/license */ 
const $d95eb579b2ac24ae$var$e = {
    autoStart: !0,
    pauseOnHover: !0,
    showProgressbar: !0,
    timeout: 2e3
}, $d95eb579b2ac24ae$export$6c96167f46662e38 = ()=>{
    let n, o, i = !1, a = !1, l = !1, s = null;
    function r(o) {
        const i = null == n ? void 0 : n.getOptions().Autoplay;
        let a = ((0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(i) ? Object.assign(Object.assign({}, $d95eb579b2ac24ae$var$e), i) : $d95eb579b2ac24ae$var$e)[o];
        return a && "function" == typeof a && n ? a(n) : a;
    }
    function u() {
        var t;
        const e = (null === (t = null == n ? void 0 : n.getPage()) || void 0 === t ? void 0 : t.slides) || [];
        for (const t of e)if (0 === t.state) return !0;
        return !1;
    }
    function d() {
        clearTimeout(o), o = void 0;
    }
    function g() {
        if (o) return;
        if (l) return;
        if (u()) return;
        if (!(null == n ? void 0 : n.isSettled())) return;
        !function() {
            var t, e, o, i;
            if (!n) return;
            if (v(), !r("showProgressbar")) return;
            let a = r("progressbarParentEl");
            !a && (null === (t = n.getPlugins().Toolbar) || void 0 === t ? void 0 : t.isEnabled()) && (a = n.getContainer());
            if (!a && !0 !== (null === (e = n.getPlugins().Toolbar) || void 0 === e ? void 0 : e.isEnabled())) {
                const t = (null === (o = n.getPages()[0]) || void 0 === o ? void 0 : o.slides) || [], e = (null === (i = n.getPage()) || void 0 === i ? void 0 : i.slides) || [];
                1 === t.length && 1 === e.length && (a = e[0].el);
            }
            a || (a = n.getViewport());
            if (!a) return;
            s = document.createElement("div"), s.classList.add("f-progressbar"), a.prepend(s);
            const l = r("timeout") || 1e3;
            s.style.animationDuration = `${l}ms`;
        }();
        const t = r("timeout");
        o = setTimeout(()=>{
            n && i && !a && (n.isInfinite() || n.getPageIndex() !== n.getPages().length - 1 ? n.next() : n.goTo(0));
        }, t);
    }
    function f() {
        var t, e;
        if (!n || n.getPages().length < 2 || !1 === n.getOptions().Autoplay) return;
        if (i) return;
        i = !0, n.emit("autoplay:start", r("timeout")), null === (t = n.getContainer()) || void 0 === t || t.classList.add("has-autoplay"), null === (e = n.getTween()) || void 0 === e || e.on("start", b);
        const o = null == n ? void 0 : n.getContainer();
        o && r("pauseOnHover") && matchMedia("(hover: hover)").matches && (o.addEventListener("mouseenter", E, !1), o.addEventListener("mouseleave", x, !1)), n.on("change", h), n.on("settle", y), n.on("contentReady", p), n.on("panzoom:animationStart", c), n.isSettled() && g();
    }
    function c() {
        var t, e;
        if (d(), v(), i && n) {
            n.emit("autoplay:end"), null === (t = n.getContainer()) || void 0 === t || t.classList.remove("has-autoplay"), null === (e = n.getTween()) || void 0 === e || e.off("start", b);
            const o = null == n ? void 0 : n.getContainer();
            o && (o.removeEventListener("mouseenter", E, !1), o.removeEventListener("mouseleave", x, !1));
        }
        n && (n.off("change", h), n.off("settle", y), n.off("contentReady", p), n.off("panzoom:animationStart", c)), i = !1, a = !1;
    }
    function v() {
        s && (s.remove(), s = null);
    }
    function m() {
        n && n.getPages().length > 1 && r("autoStart") && f();
    }
    function p(t) {
        n && n.getPageIndex(t.index) === n.getPageIndex() && (!i || l || u() || g());
    }
    function P(t, e) {
        const n = e.target;
        n && !e.defaultPrevented && "toggle" === n.dataset.autoplayAction && L.toggle();
    }
    function h() {
        !n || !(null == n ? void 0 : n.isInfinite()) && n.getPageIndex() === n.getPages().length - 1 ? c() : (v(), d());
    }
    function y() {
        !i || l || a || g();
    }
    function b() {
        d(), v();
    }
    function E() {
        l = !0, i && (v(), d());
    }
    function x() {
        l = !1, i && !a && (null == n ? void 0 : n.isSettled()) && g();
    }
    const L = {
        init: function(t) {
            n = t, n.on("ready", m), n.on("click", P);
        },
        destroy: function() {
            c(), null == n || n.off("ready", m), null == n || n.off("click", P), n = void 0;
        },
        isEnabled: ()=>i,
        pause: function() {
            a = !0, d();
        },
        resume: function() {
            a = !1, i && !l && g();
        },
        start () {
            f();
        },
        stop () {
            c();
        },
        toggle () {
            i ? c() : f();
        }
    };
    return L;
};


/*! License details at fancyapps.com/license */ 






const $20f7690e73616c4b$var$r = {
    Carousel: {
        Lazyload: {
            showLoading: !1
        }
    },
    minCount: 2,
    showOnStart: !0,
    thumbTpl: '<button aria-label="Slide to #{{page}}"><img draggable="false" alt="{{alt}}" data-lazy-src="{{src}}" /></button>',
    type: "modern"
};
let $20f7690e73616c4b$var$u;
const $20f7690e73616c4b$export$73e055b807a6709 = ()=>{
    let a, d, c, f = 0, m = 0, g = !0;
    function h(e) {
        const n = null == a ? void 0 : a.getOptions().Thumbs;
        let i = ((0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(n) ? Object.assign(Object.assign({}, $20f7690e73616c4b$var$r), n) : $20f7690e73616c4b$var$r)[e];
        return i && "function" == typeof i ? i() : i;
    }
    function v() {
        if (!a) return !1;
        if (!1 === (null == a ? void 0 : a.getOptions().Thumbs)) return !1;
        let t = 0;
        for (const e of a.getSlides())e.thumbSrc && t++;
        return t >= h("minCount");
    }
    function p() {
        return "modern" === h("type");
    }
    function b(t = !1) {
        var e;
        const n = null == a ? void 0 : a.getContainer();
        if (!a || !n || c) return;
        if (!v()) return;
        if (!c) {
            const t = n.nextElementSibling;
            (null == t ? void 0 : t.classList.contains("f-thumbs")) && (c = t);
        }
        if (!c) {
            c = document.createElement("div");
            const t = h("parentEl");
            t ? t.insertAdjacentElement("beforeend", c) : n.insertAdjacentElement("afterend", c);
        }
        const i = null === (e = h("Carousel")) || void 0 === e ? void 0 : e.classes;
        (null == i ? void 0 : i.container) && (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(c, i.container), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(c, "f-thumbs"), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(c, `is-${h("type")}`), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(c, "is-syncing"), t && (c.style.maxHeight = "0px");
    }
    function y(t) {
        const e = t.thumb ? t.thumb instanceof HTMLImageElement ? t.thumb.src : t.thumb : t.thumbSrc || void 0, i = void 0 === t.thumbAlt ? `Thumbnail #${t.index}` : t.thumbAlt + "";
        let o = h("thumbTpl");
        return o = (0, $88e8bb7c39366d5a$export$b8b3234b4edfc4c2)(o, "{{alt}}", i), o = (0, $88e8bb7c39366d5a$export$b8b3234b4edfc4c2)(o, "{{src}}", e + ""), o = (0, $88e8bb7c39366d5a$export$b8b3234b4edfc4c2)(o, "{{index}}", `${t.index}`), o = (0, $88e8bb7c39366d5a$export$b8b3234b4edfc4c2)(o, "{{page}}", `${t.index || 1}`), {
            html: o,
            class: t.thumbClass
        };
    }
    function S() {
        var t;
        if (!$20f7690e73616c4b$var$u) return;
        if (!a || !c || d) return;
        const n = [];
        for (const t of a.getSlides())n.push(y(t));
        n.length && (d = $20f7690e73616c4b$var$u(c, (0, $d183dc8f1ac8b27e$export$8b58be045bf06082)({}, {
            Sync: {
                target: a
            },
            Lazyload: {
                preload: 1
            },
            slides: n,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                slide: "f-thumbs__slide"
            },
            initialSlide: a.getOptions().initialPage,
            center: !0,
            fill: !p(),
            infinite: !1,
            dragFree: !0,
            rtl: a.getOptions().rtl || !1,
            slidesPerPage: (t)=>{
                let e = 0;
                return p() && (!function() {
                    if (!p()) return;
                    if (!c) return;
                    const t = (t)=>c && parseFloat(getComputedStyle(c).getPropertyValue("--f-thumb-" + t)) || 0;
                    f = t("width"), m = t("clip-width");
                }(), e = 4 * (f - m)), t && t.getTotalSlideDim() <= t.getViewportDim() - e ? 1 / 0 : 1;
            }
        }, $20f7690e73616c4b$var$r.Carousel || {}, h("Carousel") || {}), {
            Sync: (0, $956d090b1e9b0f09$export$2ae15352e0a80063),
            Lazyload: (0, $8debf9aa752fe8dc$export$6f539aaa4f74fdd1)
        }), d.on("ready", ()=>{
            null == a || a.emit("thumbs:ready");
        }), d.on("destroy", ()=>{
            null == a || a.emit("thumbs:destroy");
        }), d.init(), null === (t = d.getGestures()) || void 0 === t || t.on("start", ()=>{
            g = !1;
        }), d.on("click", (t, e)=>{
            const n = e.target;
            if (n) {
                const t = n.matches("button") ? n : n.firstElementChild;
                t && t.matches("button") && (e.preventDefault(), t.focus({
                    preventScroll: !0
                }));
            }
        }), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(a.getContainer(), "has-thumbs"), L());
    }
    function x() {
        v() && h("showOnStart") && (b(), S());
    }
    function C() {
        var t;
        v() && (null == a || a.on("addSlide", E), null == a || a.on("click", T), null === (t = null == a ? void 0 : a.getGestures()) || void 0 === t || t.on("start", P));
    }
    function P() {
        var t, e;
        g = !0;
        (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = document.activeElement) || void 0 === e || e.blur());
    }
    function j() {
        var t, e;
        null == c || c.classList.toggle("is-syncing", !1 === (null == a ? void 0 : a.hasNavigated()) || (null === (t = null == a ? void 0 : a.getTween()) || void 0 === t ? void 0 : t.isRunning())), L(), (null === (e = null == a ? void 0 : a.getGestures()) || void 0 === e ? void 0 : e.isPointerDown()) && function() {
            if (!p()) return;
            if (!a || !d) return;
            if (!g) return;
            const t = d.getTween(), e = d.getPages(), n = a.getPageIndex() || 0, o = a.getPageProgress() || 0;
            if (!(a && e && e[n] && t)) return;
            const l = t.isRunning() ? t.getCurrentValues().pos : d.getPosition();
            if (void 0 === l) return;
            let s = e[n].pos + o * (f - m);
            s = (0, $4b4c58c4de0c58b0$export$7d15b64cf5a3a4c4)(e[0].pos, s, e[e.length - 1].pos), t.from({
                pos: l
            }).to({
                pos: s
            }).start();
        }();
    }
    function w() {
        g = !0;
    }
    function E(t, e) {
        null == d || d.add(y(e), e.index);
    }
    function T(t, e) {
        const n = e.target;
        n && !e.defaultPrevented && "toggle" === n.dataset.thumbsAction && function() {
            if (c || (b(!0), S()), !c) return;
            const t = (null == d ? void 0 : d.isVertical()) ? "maxWidth" : "maxHeight", e = c.style[t];
            c.style[t] = e ? "" : "0px";
        }();
    }
    function L() {
        if (!p()) return;
        if (!a || !d) return;
        const t = (null == d ? void 0 : d.getSlides()) || [];
        let e = -0.5 * f;
        for (const n of t){
            const t = n.el;
            if (!t) continue;
            let i = a.getPageProgress(n.index) || 0;
            i = Math.max(-1, Math.min(1, i)), i > -1 && i < 1 && (e += .5 * f * (1 - Math.abs(i))), i = Math.round(1e4 * i) / 1e4, e = Math.round(1e4 * e) / 1e4, t.style.setProperty("--progress", `${Math.abs(i)}`), t.style.setProperty("--shift", `${(null == a ? void 0 : a.isRTL()) ? -1 * e : e}px`), i > -1 && i < 1 && (e += .5 * f * (1 - Math.abs(i)));
        }
    }
    return {
        init: function(t, e) {
            $20f7690e73616c4b$var$u = e, a = t, a.on("ready", C), a.on("initSlides", x), a.on("render", j), a.on("change", w);
        },
        destroy: function() {
            var t, e;
            null == a || a.off("ready", C), null == a || a.off("initSlides", x), null == a || a.off("render", j), null == a || a.off("change", w), null == a || a.off("addSlide", E), null == a || a.off("click", T), null === (t = null == a ? void 0 : a.getGestures()) || void 0 === t || t.off("start", P), null === (e = null == a ? void 0 : a.getContainer()) || void 0 === e || e.classList.remove("has-thumbs"), a = void 0, null == d || d.destroy(), d = void 0, null == c || c.remove(), c = void 0;
        },
        getCarousel: function() {
            return d;
        },
        getContainer: function() {
            return c;
        },
        isEnabled: function() {
            return v();
        }
    };
};


/*! License details at fancyapps.com/license */ 

const $bff16bdf8c577655$var$a = {
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    }
}, $bff16bdf8c577655$export$13f9d3c4397c4713 = ()=>{
    let i;
    function l(t, a) {
        let i = a.src;
        if (!(0, $bc360f0f1dfbc749$export$844ec244b1367d54)(i)) return;
        let l = a.type;
        if (!l) {
            if (l || ("#" === i.charAt(0) ? l = "inline" : i.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.((a)?png|avif|gif|jp(g|eg)|pjp(eg)?|jfif|svg|webp|bmp|ico|tif(f)?)((\?|#).*)?$)/i) ? l = "image" : i.match(/\.(pdf)((\?|#).*)?$/i) ? l = "pdf" : i.match(/\.(html|php)((\?|#).*)?$/i) && (l = "iframe")), !l) {
                const t = i.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i);
                t && (i = `https://maps.google.${t[1]}/?ll=${(t[2] ? t[2] + "&z=" + Math.floor(parseFloat(t[3])) + (t[4] ? t[4].replace(/^\//, "&") : "") : t[4] + "").replace(/\?/, "&")}&output=${t[4] && t[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, l = "gmap");
            }
            if (!l) {
                const t = i.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i);
                t && (i = `https://maps.google.${t[1]}/maps?q=${t[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, l = "gmap");
            }
            a.src = i, a.type = l;
        }
    }
    function o(e, l) {
        "iframe" !== l.type && "pdf" !== l.type && "gmap" !== l.type || function(e) {
            if (!i || !e.el || !e.src) return;
            const l = document.createElement("iframe");
            l.classList.add("f-iframe");
            for (const [e, o] of Object.entries(function() {
                const e = null == i ? void 0 : i.getOptions().Html;
                return (0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(e) ? Object.assign(Object.assign({}, $bff16bdf8c577655$var$a), e) : $bff16bdf8c577655$var$a;
            }().iframeAttr || {}))l.setAttribute(e, o);
            l.onerror = ()=>{
                i && 1 === i.getState() && i.showError(e, "{{IFRAME_ERROR}}");
            }, l.src = e.src;
            const o = document.createElement("div");
            if (o.classList.add("f-html"), o.append(l), e.width) {
                let t = `${e.width}`;
                t.match(/^\d+$/) && (t += "px"), o.style.maxWidth = `${t}`;
            }
            if (e.height) {
                let t = `${e.height}`;
                t.match(/^\d+$/) && (t += "px"), o.style.maxHeight = `${t}`;
            }
            if (e.aspectRatio) {
                const t = e.el.getBoundingClientRect();
                o.style.aspectRatio = `${e.aspectRatio}`, o.style[t.width > t.height ? "width" : "height"] = "auto", o.style[t.width > t.height ? "maxWidth" : "maxHeight"] = "none";
            }
            e.contentEl = l, e.htmlEl = o, e.el.classList.add("has-html"), e.el.classList.add("has-iframe"), e.el.classList.add(`has-${e.type}`), e.el.prepend(o), i.emit("contentReady", e);
        }(l);
    }
    function n(t, e) {
        var a, l;
        "iframe" !== e.type && "pdf" !== e.type && "gmap" !== e.type || (null == i || i.hideError(e), null === (a = e.contentEl) || void 0 === a || a.remove(), e.contentEl = void 0, null === (l = e.htmlEl) || void 0 === l || l.remove(), e.htmlEl = void 0);
    }
    return {
        init: function(t) {
            i = t, i.on("addSlide", l), i.on("attachSlideEl", o), i.on("detachSlideEl", n);
        },
        destroy: function() {
            null == i || i.off("addSlide", l), null == i || i.off("attachSlideEl", o), null == i || i.off("detachSlideEl", n), i = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 


const $5c2ab0a635a0e1ea$var$n = (t, e = {})=>{
    const o = new URL(t), n = new URLSearchParams(o.search), i = new URLSearchParams;
    for (const [t, o] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = o + "";
        if ("t" === t) {
            let t = e.match(/((\d*)m)?(\d*)s?/);
            t && i.set("start", 60 * parseInt(t[2] || "0") + parseInt(t[3] || "0") + "");
        } else i.set(t, e);
    }
    let l = i + "", s = t.match(/#t=((.*)?\d+s)/);
    return s && (l += `#t=${s[1]}`), l;
}, $5c2ab0a635a0e1ea$var$i = {
    autoplay: !1,
    html5videoTpl: '<video class="f-html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n    <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto",
        credentialless: ""
    },
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $5c2ab0a635a0e1ea$export$ae01dedf5c052bb = ()=>{
    let l, s = !1;
    function a() {
        const e = null == l ? void 0 : l.getOptions().Video;
        return (0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(e) ? Object.assign(Object.assign({}, $5c2ab0a635a0e1ea$var$i), e) : $5c2ab0a635a0e1ea$var$i;
    }
    function r() {
        var t;
        return null === (t = null == l ? void 0 : l.getPage()) || void 0 === t ? void 0 : t.slides[0];
    }
    const c = (t)=>{
        var e;
        try {
            let o = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === o.event) for (let o of Array.from((null === (e = null == l ? void 0 : l.getContainer()) || void 0 === e ? void 0 : e.getElementsByClassName("f-iframe")) || []))o instanceof HTMLIFrameElement && o.contentWindow === t.source && (o.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === o.event) {
                const t = document.getElementById(o.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    };
    function d(t, o) {
        const i = o.src;
        if (!(0, $bc360f0f1dfbc749$export$844ec244b1367d54)(i)) return;
        let l = o.type;
        if (!l || "html5video" === l) {
            const t = i.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i);
            t && (l = "html5video", o.html5videoFormat = o.html5videoFormat || "video/" + ("ogv" === t[1] ? "ogg" : t[1]));
        }
        if (!l || "youtube" === l) {
            const t = i.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i);
            if (t) {
                const e = Object.assign(Object.assign({}, a().youtube), o.youtube || {}), s = `www.youtube${e.nocookie ? "-nocookie" : ""}.com`, r = $5c2ab0a635a0e1ea$var$n(i, e), c = encodeURIComponent(t[2]);
                o.videoId = c, o.src = `https://${s}/embed/${c}?${r}`, o.thumb = o.thumb || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, l = "youtube";
            }
        }
        if (!l || "vimeo" === l) {
            const t = i.match(/^.+vimeo.com\/(?:\/)?(video\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/);
            if (t) {
                const e = Object.assign(Object.assign({}, a().vimeo), o.vimeo || {}), s = $5c2ab0a635a0e1ea$var$n(i, e), r = encodeURIComponent(t[2]), c = t[5] || "";
                o.videoId = r, o.src = `https://player.vimeo.com/video/${r}?${c ? `h=${c}${s ? "&" : ""}` : ""}${s}`, l = "vimeo";
            }
        }
        o.type = l;
    }
    function u(t, n) {
        "html5video" === n.type && function(t) {
            if (!l || !t.el || !t.src) return;
            const { el: n, src: i } = t;
            if (!n || !i) return;
            const s = t.html5videoTpl || a().html5videoTpl, r = t.html5videoFormat || a().html5videoFormat;
            if (!s) return;
            const c = t.poster || (t.thumb && (0, $bc360f0f1dfbc749$export$844ec244b1367d54)(t.thumb) ? t.thumb : ""), d = (0, $8a814a110db3ad66$export$b368690db5627d91)(s.replace(/\{\{src\}\}/gi, i + "").replace(/\{\{format\}\}/gi, r || "").replace(/\{\{poster\}\}/gi, c + ""));
            if (!d) return;
            const u = document.createElement("div");
            u.classList.add("f-html"), u.append(d), t.contentEl = d, t.htmlEl = u, n.classList.add(`has-${t.type}`), n.prepend(u), h(t), l.emit("contentReady", t);
        }(n), "youtube" !== n.type && "vimeo" !== n.type || function(t) {
            if (!l || !t.el || !t.src) return;
            const e = document.createElement("iframe");
            e.classList.add("f-iframe"), e.setAttribute("id", `f-iframe_${t.videoId}`);
            for (const [t, o] of Object.entries(a().iframeAttr || {}))e.setAttribute(t, o);
            e.onload = ()=>{
                var o;
                l && 1 === l.getState() && "youtube" === t.type && (null === (o = e.contentWindow) || void 0 === o || o.postMessage(JSON.stringify({
                    event: "listening",
                    id: e.getAttribute("id")
                }), "*"));
            }, e.onerror = ()=>{
                l && 1 === l.getState() && (null == l || l.showError(t, "{{IFRAME_ERROR}}"));
            }, e.src = t.src;
            const o = document.createElement("div");
            o.classList.add("f-html"), o.append(e), t.contentEl = e, t.htmlEl = o, t.el.classList.add("has-html"), t.el.classList.add("has-iframe"), t.el.classList.add(`has-${t.type}`), t.el.prepend(o), h(t), l.emit("contentReady", t);
        }(n);
    }
    function m(t, e) {
        var o, n;
        "html5video" !== e.type && "youtube" !== e.type && "vimeo" !== e.type || (null === (o = e.contentEl) || void 0 === o || o.remove(), e.contentEl = void 0, null === (n = e.htmlEl) || void 0 === n || n.remove(), e.htmlEl = void 0), e.poller && clearTimeout(e.poller);
    }
    function f() {
        s = !1;
    }
    function p() {
        if (s) return;
        s = !0;
        const t = r();
        (t && void 0 !== t.autoplay ? t.autoplay : a().autoplay) && (function() {
            var t;
            const e = r(), o = null == e ? void 0 : e.el;
            if (o && "html5video" === (null == e ? void 0 : e.type)) try {
                const t = o.querySelector("video");
                if (t) {
                    const e = t.play();
                    void 0 !== e && e.then(()=>{}).catch((e)=>{
                        t.muted = !0, t.play();
                    });
                }
            } catch (t) {}
            const n = null == e ? void 0 : e.htmlEl;
            n instanceof HTMLIFrameElement && (null === (t = n.contentWindow) || void 0 === t || t.postMessage('{"event":"command","func":"stopVideo","args":""}', "*"));
        }(), function() {
            const t = r(), e = null == t ? void 0 : t.type;
            if (!(null == t ? void 0 : t.el) || "youtube" !== e && "vimeo" !== e) return;
            const o = ()=>{
                if (t.contentEl && t.contentEl instanceof HTMLIFrameElement && t.contentEl.contentWindow) {
                    let e;
                    if ("true" === t.contentEl.dataset.ready) return e = "youtube" === t.type ? {
                        event: "command",
                        func: "playVideo"
                    } : {
                        method: "play",
                        value: "true"
                    }, e && t.contentEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                    "youtube" === t.type && (e = {
                        event: "listening",
                        id: t.contentEl.getAttribute("id")
                    }, t.contentEl.contentWindow.postMessage(JSON.stringify(e), "*"));
                }
                t.poller = setTimeout(o, 250);
            };
            o();
        }());
    }
    function h(t) {
        const e = null == t ? void 0 : t.htmlEl;
        if (t && e && ("html5video" === t.type || "youtube" === t.type || "vimeo" === t.type)) {
            if (e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.style.maxWidth = "", e.style.maxHeight = "", t.width) {
                let o = `${t.width}`;
                o.match(/^\d+$/) && (o += "px"), e.style.maxWidth = `${o}`;
            }
            if (t.height) {
                let o = `${t.height}`;
                o.match(/^\d+$/) && (o += "px"), e.style.maxHeight = `${o}`;
            }
            if (t.aspectRatio) {
                const o = t.aspectRatio.split("/"), n = parseFloat(o[0].trim()), i = o[1] ? parseFloat(o[1].trim()) : 0, l = n && i ? n / i : n;
                e.offsetHeight;
                const s = e.getBoundingClientRect(), a = l < (s.width || 1) / (s.height || 1);
                e.style.aspectRatio = `${t.aspectRatio}`, e.style.width = a ? "auto" : "", e.style.height = a ? "" : "auto";
            }
        }
    }
    function v() {
        h(r());
    }
    return {
        init: function(t) {
            l = t, l.on("addSlide", d), l.on("attachSlideEl", u), l.on("detachSlideEl", m), l.on("ready", p), l.on("change", f), l.on("settle", p), l.on("refresh", v), window.addEventListener("message", c);
        },
        destroy: function() {
            null == l || l.off("addSlide", d), null == l || l.off("attachSlideEl", u), null == l || l.off("detachSlideEl", m), null == l || l.off("ready", p), null == l || l.off("change", f), null == l || l.off("settle", p), null == l || l.off("refresh", v), window.removeEventListener("message", c), l = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 
const $f8248ec59847c8c0$var$n = {
    autoStart: !1,
    btnTpl: '<button data-fullscreen-action="toggle" class="f-button" title="{{TOGGLE_FULLSCREEN}}"><svg><g><path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
}, $f8248ec59847c8c0$var$t = "in-fullscreen-mode", $f8248ec59847c8c0$export$159cd03be7087f39 = ()=>{
    let l;
    function u(t) {
        const u = null == l ? void 0 : l.getOptions().Fullscreen;
        let o = ((0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(u) ? Object.assign(Object.assign({}, $f8248ec59847c8c0$var$n), u) : $f8248ec59847c8c0$var$n)[t];
        return o && "function" == typeof o && l ? o(l) : o;
    }
    function o() {
        var e;
        null === (e = null == l ? void 0 : l.getPlugins().Toolbar) || void 0 === e || e.add("fullscreen", {
            tpl: u("btnTpl")
        });
    }
    function c() {
        if (u("autoStart")) {
            const e = r();
            e && d(e);
        }
    }
    function i(e, n) {
        const t = n.target;
        t && !n.defaultPrevented && "toggle" === t.dataset.fullscreenAction && b();
    }
    function s(e) {
        r() && "Escape" === e.key && !e.defaultPrevented && b();
    }
    function r() {
        return u("el") || (null == l ? void 0 : l.getContainer()) || void 0;
    }
    function a() {
        const e = document;
        return e.fullscreenEnabled ? !!e.fullscreenElement : !!e.webkitFullscreenEnabled && !!e.webkitFullscreenElement;
    }
    function d(e) {
        const n = document;
        let l;
        return e || (e = n.documentElement), n.fullscreenEnabled ? l = e.requestFullscreen() : n.webkitFullscreenEnabled && (l = e.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)), l && l.then(()=>{
            e.classList.add($f8248ec59847c8c0$var$t);
        }), l;
    }
    function f() {
        const e = document;
        let n;
        return e.fullscreenEnabled ? n = e.fullscreenElement && e.exitFullscreen() : e.webkitFullscreenEnabled && (n = e.webkitFullscreenElement && e.webkitExitFullscreen()), n && n.then(()=>{
            var e;
            null === (e = r()) || void 0 === e || e.classList.remove($f8248ec59847c8c0$var$t);
        }), n;
    }
    function b() {
        const e = r();
        e && (a() ? f() : d(e));
    }
    return {
        init: function(e) {
            l = e, l.on("initPlugins", o), l.on("ready", c), l.on("click", i);
        },
        destroy: function() {
            null == l || l.off("initPlugins", o), null == l || l.off("ready", c), null == l || l.off("click", i), document.removeEventListener("keydown", s, !0);
        },
        exit: f,
        inFullscreen: a,
        request: d,
        toggle: b
    };
};


/*! License details at fancyapps.com/license */ 
let $6fc11d6b67175841$var$e, $6fc11d6b67175841$var$n = !1, $6fc11d6b67175841$var$o = !1, $6fc11d6b67175841$var$i = !1, $6fc11d6b67175841$var$r = !1;
const $6fc11d6b67175841$var$l = ()=>{
    const t = new URL(document.URL).hash, e = t.slice(1).split("-"), n = e[e.length - 1], o = n && /^\+?\d+$/.test(n) && parseInt(e.pop() || "1", 10) || 1;
    return {
        hash: t,
        slug: e.join("-"),
        index: o
    };
}, $6fc11d6b67175841$var$a = ()=>{
    if (!$6fc11d6b67175841$var$e || $6fc11d6b67175841$var$e.getInstance()) return;
    const { slug: t, index: n } = $6fc11d6b67175841$var$l();
    if (!t) return;
    let o = document.querySelector(`[data-slug="${t}"]`);
    if (o && o.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })), !$6fc11d6b67175841$var$e || $6fc11d6b67175841$var$e.getInstance()) return;
    const i = document.querySelectorAll(`[data-fancybox="${t}"]`);
    i.length && (o = i[n - 1], o && o.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })));
}, $6fc11d6b67175841$var$s = ()=>{
    var t, n, o;
    if (!$6fc11d6b67175841$var$e) return;
    if ($6fc11d6b67175841$var$i) return;
    const s = null == $6fc11d6b67175841$var$e ? void 0 : $6fc11d6b67175841$var$e.getInstance();
    if (!1 === (null == s ? void 0 : s.getOptions().Hash)) return;
    const { slug: c, index: u } = $6fc11d6b67175841$var$l(), d = (null === (t = null == s ? void 0 : s.getSlide()) || void 0 === t ? void 0 : t.fancybox) || (null === (n = null == s ? void 0 : s.getSlide()) || void 0 === n ? void 0 : n.slug) || void 0;
    s && d && (c === d ? null === (o = s.getCarousel()) || void 0 === o || o.goTo(u - 1) : ($6fc11d6b67175841$var$r = !0, s.close(), $6fc11d6b67175841$var$r = !1)), $6fc11d6b67175841$var$a();
}, $6fc11d6b67175841$var$c = ()=>{
    $6fc11d6b67175841$var$e && setTimeout(()=>{
        $6fc11d6b67175841$var$n = !0, $6fc11d6b67175841$var$a(), $6fc11d6b67175841$var$n = !1, window.addEventListener("hashchange", $6fc11d6b67175841$var$s, !1);
    }, 300);
}, $6fc11d6b67175841$export$ab85ecd77ce6a5cd = ()=>{
    let t, e = "auto", a = "";
    function s() {
        if (!t || !t.isTopMost()) return;
        if (!1 === t.getOptions().Hash) return;
        const i = t.getCarousel();
        if (!i) return;
        const { hash: r, slug: s } = $6fc11d6b67175841$var$l(), u = t.getSlide();
        if (!u) return;
        let d = u.fancybox || "", h = parseInt(u.index + "", 10) + 1;
        if (!d) return;
        let f = `#${d}-${h}`;
        if (r !== f && (a = r), history.scrollRestoration && (e = history.scrollRestoration, history.scrollRestoration = "manual"), i.on("change", c), !$6fc11d6b67175841$var$n) {
            if (d === s) try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + f);
            } catch (t) {}
            else try {
                window.history.pushState({}, document.title, window.location.pathname + window.location.search + f), $6fc11d6b67175841$var$o = !0;
            } catch (t) {}
        }
    }
    function c() {
        if (!t || !t.isTopMost()) return;
        if (!1 === t.getOptions().Hash) return;
        const { slug: e } = $6fc11d6b67175841$var$l(), n = t.getSlide();
        if (!n) return;
        let o = n.fancybox || "", r = `#${o}-${n.index + 1}`;
        if (o === e) {
            $6fc11d6b67175841$var$i = !0;
            try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + r);
            } catch (t) {}
            $6fc11d6b67175841$var$i = !1;
        }
    }
    function u() {
        if ($6fc11d6b67175841$var$r) return;
        if (!t || !t.isTopMost()) return;
        if (!1 === t.getOptions().Hash) return;
        const e = t.getSlide();
        if (!e) return;
        if (e.fancybox || "") {
            $6fc11d6b67175841$var$i = !0;
            try {
                !$6fc11d6b67175841$var$o || $6fc11d6b67175841$var$n || function() {
                    if (window.parent === window) return !1;
                    try {
                        var t = window.frameElement;
                    } catch (e) {
                        t = null;
                    }
                    return null === t ? "data:" === location.protocol : t.hasAttribute("sandbox");
                }() ? window.history.replaceState({}, document.title, window.location.pathname + window.location.search + a) : window.history.back();
            } catch (t) {}
            $6fc11d6b67175841$var$i = !1;
        }
    }
    return {
        init: function(e) {
            t = e, t.on("ready", s), t.on("close", u);
        },
        destroy: function() {
            null == t || t.off("ready", s), null == t || t.off("close", u);
            const n = null == t ? void 0 : t.getCarousel();
            n && n.off("change", c), t = void 0, history.scrollRestoration && e && (history.scrollRestoration = e);
        }
    };
};
$6fc11d6b67175841$export$ab85ecd77ce6a5cd.startFromUrl = $6fc11d6b67175841$var$a, $6fc11d6b67175841$export$ab85ecd77ce6a5cd.setup = function(n) {
    $6fc11d6b67175841$var$e || ($6fc11d6b67175841$var$e = n, (0, $b73b213c51fa4dcc$export$71594e8a50f746f4)() && (/complete|interactive|loaded/.test(document.readyState) ? $6fc11d6b67175841$var$c() : document.addEventListener("DOMContentLoaded", $6fc11d6b67175841$var$c)));
};



/*! License details at fancyapps.com/license */ 
const $4e79b024c58abc40$export$30568d076ec2f42 = Object.assign(Object.assign({}, (0, $ff9fa40b857caa63$export$30568d076ec2f42)), {
    CLOSE: "Close",
    NEXT: "Next",
    PREV: "Previous",
    MODAL: "You can close this modal content with the ESC key",
    ELEMENT_NOT_FOUND: "HTML Element Not Found",
    IFRAME_ERROR: "Error Loading Page"
});





const $cc1723ee964ba41d$var$T = '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="M19.286 4.714 4.714 19.286M4.714 4.714l14.572 14.572" /></svg></button>';
(0, $20fc63f0f74f430d$export$4c260019440d418f)().add("close", {
    tpl: $cc1723ee964ba41d$var$T
});
const $cc1723ee964ba41d$var$A = (e)=>{
    e && e.dispatchEvent(new CustomEvent("animationend", {
        bubbles: !1,
        cancelable: !0,
        currentTarget: e
    }));
}, $cc1723ee964ba41d$var$M = (e = null, t = "", n)=>{
    if (!e || !e.parentElement || !t) return void (n && n());
    $cc1723ee964ba41d$var$A(e);
    const o = (i)=>{
        i.target === e && e.dataset.animationName && (e.removeEventListener("animationend", o), delete e.dataset.animationName, n && n(), e.classList.remove(t));
    };
    e.dataset.animationName = t, e.addEventListener("animationend", o), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(e, t);
};
var $cc1723ee964ba41d$export$b3af8f1b99ca9976;
!function(e) {
    e[e.Init = 0] = "Init", e[e.Ready = 1] = "Ready", e[e.Closing = 2] = "Closing", e[e.Destroyed = 3] = "Destroyed";
}($cc1723ee964ba41d$export$b3af8f1b99ca9976 || ($cc1723ee964ba41d$export$b3af8f1b99ca9976 = {}));
const $cc1723ee964ba41d$var$_ = {
    ajax: null,
    backdropClick: "close",
    Carousel: {},
    closeButton: "auto",
    closeExisting: !1,
    delegateEl: void 0,
    dragToClose: !0,
    fadeEffect: !0,
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    id: void 0,
    idle: !1,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    l10n: (0, $4e79b024c58abc40$export$30568d076ec2f42),
    mainClass: "",
    mainStyle: {},
    mainTpl: '<dialog class="fancybox__dialog">\n    <div class="fancybox__container" tabindex="0" aria-label="{{MODAL}}">\n      <div class="fancybox__backdrop"></div>\n      <div class="fancybox__carousel"></div>\n    </div>\n  </dialog>',
    on: {},
    parentEl: void 0,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    sync: void 0,
    theme: "dark",
    triggerEl: void 0,
    triggerEvent: void 0,
    zoomEffect: !0
}, $cc1723ee964ba41d$var$O = new Map;
let $cc1723ee964ba41d$var$D = 0;
const $cc1723ee964ba41d$var$R = "with-fancybox", $cc1723ee964ba41d$var$I = ()=>{
    let r, w, j, I, H, B = $cc1723ee964ba41d$export$b3af8f1b99ca9976.Init, N = Object.assign({}, $cc1723ee964ba41d$var$_), q = -1, V = {}, F = [], W = !1, $ = !0, K = 0;
    function U(e, ...t) {
        let n = N[e];
        return n && "function" == typeof n ? n(Pe, ...t) : n;
    }
    function X(e, t = []) {
        const n = U("l10n") || {};
        e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t)=>n[t] || e);
        for(let n = 0; n < t.length; n++)e = e.split(t[n][0]).join(t[n][1]);
        return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
    }
    const G = new Map;
    function Y(e, ...t) {
        const n = [
            ...G.get(e) || []
        ];
        for (const [t, o] of Object.entries(N.on || {}))(t === e || t.split(" ").indexOf(e) > -1) && n.push(o);
        for (const e of n)e && "function" == typeof e && e(Pe, ...t);
        "*" !== e && Y("*", e, ...t);
    }
    function Z(t = [], n = {}) {
        B !== $cc1723ee964ba41d$export$b3af8f1b99ca9976.Init && (Pe.destroy(), B = $cc1723ee964ba41d$export$b3af8f1b99ca9976.Init), N = (0, $d183dc8f1ac8b27e$export$8b58be045bf06082)({}, $cc1723ee964ba41d$var$_, n), q = U("id") || "fancybox-" + ++$cc1723ee964ba41d$var$D;
        const a = $cc1723ee964ba41d$var$O.get(q);
        if (a && a.destroy(), $cc1723ee964ba41d$var$O.set(q, Pe), Y("init"), function() {
            for (const [e, t] of Object.entries(Object.assign(Object.assign({}, $cc1723ee964ba41d$export$cb45b08d97cdc4fd.Plugins), N.plugins || {})))if (e && !V[e] && t instanceof Function) {
                const n = t();
                n.init(Pe), V[e] = n;
            }
            Y("initPlugins");
        }(), function(e = []) {
            Y("initSlides", e), F = [
                ...e
            ];
        }(t), function() {
            const t = U("parentEl") || document.body;
            if (!(t && t instanceof HTMLElement)) return;
            const n = X(U("mainTpl") || "");
            if (r = (0, $8a814a110db3ad66$export$b368690db5627d91)(n) || void 0, !r) return;
            if (w = r.querySelector(".fancybox__container"), !(w && w instanceof HTMLElement)) return;
            const l = U("mainClass");
            l && (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(w, l);
            const a = U("mainStyle");
            if (a && (0, $343f588d0e79d7b3$export$53b83ca8eaab0383)(a)) for (const [e, t] of Object.entries(a))w.style.setProperty(e, t);
            const u = U("theme"), d = "auto" === u ? window.matchMedia("(prefers-color-scheme:light)").matches : "light" === u;
            w.setAttribute("theme", d ? "light" : "dark"), r.setAttribute("id", `${q}`), r.addEventListener("keydown", (e)=>{
                "Escape" === e.key && e.preventDefault();
            }), r.addEventListener("wheel", (e)=>{
                const t = e.target;
                let n = U("wheel", e);
                t.closest(".f-thumbs") && (n = "slide");
                const o = "slide" === n, s = [
                    -e.deltaX || 0,
                    -e.deltaY || 0,
                    -e.detail || 0
                ].reduce(function(e, t) {
                    return Math.abs(t) > Math.abs(e) ? t : e;
                }), l = Math.max(-1, Math.min(1, s)), r = Date.now();
                K && r - K < 300 ? o && e.preventDefault() : (K = r, Y("wheel", e, l), e.defaultPrevented || ("close" === n ? we(e) : "slide" === n && I && !(0, $af9ab31d2acb78ba$export$e41e80160bed5714)(t) && (e.preventDefault(), I[l > 0 ? "prev" : "next"]())));
            }, {
                capture: !0,
                passive: !1
            }), r.addEventListener("cancel", (e)=>{
                we(e);
            }), t.append(r), 1 === $cc1723ee964ba41d$var$O.size && (U("hideScrollbar") && (0, $71b6a833cd4e8ed4$export$b539ed14f4f9e78)(!0), document.documentElement.classList.add($cc1723ee964ba41d$var$R));
            r instanceof HTMLDialogElement && r.showModal();
            Y("initLayout");
        }(), function() {
            if (j = (null == r ? void 0 : r.querySelector(".fancybox__carousel")) || void 0, !j) return;
            const e = (0, $d183dc8f1ac8b27e$export$8b58be045bf06082)({}, {
                Autoplay: {
                    autoStart: !1,
                    pauseOnHover: !1,
                    progressbarParentEl: (e)=>{
                        const t = e.getContainer();
                        return (null == t ? void 0 : t.querySelector(".f-carousel__toolbar [data-autoplay-action]")) || t;
                    }
                },
                Fullscreen: {
                    el: w
                },
                Toolbar: {
                    absolute: !0,
                    display: {
                        left: [
                            "counter"
                        ],
                        right: [
                            "toggleFull",
                            "autoplay",
                            "fullscreen",
                            "thumbs",
                            "close"
                        ]
                    }
                },
                Video: {
                    autoplay: !0
                },
                Thumbs: {
                    minCount: 2,
                    Carousel: {
                        classes: {
                            container: "fancybox__thumbs"
                        }
                    }
                },
                classes: {
                    container: "fancybox__carousel",
                    viewport: "fancybox__viewport",
                    slide: "fancybox__slide"
                },
                spinnerTpl: '<div class="f-spinner" data-fancybox-close></div>',
                dragFree: !1,
                slidesPerPage: 1,
                plugins: {
                    Sync: (0, $956d090b1e9b0f09$export$2ae15352e0a80063),
                    Arrows: (0, $f028c4ade87b683d$export$b6e350ab9915297a),
                    Lazyload: (0, $8debf9aa752fe8dc$export$6f539aaa4f74fdd1),
                    Zoomable: (0, $9048b1527748519a$export$b7fc409e12a7dcec),
                    Html: (0, $bff16bdf8c577655$export$13f9d3c4397c4713),
                    Video: (0, $5c2ab0a635a0e1ea$export$ae01dedf5c052bb),
                    Autoplay: (0, $d95eb579b2ac24ae$export$6c96167f46662e38),
                    Fullscreen: (0, $f8248ec59847c8c0$export$159cd03be7087f39),
                    Thumbs: (0, $20f7690e73616c4b$export$73e055b807a6709),
                    Toolbar: (0, $20fc63f0f74f430d$export$4c260019440d418f)
                }
            }, U("Carousel") || {}, {
                slides: F,
                enabled: !0,
                initialPage: U("startIndex") || 0,
                l10n: U("l10n")
            });
            I = (0, $9b8ac375a20c1e65$export$144901db2ea8e967)(j, e), Y("initCarousel", I), I.on("*", (e, t, ...n)=>{
                Y(`Carousel.${t}`, e, ...n);
            }), I.on("attachSlideEl", Q), I.on("detachSlideEl", ee), I.on("contentReady", se), I.on("ready", oe), I.on("change", ne), I.on("settle", ie), I.on("thumbs:ready", le), I.on("thumbs:destroy", le), I.init();
        }(), r && w) {
            if (U("closeExisting")) for (const [e, t] of $cc1723ee964ba41d$var$O.entries())e !== q && t.close();
            U("fadeEffect") ? (setTimeout(()=>{
                J();
            }, 500), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(w, "is-revealing")) : J(), w.classList.add("is-ready"), B = $cc1723ee964ba41d$export$b3af8f1b99ca9976.Ready, Y("ready");
        }
    }
    function J() {
        (0, $0139cdb5d63893b2$export$c2255604a80b4506)(w, "is-revealing");
        try {
            if (document.activeElement === r) ((null == w ? void 0 : w.querySelector("[autofocus]")) || w).focus();
        } catch (e) {}
    }
    function Q(e, n) {
        var o;
        de(n), null === (o = n.el) || void 0 === o || o.addEventListener("click", te), "inline" !== n.type && "clone" !== n.type || function(e) {
            if (!I || !e || !e.el) return;
            let n = null;
            if ((0, $bc360f0f1dfbc749$export$844ec244b1367d54)(e.src)) {
                const t = e.src.split("#", 2).pop();
                n = t ? document.getElementById(t) : null;
            }
            if (n) {
                if ((0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(n, "f-html"), "clone" === e.type || n.closest(".fancybox__carousel")) {
                    n = n.cloneNode(!0);
                    const t = n.dataset.animationName;
                    t && (n.classList.remove(t), delete n.dataset.animationName);
                    let o = n.getAttribute("id");
                    o = o ? `${o}--clone` : `clone-${q}-${e.index}`, n.setAttribute("id", o);
                } else if (n.parentNode) {
                    const t = document.createElement("div");
                    t.inert = !0, n.parentNode.insertBefore(t, n), e.placeholderEl = t;
                }
                e.htmlEl = n, (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(e.el, "has-html"), e.el.prepend(n), n.classList.remove("hidden"), "none" === n.style.display && (n.style.display = ""), "none" === getComputedStyle(n).getPropertyValue("display") && (n.style.display = n.dataset.display || "flex"), null == I || I.emit("contentReady", e);
            } else null == I || I.showError(e, "{{ELEMENT_NOT_FOUND}}");
        }(n), "ajax" === n.type && function(e) {
            const t = e.el;
            if (!t) return;
            if (e.htmlEl || e.xhr) return;
            null == I || I.showLoading(e), e.state = 0;
            const n = new XMLHttpRequest;
            n.onreadystatechange = function() {
                if (n.readyState === XMLHttpRequest.DONE && B === $cc1723ee964ba41d$export$b3af8f1b99ca9976.Ready) {
                    if (null == I || I.hideLoading(e), e.state = 1, 200 === n.status) {
                        let o = n.responseText + "", i = null, s = null;
                        if (e.filter) {
                            const t = document.createElement("div");
                            t.innerHTML = o, s = t.querySelector(e.filter + "");
                        }
                        s && s instanceof HTMLElement ? i = s : (i = document.createElement("div"), i.innerHTML = o), i.classList.add("f-html"), e.htmlEl = i, t.classList.add("has-html"), t.classList.add("has-ajax"), t.prepend(i), null == I || I.emit("contentReady", e);
                    } else null == I || I.showError(e);
                }
            };
            const o = U("ajax") || null;
            n.open(o ? "POST" : "GET", e.src + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(o), e.xhr = n;
        }(n);
    }
    function ee(e, t) {
        var n;
        !function(e) {
            e.closeButtonEl && (e.closeButtonEl.remove(), e.closeButtonEl = void 0);
        }(t), null === (n = t.el) || void 0 === n || n.removeEventListener("click", te), "inline" !== t.type && "clone" !== t.type || function(e) {
            const t = e.htmlEl, n = e.placeholderEl;
            t && ("none" !== getComputedStyle(t).getPropertyValue("display") && (t.style.display = "none"), t.offsetHeight);
            n && (t && n.parentNode && n.parentNode.insertBefore(t, n), n.remove());
            e.htmlEl = void 0, e.placeholderEl = void 0;
        }(t), t.xhr && (t.xhr.abort(), t.xhr = void 0);
    }
    function te(e) {
        if (!me()) return;
        if (B !== $cc1723ee964ba41d$export$b3af8f1b99ca9976.Ready) return e.preventDefault(), void e.stopPropagation();
        if (e.defaultPrevented) return;
        if (!(0, $d1d67bf17d8c2ed0$export$1f911e2d31b2843e).isClickAllowed()) return;
        const t = e.composedPath()[0];
        t.closest(".fancybox__carousel") && t.classList.contains("fancybox__slide") && re(e);
    }
    function ne() {
        $ = !1, w && I && w.classList.remove("is-revealing");
        const e = U("sync");
        if (I && e) {
            const t = e.getPageIndex(I.getPageIndex()) || 0;
            e.goTo(t, {
                transition: !1
            });
        }
    }
    function oe() {
        var e;
        if (B !== $cc1723ee964ba41d$export$b3af8f1b99ca9976.Ready) return;
        fe(pe()), function() {
            if (!U("dragToClose")) return;
            if (!I) return;
            const e = I.getViewport();
            if (!e) return;
            const t = (0, $d1d67bf17d8c2ed0$export$1f911e2d31b2843e)(e).init();
            if (!t) return;
            let n = 0, o = 0, s = (0, $4397b247ae6d78b1$export$208a41d6b4e37b97)().on("step", (e)=>{
                n = e.y;
                const t = null == I ? void 0 : I.getViewport();
                if (w && t) {
                    const e = (0, $f4b601cd4abee47d$export$871de8747c9eaa88)(Math.abs(n), 0, .5 * t.getBoundingClientRect().height, 1, .5);
                    w.style.setProperty("--f-drag-opacity", e + ""), w.style.setProperty("--f-drag-offset", n + "px");
                }
            }).on("end", ()=>{
                if (!n) {
                    w && w.style.removeProperty("--f-opacity");
                    const e = null == I ? void 0 : I.getViewport();
                    e && (e.style.transform = "");
                }
            });
            t.on("start", function() {
                s.pause();
            }).on("panstart", (e)=>{
                var t;
                const n = e.srcEvent.target;
                n && !(0, $af9ab31d2acb78ba$export$e41e80160bed5714)(n) && (null === (t = null == I ? void 0 : I.getViewport()) || void 0 === t || t.classList.add("is-dragging"));
            }).on("pan", function(e) {
                const t = e.srcEvent.target;
                if (t && (0, $af9ab31d2acb78ba$export$e41e80160bed5714)(t)) return;
                (null == I ? void 0 : I.getViewport()) && "y" === e.axis && (o += e.deltaY, s.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 860,
                    friction: 17,
                    restDelta: .01,
                    restSpeed: .01
                }).from({
                    y: n
                }).to({
                    y: o
                }).start());
            }).on("end", function(e) {
                s.pause(), "y" === e.axis && Math.abs(e.velocityY) > 5 && Math.abs(o) > 0 && (we(e.srcEvent, "f-throwOut" + (e.velocityY > 0 ? "Down" : "Up")), B === $cc1723ee964ba41d$export$b3af8f1b99ca9976.Closing) || 0 !== o && (o = 0, s.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 140,
                    friction: 25,
                    restDelta: .1,
                    restSpeed: .1,
                    maxSpeed: 1 / 0
                }).from({
                    y: n
                }).to({
                    y: o
                }).start());
            });
        }(), document.body.addEventListener("click", ue), document.body.addEventListener("keydown", ce, {
            passive: !1,
            capture: !0
        }), he();
        const t = U("sync");
        t && (null === (e = t.getTween()) || void 0 === e || e.start());
    }
    function ie() {
        (null == I ? void 0 : I.canGoNext()) ? he() : xe();
    }
    function se(e, t) {
        de(t), fe(t);
    }
    function le() {
        var e;
        const t = null == I ? void 0 : I.getPlugins().Thumbs;
        (0, $6148d53608c1432f$export$4a80062ca50b57c7)(w, "has-thumbs", (null == t ? void 0 : t.isEnabled()) || !1), (0, $6148d53608c1432f$export$4a80062ca50b57c7)(w, "has-vertical-thumbs", (null === (e = null == t ? void 0 : t.getCarousel()) || void 0 === e ? void 0 : e.isVertical()) || !1);
    }
    function re(e) {
        if (!!e.composedPath()[0].closest("[data-fancybox-close]")) return void we(e);
        if (Y("backdropClick", e), e.defaultPrevented) return;
        U("backdropClick") && we(e);
    }
    function ae() {
        Ee();
    }
    function ce(e) {
        if (!me()) return;
        if (B !== $cc1723ee964ba41d$export$b3af8f1b99ca9976.Ready) return;
        const t = e.key, o = U("keyboard");
        if (!o) return;
        if (e.ctrlKey || e.altKey || e.shiftKey) return;
        const i = e.composedPath()[0];
        if (!(0, $556b1b852427b8a8$export$8ee0fc9ee280b4ee)(i)) return;
        if ("Escape" !== t && ((e)=>{
            const t = [
                "input",
                "textarea",
                "select",
                "option",
                "video",
                "iframe",
                "[contenteditable]",
                "[data-selectable]",
                "[data-draggable]"
            ].join(",");
            return e.matches(t) || e.closest(t);
        })(i)) return;
        if (Y("keydown", e), e.defaultPrevented) return;
        const s = o[t];
        if (s) switch(s){
            case "close":
                we(e);
                break;
            case "next":
                e.preventDefault(), null == I || I.next();
                break;
            case "prev":
                e.preventDefault(), null == I || I.prev();
        }
    }
    function ue(e) {
        if (!me()) return;
        if (B !== $cc1723ee964ba41d$export$b3af8f1b99ca9976.Ready) return;
        if (Ee(), e.defaultPrevented) return;
        const t = e.composedPath()[0], n = !!t.closest("[data-fancybox-close]"), o = t.classList.contains("fancybox__backdrop");
        (n || o) && re(e);
    }
    function de(e) {
        var t;
        const { el: n, htmlEl: i, closeButtonEl: s } = e;
        if (!n || !i || s) return;
        let l = U("closeButton");
        if ("auto" === l && (l = !0 !== (null === (t = null == I ? void 0 : I.getPlugins().Toolbar) || void 0 === t ? void 0 : t.isEnabled())), l) {
            const t = (0, $8a814a110db3ad66$export$b368690db5627d91)(X($cc1723ee964ba41d$var$T));
            t && (e.closeButtonEl = i.insertAdjacentElement("afterbegin", t), n.classList.add("has-close-btn"));
        }
    }
    function fe(e) {
        if (!($ && I && 1 === I.getState() && e && e.index === I.getOptions().initialPage && e.el && e.el.parentElement)) return;
        if (void 0 !== e.state && 1 !== e.state) return;
        $ = !1;
        const t = e.panzoomRef, n = null == t ? void 0 : t.getTween(), o = U("zoomEffect") ? ve(e) : void 0;
        if (t && n && o) {
            const e = t.getScale("base") || 1, { x: i, y: s } = t.getMousemovePos(e) || {
                x: 0,
                y: 0
            };
            return void n.spring({
                tension: 225,
                friction: 25,
                restDelta: .001,
                restSpeed: .001,
                maxSpeed: 1 / 0
            }).from(o).to({
                x: i,
                y: s,
                scale: e
            }).start();
        }
        const i = (null == t ? void 0 : t.getWrapper()) || e.htmlEl;
        i && $cc1723ee964ba41d$var$M(i, U("showClass", e));
    }
    function me() {
        var e;
        return (null === (e = $cc1723ee964ba41d$export$cb45b08d97cdc4fd.getInstance()) || void 0 === e ? void 0 : e.getId()) === q;
    }
    function pe() {
        var e;
        return null === (e = null == I ? void 0 : I.getPage()) || void 0 === e ? void 0 : e.slides[0];
    }
    function ge() {
        const e = pe();
        return e ? e.triggerEl || U("triggerEl") : void 0;
    }
    function ve(e) {
        var t, n;
        const o = null === (n = null === (t = e.panzoomRef) || void 0 === t ? void 0 : t.getWrapper()) || void 0 === n ? void 0 : n.getBoundingClientRect(), i = null == o ? void 0 : o.width, s = null == o ? void 0 : o.height;
        if (!i || !s) return;
        const l = e.thumbEl;
        if (!l) return;
        const r = l.getBoundingClientRect();
        let a = r.width, c = r.height, u = r.left, d = r.top;
        if (!r || !a || !c) return;
        if (!((e)=>{
            const t = e.getBoundingClientRect(), n = e.closest("[style]"), o = null == n ? void 0 : n.parentElement;
            if (n && n.style.transform && o) {
                const e = o.getBoundingClientRect();
                if (t.left < e.left || t.left > e.left + e.width - t.width) return !1;
                if (t.top < e.top || t.top > e.top + e.height - t.height) return !1;
            }
            const i = Math.max(document.documentElement.clientHeight, window.innerHeight), s = Math.max(document.documentElement.clientWidth, window.innerWidth);
            return !(t.bottom < 0 || t.top - i >= 0 || t.right < 0 || t.left - s >= 0);
        })(l)) return;
        if (l instanceof HTMLImageElement) {
            const e = window.getComputedStyle(l).getPropertyValue("object-fit");
            if ("contain" === e || "scale-down" === e) {
                const { width: t, height: n } = ((e, t, n, o, i = "contain")=>{
                    if ("contain" === i || e > n || t > o) {
                        const i = n / e, s = o / t, l = Math.min(i, s);
                        e *= l, t *= l;
                    }
                    return {
                        width: e,
                        height: t
                    };
                })(l.naturalWidth, l.naturalHeight, a, c, e);
                u += .5 * (a - t), d += .5 * (c - n), a = t, c = n;
            }
        }
        if (Math.abs(i / s - a / c) > .1) return;
        return {
            x: u + .5 * a - (o.left + .5 * i),
            y: d + .5 * c - (o.top + .5 * s),
            scale: a / i
        };
    }
    function ye() {
        H && clearTimeout(H), H = void 0, document.removeEventListener("mousemove", ae);
    }
    function he() {
        if (W) return;
        if (H) return;
        const e = U("idle");
        e && (H = setTimeout(be, e));
    }
    function be() {
        w && (ye(), (0, $8cf35f8bcc021ff3$export$d2cf6cd1dc7067d3)(w, "is-idle"), document.addEventListener("mousemove", ae), W = !0);
    }
    function Ee() {
        W && (xe(), he());
    }
    function xe() {
        ye(), null == w || w.classList.remove("is-idle"), W = !1;
    }
    function we(e, t) {
        var n, o, i, s, r, a;
        if (B === $cc1723ee964ba41d$export$b3af8f1b99ca9976.Closing || B === $cc1723ee964ba41d$export$b3af8f1b99ca9976.Destroyed) return;
        const c = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (Y("shouldClose", c, e), c.defaultPrevented) return;
        if (ye(), e) {
            if (e.defaultPrevented) return;
            e.cancelable && e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
        }
        if (B = $cc1723ee964ba41d$export$b3af8f1b99ca9976.Closing, I) {
            null === (n = I.getGestures()) || void 0 === n || n.destroy(), null === (o = I.getTween()) || void 0 === o || o.pause();
            const e = pe(), t = null == e ? void 0 : e.panzoomRef;
            e && t && (0, $d183dc8f1ac8b27e$export$8b58be045bf06082)(t.getOptions(), {
                clickAction: !1,
                wheelAction: !1,
                bounds: !1,
                minScale: 0,
                maxScale: 1 / 0
            });
            for (const e of I.getSlides())null === (s = null === (i = e.panzoomRef) || void 0 === i ? void 0 : i.getGestures()) || void 0 === s || s.destroy(), null === (a = null === (r = e.panzoomRef) || void 0 === r ? void 0 : r.getTween()) || void 0 === a || a.pause();
        }
        const u = null == I ? void 0 : I.getPlugins().fullscreen;
        u && u.inFullscreen() ? Promise.resolve(u.exit()).then(()=>{
            setTimeout(()=>{
                Le(e, t);
            }, 150);
        }) : Le(e, t);
    }
    function Le(e, t) {
        var n, o, i, s, l;
        if (B !== $cc1723ee964ba41d$export$b3af8f1b99ca9976.Closing) return;
        if (Y("close", e), U("placeFocusBack")) {
            const e = ge();
            !e || (l = e.getBoundingClientRect()).bottom > 0 && l.right > 0 && l.left < (window.innerWidth || document.documentElement.clientWidth) && l.top < (window.innerHeight || document.documentElement.clientHeight) || e.scrollIntoView({
                behavior: "instant",
                block: "center",
                inline: "center"
            });
        }
        U("fadeEffect") && (null == w || w.classList.remove("is-ready"), null == w || w.classList.add("is-hiding")), null == w || w.classList.add("is-closing");
        const r = pe(), a = null == r ? void 0 : r.panzoomRef, c = null === (n = null == r ? void 0 : r.panzoomRef) || void 0 === n ? void 0 : n.getTween(), d = t || U("hideClass");
        let f = !1, m = !1;
        if (I && r && a && c) {
            let e;
            U("zoomEffect") && ((null === (i = null === (o = I.getTween()) || void 0 === o ? void 0 : o.getCurrentVelocities()) || void 0 === i ? void 0 : i.pos) || 0) < 700 && 1 === r.state && (e = ve(r)), e && (f = !0, I.on("refresh", ()=>{
                const e = ve(r);
                e && c.to(Object.assign(Object.assign({}, (0, $d05bed9ea06f74d2$export$15463f5204f2871f)), e));
            }), c.easing((0, $4397b247ae6d78b1$export$208a41d6b4e37b97).Easings.EaseOut).duration(350).from(Object.assign({}, a.getTransform())).to(Object.assign(Object.assign({}, (0, $d05bed9ea06f74d2$export$15463f5204f2871f)), e)).start());
        }
        const p = (null == r ? void 0 : r.htmlEl) || (null === (s = null == r ? void 0 : r.panzoomRef) || void 0 === s ? void 0 : s.getWrapper());
        p && $cc1723ee964ba41d$var$A(p), !f && d && p && (m = !0, $cc1723ee964ba41d$var$M(p, d, ()=>{
            je();
        })), f || m ? setTimeout(()=>{
            je();
        }, 350) : je();
    }
    function je() {
        var e, t, n, o, i;
        if (B === $cc1723ee964ba41d$export$b3af8f1b99ca9976.Destroyed) return;
        B = $cc1723ee964ba41d$export$b3af8f1b99ca9976.Destroyed, document.body.removeEventListener("click", ue), document.body.removeEventListener("keydown", ce, {
            passive: !1,
            capture: !0
        });
        const l = ge();
        Y("destroy"), null === (t = null === (e = U("sync")) || void 0 === e ? void 0 : e.getPlugins().Autoplay) || void 0 === t || t.resume(), null === (o = null === (n = U("sync")) || void 0 === n ? void 0 : n.getPlugins().Autoscroll) || void 0 === o || o.resume(), r instanceof HTMLDialogElement && r.close(), null === (i = null == I ? void 0 : I.getContainer()) || void 0 === i || i.classList.remove("is-idle"), null == I || I.destroy();
        for (const e of Object.values(V))null == e || e.destroy();
        if (V = {}, null == r || r.remove(), r = void 0, w = void 0, I = void 0, $cc1723ee964ba41d$var$O.delete(q), !$cc1723ee964ba41d$var$O.size && ((0, $71b6a833cd4e8ed4$export$b539ed14f4f9e78)(!1), document.documentElement.classList.remove($cc1723ee964ba41d$var$R), U("placeFocusBack"))) try {
            null == l || l.focus({
                preventScroll: !0
            });
        } catch (e) {}
    }
    const Pe = {
        close: we,
        destroy: je,
        getCarousel: function() {
            return I;
        },
        getContainer: function() {
            return w;
        },
        getId: function() {
            return q;
        },
        getOptions: function() {
            return N;
        },
        getPlugins: function() {
            return V;
        },
        getSlide: function() {
            return pe();
        },
        getState: function() {
            return B;
        },
        init: function(e = [], t = {}) {
            return Z(e, t), Pe;
        },
        isCurrentSlide: function(e) {
            const t = pe();
            return !(!e || !t) && t.index === e.index;
        },
        isTopMost: function() {
            return me();
        },
        off: function(e, t) {
            return G.has(e) && G.set(e, G.get(e).filter((e)=>e !== t)), Pe;
        },
        on: function(e, t) {
            return G.set(e, [
                ...G.get(e) || [],
                t
            ]), Pe;
        },
        toggleIdle (e) {
            (W || !0 === e) && be(), W && !1 !== e || xe();
        }
    };
    return Pe;
};
const $cc1723ee964ba41d$export$cb45b08d97cdc4fd = {
    Plugins: {
        Hash: (0, $6fc11d6b67175841$export$ab85ecd77ce6a5cd)
    },
    version: "6.0.26",
    openers: new Map,
    bind: function(e, n, o) {
        if (!(0, $b73b213c51fa4dcc$export$71594e8a50f746f4)()) return;
        let i = document.body, s = "[data-fancybox]", l = {};
        if ((0, $bc360f0f1dfbc749$export$844ec244b1367d54)(e) ? (i = document.body, s = e, "object" == typeof n && (l = n || {})) : e instanceof Element && (i = e, (0, $bc360f0f1dfbc749$export$844ec244b1367d54)(n) && (s = n), "object" == typeof o && (l = o || {})), !(i && i instanceof Element && s)) return !1;
        const a = $cc1723ee964ba41d$export$cb45b08d97cdc4fd.openers.get(i) || new Map;
        if (a.set(s, l), $cc1723ee964ba41d$export$cb45b08d97cdc4fd.openers.set(i, a), 1 === a.size) {
            i.addEventListener("click", $cc1723ee964ba41d$export$cb45b08d97cdc4fd.fromEvent);
            for (const e of Object.values($cc1723ee964ba41d$export$cb45b08d97cdc4fd.Plugins)){
                const t = e.setup;
                "function" == typeof t && t($cc1723ee964ba41d$export$cb45b08d97cdc4fd);
            }
        }
        return !0;
    },
    close: function(e = !0, ...t) {
        if (e) for (const e of $cc1723ee964ba41d$var$O.values())e.close(...t);
        else {
            const e = $cc1723ee964ba41d$export$cb45b08d97cdc4fd.getInstance();
            e && e.close(...t);
        }
    },
    destroy: function() {
        let e;
        for(; e = $cc1723ee964ba41d$export$cb45b08d97cdc4fd.getInstance();)e.destroy();
        for (const e of $cc1723ee964ba41d$export$cb45b08d97cdc4fd.openers.keys())e.removeEventListener("click", $cc1723ee964ba41d$export$cb45b08d97cdc4fd.fromEvent);
        $cc1723ee964ba41d$export$cb45b08d97cdc4fd.openers.clear();
    },
    fromEvent: function(e) {
        var t, n, o;
        if (e.defaultPrevented) return;
        if (e.button && 0 !== e.button) return;
        if (e.ctrlKey || e.metaKey || e.shiftKey) return;
        let i = e.composedPath()[0];
        if (i.closest(".fancybox__container.is-hiding")) return e.preventDefault(), void e.stopPropagation();
        const s = i.closest("[data-fancybox-delegate]") || void 0;
        if (s) {
            const e = s.dataset.fancyboxDelegate || "", t = document.querySelectorAll(`[data-fancybox="${e}"]`);
            i = t[parseInt(s.dataset.fancyboxIndex || "", 10) || 0] || t[0];
        }
        if (!(i && i instanceof Element)) return;
        let r, a, c = {};
        for (const [e, t] of $cc1723ee964ba41d$export$cb45b08d97cdc4fd.openers)if (t && e.contains(i)) for (const [n, o] of t){
            let t = null;
            try {
                t = i.closest(n);
            } catch (e) {}
            t && (i = t, r = e, a = n, (0, $d183dc8f1ac8b27e$export$8b58be045bf06082)(c, o || {}));
        }
        if (!r || !a) return;
        e.preventDefault();
        const u = (0, $d183dc8f1ac8b27e$export$8b58be045bf06082)({}, $cc1723ee964ba41d$var$_, {
            triggerEvent: e,
            triggerEl: i,
            delegateEl: s
        }, c), d = u.groupAll, f = u.groupAttr, m = f && i ? i.getAttribute(`${f}`) : "";
        let p = [];
        const g = null === (t = i.closest(".f-carousel")) || void 0 === t ? void 0 : t.carousel;
        if (g) {
            const e = [];
            for (const t of null == g ? void 0 : g.getSlides()){
                const n = t.el;
                n && (n.matches(a) ? e.push(n) : e.push(...[].slice.call(n.querySelectorAll(a))));
            }
            e.length && (p = [
                ...e
            ], null === (n = g.getPlugins().Autoplay) || void 0 === n || n.pause(), null === (o = g.getPlugins().Autoscroll) || void 0 === o || o.pause(), u.sync = g);
        } else (!i || m || d) && (p = [].slice.call(r.querySelectorAll(a)));
        if (i && !d && (p = m ? p.filter((e)=>e.getAttribute(`${f}`) === m) : [
            i
        ]), !p.length) return;
        const v = $cc1723ee964ba41d$export$cb45b08d97cdc4fd.getInstance();
        if (v) {
            const e = v.getOptions().triggerEl;
            if (e && p.indexOf(e) > -1) return;
        }
        return Object.assign({}, u.Carousel || {}).rtl && (p = p.reverse()), i && (u.startIndex = p.indexOf(i)), $cc1723ee964ba41d$export$cb45b08d97cdc4fd.fromNodes(p, u);
    },
    fromNodes: function(e, t) {
        t = (0, $d183dc8f1ac8b27e$export$8b58be045bf06082)({}, $cc1723ee964ba41d$var$_, t || {});
        const n = [], o = (e)=>e instanceof HTMLImageElement ? e : e instanceof HTMLElement ? e.querySelector("img:not([aria-hidden])") : void 0;
        for (const i of e){
            const s = i.dataset || {}, l = t.delegateEl && e.indexOf(i) === t.startIndex ? t.delegateEl : void 0, r = o(l) || o(i) || void 0, a = s.src || i.getAttribute("href") || i.getAttribute("currentSrc") || i.getAttribute("src") || void 0, c = s.thumb || s.thumbSrc || (null == r ? void 0 : r.getAttribute("currentSrc")) || (null == r ? void 0 : r.getAttribute("src")) || (null == r ? void 0 : r.dataset.lazySrc) || void 0, u = {
                src: a,
                alt: s.alt || (null == r ? void 0 : r.getAttribute("alt")) || void 0,
                thumbSrc: c,
                thumbEl: r,
                triggerEl: i,
                delegateEl: l
            };
            for(const e in s){
                let t = s[e] + "";
                t = "false" !== t && ("true" === t || t), u[e] = t;
            }
            n.push(u);
        }
        return $cc1723ee964ba41d$export$cb45b08d97cdc4fd.show(n, t);
    },
    fromSelector: function(e, n, o) {
        let i = document.body, s = "", r = {};
        if ((0, $bc360f0f1dfbc749$export$844ec244b1367d54)(e) ? s = e : e instanceof Element && (i = e, (0, $bc360f0f1dfbc749$export$844ec244b1367d54)(n) && (s = n), "object" == typeof o && (r = o || {})), !(i && i instanceof Element && s)) return;
        const a = $cc1723ee964ba41d$export$cb45b08d97cdc4fd.openers.get(i);
        return a ? (r = (0, $d183dc8f1ac8b27e$export$8b58be045bf06082)({}, a.get(s) || {}, r), r ? $cc1723ee964ba41d$export$cb45b08d97cdc4fd.fromNodes(Array.from(i.querySelectorAll(s)), r) : void 0) : void 0;
    },
    getCarousel: function() {
        var e;
        return (null === (e = $cc1723ee964ba41d$export$cb45b08d97cdc4fd.getInstance()) || void 0 === e ? void 0 : e.getCarousel()) || void 0;
    },
    getDefaults: function() {
        return $cc1723ee964ba41d$var$_;
    },
    getInstance: function(e) {
        if (e) {
            const t = $cc1723ee964ba41d$var$O.get(e);
            return t && t.getState() !== $cc1723ee964ba41d$export$b3af8f1b99ca9976.Destroyed ? t : void 0;
        }
        return Array.from($cc1723ee964ba41d$var$O.values()).reverse().find((e)=>{
            if (e.getState() !== $cc1723ee964ba41d$export$b3af8f1b99ca9976.Destroyed) return e;
        }) || void 0;
    },
    getSlide: function() {
        var e;
        return (null === (e = $cc1723ee964ba41d$export$cb45b08d97cdc4fd.getInstance()) || void 0 === e ? void 0 : e.getSlide()) || void 0;
    },
    show: function(e = [], t = {}) {
        return $cc1723ee964ba41d$var$I().init(e, t);
    },
    unbind: function(e, n) {
        let o = document.body, i = "";
        if ((0, $bc360f0f1dfbc749$export$844ec244b1367d54)(e) ? i = e : e instanceof Element && (o = e, (0, $bc360f0f1dfbc749$export$844ec244b1367d54)(n) && (i = n)), o) {
            const e = $cc1723ee964ba41d$export$cb45b08d97cdc4fd.openers.get(o);
            e && i && e.delete(i), (null == e ? void 0 : e.size) && i || $cc1723ee964ba41d$export$cb45b08d97cdc4fd.openers.delete(o), o.removeEventListener("click", $cc1723ee964ba41d$export$cb45b08d97cdc4fd.fromEvent);
        }
    }
};














var $e0442f89a2161822$exports = {};
/*! smooth-scroll v16.1.3 | (c) 2020 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/smooth-scroll */ window.Element && !Element.prototype.closest && (Element.prototype.closest = function(e) {
    var t, n = (this.document || this.ownerDocument).querySelectorAll(e), o = this;
    do {
        for(t = n.length; 0 <= --t && n.item(t) !== o;);
    }while (t < 0 && (o = o.parentElement));
    return o;
}), function() {
    if ("function" == typeof window.CustomEvent) return;
    function e(e, t) {
        t = t || {
            bubbles: !1,
            cancelable: !1,
            detail: void 0
        };
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n;
    }
    e.prototype = window.Event.prototype, window.CustomEvent = e;
}(), function() {
    for(var r = 0, e = [
        "ms",
        "moz",
        "webkit",
        "o"
    ], t = 0; t < e.length && !window.requestAnimationFrame; ++t)window.requestAnimationFrame = window[e[t] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[e[t] + "CancelAnimationFrame"] || window[e[t] + "CancelRequestAnimationFrame"];
    window.requestAnimationFrame || (window.requestAnimationFrame = function(e, t) {
        var n = (new Date).getTime(), o = Math.max(0, 16 - (n - r)), a = window.setTimeout(function() {
            e(n + o);
        }, o);
        return r = n + o, a;
    }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(e) {
        clearTimeout(e);
    });
}(), function(e, t) {
    "function" == typeof define && define.amd ? define([], function() {
        return t(e);
    }) : $e0442f89a2161822$exports = t(e);
}("undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof window ? window : $e0442f89a2161822$exports, function(M) {
    "use strict";
    var q = {
        ignore: "[data-scroll-ignore]",
        header: null,
        topOnEmptyHash: !0,
        speed: 500,
        speedAsDuration: !1,
        durationMax: null,
        durationMin: null,
        clip: !0,
        offset: 0,
        easing: "easeInOutCubic",
        customEasing: null,
        updateURL: !0,
        popstate: !0,
        emitEvents: !0
    }, I = function() {
        var n = {};
        return Array.prototype.forEach.call(arguments, function(e) {
            for(var t in e){
                if (!e.hasOwnProperty(t)) return;
                n[t] = e[t];
            }
        }), n;
    }, r = function(e) {
        "#" === e.charAt(0) && (e = e.substr(1));
        for(var t, n = String(e), o = n.length, a = -1, r = "", i = n.charCodeAt(0); ++a < o;){
            if (0 === (t = n.charCodeAt(a))) throw new InvalidCharacterError("Invalid character: the input contains U+0000.");
            1 <= t && t <= 31 || 127 == t || 0 === a && 48 <= t && t <= 57 || 1 === a && 48 <= t && t <= 57 && 45 === i ? r += "\\" + t.toString(16) + " " : r += 128 <= t || 45 === t || 95 === t || 48 <= t && t <= 57 || 65 <= t && t <= 90 || 97 <= t && t <= 122 ? n.charAt(a) : "\\" + n.charAt(a);
        }
        return "#" + r;
    }, F = function() {
        return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
    }, L = function(e) {
        var t;
        return e ? (t = e, parseInt(M.getComputedStyle(t).height, 10) + e.offsetTop) : 0;
    }, x = function(e, t, n) {
        0 === e && document.body.focus(), n || (e.focus(), document.activeElement !== e && (e.setAttribute("tabindex", "-1"), e.focus(), e.style.outline = "none"), M.scrollTo(0, t));
    }, H = function(e, t, n, o) {
        if (t.emitEvents && "function" == typeof M.CustomEvent) {
            var a = new CustomEvent(e, {
                bubbles: !0,
                detail: {
                    anchor: n,
                    toggle: o
                }
            });
            document.dispatchEvent(a);
        }
    };
    return function(o, e) {
        var b, a, A, O, C = {};
        C.cancelScroll = function(e) {
            cancelAnimationFrame(O), O = null, e || H("scrollCancel", b);
        }, C.animateScroll = function(a, r, e) {
            C.cancelScroll();
            var i = I(b || q, e || {}), c = "[object Number]" === Object.prototype.toString.call(a), t = c || !a.tagName ? null : a;
            if (c || t) {
                var s = M.pageYOffset;
                i.header && !A && (A = document.querySelector(i.header));
                var n, o, u, l, m, d, f, h, p = L(A), g = c ? a : function(e, t, n, o) {
                    var a = 0;
                    if (e.offsetParent) for(; a += e.offsetTop, e = e.offsetParent;);
                    return a = Math.max(a - t - n, 0), o && (a = Math.min(a, F() - M.innerHeight)), a;
                }(t, p, parseInt("function" == typeof i.offset ? i.offset(a, r) : i.offset, 10), i.clip), y = g - s, v = F(), w = 0, S = (n = y, u = (o = i).speedAsDuration ? o.speed : Math.abs(n / 1e3 * o.speed), o.durationMax && u > o.durationMax ? o.durationMax : o.durationMin && u < o.durationMin ? o.durationMin : parseInt(u, 10)), E = function(e) {
                    var t, n, o;
                    l || (l = e), w += e - l, d = s + y * (n = m = 1 < (m = 0 === S ? 0 : w / S) ? 1 : m, "easeInQuad" === (t = i).easing && (o = n * n), "easeOutQuad" === t.easing && (o = n * (2 - n)), "easeInOutQuad" === t.easing && (o = n < .5 ? 2 * n * n : (4 - 2 * n) * n - 1), "easeInCubic" === t.easing && (o = n * n * n), "easeOutCubic" === t.easing && (o = --n * n * n + 1), "easeInOutCubic" === t.easing && (o = n < .5 ? 4 * n * n * n : (n - 1) * (2 * n - 2) * (2 * n - 2) + 1), "easeInQuart" === t.easing && (o = n * n * n * n), "easeOutQuart" === t.easing && (o = 1 - --n * n * n * n), "easeInOutQuart" === t.easing && (o = n < .5 ? 8 * n * n * n * n : 1 - 8 * --n * n * n * n), "easeInQuint" === t.easing && (o = n * n * n * n * n), "easeOutQuint" === t.easing && (o = 1 + --n * n * n * n * n), "easeInOutQuint" === t.easing && (o = n < .5 ? 16 * n * n * n * n * n : 1 + 16 * --n * n * n * n * n), t.customEasing && (o = t.customEasing(n)), o || n), M.scrollTo(0, Math.floor(d)), function(e, t) {
                        var n = M.pageYOffset;
                        if (e == t || n == t || (s < t && M.innerHeight + n) >= v) return C.cancelScroll(!0), x(a, t, c), H("scrollStop", i, a, r), O = l = null, true;
                    }(d, g) || (O = M.requestAnimationFrame(E), l = e);
                };
                0 === M.pageYOffset && M.scrollTo(0, 0), f = a, h = i, c || history.pushState && h.updateURL && history.pushState({
                    smoothScroll: JSON.stringify(h),
                    anchor: f.id
                }, document.title, f === document.documentElement ? "#top" : "#" + f.id), "matchMedia" in M && M.matchMedia("(prefers-reduced-motion)").matches ? x(a, Math.floor(g), !1) : (H("scrollStart", i, a, r), C.cancelScroll(!0), M.requestAnimationFrame(E));
            }
        };
        var t = function(e) {
            if (!e.defaultPrevented && !(0 !== e.button || e.metaKey || e.ctrlKey || e.shiftKey) && "closest" in e.target && (a = e.target.closest(o)) && "a" === a.tagName.toLowerCase() && !e.target.closest(b.ignore) && a.hostname === M.location.hostname && a.pathname === M.location.pathname && /#/.test(a.href)) {
                var t, n;
                try {
                    t = r(decodeURIComponent(a.hash));
                } catch (e) {
                    t = r(a.hash);
                }
                if ("#" === t) {
                    if (!b.topOnEmptyHash) return;
                    n = document.documentElement;
                } else n = document.querySelector(t);
                (n = n || "#top" !== t ? n : document.documentElement) && (e.preventDefault(), function(e) {
                    if (history.replaceState && e.updateURL && !history.state) {
                        var t = M.location.hash;
                        t = t || "", history.replaceState({
                            smoothScroll: JSON.stringify(e),
                            anchor: t || M.pageYOffset
                        }, document.title, t || M.location.href);
                    }
                }(b), C.animateScroll(n, a));
            }
        }, n = function(e) {
            if (null !== history.state && history.state.smoothScroll && history.state.smoothScroll === JSON.stringify(b)) {
                var t = history.state.anchor;
                "string" == typeof t && t && !(t = document.querySelector(r(history.state.anchor))) || C.animateScroll(t, null, {
                    updateURL: !1
                });
            }
        };
        C.destroy = function() {
            b && (document.removeEventListener("click", t, !1), M.removeEventListener("popstate", n, !1), C.cancelScroll(), O = A = a = b = null);
        };
        return function() {
            if (!("querySelector" in document && "addEventListener" in M && "requestAnimationFrame" in M && "closest" in M.Element.prototype)) throw "Smooth Scroll: This browser does not support the required JavaScript methods and browser APIs.";
            C.destroy(), b = I(q, e || {}), A = b.header ? document.querySelector(b.header) : null, document.addEventListener("click", t, !1), b.updateURL && b.popstate && M.addEventListener("popstate", n, !1);
        }(), C;
    };
});



function $a6df9c40ba402dc9$export$3ae94a2503e890a1(timestamp) {
    const days = [
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu",
        "Minggu"
    ];
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ];
    const date = new Date(timestamp);
    const day = days[date.getDay()];
    const month = months[date.getMonth()];
    return `${day}, ${date.getDate()} ${month} ${date.getFullYear()}`;
}
function $a6df9c40ba402dc9$export$feb80e120a50087f(element, separator = ".") {
    const textLength = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element).text().length;
    if (textLength > 6) {
        const firstPart = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element).text().slice(0, textLength - 6);
        const middlePart = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element).text().slice(textLength - 6, textLength - 3);
        const lastPart = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element).text().slice(textLength - 3, textLength);
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element).text(`${firstPart}${separator}${middlePart}${separator}${lastPart}`);
    } else if (textLength > 3) {
        const lastPart = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element).text().slice(textLength - 3, textLength);
        const firstPart = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element).text().slice(0, textLength - 3);
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element).text(`${firstPart}${separator}${lastPart}`);
    } else (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element).text(0);
}
function $a6df9c40ba402dc9$export$ec7c9cb9653b3275(event, prevX, prevY) {
    let direction;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).width() > 768) direction = event.pageX > prevX ? "left" : event.pageX < prevX ? "right" : direction;
    else direction = event.pageY < prevY ? "down" : event.pageY > prevY ? "up" : direction;
    return direction;
}
function $a6df9c40ba402dc9$export$bd9529c9fe839a6e(array = [], key, order) {
    return array.sort(function(a, b) {
        return order === "asc" ? new Date(a[key]) - new Date(b[key]) : new Date(b[key]) - new Date(a[key]);
    });
}
function $a6df9c40ba402dc9$export$cf2683946e25dd6c(str, length) {
    return str.length > length ? `${str.slice(0, length)}...` : str;
}


var $c31cf161124fb2c8$exports = {};
$c31cf161124fb2c8$exports = JSON.parse('{"pageProps":{"category":{"id":2,"count":61,"description":"Informasi terkini mengenai COVID-19. 100% faktual, dari sumber-sumber terpercaya.","name":"Artikel","slug":"artikel"},"posts":[{"id":2192,"date_gmt":"2021-10-05T14:16:46","modified_gmt":"2021-10-05T14:22:35","slug":"pentingnya-vaksinasi-untuk-sekolah-tatap-muka","type":"post","title":{"rendered":"Pentingnya Vaksinasi Untuk Sekolah Tatap Muka"},"excerpt":{"rendered":"<p>Pembukaan sekolah sudah mulai berjalan. Namun pertanyaannya yang sama juga masih bergaung, \u201CAmankah?\u201D</p>","protected":false},"author":2},{"id":2135,"date_gmt":"2021-07-24T03:35:57","modified_gmt":"2021-07-24T03:36:26","slug":"varian-delta-yang-perlu-anda-ketahui","type":"post","title":{"rendered":"Varian Delta: Yang Perlu Anda Ketahui"},"excerpt":{"rendered":"<p>Simak rangkuman tentang varian delta yang perlu anda ketahui</p>","protected":false},"author":2},{"id":2066,"date_gmt":"2021-07-16T12:15:49","modified_gmt":"2021-07-21T01:03:43","slug":"panduan-menyambut-ibadah-idul-adha-2021","type":"post","title":{"rendered":"Panduan Menyambut Ibadah Idul Adha 2021 :"},"excerpt":{"rendered":"<p>Simak panduan berikut untuk menyambut ibadah Idul Adha 2021 yang dikeluarkan oleh Kementrian Agama</p>","protected":false},"author":2},{"id":1964,"date_gmt":"2021-06-19T07:04:06","modified_gmt":"2021-06-19T07:49:26","slug":"10-cara-indonesia-tangguh-melawan-covid-19","type":"post","title":{"rendered":"10 Cara Indonesia Tangguh Melawan COVID-19"},"excerpt":{"rendered":"<p>Wabah COVID19 kembali memuncak. Naiknya mobilitas masyarakat, mengendornya prosedur dan ketaatan akan protokol kesehatan di semua lini, dan masuknya varian Alfa dan Delta yang lebih cepat penyebarannya menyebabkan kasus positif harian terus meninggi. </p>","protected":false},"author":2},{"id":1960,"date_gmt":"2021-06-18T14:14:17","modified_gmt":"2021-06-18T14:15:06","slug":"e-participation-against-covid-19-case-of-kawalcovid-19-id","type":"post","title":{"rendered":"E-Participation against COVID-19: Case of KawalCOVID-19.id"},"excerpt":{"rendered":"","protected":false},"author":2},{"id":1956,"date_gmt":"2021-06-14T09:22:43","modified_gmt":"2021-06-14T09:23:42","slug":"vaksin-untuk-penyintas-covid-19-perlu-atau-tidak","type":"post","title":{"rendered":"Vaksin untuk Penyintas COVID-19, Perlu atau Tidak?"},"excerpt":{"rendered":"<p>Vaksinasi untuk penyintas COVID-19 apakah diperlukan? Simak bahasan berikut ini.</p>","protected":false},"author":2},{"id":1931,"date_gmt":"2021-05-31T02:44:59","modified_gmt":"2021-07-03T09:34:24","slug":"cara-isolasi-mandiri-yang-benar","type":"post","title":{"rendered":"Cara Isolasi Mandiri yang Benar"},"excerpt":{"rendered":"<p>Tim KawalCOVID-19 berbincang dengan dr. Sayuri Suwandi, SpPD dan dr. Dirga Sakti Rambe, SpPD, untuk menjawab pertanyaan seputar cara isolasi mandiri (isoman) yang benar. Berikut ringkasan dari dua sesi Instagram Live yang bisa dilihat di sini.</p>","protected":false},"author":2},{"id":1928,"date_gmt":"2021-05-12T15:22:00","modified_gmt":"2021-05-12T15:24:39","slug":"mengenal-dan-mencegah-varian-baru-virus-sars-cov-2","type":"post","title":{"rendered":"Mengenal dan Mencegah Varian Baru Virus SARS-CoV-2"},"excerpt":{"rendered":"<p>Virus SARS-CoV-2, yang menjadi penyebab munculnya COVID-19, telah bermutasi dan menyebar ke seluruh dunia. Mutasi menghasilkan beberapa varian baru, satu di antaranya ialah B.1.1.7 yang terdeteksi pertama kali di Inggris Raya pada September 2020.</p>","protected":false},"author":2},{"id":1913,"date_gmt":"2021-04-29T01:25:03","modified_gmt":"2021-04-29T01:25:42","slug":"ramadhan-2021-tetap-waspada-menjaga-3m-dan-bersiap-untuk-tidak-mudik","type":"post","title":{"rendered":"Ramadhan 2021: Tetap Waspada, Menjaga 3M dan Bersiap untuk Tidak Mudik."},"excerpt":{"rendered":"<p>Refleksi di Ramadhan 2021 terkait kondisi pandemi COVID-19</p>","protected":false},"author":2},{"id":1906,"date_gmt":"2021-04-19T00:54:15","modified_gmt":"2021-04-27T01:32:31","slug":"gangguan-stres-pascatrauma-pada-penyintas-covid-19","type":"post","title":{"rendered":"Gangguan Stres Pascatrauma pada Penyintas COVID-19"},"excerpt":{"rendered":"<p>Dinyatakan sembuh dari COVID-19 tidak serta merta membuat para penyintas kembali hidup normal. Ada risiko penurunan kondisi fisik, dan juga kesehatan mental. Artikel ini membahas gangguan stres pasca trauma pada penyintas COVID-19</p>","protected":false},"author":2},{"id":1904,"date_gmt":"2021-04-19T00:53:13","modified_gmt":"2021-04-19T01:01:02","slug":"satu-tahun-covid-19-di-indonesia-waspadai-pandemic-fatigue","type":"post","title":{"rendered":"Satu Tahun COVID-19 di Indonesia, Waspadai Pandemic Fatigue!"},"excerpt":{"rendered":"<p>Berbagai adaptasi terhadap kebiasaan baru dan pembatasan yang terjadi selama satu tahun ini telah membuat sebagian besar dari kita merasa kelelahan. Artikel ini akan membahas tentang kelelahan pandemi (pandemic fatigue), dampak yang dapat ditimbulkan, dan kiat yang dapat kita lakukan bersama untuk mengatasinya.</p>","protected":false},"author":2},{"id":1902,"date_gmt":"2021-04-19T00:51:49","modified_gmt":"2021-04-19T01:00:29","slug":"kipi-atau-reaksi-kecemasan-terkait-vaksinasi","type":"post","title":{"rendered":"KIPI atau Reaksi Kecemasan Terkait Vaksinasi?"},"excerpt":{"rendered":"<p>Hendaknya kita tidak perlu terlalu panik dan terburu-buru melabeli setiap keluhan yang muncul ketika atau setelah vaksinasi sebagai efek samping vaksin atau efek prosedur vaksinasi. Bisa jadi, itu adalah reaksi kecemasan terkait vaksinasi. Artikel ini menjelaskan berbagai jenis KIPI, cara membedakan, dan kiat mengatasinya baik dari sisi tenaga kesehatan yang bertugas maupun masyarakat penerima vaksin.</p>","protected":false},"author":2},{"id":1879,"date_gmt":"2021-04-15T02:48:10","modified_gmt":"2021-06-25T09:40:22","slug":"satgas-kesehatan-di-sekolah-untuk-apa","type":"post","title":{"rendered":"Satgas Kesehatan di Sekolah, Untuk Apa?"},"excerpt":{"rendered":"<p>Per 24 Februari 2021, sudah ada wacana membuka kembali sekolah setelah vaksinasi guru rampung di bulan Juni. Di medio 2021, belum tentu pandemi sudah terkendali, apalagi berakhir. Karenanya, selain harus bersiap untuk mencegah penularan, sekolah juga harus bersiap diri untuk menangani adanya penularan di sekolah, sehingga tidak bingung dan menangani dengan serabutan ketika ada kasus. [&hellip;]</p>","protected":false},"author":2},{"id":1828,"date_gmt":"2021-04-05T14:44:30","modified_gmt":"2021-04-05T14:44:51","slug":"benarkah-covid-19-memicu-penyakit-ginjal","type":"post","title":{"rendered":"Benarkah COVID-19 Memicu Penyakit Ginjal?"},"excerpt":{"rendered":"<p>COVID-19 menimbulkan berbagai komplikasi penyakit, salah satunya penyakit ginjal. Beberapa penelitian menunjukkan bahwa pasien COVID-19 dapat menderita sakit ginjal, spesifiknya cedera ginjal akut. </p>","protected":false},"author":2},{"id":1818,"date_gmt":"2021-04-01T03:05:23","modified_gmt":"2021-07-03T09:03:10","slug":"interaksi-guru-murid-yang-minim-risiko","type":"post","title":{"rendered":"Interaksi Guru-Murid Yang Minim Risiko"},"excerpt":{"rendered":"<p>Per 24 Februari 2021, sudah ada wacana bahwa pemerintah akan membuka sekolah setelah vaksinasi guru rampung di bulan Juni. Di medio 2021, belum tentu pandemi terkendali, apalagi berakhir. Karenanya, penting bagi pendidik untuk melengkapi diri dengan cara aman melakukan berinteraksi dengan anak didik.&nbsp; COVID-19 menyebar lewat droplet seperti air liur dan ingus, dua hal yang [&hellip;]</p>","protected":false},"author":2},{"id":1669,"date_gmt":"2021-03-18T14:44:28","modified_gmt":"2021-04-05T14:51:50","slug":"tb-dan-covid-19","type":"post","title":{"rendered":"TB dan COVID-19"},"excerpt":{"rendered":"<p>Penulis: Nabila Hana Wardhani Tuberkulosis dan COVID-19 memiliki gejala yang serupa tapi tak sama seperti adanya batuk, demam dan sesak napas. Penyebab dan pengobatan dari kedua penyakit tersebut juga berbeda. Apabila keduanya diidap oleh seseorang, perkiraan perjalanan COVID-19 seseorang akan menjadi lebih buruk. Selain itu pandemi membawa problematika baru bagi TB, seperti melonjaknya kasus resistensi [&hellip;]</p>","protected":false},"author":2},{"id":1660,"date_gmt":"2021-02-27T02:28:10","modified_gmt":"2021-04-05T14:53:18","slug":"vaksin-covid-19","type":"post","title":{"rendered":"Vaksin COVID-19"},"excerpt":{"rendered":"<p>Penjelasan singkat tentang vaksin COVID-19</p>","protected":false},"author":2},{"id":1645,"date_gmt":"2021-02-20T05:39:49","modified_gmt":"2021-07-03T09:03:19","slug":"seri-covid-19-artikel-2-sebelum-buka-sekolah-apa-yang-harus-dikomunikasikan","type":"post","title":{"rendered":"Sebelum Buka Sekolah, Apa yang Harus Dikomunikasikan?"},"excerpt":{"rendered":"<p>Kebanyakan sekolah mengerti bahwa ada protokol kesehatan yang harus disiapkan sebelum membuka sekolah di masa pandemi. Tapi dari berbagai input yang disampaikan oleh guru, murid, orang tua maupun administrator sekolah, tidak ada pedoman bagaimana mengkomunikasikan pembukaan sekolah dan perilaku seperti apa yang sekolah minta dari para guru, siswa dan orang tua murid.</p>","protected":false},"author":2},{"id":1642,"date_gmt":"2021-02-20T05:35:56","modified_gmt":"2021-04-07T10:24:29","slug":"infrastruktur-apa-yang-perlu-disiapkan-sekolah-new-normal","type":"post","title":{"rendered":"Infrastruktur Apa yang Perlu Disiapkan Sekolah New Normal?"},"excerpt":{"rendered":"<p>Di satu titik, sekolah akan tatap muka lagi. Berapa lama lagi, kita belum tahu. Tapi sekolah perlu menyiapkan infrastruktur new normal mulai sekarang agar ketika nanti sekolah dibuka, semua pihak sudah mengerti apa yang harus dilakukan.</p>","protected":false},"author":2},{"id":1612,"date_gmt":"2021-01-14T02:21:49","modified_gmt":"2021-03-02T04:52:49","slug":"pertimbangan-untuk-langkah-langkah-kesehatan-masyarakat-terkait-sekolah-dalam-konteks-covid-19","type":"post","title":{"rendered":"Pertimbangan untuk Langkah-Langkah Kesehatan Masyarakat Terkait Sekolah dalam Konteks COVID-19"},"excerpt":{"rendered":"","protected":false},"author":2},{"id":2206,"date_gmt":"2020-12-29T13:34:00","modified_gmt":"2022-02-07T23:32:45","slug":"laporan-donasi-dana-tahap-kedua-infrastruktur-kawalcovid19-id-di-azure-cloud","type":"post","title":{"rendered":"Laporan Donasi Dana Tahap Kedua Infrastruktur KawalCOVID19.id di Azure Cloud"},"excerpt":{"rendered":"<p>Tim KawalCOVID19.id menerima Donasi Tahap Kedua dari Program IEG Peduli COVID-19 Yayasan Indika. Donasi digunakan seutuhnya untuk pendanaan infrastruktur teknologi website KawalCOVID19.id yang menggunakan Azure Cloud. Rincian data donasi terlampir dan dapat diunduh (download) di sini.</p>","protected":false},"author":2},{"id":1558,"date_gmt":"2020-12-22T15:15:43","modified_gmt":"2021-03-02T04:36:10","slug":"pandemic-fatigue","type":"post","title":{"rendered":"Pandemic Fatigue"},"excerpt":{"rendered":"<p>Bosan dengar masalah Covid? Inilah kenapa anda mengalami kelelahan pandemi atau pandemic fatigue</p>","protected":false},"author":2},{"id":1541,"date_gmt":"2020-11-26T02:03:54","modified_gmt":"2021-03-02T04:36:21","slug":"penapisan-covid-19-bagi-petugas-pilkada","type":"post","title":{"rendered":"Penapisan COVID-19 bagi Petugas Pilkada"},"excerpt":{"rendered":"<p>Tes antibodi saja tidak bisa diandalkan untuk mencegah penularan COVID-19 selama Pilkada. Artikel ini menjabarkan strategi pemilahan kelompok sesuai hasil tes PCR dan langkah selanjutnya yang perlu diambil.</p>","protected":false},"author":2},{"id":2201,"date_gmt":"2020-09-22T15:37:00","modified_gmt":"2022-02-07T23:31:52","slug":"laporan-donasi-dana-tahap-pertama-infrastruktur-kawalcovid19-id-di-azure-cloud","type":"post","title":{"rendered":"Laporan Donasi Dana Tahap Pertama Infrastruktur KawalCOVID19.id di Azure Cloud"},"excerpt":{"rendered":"<p>Tim KawalCOVID19.id menerima Donasi Tahap Pertama dari Program IEG Peduli COVID-19 Yayasan Indika. Donasi digunakan seutuhnya untuk pendanaan infrastruktur teknologi website KawalCOVID19.id yang menggunakan Azure Cloud. Rincian data donasi terlampir dan bisa diunduh (download) di sini.</p>","protected":false},"author":2},{"id":1466,"date_gmt":"2020-09-17T05:27:39","modified_gmt":"2021-03-02T04:36:37","slug":"rendahnya-pelacakan-kontak-dan-tingginya-tingkat-positivitas-tes-latar-belakang-dan-prospek-psbb-ii-dki-jakarta","type":"post","title":{"rendered":"Rendahnya Pelacakan Kontak dan Tingginya Tingkat Positivitas Tes: Latar Belakang dan Prospek PSBB II DKI Jakarta"},"excerpt":{"rendered":"<p>Kami menjabarkan tiga tren penting yang menjelaskan lonjakan kasus di DKI Jakarta, yakni (1) memburuknya pelacakan, (2) meningkatnya tingkat positivitas tes meskipun jumlah tesnya bertambah dan (3) inefisiensi tes mandiri. Rekomendasi kami bagi Pemprov DKI agar PSBB kedua berhasil mengendalikan wabah: 1) tingkatkan rasio lacak isolasi hingga 30 kontak erat per 1 kasus baru, 2) pekerjakan tim pelacak kontak khusus, 3) lampaui protokol revisi ke-5 dan haruskan semua kontak erat dites usap meskipun tidak bergejala ketika dikarantina di fasilitas terpusat, 4) kurangi tes mandiri yang tidak perlu dan 5) pertimbangkan pendekatan \u201Cstick and carrot\u201D.</p>","protected":false},"author":2},{"id":1361,"date_gmt":"2020-07-22T14:56:02","modified_gmt":"2021-03-02T04:36:44","slug":"serial-data-virus-corona-4-cara-memperbaiki-indeks-kewaspadaan","type":"post","title":{"rendered":"Serial Data Virus Corona 4: Cara Memperbaiki Indeks Kewaspadaan"},"excerpt":{"rendered":"<p>Serial data virus corona ke-4 ini menjelaskan bagaimana cara memperbaiki indeks kewaspadaan</p>","protected":false},"author":2},{"id":1330,"date_gmt":"2020-07-09T12:09:26","modified_gmt":"2021-03-02T04:36:53","slug":"serial-data-virus-korona-3-indeks-kewaspadaan","type":"post","title":{"rendered":"Serial Data Virus Korona 3: Indeks Kewaspadaan"},"excerpt":{"rendered":"<p>Serial data virus korona 3 ini merupakan kelanjutan dari serial data 1 dan 2 yang menggambarkan indeks kewaspadaan daerah pengidap positif COVID-19. Dengan adanya indeks kewaspadaan ini, dapat dapat terlihat gambaran relatif berapa besar kemungkinan terjadi transmisi COVID-19 di daerah domisili Anda.</p>","protected":false},"author":2},{"id":1294,"date_gmt":"2020-07-04T14:02:35","modified_gmt":"2021-03-02T04:37:01","slug":"serial-data-virus-korona-2-rasio-lacak-isolasi-rli-dan-korelasinya-dengan-kematian-kumulatif","type":"post","title":{"rendered":"Serial Data Virus Korona 2: Rasio Lacak &#8211; Isolasi (RLI) dan Korelasinya dengan Kematian Kumulatif"},"excerpt":{"rendered":"<p>Serial data kedua ini merupakan kelanjutan dari serial data pertama yang memmbahas tentang rasio lacak-isolasi dan hubungannya dengan jumlah kematian</p>","protected":false},"author":2},{"id":1288,"date_gmt":"2020-07-04T14:00:18","modified_gmt":"2021-03-02T04:37:11","slug":"serial-data-virus-korona-1-3t-trace-test-treat","type":"post","title":{"rendered":"Serial Data Virus Korona 1: 3T (Trace, Test, Treat)"},"excerpt":{"rendered":"<p>Serial data pertama ini menyajikan bagaimana menurunkan penyebaran COVID-19  melalui 3T (Trace, Test, Treat)</p>","protected":false},"author":2},{"id":1284,"date_gmt":"2020-06-15T15:45:44","modified_gmt":"2021-03-02T04:53:16","slug":"mpasi-anak-dalam-kondisi-darurat","type":"post","title":{"rendered":"MPASI Anak dalam Kondisi Darurat"},"excerpt":{"rendered":"<p>Menjaga asupan gizi anak penting di tengah pandemi dan mudah dilakukan dengan memberikan Menu 4 Bintang.</p>","protected":false},"author":2},{"id":1268,"date_gmt":"2020-05-15T10:11:37","modified_gmt":"2021-03-16T17:30:39","slug":"ramadan-psbb-dan-mcdonalds","type":"post","title":{"rendered":"Ramadan, PSBB dan McDonalds"},"excerpt":{"rendered":"<p>Berikut beberapa contoh kejadian yang dapat meningkatkan penyebaran virus korona.</p>","protected":false},"author":2},{"id":1215,"date_gmt":"2020-05-03T12:38:09","modified_gmt":"2021-03-02T04:45:12","slug":"tips-pengolahan-makanan-dengan-penanak-nasi","type":"post","title":{"rendered":"Tips Pengolahan Makanan dengan Penanak Nasi"},"excerpt":{"rendered":"<p>Tips ini berisi cara memasak setiap kelompok bahan makanan menggunakan penanak nasi (rice cooker) untuk mempertahankan nilai gizi dengan menghindari pemanasan terlalu tinggi dalam waktu lama.</p>","protected":false},"author":2},{"id":1183,"date_gmt":"2020-04-27T07:52:40","modified_gmt":"2021-03-02T04:45:22","slug":"rapid-test-atau-swab-test-apa-bedanya-mana-yang-lebih-baik","type":"post","title":{"rendered":"Rapid test atau swab test: Apa bedanya? Mana yang lebih baik?"},"excerpt":{"rendered":"<p>Perbandingan metode rapid test dan swab test dalam pendeteksian COVID-19.</p>","protected":false},"author":2},{"id":1177,"date_gmt":"2020-04-27T07:33:49","modified_gmt":"2021-03-02T04:53:36","slug":"imunisasi-rutin-selama-pandemi-covid-19","type":"post","title":{"rendered":"Imunisasi Rutin Selama Pandemi COVID-19"},"excerpt":{"rendered":"<p>Panduan untuk imunisasi rutin selama adanya pandemi COVID-19.</p>","protected":false},"author":2},{"id":1090,"date_gmt":"2020-04-17T12:36:06","modified_gmt":"2021-03-02T04:46:02","slug":"hoax-dan-misinformasi-seputar-covid-19-apa-yang-bisa-kita-lakukan","type":"post","title":{"rendered":"Hoax dan Misinformasi Seputar COVID-19; Apa yang Bisa Kita Lakukan?"},"excerpt":{"rendered":"<p>Perkembangan Terkini Seputar Hoax COVID-19</p>","protected":false},"author":2},{"id":1079,"date_gmt":"2020-04-15T05:47:19","modified_gmt":"2021-03-02T04:53:52","slug":"himbauan-untuk-vaksinasi","type":"post","title":{"rendered":"Himbauan untuk Vaksinasi"},"excerpt":{"rendered":"<p>Dokumen terkait himbauan untuk pelaksanaan vaksinasi anak selama pandemi COVID-19.</p>","protected":false},"author":2},{"id":1021,"date_gmt":"2020-04-11T12:43:35","modified_gmt":"2021-03-02T04:47:08","slug":"apakah-penyemprotan-disinfektan-efektif-membunuh-sars-cov-2","type":"post","title":{"rendered":"Apakah Penyemprotan Disinfektan Efektif Membunuh SARS-COV-2?"},"excerpt":{"rendered":"<p>Beberapa hal yang harus diketahui tentang penyemprotan cairan disinfektan.</p>","protected":false},"author":2},{"id":1006,"date_gmt":"2020-04-10T08:11:49","modified_gmt":"2021-03-02T04:47:32","slug":"cerita-dari-jerman-pengalaman-dua-wni-di-bochum-dan-frankfurt","type":"post","title":{"rendered":"Cerita dari Jerman: Pengalaman Dua WNI di Bochum dan Frankfurt"},"excerpt":{"rendered":"<p>Seorang pelajar dan seorang pekerja asal Indonesia yang tinggal di Jerman membagikan kisah penanganan pandemi oleh pemerintah Jerman</p>","protected":false},"author":2},{"id":992,"date_gmt":"2020-04-10T08:07:59","modified_gmt":"2021-03-02T04:47:39","slug":"cerita-dari-taiwan-respons-tepat-taiwan-dalam-menghadapi-sars-cov-2-dan-covid-19","type":"post","title":{"rendered":"Cerita dari Taiwan: Respons Tepat Taiwan dalam Menghadapi SARS COV-2 dan COVID-19"},"excerpt":{"rendered":"<p>Taiwan disebut-sebut sebagai negara yang mengantisipasi penyebaran COVID-19 dengan baik sebelum wabah memburuk. Artikel ini merangkum hal-hal baik yang dilakukan oleh Taiwan dan yang dapat dijadikan contoh.</p>","protected":false},"author":2},{"id":972,"date_gmt":"2020-04-07T11:23:11","modified_gmt":"2021-03-02T04:47:48","slug":"cerita-dari-swedia-dont-try-this-at-home-jangan-terapkan-di-indonesia","type":"post","title":{"rendered":"Cerita dari Swedia: Don\u2019t try this at home! (Jangan Terapkan di Indonesia!)"},"excerpt":{"rendered":"<p>Swedia dan Indonesia memiliki kondisi sosial dan budaya yang berbeda. Maka, kebijakan pemerintah Swedia tidak semerta-merta dapat diterapkan di Indonesia karena perbedaan konteks memerlukan penanganan yang berbeda pula.</p>","protected":false},"author":2},{"id":950,"date_gmt":"2020-04-05T07:22:31","modified_gmt":"2021-03-02T04:47:59","slug":"edukasi-saya-pengidap-asma-apa-yang-harus-saya-persiapkan","type":"post","title":{"rendered":"[EDUKASI] Saya pengidap asma. Apa yang harus saya persiapkan?"},"excerpt":{"rendered":"<p>Yuk simak beberapa saran yang harus Anda lakukan jika mengidap kondisi medis kronis.</p>","protected":false},"author":2},{"id":880,"date_gmt":"2020-04-03T05:37:16","modified_gmt":"2021-03-02T04:48:08","slug":"komunikasi-risiko-covid-19-untuk-fasilitas-pelayanan-kesehatan","type":"post","title":{"rendered":"Komunikasi Risiko COVID-19 untuk Fasilitas Pelayanan Kesehatan"},"excerpt":{"rendered":"<p>Materi ini memberikan gambaran langkah-langkah utama menjaga keselamatan dan kesehatan di tempat kerja untuk manajemen fasilitas pelayanan kesehatan dan tenaga kesehatan.</p>","protected":false},"author":2},{"id":843,"date_gmt":"2020-03-31T04:43:23","modified_gmt":"2021-03-02T04:48:26","slug":"dunia-dalam-berita-covid-19","type":"post","title":{"rendered":"Dunia dalam Berita COVID-19"},"excerpt":{"rendered":"<p>Rangkuman berita terkini seputar Covid-19, termasuk Fatwa MUI terkait pengurusan jenazah.</p>","protected":false},"author":2},{"id":800,"date_gmt":"2020-03-28T05:43:05","modified_gmt":"2021-03-02T04:48:44","slug":"informasi-terkini-28-maret-2020","type":"post","title":{"rendered":"Informasi terkini &#8211; 28 Maret 2020"},"excerpt":{"rendered":"<p>Monitor pemberitaan media per-harinya terkait covid-19</p>","protected":false},"author":2},{"id":724,"date_gmt":"2020-03-21T18:24:53","modified_gmt":"2021-03-02T04:48:54","slug":"tips-hidup-sehat-agar-tubuh-lebih-tahan-terhadap-penyakit","type":"post","title":{"rendered":"Tips Hidup Sehat Agar Tubuh Lebih Tahan terhadap Penyakit"},"excerpt":{"rendered":"<p>Kekebalan tubuh memegang peran penting dalam menjaga tubuh dari penyakit.</p>","protected":false},"author":2},{"id":639,"date_gmt":"2020-03-20T13:18:03","modified_gmt":"2021-03-02T04:49:15","slug":"polemik-penggunaan-ibuprofen","type":"post","title":{"rendered":"Polemik penggunaan Ibuprofen"},"excerpt":{"rendered":"<p>Apakah ibuprofen memperburuk infeksi COVID-19? &#8211; Bagaimana dengan obat penawar rasa sakit yang lainnya?</p>","protected":false},"author":2},{"id":721,"date_gmt":"2020-03-18T18:15:00","modified_gmt":"2021-03-02T04:49:24","slug":"penanganan-jenazah-yang-terduga-odp-kemungkinan-pdp-dan-terkonfirmasi-positif-terinfeksi-covid-19","type":"post","title":{"rendered":"Penanganan Jenazah yang Terduga (ODP) / Kemungkinan (PDP) dan Terkonfirmasi (Positif) Terinfeksi COVID-19"},"excerpt":{"rendered":"<p>Meskipun belum ada korban COVID-19, pemerintah Singapura sudah mempersiapkan panduan penanganan jenazah untuk pemakaman dan kremasi</p>","protected":false},"author":2},{"id":546,"date_gmt":"2020-03-17T05:37:28","modified_gmt":"2021-03-02T04:49:32","slug":"coronavirus-covid-19-bagaimana-mempersiapkan-keluarga-anda","type":"post","title":{"rendered":"Coronavirus (COVID-19): Bagaimana Mempersiapkan Keluarga Anda?"},"excerpt":{"rendered":"<p>Beberapa hal yang dapat dipersiapkan untuk keluarga Anda dalam menghadapi COVID-19.</p>","protected":false},"author":2},{"id":510,"date_gmt":"2020-03-16T10:01:50","modified_gmt":"2021-03-02T04:49:40","slug":"dos-and-donts-dalam-social-distancing","type":"post","title":{"rendered":"Do&#8217;s and Don&#8217;ts dalam Social Distancing"},"excerpt":{"rendered":"<p>Kuncinya hanya satu: Apakah kondisi tubuh kita sehat dan apakah kita punya gejala sakit? </p>","protected":false},"author":2},{"id":463,"date_gmt":"2020-03-16T07:17:28","modified_gmt":"2021-03-02T04:49:50","slug":"protokol-isolasi-mandiri-home-quarantine","type":"post","title":{"rendered":"Protokol Isolasi Mandiri (Home Quarantine)"},"excerpt":{"rendered":"<p>Langkah-langkah yang dapat dilakukan ketika isolasi mandiri untuk mencegah penularan</p>","protected":false},"author":2},{"id":466,"date_gmt":"2020-03-16T06:55:29","modified_gmt":"2021-03-02T04:49:58","slug":"tips-menghadapi-karantina-di-rumah","type":"post","title":{"rendered":"Tips Menghadapi Karantina di Rumah"},"excerpt":{"rendered":"<p>Karantina membantu memperlambat penyebaran infeksi. Siapkan sebuah Perencanaan Karantina Rumah</p>","protected":false},"author":2},{"id":464,"date_gmt":"2020-03-16T06:48:58","modified_gmt":"2021-03-02T04:50:06","slug":"apa-beda-orang-dalam-pemantauan-odp-dengan-pasien-dalam-pengawasan-pdp","type":"post","title":{"rendered":"Apa Beda Orang Dalam Pemantauan (ODP) dengan Pasien Dalam Pengawasan (PDP)?"},"excerpt":{"rendered":"<p>Baca artikel ini supaya lebih tahu tentang Orang Dalam Pemantauan dan Pasien Dalam Pengawasan!</p>","protected":false},"author":2},{"id":450,"date_gmt":"2020-03-16T00:27:00","modified_gmt":"2021-03-02T04:50:13","slug":"hampir-700-wni-hadiri-acara-di-pusat-penyebaran-covid-19-apa-respon-pemerintah","type":"post","title":{"rendered":"Hampir 700 WNI hadiri acara di pusat penyebaran COVID-19: Apa respon pemerintah?"},"excerpt":{"rendered":"<p>Dampak adanya acara besar terhadap penyebaran COVID-19 </p>","protected":false},"author":2},{"id":431,"date_gmt":"2020-03-14T12:11:00","modified_gmt":"2021-03-02T04:50:22","slug":"pencegahan-covid-19-di-lingkungan-institusi-pendidikan","type":"post","title":{"rendered":"Pencegahan COVID-19 di Lingkungan Institusi Pendidikan \uFEFF"},"excerpt":{"rendered":"<p>Beberapa hal yang dapat dilakukan untuk mencegah penularan COVID-19 di lingkungan pendidikan.</p>","protected":false},"author":2},{"id":416,"date_gmt":"2020-03-14T10:53:45","modified_gmt":"2021-03-02T04:50:29","slug":"do-dont-and-minimize-untuk-acara-besar","type":"post","title":{"rendered":"Do, Don&#8217;t and Minimize untuk Acara Besar"},"excerpt":{"rendered":"<p>Panduan untuk Mengurangi Risiko dalam Acara Besar</p>","protected":false},"author":2},{"id":360,"date_gmt":"2020-03-13T03:52:52","modified_gmt":"2021-03-02T04:50:36","slug":"covid-19-mengapa-kita-harus-bertindak-sekarang","type":"post","title":{"rendered":"Covid-19: Mengapa Kita Harus Bertindak Sekarang!"},"excerpt":{"rendered":"<p>Dengan semua kejadian terkait Covid-19, saat ini, tentunya anda akan menghadapi kesulitan untuk mengambil keputusan hari ini. Apakah perlu menunggu informasi lebih lanjut atau melakukan sesuatu hari ini?</p>","protected":false},"author":2},{"id":346,"date_gmt":"2020-03-12T15:33:23","modified_gmt":"2021-03-02T04:50:43","slug":"coronavirus-apa-yang-bisa-dilakukan-anak-anak","type":"post","title":{"rendered":"Coronavirus: Apa yang Bisa Dilakukan Anak-Anak?"},"excerpt":{"rendered":"<p>Yuk, simak hal apa saja yang dapat dilakukan anak-anak terkait coronavirus!</p>","protected":false},"author":2},{"id":337,"date_gmt":"2020-03-12T09:37:29","modified_gmt":"2021-03-02T04:50:51","slug":"cara-gampang-membunuh-virus","type":"post","title":{"rendered":"Cara Gampang Membunuh Virus"},"excerpt":{"rendered":"<p>Alasan pentingnya rajin mencuci tangan dengan sabun.</p>","protected":false},"author":2},{"id":334,"date_gmt":"2020-03-12T03:46:37","modified_gmt":"2021-03-02T04:50:58","slug":"mengapa-kita-tidak-bisa-meremehkan-covid-19","type":"post","title":{"rendered":"Mengapa Kita Tidak Bisa Meremehkan COVID-19?"},"excerpt":{"rendered":"<p>Beberapa hal yang membuat kita harus penuh kewaspadaan dalam menghadapi COVID-19</p>","protected":false},"author":2},{"id":282,"date_gmt":"2020-03-07T17:30:00","modified_gmt":"2021-07-21T12:59:17","slug":"kawalcovid19-id-untuk-mengurai-derasnya-informasi-seputar-covid-19","type":"post","title":{"rendered":"KawalCOVID19 untuk mengurai derasnya informasi seputar COVID-19"},"excerpt":{"rendered":"<p>Website kawalcovid19.id beserta akun-akun media sosialnya akan dimutakhirkan berkala dengan esensi Informasi, Verifikasi, dan Edukasi.</p>","protected":false},"author":2},{"id":2,"date_gmt":"2020-03-05T03:10:00","modified_gmt":"2021-03-02T04:51:15","slug":"faq","type":"post","title":{"rendered":"Tanya Jawab Seputar COVID-19"},"excerpt":{"rendered":"<p>Yang perlu Anda ketahui seputar COVID-19.</p>","protected":false},"author":2}],"authors":{"2":{"id":2,"name":"Kawal COVID-19","description":"Tim administrator situs KawalCOVID19.id","slug":"admin","avatar_urls":{"24":"http://0.gravatar.com/avatar/662a7ed69e971f6fb58f2c0aff371674?s=24&d=retro&r=g","48":"http://0.gravatar.com/avatar/662a7ed69e971f6fb58f2c0aff371674?s=48&d=retro&r=g","96":"http://0.gravatar.com/avatar/662a7ed69e971f6fb58f2c0aff371674?s=96&d=retro&r=g"},"_links":{"self":[{"href":"http://18.141.204.243/index.php?rest_route=/wp/v2/users/2"}],"collection":[{"href":"http://18.141.204.243/index.php?rest_route=/wp/v2/users"}]}}}},"__N_SSG":true}');


var $a96fc9b2ca5532ff$exports = {};
$a96fc9b2ca5532ff$exports = JSON.parse('{"pageProps":{"category":{"id":40,"count":22,"description":"Panduan dan protokol terkait COVID-19","name":"Panduan","slug":"panduan"},"posts":[{"id":2137,"date_gmt":"2021-07-24T03:51:55","modified_gmt":"2021-07-24T03:59:47","slug":"revisi-panduan-tata-laksana-covid-19-di-indonesia","type":"post","title":{"rendered":"Revisi Panduan Tata Laksana COVID-19 di Indonesia"},"excerpt":{"rendered":"<p>Pada tanggal 14 Juli 2021, organisasi profesi dokter di Indonesia, yaitu Perhimpunan Dokter Paru Indonesia (PDPI), Perhimpunan Dokter Spesialis Kardiovaskular Indonesia (PERKI), Perhimpunan Dokter Spesialis Penyakit Dalam Indonesia (PAPDI), Perhimpunan Dokter Spesialis Anestesiologi dan Terapi Intensif (PERDATIN), dan Ikatan Dokter Anak Indonesia (IDAI) merevisi rekomendasi panduan tata laksana COVID-19 di Indonesia. Revisi ini ditujukan untuk [&hellip;]</p>\\n","protected":false},"author":2},{"id":1931,"date_gmt":"2021-05-31T02:44:59","modified_gmt":"2021-07-03T09:34:24","slug":"cara-isolasi-mandiri-yang-benar","type":"post","title":{"rendered":"Cara Isolasi Mandiri yang Benar"},"excerpt":{"rendered":"<p>Tim KawalCOVID-19 berbincang dengan dr. Sayuri Suwandi, SpPD dan dr. Dirga Sakti Rambe, SpPD, untuk menjawab pertanyaan seputar cara isolasi mandiri (isoman) yang benar. Berikut ringkasan dari dua sesi Instagram Live yang bisa dilihat di sini.</p>\\n","protected":false},"author":2},{"id":1879,"date_gmt":"2021-04-15T02:48:10","modified_gmt":"2021-06-25T09:40:22","slug":"satgas-kesehatan-di-sekolah-untuk-apa","type":"post","title":{"rendered":"Satgas Kesehatan di Sekolah, Untuk Apa?"},"excerpt":{"rendered":"<p>Per 24 Februari 2021, sudah ada wacana membuka kembali sekolah setelah vaksinasi guru rampung di bulan Juni. Di medio 2021, belum tentu pandemi sudah terkendali, apalagi berakhir. Karenanya, selain harus bersiap untuk mencegah penularan, sekolah juga harus bersiap diri untuk menangani adanya penularan di sekolah, sehingga tidak bingung dan menangani dengan serabutan ketika ada kasus. [&hellip;]</p>\\n","protected":false},"author":2},{"id":1818,"date_gmt":"2021-04-01T03:05:23","modified_gmt":"2021-07-03T09:03:10","slug":"interaksi-guru-murid-yang-minim-risiko","type":"post","title":{"rendered":"Interaksi Guru-Murid Yang Minim Risiko"},"excerpt":{"rendered":"<p>Per 24 Februari 2021, sudah ada wacana bahwa pemerintah akan membuka sekolah setelah vaksinasi guru rampung di bulan Juni. Di medio 2021, belum tentu pandemi terkendali, apalagi berakhir. Karenanya, penting bagi pendidik untuk melengkapi diri dengan cara aman melakukan berinteraksi dengan anak didik.&nbsp; COVID-19 menyebar lewat droplet seperti air liur dan ingus, dua hal yang [&hellip;]</p>\\n","protected":false},"author":2},{"id":1645,"date_gmt":"2021-02-20T05:39:49","modified_gmt":"2021-07-03T09:03:19","slug":"seri-covid-19-artikel-2-sebelum-buka-sekolah-apa-yang-harus-dikomunikasikan","type":"post","title":{"rendered":"Sebelum Buka Sekolah, Apa yang Harus Dikomunikasikan?"},"excerpt":{"rendered":"<p>Kebanyakan sekolah mengerti bahwa ada protokol kesehatan yang harus disiapkan sebelum membuka sekolah di masa pandemi. Tapi dari berbagai input yang disampaikan oleh guru, murid, orang tua maupun administrator sekolah, tidak ada pedoman bagaimana mengkomunikasikan pembukaan sekolah dan perilaku seperti apa yang sekolah minta dari para guru, siswa dan orang tua murid.</p>\\n","protected":false},"author":2},{"id":1642,"date_gmt":"2021-02-20T05:35:56","modified_gmt":"2021-04-07T10:24:29","slug":"infrastruktur-apa-yang-perlu-disiapkan-sekolah-new-normal","type":"post","title":{"rendered":"Infrastruktur Apa yang Perlu Disiapkan Sekolah New Normal?"},"excerpt":{"rendered":"<p>Di satu titik, sekolah akan tatap muka lagi. Berapa lama lagi, kita belum tahu. Tapi sekolah perlu menyiapkan infrastruktur new normal mulai sekarang agar ketika nanti sekolah dibuka, semua pihak sudah mengerti apa yang harus dilakukan.</p>\\n","protected":false},"author":2},{"id":1612,"date_gmt":"2021-01-14T02:21:49","modified_gmt":"2021-03-02T04:52:49","slug":"pertimbangan-untuk-langkah-langkah-kesehatan-masyarakat-terkait-sekolah-dalam-konteks-covid-19","type":"post","title":{"rendered":"Pertimbangan untuk Langkah-Langkah Kesehatan Masyarakat Terkait Sekolah dalam Konteks COVID-19"},"excerpt":{"rendered":"","protected":false},"author":2},{"id":1550,"date_gmt":"2020-12-07T14:27:32","modified_gmt":"2021-03-02T04:52:56","slug":"panduan-perawatan-di-rumah-untuk-suspek-dan-positif-covid-19-dengan-gejala-ringan-atau-tanpa-gejala","type":"post","title":{"rendered":"Panduan Perawatan di Rumah untuk Suspek dan Positif- COVID-19 dengan Gejala Ringan atau Tanpa Gejala"},"excerpt":{"rendered":"<p>Proses hasil PCR yang lambat, makin banyaknya kasus positif sehingga RS hanya mampu melayani pasien dengan gejala sedang/berat, sehingga isolasi mandiri adalah pilihan buat pasien positif dengan gejala ringan atau untuk suspek COVID-19. Panduan ini diharapkan dapat membantu perawatan mandiri.</p>\\n","protected":false},"author":2},{"id":1522,"date_gmt":"2020-11-01T02:49:47","modified_gmt":"2021-03-02T04:53:06","slug":"isolasi-mandiri-untuk-ibu-menyusui","type":"post","title":{"rendered":"Isolasi Mandiri untuk Ibu Menyusui"},"excerpt":{"rendered":"<p>Rangkuman panduan yang harus dilakukan jika ibu menyusui terpapar COVID-19.</p>\\n","protected":false},"author":2},{"id":1284,"date_gmt":"2020-06-15T15:45:44","modified_gmt":"2021-03-02T04:53:16","slug":"mpasi-anak-dalam-kondisi-darurat","type":"post","title":{"rendered":"MPASI Anak dalam Kondisi Darurat"},"excerpt":{"rendered":"<p>Menjaga asupan gizi anak penting di tengah pandemi dan mudah dilakukan dengan memberikan Menu 4 Bintang.</p>\\n","protected":false},"author":2},{"id":1211,"date_gmt":"2020-04-30T08:49:24","modified_gmt":"2021-03-02T04:53:24","slug":"menyikapi-kedukaan-dan-kehilangan-saat-pandemi","type":"post","title":{"rendered":"Menyikapi Kedukaan dan Kehilangan Saat Pandemi"},"excerpt":{"rendered":"<p>Kehilangan orang tercinta bukan hal yang mudah dihadapi, apalagi di tengah pandemi. Dalam situasi sulit ini, bila memungkinkan, gunakan Internet dan solusi virtual lainnya untuk menjaga silaturahmi dengan keluarga dan teman untuk berbagi rasa kehilangan, serta untuk melaksanakan keinginan terakhir almarhum/almarhumah.</p>\\n","protected":false},"author":2},{"id":1177,"date_gmt":"2020-04-27T07:33:49","modified_gmt":"2021-03-02T04:53:36","slug":"imunisasi-rutin-selama-pandemi-covid-19","type":"post","title":{"rendered":"Imunisasi Rutin Selama Pandemi COVID-19"},"excerpt":{"rendered":"<p>Panduan untuk imunisasi rutin selama adanya pandemi COVID-19.</p>\\n","protected":false},"author":2},{"id":1171,"date_gmt":"2020-04-26T13:53:08","modified_gmt":"2021-03-02T04:53:43","slug":"panduan-menerima-dan-memberikan-bantuan-sosial-%ef%bb%bf","type":"post","title":{"rendered":"Panduan Menerima dan Memberikan Bantuan Sosial \uFEFF"},"excerpt":{"rendered":"<p>Saat ini, pembagian bantuan sosial, baik berupa paket sembako, uang, maupun keduanya, sudah banyak berlangsung. Hal ini adalah inisiatif yang baik untuk membantu masyarakat yang membutuhkan di tengah wabah COVID-19. Namun, ada beberapa hal yang perlu dipersiapkan oleh pemberi dan penerima bantuan.</p>\\n","protected":false},"author":2},{"id":1079,"date_gmt":"2020-04-15T05:47:19","modified_gmt":"2021-03-02T04:53:52","slug":"himbauan-untuk-vaksinasi","type":"post","title":{"rendered":"Himbauan untuk Vaksinasi"},"excerpt":{"rendered":"<p>Dokumen terkait himbauan untuk pelaksanaan vaksinasi anak selama pandemi COVID-19.</p>\\n","protected":false},"author":2},{"id":1063,"date_gmt":"2020-04-14T13:15:05","modified_gmt":"2021-03-02T04:54:09","slug":"tips-siaga-bagi-pasangan-yang-menunggu-kelahiran","type":"post","title":{"rendered":"Tips Siaga Bagi Pasangan yang Menunggu Kelahiran"},"excerpt":{"rendered":"<p>Lebih dari 200 juta wanita hamil di seluruh dunia berpotensi terinfeksi coronavirus. Beberapa penelitian mulai menguak bahaya virus SARS-CoV-2 ini pada wanita hamil dan bayinya, namun hasilnya&#8230;</p>\\n","protected":false},"author":2},{"id":969,"date_gmt":"2020-04-07T10:47:14","modified_gmt":"2021-03-02T04:54:17","slug":"seputar-penghantaran-dan-atau-penerimaan-gofood-gosend","type":"post","title":{"rendered":"Panduan Higienis Pengiriman dan/atau Penerimaan Barang/Makanan saat Pandemi"},"excerpt":{"rendered":"<p>Panduan apa yang sebaiknya dilakukan saat menerima atau mengirim barang melalui ojek online.</p>\\n","protected":false},"author":2},{"id":962,"date_gmt":"2020-04-07T04:31:11","modified_gmt":"2021-03-02T04:54:24","slug":"rt-dan-desa-mandiri-lawan-korona","type":"post","title":{"rendered":"RT dan Desa Mandiri Lawan Korona"},"excerpt":{"rendered":"<p>Simak tulisan berikut ini untuk mengetahui panduan bagi RT dan desa dalam melawan koronavirus.</p>\\n","protected":false},"author":2},{"id":960,"date_gmt":"2020-04-06T14:30:12","modified_gmt":"2021-03-02T04:54:32","slug":"prosedur-mendirikan-pusat-karantina-di-luar-fasilitas-kesehatan","type":"post","title":{"rendered":"Prosedur Mendirikan Pusat Karantina Di Luar Fasilitas Kesehatan"},"excerpt":{"rendered":"<p>Saat jumlah kasus positif COVID-19 meningkat sangat drastis melebihi kemampuan rumah sakit untuk merawat penderita, maka pemerintah setempat&#8230;.</p>\\n","protected":false},"author":2},{"id":850,"date_gmt":"2020-03-31T09:59:48","modified_gmt":"2021-03-02T04:54:40","slug":"panduan-membuat-masker-kain-sendiri","type":"post","title":{"rendered":"Panduan Membuat Masker Kain Sendiri"},"excerpt":{"rendered":"<p>Saat ini, masker sulit ditemukan. Kalau pun tersedia, masker bedah lebih dibutuhkan oleh tenaga medis daripada masyarakat umum. Tapi jangan khawatir, untuk melindungi diri sendiri dan orang di sekitar, kita bisa, kok, membuat masker sendiri untuk kita dan keluarga. Simak tulisan berikut ini. </p>\\n","protected":false},"author":2},{"id":846,"date_gmt":"2020-03-31T05:20:53","modified_gmt":"2021-03-02T04:54:49","slug":"panduan-menjaga-diri-dan-orang-lain-bila-terlanjur-mudik","type":"post","title":{"rendered":"Panduan Menjaga Diri dan Orang Lain Bila Terlanjur Mudik"},"excerpt":{"rendered":"<p>Bepergian ke luar kota, apalagi ke luar negeri, sangat tidak dianjurkan di tengah wabah. Namun, jika terlanjur mudik, ada hal-hal yang perlu dilakukan untuk menjaga diri dan orang di sekitar kita.</p>\\n","protected":false},"author":2},{"id":715,"date_gmt":"2020-03-21T18:12:47","modified_gmt":"2021-03-02T04:54:57","slug":"panduan-penanganan-jenazah-terduga-kemungkinan-terkonfirmasi-covid-19","type":"post","title":{"rendered":"Panduan Penanganan Jenazah Terduga / Kemungkinan / Terkonfirmasi COVID-19"},"excerpt":{"rendered":"<p>Ikuti panduan ini untuk penanganan jenazah Terduga atau Positif COVID-19</p>\\n","protected":false},"author":2},{"id":563,"date_gmt":"2020-03-17T09:27:09","modified_gmt":"2021-03-02T04:55:06","slug":"panduan-naik-ojek-motor-mobil-untuk-pengemudi-dan-penumpang","type":"post","title":{"rendered":"Panduan Naik Ojek Motor/Mobil untuk Pengemudi dan Penumpang"},"excerpt":{"rendered":"<p>Ikuti panduan ini yuk untuk berkendara aman dengan Ojek Motor/Mobil di masa pandemi COVID-19 ini.</p>\\n","protected":false},"author":2}],"authors":{"2":{"id":2,"name":"Kawal COVID-19","description":"Tim administrator situs KawalCOVID19.id","slug":"admin","avatar_urls":{"24":"http://0.gravatar.com/avatar/662a7ed69e971f6fb58f2c0aff371674?s=24&d=retro&r=g","48":"http://0.gravatar.com/avatar/662a7ed69e971f6fb58f2c0aff371674?s=48&d=retro&r=g","96":"http://0.gravatar.com/avatar/662a7ed69e971f6fb58f2c0aff371674?s=96&d=retro&r=g"},"_links":{"self":[{"href":"http://18.141.204.243/index.php?rest_route=/wp/v2/users/2"}],"collection":[{"href":"http://18.141.204.243/index.php?rest_route=/wp/v2/users"}]}}}},"__N_SSG":true}');


var $91a039895cb85b0e$exports = {};
$91a039895cb85b0e$exports = JSON.parse('{"pageProps":{"category":{"id":44,"count":64,"description":"Bacaan penting dan analisa penting Covid-19","name":"Bacaan Pilihan","slug":"bacaan"},"posts":[{"id":2148,"date_gmt":"2021-09-02T13:27:36","modified_gmt":"2021-09-02T13:28:54","slug":"pengalaman-karantina-mandiri-sepulang-dari-as","type":"post","title":{"rendered":"Pengalaman Karantina Mandiri Sepulang dari AS"},"excerpt":{"rendered":"<p>Akhir Juli lalu, saya dan suami berangkat ke AS setelah menunda beberapa bulan karena pandemi. Kami di sana selama dua minggu dan kembali ke Jakarta pada 5 Agustus 2021. Untuk itu, saya segera melengkapi diri dengan informasi mengenai tahapan yang harus dilewati saat pulang, termasuk keharusan menjalani karantina selama delapan hari.&nbsp; Begitu keluar dari pesawat, [&hellip;]</p>\\n","protected":false},"author":2},{"id":1970,"date_gmt":"2021-06-30T01:56:00","modified_gmt":"2021-06-30T01:56:15","slug":"kalasuba-lockdown-vastraharan-drupadi","type":"post","title":{"rendered":"Kalasuba: Lockdown &#038; Vastraharan Drupadi"},"excerpt":{"rendered":"<p>oleh Sidrotun Naim28/6/2021 Vastraharan Punya suami lima Pandawa, harusnya hidup Drupadi serba enak. Lho, punya lima suami? Ya, begitulah versi asli Mahabharata, di versi wayang Jawa diperhalus bahwa dia hanya istri dari Yudistira, Pandawa tertua. Kurawa yang dipimpin Duryudana selalu ingin menjadi pewaris sah Hastinapura. Maka Hastinapura dibagi menjadi dua. Pandawa yang harus keluar, dengan [&hellip;]</p>\\n","protected":false},"author":2},{"id":1925,"date_gmt":"2021-05-11T00:36:26","modified_gmt":"2021-05-11T00:37:06","slug":"ketika-harus-menyampaikan-kabar-buruk","type":"post","title":{"rendered":"Ketika Harus Menyampaikan Kabar Buruk"},"excerpt":{"rendered":"<p>Bagaimana mengkomunikasikan kabar buruk? Artikel ini membahas bagaimana berkomunikasi dengan empati terutama dalam konteks pandemi COVID-19.</p>\\n","protected":false},"author":2},{"id":1658,"date_gmt":"2021-02-27T02:25:18","modified_gmt":"2021-03-01T02:11:05","slug":"seri-penyintas-covid-19-klaster-keluarga-yang-masih-berjuang-untuk-pulih","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Klaster Keluarga Yang Masih Berjuang Untuk Pulih"},"excerpt":{"rendered":"<p>Saya ingin membagi pengalaman kami sekeluarga untuk menjadi penyemangat teman-teman yang orang tua dan keluarganya terkena COVID-19. Kisah oleh @anindya_hafsa</p>\\n","protected":false},"author":2},{"id":1638,"date_gmt":"2021-02-17T01:34:49","modified_gmt":"2021-03-01T02:11:15","slug":"kisahku-dan-covid-19","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Kisahku dan COVID-19"},"excerpt":{"rendered":"<p>Penulis merasakan gejala yang mirip flu setelah pulang dari Bandung mengunjungi keluarganya. Ternyata penulis positif dan  hampir seluruh keluarganya terinfeksi COVID-19. Penulis menceritakan perjalanan perawatannya selama di RS.</p>\\n","protected":false},"author":2},{"id":1629,"date_gmt":"2021-02-03T08:03:57","modified_gmt":"2021-03-01T02:11:24","slug":"satu-tahun-evakuasi-dari-wuhan","type":"post","title":{"rendered":"Satu Tahun Evakuasi dari Wuhan"},"excerpt":{"rendered":"<p>Genap satu tahun penulis dipulangkan dari Wuhan bersama WNI lainnya. Penulis menceritakan kilas balik evakuasi mereka dari Wuhan, Tiongkok. Satu tahun berselang, Wuhan sebagai episentrum pertama COVID-19 telah kembali normal, sedangkan Indonesia masih berjuang untuk mengatasi pandemi ini. Ia mengajak Indonesia untuk menyontoh kegigihan Wuhan bersusah-susah dahulu agar kita bisa lebih cepat keluar dari pandemi.</p>\\n","protected":false},"author":2},{"id":1627,"date_gmt":"2021-02-03T08:02:45","modified_gmt":"2021-03-01T02:11:34","slug":"pengalaman-penderita-diabetes-terinfeksi-covid-19","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Pengalaman Penderita Diabetes Terinfeksi COVID-19"},"excerpt":{"rendered":"<p>Setelah bertugas sebagai panitia KPPS (yang menyiapkan Pilkada di TPS masing-masing), penulis mengalami demam tinggi. Hasil rapid test non-reaktif, dan diagnosa pertama adalah typhus. Setelah beberapa hari di RS, kondisi tidak membaik dan hasil rontgen paru-paru menunjukkan infeksi COVID-19 yang divalidasi dengan hasil swab PCR positif.</p>\\n","protected":false},"author":2},{"id":1616,"date_gmt":"2021-01-24T04:07:21","modified_gmt":"2021-03-01T02:11:42","slug":"seri-penyintas-covid-19-saya-penyintas-dan-mengalami-long-covid","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Saya Penyintas dan Mengalami Long COVID"},"excerpt":{"rendered":"<p>Cerita Juno, penyintas COVID-19 yang mengalami gejala Long COVID.</p>\\n","protected":false},"author":2},{"id":1606,"date_gmt":"2021-01-08T07:19:31","modified_gmt":"2021-03-01T02:11:52","slug":"catatan-penyintas-covid-19-bernatal-di-wisma-atlit","type":"post","title":{"rendered":"Catatan Penyintas COVID-19: Bernatal di Wisma Atlit"},"excerpt":{"rendered":"<p>Ketika berkumpul bersama keluarga, protokol kesehatan sering terlupakan dan menjadi celah penularan COVID-19. Penulis menceritakan kronologi terpaparnya dia dan keluarganya oleh COVID-19 sehingga merayakan Natal di Wisma Atlit</p>\\n","protected":false},"author":2},{"id":1568,"date_gmt":"2020-12-31T03:24:38","modified_gmt":"2021-03-01T02:12:01","slug":"anak-kami-tertular-covid-19-di-sekolah-bagian-2","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Anak Kami Tertular COVID-19 di Sekolah &#8211; bagian 2"},"excerpt":{"rendered":"<p>Kondisi COVID-19 di UK saat ini, walaupun lockdown diberlakukan namun sekolah  tetap dibuka. Dan tanpa kewajiban menggunakan masker bagi siswa dan guru</p>\\n","protected":false},"author":2},{"id":1565,"date_gmt":"2020-12-31T03:21:59","modified_gmt":"2021-03-01T02:12:12","slug":"anak-kami-tertular-covid-19-di-sekolah-bagian-1","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Anak Kami Tertular COVID-19 di Sekolah &#8211; bagian 1"},"excerpt":{"rendered":"<p>Benarkah sekolah sudah aman untuk dibuka? Bagaimana jika ada yang positif di sekolah?</p>\\n","protected":false},"author":2},{"id":1536,"date_gmt":"2020-11-17T06:49:03","modified_gmt":"2021-03-01T02:12:20","slug":"seri-penyintas-covid-19-kami-positif-tapi-tidak-masuk-ke-data","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Kami Positif Tapi Tidak Masuk ke Data"},"excerpt":{"rendered":"<p>Penulis dan keluarganya bergejala ringan tapi baru terbukti positif COVID-19 setelah swab kedua. Ia juga mempertanyakan kenapa data kasus positif tidak bertambah padahal keluarganya positif.</p>\\n","protected":false},"author":2},{"id":1498,"date_gmt":"2020-10-16T06:57:14","modified_gmt":"2021-03-01T02:12:32","slug":"seri-penyintas-covid-19-dua-kali-terpapar-dengan-gejala-yang-berbeda","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Dua Kali Terpapar dengan Gejala yang Berbeda"},"excerpt":{"rendered":"<p>Bulan Maret 2020, penulis terpapar COVID-19 dengan gejala kritis. Di awal Juli 2020, penulis kembali terkena COVID-19 tapi tanpa gejala, beserta dengan istri dan anaknya. Cerita ini adalah contoh bagaimana seseorang bisa terkena COVID-19 lebih dari sekali (reinfeksi). </p>\\n","protected":false},"author":2},{"id":1487,"date_gmt":"2020-10-01T14:40:13","modified_gmt":"2021-07-03T09:03:36","slug":"kumpulan-cerita-pengawal-pagebluk","type":"post","title":{"rendered":"Kumpulan Cerita Pengawal Pagebluk"},"excerpt":{"rendered":"<p>Agar masyarakat umum lebih memahami kondisi pandemi di lapangan, kami mengumpulkan narasi orang pertama dari tenaga kesehatan, lab, dan pihak lain yang turut mengawal penanganan COVID-19 di berbagai daerah di Indonesia.</p>\\n","protected":false},"author":2},{"id":1483,"date_gmt":"2020-10-01T14:18:31","modified_gmt":"2021-03-01T02:14:59","slug":"seri-pengawal-pagebluk-pasien-mendadak-kritis-atau-meninggal-testing-lemah-dan-warga-abai","type":"post","title":{"rendered":"Seri Pengawal Pagebluk: Pasien Mendadak Kritis atau Meninggal, Testing Lemah, dan Warga Abai"},"excerpt":{"rendered":"<p>Jumlah kasus positif rendah bukan berarti sebuah daerah aman dari COVID-19. Seorang dokter di Provinsi Lampung melaporkan beberapa pasien yang ternyata positif COVID-19, mendadak kritis, atau bahkan meninggal dalam waktu singkat ketika sudah berada di RS rujukan COVID-19. Minimnya testing membuat warga tidak was-was dan akhirnya abai.</p>\\n","protected":false},"author":2},{"id":1477,"date_gmt":"2020-09-27T03:11:02","modified_gmt":"2021-03-01T02:15:08","slug":"cerita-covid-19-art-positif-meski-berkegiatan-di-sekitar-rumah-saja","type":"post","title":{"rendered":"Cerita COVID-19: ART Positif Meski Berkegiatan di Sekitar Rumah Saja"},"excerpt":{"rendered":"<p>Asisten rumah tangga (ART) penulis positif COVID-19 meski tinggal di rumah saja dan hanya keluar untuk keperluan tertentu. Sementara itu, ART lainnya meninggal dunia dua hari sejak gejala awal muncul. Pengalaman ini adalah contoh bagaimana rumah bisa menjadi klaster penyebaran.</p>\\n","protected":false},"author":2},{"id":1474,"date_gmt":"2020-09-24T06:25:43","modified_gmt":"2021-03-01T02:15:18","slug":"seri-penyintas-covid-19-perjuangan-mencari-rumah-sakit-dan-melewati-masa-kritis","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Perjuangan Mencari Rumah Sakit dan Melewati Masa Kritis"},"excerpt":{"rendered":"<p>Seorang penyintas di Surabaya mengalami COVID-19 sekaligus demam berdarah. Selama berhari-hari, kondisinya kritis dan nyawanya bergantung pada ventilator. Ia selamat tapi kehilangan nenek tercinta akibat COVID-19.</p>\\n","protected":false},"author":2},{"id":1460,"date_gmt":"2020-08-31T15:25:25","modified_gmt":"2021-03-01T02:15:27","slug":"benarkah-virus-mutasi-d614g-10x-lebih-mudah-menginfeksi","type":"post","title":{"rendered":"Benarkah Virus Mutasi D614G 10x Lebih Mudah Menginfeksi?"},"excerpt":{"rendered":"<p>Menanggapi klaim Dr Noor Hisham bahwa virus mutasi D614G 10x lebih menular, KawalCOVID19.id memberikan analisis dan posisi kami terhadap isu ini.</p>\\n","protected":false},"author":2},{"id":1457,"date_gmt":"2020-08-28T14:00:57","modified_gmt":"2021-03-01T02:15:37","slug":"seri-garda-terdepan-suka-duka-merawat-pasien-covid-19-di-rs-suyoto","type":"post","title":{"rendered":"Seri Pengawal Pagebluk: Suka Duka Merawat Pasien COVID-19 di RS Suyoto"},"excerpt":{"rendered":"<p>Seorang dokter relawan di Jakarta menggambarkan situasi perawatan COVID-19 di lapangan, termasuk prosedur memakai APD setiap kali memeriksa pasien hingga kematian pasien akibat penyakit penyerta, bahkan pada pasien remaja.</p>\\n","protected":false},"author":2},{"id":1409,"date_gmt":"2020-08-24T08:24:50","modified_gmt":"2021-03-01T02:15:45","slug":"seri-garda-terdepan-kendala-lapangan-analis-medis-di-kalimantan-selatan","type":"post","title":{"rendered":"Seri Pengawal Pagebluk: Kendala Lapangan Analis Medis di Kalimantan Selatan"},"excerpt":{"rendered":"<p>Seorang analis kesehatan di Kalimantan Selatan memaparkan faktor-faktor yang menyebabkan hasil swab lama dipublikasikan, mulai dari kekurangan SDM, kecilnya kapasitas alat tes, hingga data yang tidak sinkron.</p>\\n","protected":false},"author":2},{"id":1399,"date_gmt":"2020-08-15T14:52:50","modified_gmt":"2021-03-01T02:15:53","slug":"seri-penyintas-covid-19-ibu-dan-anak-sesama-dokter-tertular-dan-sembuh-dari-covid-19","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Ibu dan Anak Sesama Dokter Tertular dan Sembuh dari COVID-19"},"excerpt":{"rendered":"<p>Seorang dokter gigi (ibu) dan dokter umum (anak) terpapar COVID-19 di fasilitas kesehatan pada waktu yang berlainan. Meski gejalanya ringan, masa isolasi terasa berat. Belum lagi tuduhan yang diterima dari keluarga pasien bahwa COVID-19 ini konspirasi RS.</p>\\n","protected":false},"author":2},{"id":1390,"date_gmt":"2020-08-04T13:00:40","modified_gmt":"2021-03-01T02:16:01","slug":"seri-penyintas-covid-19-papaku-terus-sesak-napas-meski-sudah-dinyatakan-sembuh","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Papaku Terus Sesak Napas Meski Sudah Dinyatakan Sembuh"},"excerpt":{"rendered":"<p>Lima minggu setelah dinyatakan sembuh dari COVID-19, ayah dari penulis masih terus sesak napas dan memakai masker oksigen di rumah.</p>\\n","protected":false},"author":2},{"id":1388,"date_gmt":"2020-08-04T12:58:01","modified_gmt":"2021-03-01T02:16:08","slug":"seri-penyintas-covid-19-dari-kehilangan-kerabat-hingga-donor-plasma-darah","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Dari Kehilangan Kerabat Hingga Donor Plasma Darah"},"excerpt":{"rendered":"<p>Belum usai berduka setelah kerabatnya meninggal dunia akibat COVID-19, penulis terkonfirmasi positif. Dengan kesabaran selama perawatan di ruang isolasi RS, ia pun sembuh dan telah mendonorkan plasma darah untuk membantu pasien COVID-19 lain dengan kondisi kritis.</p>\\n","protected":false},"author":2},{"id":1383,"date_gmt":"2020-07-28T14:57:34","modified_gmt":"2021-03-01T02:49:32","slug":"seri-penyintas-covid-19-ketidakjujuran-pasien-icu-dan-keluarganya-membuat-saya-terpapar-dan-diintubasi","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Ketidakjujuran Pasien ICU dan Keluarganya Membuat Saya Terpapar dan Diintubasi"},"excerpt":{"rendered":"<p>Akibat kebohongan satu orang, sedikitnya tujuh orang tim medis dan non-medis di RS rujukan COVID-19 di Yogyakarta terinfeksi. </p>\\n","protected":false},"author":2},{"id":1365,"date_gmt":"2020-07-23T04:53:42","modified_gmt":"2021-03-01T08:12:34","slug":"kumpulan-cerita-penyintas-covid-19","type":"post","title":{"rendered":"Kumpulan Cerita Penyintas COVID-19"},"excerpt":{"rendered":"<p>Berikut kisah penyintas COVID-19 yang berhasil kami kumpulkan selama ini.</p>\\n","protected":false},"author":2},{"id":1359,"date_gmt":"2020-07-22T14:49:14","modified_gmt":"2021-03-01T02:49:48","slug":"seri-penyintas-covid-19-tiga-bulan-bergumul-dengan-covid-19","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Tiga Bulan Bergumul dengan COVID-19"},"excerpt":{"rendered":"<p>Sepulang dari Inggris, penulis mengalami anosmia (kehilangan indera penciuman). Selama tiga bulan lamanya, ia dinyatakan positif COVID-19 dengan total 10 tes swab.</p>\\n","protected":false},"author":2},{"id":1356,"date_gmt":"2020-07-22T14:23:01","modified_gmt":"2021-03-01T02:49:55","slug":"gambaran-penggunaan-ventilator-bagi-pasien-covid-19-kritis","type":"post","title":{"rendered":"Gambaran Penggunaan Ventilator bagi Pasien COVID-19 Kritis"},"excerpt":{"rendered":"<p>Inilah ilustrasi penggunaan ventilator bagi pasien COVID-19 dengan kondisi kritis.</p>\\n","protected":false},"author":2},{"id":1354,"date_gmt":"2020-07-22T14:19:11","modified_gmt":"2021-03-01T02:50:03","slug":"seri-penyintas-covid-19-virus-tidak-kenal-profesi-dan-usia","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Virus Tidak Kenal Profesi dan Usia"},"excerpt":{"rendered":"<p>Seorang dokter di usia produktif di Bali terpapar COVID-19 dengan kondisi kritis. Kisahnya menyadarkan bahwa seseorang yang tahu betul soal dunia medis dan berusia relatif muda tidak serta merta kebal dari virus.</p>\\n","protected":false},"author":2},{"id":1349,"date_gmt":"2020-07-21T03:33:53","modified_gmt":"2021-03-01T02:50:10","slug":"kisah-dania-berjuang-sembuh-dengan-diagnosa-tidak-pasti","type":"post","title":{"rendered":"Kisah Dania: Berjuang Sembuh dengan Diagnosa Tidak Pasti"},"excerpt":{"rendered":"<p>Benarkah Rumah Sakit mempositifkan banyak orang demi mendapat insentif pemerintah?</p>\\n","protected":false},"author":2},{"id":1347,"date_gmt":"2020-07-21T03:25:38","modified_gmt":"2021-03-01T02:50:21","slug":"kisah-mila-perjuangan-di-ruang-isolasi-dengan-status-pdp","type":"post","title":{"rendered":"Kisah Mila*: Perjuangan di Ruang Isolasi dengan Status PDP"},"excerpt":{"rendered":"<p>Benarkah Rumah Sakit mempositifkan banyak orang demi mendapat insentif pemerintah?</p>\\n","protected":false},"author":2},{"id":1278,"date_gmt":"2020-06-12T12:47:02","modified_gmt":"2021-03-01T02:50:31","slug":"edukasi-benarkah-otg-tidak-menular","type":"post","title":{"rendered":"[EDUKASI] Benarkah OTG tidak menular?"},"excerpt":{"rendered":"<p>Meluruskan kesimpangsiuran tentang risiko OTG menularkan COVID-19</p>\\n","protected":false},"author":62},{"id":1225,"date_gmt":"2020-05-08T07:38:04","modified_gmt":"2021-03-01T02:50:40","slug":"seri-garda-terdepan-bertugas-sebagai-dokter-di-rs-darurat-covid-19","type":"post","title":{"rendered":"Seri Pengawal Pagebluk: Bertugas sebagai Dokter di RS Darurat COVID-19"},"excerpt":{"rendered":"<p>Seorang dokter yang ditugaskan di Rumah Sakit Darurat COVID-19 Wisma Atlet Kemayoran, Jakarta, menceritakan kesehariannya selama dua minggu pertama bertugas.</p>\\n","protected":false},"author":2},{"id":1192,"date_gmt":"2020-04-28T12:08:52","modified_gmt":"2021-03-01T02:50:50","slug":"seri-penyintas-covid-19-tidak-bergejala-serius-bukan-berarti-tidak-terinfeksi","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Tidak Bergejala Serius Bukan Berarti Tidak Terinfeksi"},"excerpt":{"rendered":"<p>Seorang penyintas COVID-19 tanpa gejala serius menceritakan hari-hari selama isolasi dan pesan pentingnya bagi pasien lain.  </p>\\n","protected":false},"author":2},{"id":1190,"date_gmt":"2020-04-28T12:08:07","modified_gmt":"2021-03-01T02:51:01","slug":"bertahan-saja-sudah-cukup","type":"post","title":{"rendered":"Bertahan Saja Sudah Cukup"},"excerpt":{"rendered":"<p>Cerita dan saran bagaimana mengatasi rasa cemas karena bipolar disorder yang dapat diterapkan untuk mengatasi rasa cemas karena pandemi.</p>\\n","protected":false},"author":2},{"id":1181,"date_gmt":"2020-04-27T07:46:27","modified_gmt":"2021-03-01T02:51:10","slug":"tiga-hal-yang-penting-untuk-kebijakan-mitigasi-wabah-covid-19-berdasarkan-data-indonesia","type":"post","title":{"rendered":"Tiga Hal yang Penting untuk Kebijakan Mitigasi Wabah COVID-19 Berdasarkan Data Indonesia"},"excerpt":{"rendered":"<p>Mari simak pola-pola pasien COVID-19 di Indonesia berdasarkan data dan bagaimana kebijakan mitigasi yang tepat.</p>\\n","protected":false},"author":2},{"id":1179,"date_gmt":"2020-04-27T07:35:01","modified_gmt":"2021-03-01T02:51:20","slug":"belajar-dari-singapura-no-one-is-safe-until-everyone-is-safe","type":"post","title":{"rendered":"Belajar dari Singapura: No One is Safe Until Everyone is Safe"},"excerpt":{"rendered":"<p>Kasus baru COVID-19 di Singapura melonjak di bulan April 2020, jumlah penambahan kasus harian di Singapura. Apa yang terjadi di Singapura dalam beberapa minggu terakhir?</p>\\n","protected":false},"author":2},{"id":1120,"date_gmt":"2020-04-20T03:20:49","modified_gmt":"2021-03-01T02:51:37","slug":"indonesia-mandiri-masker","type":"post","title":{"rendered":"Indonesia Mandiri Masker"},"excerpt":{"rendered":"<p>Yuk simak data penelitian faktual dan tervalidasi terkait manfaat masker kain buatan sendiri untuk mengurangi penularan virus penyebab COVID-19. </p>\\n","protected":false},"author":2},{"id":1094,"date_gmt":"2020-04-19T11:15:40","modified_gmt":"2021-03-01T02:51:46","slug":"saya-sudah-kehilangan-ayah-beberapa-anggota-keluarga-besar-dan-11-teman","type":"post","title":{"rendered":"Saya Sudah Kehilangan Ayah, Beberapa Anggota Keluarga Besar, dan 11 Teman"},"excerpt":{"rendered":"<p>Kisah nyata dari relawan KawalCovid19.</p>\\n","protected":false},"author":2},{"id":1006,"date_gmt":"2020-04-10T08:11:49","modified_gmt":"2021-03-02T04:47:32","slug":"cerita-dari-jerman-pengalaman-dua-wni-di-bochum-dan-frankfurt","type":"post","title":{"rendered":"Cerita dari Jerman: Pengalaman Dua WNI di Bochum dan Frankfurt"},"excerpt":{"rendered":"<p>Seorang pelajar dan seorang pekerja asal Indonesia yang tinggal di Jerman membagikan kisah penanganan pandemi oleh pemerintah Jerman</p>\\n","protected":false},"author":2},{"id":992,"date_gmt":"2020-04-10T08:07:59","modified_gmt":"2021-03-02T04:47:39","slug":"cerita-dari-taiwan-respons-tepat-taiwan-dalam-menghadapi-sars-cov-2-dan-covid-19","type":"post","title":{"rendered":"Cerita dari Taiwan: Respons Tepat Taiwan dalam Menghadapi SARS COV-2 dan COVID-19"},"excerpt":{"rendered":"<p>Taiwan disebut-sebut sebagai negara yang mengantisipasi penyebaran COVID-19 dengan baik sebelum wabah memburuk. Artikel ini merangkum hal-hal baik yang dilakukan oleh Taiwan dan yang dapat dijadikan contoh.</p>\\n","protected":false},"author":2},{"id":966,"date_gmt":"2020-04-07T04:35:32","modified_gmt":"2021-03-01T02:52:44","slug":"tips-agar-tetap-positif-selama-bekerja-dari-rumah","type":"post","title":{"rendered":"Tips Agar Tetap Positif Selama Bekerja dari Rumah"},"excerpt":{"rendered":"<p>Jenuh bekerja dari rumah? Simak tips berikut bagi tenaga profesional dan pekerja lainnya agar pikiran tetap positif selama #DiRumahAja.</p>\\n","protected":false},"author":2},{"id":964,"date_gmt":"2020-04-07T04:33:51","modified_gmt":"2021-03-01T02:52:53","slug":"bertahan-dari-hubungan-tidak-sehat-selama-pandemi-covid-19","type":"post","title":{"rendered":"Waspadai Kekerasan Dalam Rumah Tangga saat Isolasi Mandiri"},"excerpt":{"rendered":"<p>Himbauan #DiRumahAja membawa permasalahan tersendiri bagi mereka yang terlibat dalam hubungan tidak sehat (toxic relationship) di rumah. Jika Anda salah satunya, simak tips untuk mengendalikan situasi dan menyelamatkan diri.</p>\\n","protected":false},"author":2},{"id":856,"date_gmt":"2020-04-01T05:16:29","modified_gmt":"2021-03-01T02:53:01","slug":"belajar-dari-vietnam","type":"post","title":{"rendered":"Belajar dari Vietnam"},"excerpt":{"rendered":"<p>Dengan sumber daya terbatas dibandingkan Korea Selatan, Vietnam mampu mengatasi pandemi dengan langkah-langkah cepat dan tepat.</p>\\n","protected":false},"author":125},{"id":839,"date_gmt":"2020-03-30T12:09:12","modified_gmt":"2021-03-01T02:53:54","slug":"polemik-penggunaan-vitamin-dan-suplemen-kesehatan","type":"post","title":{"rendered":"Polemik Penggunaan Vitamin dan Suplemen Kesehatan"},"excerpt":{"rendered":"<p> Di tengah-tengah wabah COVID-19, banyak informasi mengenai vitamin dan suplemen kesehatan yang kita terima baik dari pesan berantai WhatsApp, maupun nasihat dari teman-teman. Kami ingin Anda lebih mengerti tentang vitamin dan suplemen kesehatan, beserta penggunaannya bagi kesehatan Anda </p>\\n","protected":false},"author":2},{"id":820,"date_gmt":"2020-03-29T04:45:03","modified_gmt":"2021-03-01T02:53:45","slug":"lockdown-bukan-berarti-ekonomi-berhenti-begini-caranya","type":"post","title":{"rendered":"Lockdown? Bukan berarti ekonomi berhenti. Begini caranya!"},"excerpt":{"rendered":"<p>New York sudah menerapkan lockdown. Kebijakan yang tadinya dikhawatirkan akan mengganggu stabilitas ekonomi ternyata hanya mengubah jenis mata pencaharian yang tersedia berkat dukungan dan intervensi pemerintah serta perusahaan-perusahaan besar.</p>\\n","protected":false},"author":2},{"id":803,"date_gmt":"2020-03-28T15:33:36","modified_gmt":"2021-03-01T02:54:02","slug":"karantina-wilayah","type":"post","title":{"rendered":"Karantina Wilayah"},"excerpt":{"rendered":"<p>&#8230; a brief to the President</p>\\n","protected":false},"author":2},{"id":796,"date_gmt":"2020-03-28T02:21:59","modified_gmt":"2021-03-01T02:54:11","slug":"dari-de-epidemie-ke-wajah-abad-ini-menghadapi-wabah","type":"post","title":{"rendered":"Dari \u201CDe Epidemie\u201D ke Wajah Abad ini Menghadapi Wabah"},"excerpt":{"rendered":"<p>COVID-19 bukan pandemi pertama yang Indonesia hadapi sepanjang sejarah. Seabad yang lalu, Hindia Belanda sebutan Indonesia di kala itu) mengalami Pandemi Flu. Artikel ini menelusuri fakta-fakta sejarah yang relevan dengan kondisi Indonesia di masa kini sebagai  pelajaran berharga.</p>\\n","protected":false},"author":2},{"id":786,"date_gmt":"2020-03-27T09:08:54","modified_gmt":"2021-03-01T02:54:22","slug":"ingat-italia-4-minggu-di-depan-indonesia","type":"post","title":{"rendered":"Ingat Italia (4 Minggu di Depan Indonesia)"},"excerpt":{"rendered":"<p>Tulisan ini menjabarkan analisis tentang intervensi yang dilakukan pemerintah Italia untuk menekan laju jumlah kasus terkonfimasi positif COVID-19 di Italia dan dampaknya.</p>\\n","protected":false},"author":125},{"id":778,"date_gmt":"2020-03-26T12:32:20","modified_gmt":"2021-03-01T02:59:39","slug":"cerita-dari-filipina-menjalani-karantina-wilayah-lockdown-sebagai-diaspora","type":"post","title":{"rendered":"Cerita dari Filipina: Menjalani Karantina wilayah (lockdown) sebagai Diaspora"},"excerpt":{"rendered":"<p>Sepulang dari Indonesia dan tiba kembali di Filipina, koresponden kami disambut dengan karantina wilayah (lockdown) oleh pemerintah setempat. Simak pengalamannya menjalani hal tersebut sebagai diaspora Indonesia di Manila.</p>\\n","protected":false},"author":2},{"id":764,"date_gmt":"2020-03-25T02:37:19","modified_gmt":"2021-03-01T02:59:49","slug":"catatan-dari-wuhan-part-1","type":"post","title":{"rendered":"Cerita dari Tiongkok: Catatan dari Wuhan"},"excerpt":{"rendered":"<p>Pengalaman tinggal di Wuhan, Cina di tengah pandemik COVID-19</p>\\n","protected":false},"author":2},{"id":745,"date_gmt":"2020-03-24T06:29:26","modified_gmt":"2021-03-01T02:59:57","slug":"cerita-dari-italia-a-cautionary-tale-peringatan-untuk-kita-semua","type":"post","title":{"rendered":"Cerita dari Italia: A Cautionary Tale (Peringatan untuk Kita Semua)"},"excerpt":{"rendered":"<p>Seorang mahasiswa S3 asal Indonesia membagikan pengalaman dan observasinya selama tinggal di Trieste, Italia di tengah pandemi COVID-19. Artikel ini penting untuk menjadi bahan renungan bagi masyarakat di Indonesia agar yang terjadi di Italia tidak perlu terulang di negara kita.</p>\\n","protected":false},"author":2},{"id":698,"date_gmt":"2020-03-21T17:38:31","modified_gmt":"2021-03-01T03:00:08","slug":"mencegah-dan-menangani-stigma-sosial-seputar-covid-19","type":"post","title":{"rendered":"Mencegah dan Menangani Stigma Sosial Seputar COVID-19"},"excerpt":{"rendered":"<p>Pandemi COVID-19 muncul bersamaan dengan stigma sosial di tengah masyarakat. Namun, hal ini dapat dicegah dan ditangani bersama oleh individu maupun pihak-pihak terkait.</p>\\n","protected":false},"author":2},{"id":679,"date_gmt":"2020-03-21T17:27:08","modified_gmt":"2021-03-01T03:00:17","slug":"cerita-dari-singapura-belajar-menjaga-diri-sendiri-dari-sekolah","type":"post","title":{"rendered":"Cerita dari Singapura: Belajar Menjaga Diri Sendiri dari Sekolah"},"excerpt":{"rendered":"<p>Dina Kharisma, seorang guru SD di Singapura, membagikan pengalamannya soal langkah-langkah yang dilakukan di sekolah ketika COVID-19 datang ke negeri singa tersebut.</p>\\n","protected":false},"author":2},{"id":685,"date_gmt":"2020-03-21T17:25:08","modified_gmt":"2021-03-01T03:00:25","slug":"tips-menjaga-kesehatan-jiwa-saat-jaga-jarak","type":"post","title":{"rendered":"Tips Menjaga Kesehatan Jiwa Saat Jaga Jarak"},"excerpt":{"rendered":"<p>Tips untuk menjaga kesehatan jiwa pada saat masa karantina dan jaga jarak dulu.</p>\\n","protected":false},"author":2},{"id":676,"date_gmt":"2020-03-21T17:22:38","modified_gmt":"2021-03-01T03:00:36","slug":"10-tips-meringankan-beban-tenaga-medis-di-lapangan","type":"post","title":{"rendered":"10 Tips Meringankan Beban Tenaga Medis di Lapangan"},"excerpt":{"rendered":"<p>Selain diam di rumah, bantu juga tenaga medis dengan melakukan hal-hal berikut ini.</p>\\n","protected":false},"author":2},{"id":650,"date_gmt":"2020-03-21T04:51:36","modified_gmt":"2021-03-01T03:00:45","slug":"bagaimana-virus-corona-menyerang-tubuh","type":"post","title":{"rendered":"Bagaimana Virus Corona Menyerang Tubuh?"},"excerpt":{"rendered":"<p>Bagaimana SARS-CoV-2 menginfeksi dan menyerang tubuh, dan apa dampaknya pada tubuh selain paru-paru. </p>\\n","protected":false},"author":2},{"id":628,"date_gmt":"2020-03-20T12:37:25","modified_gmt":"2021-03-01T03:00:54","slug":"vaksin-dan-covid-19","type":"post","title":{"rendered":"Vaksin dan COVID-19"},"excerpt":{"rendered":"<p>Vaksin COVID-19 sudah ada atau belum sih? Mari kita cari tahu kebenarannya.</p>\\n","protected":false},"author":2},{"id":592,"date_gmt":"2020-03-18T12:43:56","modified_gmt":"2021-03-01T03:01:10","slug":"siapkan-anak-anda-menghadapi-wabah-koronavirus-covid-19","type":"post","title":{"rendered":"Siapkan Anak Anda Menghadapi Wabah Koronavirus (COVID-19)"},"excerpt":{"rendered":"<p>Checklist untuk orang tua agar dapat mempersiapkan anak menghadapi wabah COVID-19</p>\\n","protected":false},"author":2},{"id":594,"date_gmt":"2020-03-18T12:38:44","modified_gmt":"2021-03-01T03:01:25","slug":"wuhan-virus-korona-dan-kewaspadaan-kita","type":"post","title":{"rendered":"Wuhan, Virus Korona, dan Kewaspadaan Kita"},"excerpt":{"rendered":"<p>Bagaimana Cina meningkatkan kewaspadaan terhadap virus korona yang mewabah</p>\\n","protected":false},"author":2},{"id":548,"date_gmt":"2020-03-17T05:43:50","modified_gmt":"2021-03-01T03:01:35","slug":"dirjen-who-virus-covid-19-adalah-virus-yang-unik-dengan-karakteristik-yang-unik-pula","type":"post","title":{"rendered":"Dirjen WHO: \u201DVirus COVID-19 adalah Virus yang Unik dengan Karakteristik yang Unik Pula&#8221;"},"excerpt":{"rendered":"<p>Berikut penjelasan beberapa perbedaan karakteristik virus penyebab COVID-19 dan influenza.</p>\\n","protected":false},"author":2},{"id":535,"date_gmt":"2020-03-16T13:32:39","modified_gmt":"2021-03-01T03:01:45","slug":"kegiatan-belajar-dan-bermain-di-rumah-untuk-anak-balita-dan-taman-kanak-kanak","type":"post","title":{"rendered":"Kegiatan Belajar dan Bermain di Rumah untuk Anak Balita dan Taman Kanak-Kanak"},"excerpt":{"rendered":"<p>Sekolah anak libur selama 2 minggu? Jangan panik! Kami sudah menyiapkan kegiatan yang dapat dilakukan bersama anak saat libur.</p>\\n","protected":false},"author":2},{"id":524,"date_gmt":"2020-03-16T12:45:55","modified_gmt":"2021-03-01T03:33:59","slug":"siapkan-anak-anda-menghadapi-wabah-koronavirus","type":"post","title":{"rendered":"Siapkan Anak Anda Menghadapi Wabah Koronavirus"},"excerpt":{"rendered":"<p>Berbicara dengan Anak tentang COVID-19</p>\\n","protected":false},"author":2},{"id":349,"date_gmt":"2020-03-12T23:22:02","modified_gmt":"2021-03-01T03:36:33","slug":"cerita-dari-korea-selatan-pengalaman-ngantor-di-tengah-wabah","type":"post","title":{"rendered":"Cerita dari Korea Selatan: Pengalaman Ngantor di Tengah Wabah"},"excerpt":{"rendered":"<p>Pengaruh coronavirus terhadap kondisi kerja di Seoul, Korea.</p>\\n","protected":false},"author":2},{"id":302,"date_gmt":"2020-03-10T04:27:20","modified_gmt":"2021-03-01T03:36:42","slug":"superspreader-setiap-orang-bisa-cegah-penularan-lebih-lanjut","type":"post","title":{"rendered":"Superspreader: Setiap Orang Bisa Cegah Penularan Lebih Lanjut"},"excerpt":{"rendered":"<p>Indonesia bisa belajar dari penyebaran luas COVID-19 di negara-negara lain yang bermula dari satu orang saja.</p>\\n","protected":false},"author":82}],"authors":{"2":{"id":2,"name":"Kawal COVID-19","description":"Tim administrator situs KawalCOVID19.id","slug":"admin","avatar_urls":{"24":"http://0.gravatar.com/avatar/662a7ed69e971f6fb58f2c0aff371674?s=24&d=retro&r=g","48":"http://0.gravatar.com/avatar/662a7ed69e971f6fb58f2c0aff371674?s=48&d=retro&r=g","96":"http://0.gravatar.com/avatar/662a7ed69e971f6fb58f2c0aff371674?s=96&d=retro&r=g"},"_links":{"self":[{"href":"http://18.141.204.243/index.php?rest_route=/wp/v2/users/2"}],"collection":[{"href":"http://18.141.204.243/index.php?rest_route=/wp/v2/users"}]}},"62":{"id":62,"name":"Elina Ciptadi","description":"","slug":"elina-ciptadi","avatar_urls":{"24":"http://1.gravatar.com/avatar/1ac374567d5d3d8fdf2879cb3460d537?s=24&d=retro&r=g","48":"http://1.gravatar.com/avatar/1ac374567d5d3d8fdf2879cb3460d537?s=48&d=retro&r=g","96":"http://1.gravatar.com/avatar/1ac374567d5d3d8fdf2879cb3460d537?s=96&d=retro&r=g"},"_links":{"self":[{"href":"http://18.141.204.243/index.php?rest_route=/wp/v2/users/62"}],"collection":[{"href":"http://18.141.204.243/index.php?rest_route=/wp/v2/users"}]}},"82":{"id":82,"name":"Septian Hartono","description":"Praktisi kesehatan dan peneliti MRI di salah satu rumah sakit umum di Singapura. Asisten Profesor di Duke-NUS Medical School.","slug":"septian-hartono","avatar_urls":{"24":"http://0.gravatar.com/avatar/3020050fbfb28276163e5b93c4dff917?s=24&d=retro&r=g","48":"http://0.gravatar.com/avatar/3020050fbfb28276163e5b93c4dff917?s=48&d=retro&r=g","96":"http://0.gravatar.com/avatar/3020050fbfb28276163e5b93c4dff917?s=96&d=retro&r=g"},"_links":{"self":[{"href":"http://18.141.204.243/index.php?rest_route=/wp/v2/users/82"}],"collection":[{"href":"http://18.141.204.243/index.php?rest_route=/wp/v2/users"}]}},"125":{"id":125,"name":"Ruly Achdiat Santabrata","description":"Seasoned Integration Architect / Data Architect at TIBCO Software, Ltd (tibco.com). Ruly helps many well known companies in complex integration and data projects covering Asia Pacific and Europe. Lives in London, England","slug":"kangsantabrata","avatar_urls":{"24":"http://1.gravatar.com/avatar/442a1d72b848e1a0cce32085d55c516d?s=24&d=retro&r=g","48":"http://1.gravatar.com/avatar/442a1d72b848e1a0cce32085d55c516d?s=48&d=retro&r=g","96":"http://1.gravatar.com/avatar/442a1d72b848e1a0cce32085d55c516d?s=96&d=retro&r=g"},"_links":{"self":[{"href":"http://18.141.204.243/index.php?rest_route=/wp/v2/users/125"}],"collection":[{"href":"http://18.141.204.243/index.php?rest_route=/wp/v2/users"}]}}}},"__N_SSG":true}');


var $b7255525513ab909$exports = {};
$b7255525513ab909$exports = JSON.parse("{\"pageProps\":{\"category\":{\"id\":43,\"count\":4,\"description\":\"List dan daftar yang bermanfaat\",\"name\":\"Check-List\",\"slug\":\"checklist\"},\"posts\":[{\"id\":1485,\"date_gmt\":\"2020-10-01T14:19:43\",\"modified_gmt\":\"2020-10-01T14:20:17\",\"slug\":\"bahan-bahan-memperkenalkan-covid-19-ke-anak-usia-dini\",\"type\":\"post\",\"title\":{\"rendered\":\"Bahan-bahan Memperkenalkan Covid-19 ke Anak Usia Dini\"},\"excerpt\":{\"rendered\":\"<p>Memperkenalkan COVID-19 ke anak-anak usia dini (3-6 tahun) sangat penting. Di bawah ini adalah beberapa resources berupa link, video, infografika, printables yang bisa diprint untuk semua. 3M&nbsp; Apa itu Covid :&nbsp; eBook :&nbsp; Cerita si Korona karangan Watiek Ideo https://online.fliphtml5.com/nwyyb/grdh/#p=1&nbsp; Gara-gara si Korona karangan Watiek Ideo https://online.fliphtml5.com/nwyyb/csin/#p=1&nbsp; Perjalanan si Korona karangan Watiek Ideo https://online.fliphtml5.com/nwyyb/lnjo/#p=10&nbsp; Video [&hellip;]</p>\\n\",\"protected\":false},\"author\":2},{\"id\":817,\"date_gmt\":\"2020-03-29T03:25:00\",\"modified_gmt\":\"2021-07-03T09:03:48\",\"slug\":\"daftar-layanan-konseling-online-se-indonesia\",\"type\":\"post\",\"title\":{\"rendered\":\"Daftar Layanan Konseling Online Se-Indonesia\"},\"excerpt\":{\"rendered\":\"<p>Kami mengumpulkan berbagai poster informasi tentang layanan konseling online yang tersebar di berbagai wilayah.</p>\\n\",\"protected\":false},\"author\":2},{\"id\":644,\"date_gmt\":\"2020-03-21T03:51:30\",\"modified_gmt\":\"2020-04-06T10:04:12\",\"slug\":\"daftar-gereja-dengan-ibadah-online\",\"type\":\"post\",\"title\":{\"rendered\":\"Daftar Gereja dengan Ibadah Online\"},\"excerpt\":{\"rendered\":\"<p>Kami mengajak semua umat Nasrani ikut berpartisipasi dalam mencegah penyebaran COVID-19 dengan melakukan #JagaJarakDulu dan #DiamDiRumah.</p>\\n\",\"protected\":false},\"author\":2},{\"id\":492,\"date_gmt\":\"2020-03-18T13:25:00\",\"modified_gmt\":\"2020-04-03T14:05:04\",\"slug\":\"jadwal-harian-covid-19-usia-sd\",\"type\":\"post\",\"title\":{\"rendered\":\"Jadwal Harian COVID-19 Usia SD\"},\"excerpt\":{\"rendered\":\"<p>Kegiatan harian yang dapat dilakukan anak untuk usia SD.</p>\\n\",\"protected\":false},\"author\":2}],\"authors\":{\"2\":{\"id\":2,\"name\":\"Kawal COVID-19\",\"description\":\"Tim administrator situs KawalCOVID19.id\",\"slug\":\"admin\",\"avatar_urls\":{\"24\":\"http://0.gravatar.com/avatar/662a7ed69e971f6fb58f2c0aff371674?s=24&d=retro&r=g\",\"48\":\"http://0.gravatar.com/avatar/662a7ed69e971f6fb58f2c0aff371674?s=48&d=retro&r=g\",\"96\":\"http://0.gravatar.com/avatar/662a7ed69e971f6fb58f2c0aff371674?s=96&d=retro&r=g\"},\"_links\":{\"self\":[{\"href\":\"http://18.141.204.243/index.php?rest_route=/wp/v2/users/2\"}],\"collection\":[{\"href\":\"http://18.141.204.243/index.php?rest_route=/wp/v2/users\"}]}}}},\"__N_SSG\":true}");


var $e85b07ce865bb499$exports = {};
$e85b07ce865bb499$exports = JSON.parse('{"pageProps":{"posts":[{"id":2148,"date_gmt":"2021-09-02T13:27:36","modified_gmt":"2021-09-02T13:28:54","slug":"pengalaman-karantina-mandiri-sepulang-dari-as","type":"post","title":{"rendered":"Pengalaman Karantina Mandiri Sepulang dari AS"},"excerpt":{"rendered":"<p>Akhir Juli lalu, saya dan suami berangkat ke AS setelah menunda beberapa bulan karena pandemi. Kami di sana selama dua minggu dan kembali ke Jakarta pada 5 Agustus 2021. Untuk itu, saya segera melengkapi diri dengan informasi mengenai tahapan yang harus dilewati saat pulang, termasuk keharusan menjalani karantina selama delapan hari.&nbsp; Begitu keluar dari pesawat, [&hellip;]</p>\\n","protected":false},"author":2},{"id":1970,"date_gmt":"2021-06-30T01:56:00","modified_gmt":"2021-06-30T01:56:15","slug":"kalasuba-lockdown-vastraharan-drupadi","type":"post","title":{"rendered":"Kalasuba: Lockdown &#038; Vastraharan Drupadi"},"excerpt":{"rendered":"<p>oleh Sidrotun Naim28/6/2021 Vastraharan Punya suami lima Pandawa, harusnya hidup Drupadi serba enak. Lho, punya lima suami? Ya, begitulah versi asli Mahabharata, di versi wayang Jawa diperhalus bahwa dia hanya istri dari Yudistira, Pandawa tertua. Kurawa yang dipimpin Duryudana selalu ingin menjadi pewaris sah Hastinapura. Maka Hastinapura dibagi menjadi dua. Pandawa yang harus keluar, dengan [&hellip;]</p>\\n","protected":false},"author":2},{"id":1925,"date_gmt":"2021-05-11T00:36:26","modified_gmt":"2021-05-11T00:37:06","slug":"ketika-harus-menyampaikan-kabar-buruk","type":"post","title":{"rendered":"Ketika Harus Menyampaikan Kabar Buruk"},"excerpt":{"rendered":"<p>Bagaimana mengkomunikasikan kabar buruk? Artikel ini membahas bagaimana berkomunikasi dengan empati terutama dalam konteks pandemi COVID-19.</p>\\n","protected":false},"author":2},{"id":1658,"date_gmt":"2021-02-27T02:25:18","modified_gmt":"2021-03-01T02:11:05","slug":"seri-penyintas-covid-19-klaster-keluarga-yang-masih-berjuang-untuk-pulih","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Klaster Keluarga Yang Masih Berjuang Untuk Pulih"},"excerpt":{"rendered":"<p>Saya ingin membagi pengalaman kami sekeluarga untuk menjadi penyemangat teman-teman yang orang tua dan keluarganya terkena COVID-19. Kisah oleh @anindya_hafsa</p>\\n","protected":false},"author":2},{"id":1638,"date_gmt":"2021-02-17T01:34:49","modified_gmt":"2021-03-01T02:11:15","slug":"kisahku-dan-covid-19","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Kisahku dan COVID-19"},"excerpt":{"rendered":"<p>Penulis merasakan gejala yang mirip flu setelah pulang dari Bandung mengunjungi keluarganya. Ternyata penulis positif dan  hampir seluruh keluarganya terinfeksi COVID-19. Penulis menceritakan perjalanan perawatannya selama di RS.</p>\\n","protected":false},"author":2},{"id":1629,"date_gmt":"2021-02-03T08:03:57","modified_gmt":"2021-03-01T02:11:24","slug":"satu-tahun-evakuasi-dari-wuhan","type":"post","title":{"rendered":"Satu Tahun Evakuasi dari Wuhan"},"excerpt":{"rendered":"<p>Genap satu tahun penulis dipulangkan dari Wuhan bersama WNI lainnya. Penulis menceritakan kilas balik evakuasi mereka dari Wuhan, Tiongkok. Satu tahun berselang, Wuhan sebagai episentrum pertama COVID-19 telah kembali normal, sedangkan Indonesia masih berjuang untuk mengatasi pandemi ini. Ia mengajak Indonesia untuk menyontoh kegigihan Wuhan bersusah-susah dahulu agar kita bisa lebih cepat keluar dari pandemi.</p>\\n","protected":false},"author":2},{"id":1627,"date_gmt":"2021-02-03T08:02:45","modified_gmt":"2021-03-01T02:11:34","slug":"pengalaman-penderita-diabetes-terinfeksi-covid-19","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Pengalaman Penderita Diabetes Terinfeksi COVID-19"},"excerpt":{"rendered":"<p>Setelah bertugas sebagai panitia KPPS (yang menyiapkan Pilkada di TPS masing-masing), penulis mengalami demam tinggi. Hasil rapid test non-reaktif, dan diagnosa pertama adalah typhus. Setelah beberapa hari di RS, kondisi tidak membaik dan hasil rontgen paru-paru menunjukkan infeksi COVID-19 yang divalidasi dengan hasil swab PCR positif.</p>\\n","protected":false},"author":2},{"id":1616,"date_gmt":"2021-01-24T04:07:21","modified_gmt":"2021-03-01T02:11:42","slug":"seri-penyintas-covid-19-saya-penyintas-dan-mengalami-long-covid","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Saya Penyintas dan Mengalami Long COVID"},"excerpt":{"rendered":"<p>Cerita Juno, penyintas COVID-19 yang mengalami gejala Long COVID.</p>\\n","protected":false},"author":2},{"id":1606,"date_gmt":"2021-01-08T07:19:31","modified_gmt":"2021-03-01T02:11:52","slug":"catatan-penyintas-covid-19-bernatal-di-wisma-atlit","type":"post","title":{"rendered":"Catatan Penyintas COVID-19: Bernatal di Wisma Atlit"},"excerpt":{"rendered":"<p>Ketika berkumpul bersama keluarga, protokol kesehatan sering terlupakan dan menjadi celah penularan COVID-19. Penulis menceritakan kronologi terpaparnya dia dan keluarganya oleh COVID-19 sehingga merayakan Natal di Wisma Atlit</p>\\n","protected":false},"author":2},{"id":1568,"date_gmt":"2020-12-31T03:24:38","modified_gmt":"2021-03-01T02:12:01","slug":"anak-kami-tertular-covid-19-di-sekolah-bagian-2","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Anak Kami Tertular COVID-19 di Sekolah &#8211; bagian 2"},"excerpt":{"rendered":"<p>Kondisi COVID-19 di UK saat ini, walaupun lockdown diberlakukan namun sekolah  tetap dibuka. Dan tanpa kewajiban menggunakan masker bagi siswa dan guru</p>\\n","protected":false},"author":2},{"id":1565,"date_gmt":"2020-12-31T03:21:59","modified_gmt":"2021-03-01T02:12:12","slug":"anak-kami-tertular-covid-19-di-sekolah-bagian-1","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Anak Kami Tertular COVID-19 di Sekolah &#8211; bagian 1"},"excerpt":{"rendered":"<p>Benarkah sekolah sudah aman untuk dibuka? Bagaimana jika ada yang positif di sekolah?</p>\\n","protected":false},"author":2},{"id":1536,"date_gmt":"2020-11-17T06:49:03","modified_gmt":"2021-03-01T02:12:20","slug":"seri-penyintas-covid-19-kami-positif-tapi-tidak-masuk-ke-data","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Kami Positif Tapi Tidak Masuk ke Data"},"excerpt":{"rendered":"<p>Penulis dan keluarganya bergejala ringan tapi baru terbukti positif COVID-19 setelah swab kedua. Ia juga mempertanyakan kenapa data kasus positif tidak bertambah padahal keluarganya positif.</p>\\n","protected":false},"author":2},{"id":1498,"date_gmt":"2020-10-16T06:57:14","modified_gmt":"2021-03-01T02:12:32","slug":"seri-penyintas-covid-19-dua-kali-terpapar-dengan-gejala-yang-berbeda","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Dua Kali Terpapar dengan Gejala yang Berbeda"},"excerpt":{"rendered":"<p>Bulan Maret 2020, penulis terpapar COVID-19 dengan gejala kritis. Di awal Juli 2020, penulis kembali terkena COVID-19 tapi tanpa gejala, beserta dengan istri dan anaknya. Cerita ini adalah contoh bagaimana seseorang bisa terkena COVID-19 lebih dari sekali (reinfeksi). </p>\\n","protected":false},"author":2},{"id":1487,"date_gmt":"2020-10-01T14:40:13","modified_gmt":"2021-07-03T09:03:36","slug":"kumpulan-cerita-pengawal-pagebluk","type":"post","title":{"rendered":"Kumpulan Cerita Pengawal Pagebluk"},"excerpt":{"rendered":"<p>Agar masyarakat umum lebih memahami kondisi pandemi di lapangan, kami mengumpulkan narasi orang pertama dari tenaga kesehatan, lab, dan pihak lain yang turut mengawal penanganan COVID-19 di berbagai daerah di Indonesia.</p>\\n","protected":false},"author":2},{"id":1483,"date_gmt":"2020-10-01T14:18:31","modified_gmt":"2021-03-01T02:14:59","slug":"seri-pengawal-pagebluk-pasien-mendadak-kritis-atau-meninggal-testing-lemah-dan-warga-abai","type":"post","title":{"rendered":"Seri Pengawal Pagebluk: Pasien Mendadak Kritis atau Meninggal, Testing Lemah, dan Warga Abai"},"excerpt":{"rendered":"<p>Jumlah kasus positif rendah bukan berarti sebuah daerah aman dari COVID-19. Seorang dokter di Provinsi Lampung melaporkan beberapa pasien yang ternyata positif COVID-19, mendadak kritis, atau bahkan meninggal dalam waktu singkat ketika sudah berada di RS rujukan COVID-19. Minimnya testing membuat warga tidak was-was dan akhirnya abai.</p>\\n","protected":false},"author":2},{"id":1477,"date_gmt":"2020-09-27T03:11:02","modified_gmt":"2021-03-01T02:15:08","slug":"cerita-covid-19-art-positif-meski-berkegiatan-di-sekitar-rumah-saja","type":"post","title":{"rendered":"Cerita COVID-19: ART Positif Meski Berkegiatan di Sekitar Rumah Saja"},"excerpt":{"rendered":"<p>Asisten rumah tangga (ART) penulis positif COVID-19 meski tinggal di rumah saja dan hanya keluar untuk keperluan tertentu. Sementara itu, ART lainnya meninggal dunia dua hari sejak gejala awal muncul. Pengalaman ini adalah contoh bagaimana rumah bisa menjadi klaster penyebaran.</p>\\n","protected":false},"author":2},{"id":1474,"date_gmt":"2020-09-24T06:25:43","modified_gmt":"2021-03-01T02:15:18","slug":"seri-penyintas-covid-19-perjuangan-mencari-rumah-sakit-dan-melewati-masa-kritis","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Perjuangan Mencari Rumah Sakit dan Melewati Masa Kritis"},"excerpt":{"rendered":"<p>Seorang penyintas di Surabaya mengalami COVID-19 sekaligus demam berdarah. Selama berhari-hari, kondisinya kritis dan nyawanya bergantung pada ventilator. Ia selamat tapi kehilangan nenek tercinta akibat COVID-19.</p>\\n","protected":false},"author":2},{"id":1460,"date_gmt":"2020-08-31T15:25:25","modified_gmt":"2021-03-01T02:15:27","slug":"benarkah-virus-mutasi-d614g-10x-lebih-mudah-menginfeksi","type":"post","title":{"rendered":"Benarkah Virus Mutasi D614G 10x Lebih Mudah Menginfeksi?"},"excerpt":{"rendered":"<p>Menanggapi klaim Dr Noor Hisham bahwa virus mutasi D614G 10x lebih menular, KawalCOVID19.id memberikan analisis dan posisi kami terhadap isu ini.</p>\\n","protected":false},"author":2},{"id":1457,"date_gmt":"2020-08-28T14:00:57","modified_gmt":"2021-03-01T02:15:37","slug":"seri-garda-terdepan-suka-duka-merawat-pasien-covid-19-di-rs-suyoto","type":"post","title":{"rendered":"Seri Pengawal Pagebluk: Suka Duka Merawat Pasien COVID-19 di RS Suyoto"},"excerpt":{"rendered":"<p>Seorang dokter relawan di Jakarta menggambarkan situasi perawatan COVID-19 di lapangan, termasuk prosedur memakai APD setiap kali memeriksa pasien hingga kematian pasien akibat penyakit penyerta, bahkan pada pasien remaja.</p>\\n","protected":false},"author":2},{"id":1409,"date_gmt":"2020-08-24T08:24:50","modified_gmt":"2021-03-01T02:15:45","slug":"seri-garda-terdepan-kendala-lapangan-analis-medis-di-kalimantan-selatan","type":"post","title":{"rendered":"Seri Pengawal Pagebluk: Kendala Lapangan Analis Medis di Kalimantan Selatan"},"excerpt":{"rendered":"<p>Seorang analis kesehatan di Kalimantan Selatan memaparkan faktor-faktor yang menyebabkan hasil swab lama dipublikasikan, mulai dari kekurangan SDM, kecilnya kapasitas alat tes, hingga data yang tidak sinkron.</p>\\n","protected":false},"author":2},{"id":1399,"date_gmt":"2020-08-15T14:52:50","modified_gmt":"2021-03-01T02:15:53","slug":"seri-penyintas-covid-19-ibu-dan-anak-sesama-dokter-tertular-dan-sembuh-dari-covid-19","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Ibu dan Anak Sesama Dokter Tertular dan Sembuh dari COVID-19"},"excerpt":{"rendered":"<p>Seorang dokter gigi (ibu) dan dokter umum (anak) terpapar COVID-19 di fasilitas kesehatan pada waktu yang berlainan. Meski gejalanya ringan, masa isolasi terasa berat. Belum lagi tuduhan yang diterima dari keluarga pasien bahwa COVID-19 ini konspirasi RS.</p>\\n","protected":false},"author":2},{"id":1390,"date_gmt":"2020-08-04T13:00:40","modified_gmt":"2021-03-01T02:16:01","slug":"seri-penyintas-covid-19-papaku-terus-sesak-napas-meski-sudah-dinyatakan-sembuh","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Papaku Terus Sesak Napas Meski Sudah Dinyatakan Sembuh"},"excerpt":{"rendered":"<p>Lima minggu setelah dinyatakan sembuh dari COVID-19, ayah dari penulis masih terus sesak napas dan memakai masker oksigen di rumah.</p>\\n","protected":false},"author":2},{"id":1388,"date_gmt":"2020-08-04T12:58:01","modified_gmt":"2021-03-01T02:16:08","slug":"seri-penyintas-covid-19-dari-kehilangan-kerabat-hingga-donor-plasma-darah","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Dari Kehilangan Kerabat Hingga Donor Plasma Darah"},"excerpt":{"rendered":"<p>Belum usai berduka setelah kerabatnya meninggal dunia akibat COVID-19, penulis terkonfirmasi positif. Dengan kesabaran selama perawatan di ruang isolasi RS, ia pun sembuh dan telah mendonorkan plasma darah untuk membantu pasien COVID-19 lain dengan kondisi kritis.</p>\\n","protected":false},"author":2},{"id":1383,"date_gmt":"2020-07-28T14:57:34","modified_gmt":"2021-03-01T02:49:32","slug":"seri-penyintas-covid-19-ketidakjujuran-pasien-icu-dan-keluarganya-membuat-saya-terpapar-dan-diintubasi","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Ketidakjujuran Pasien ICU dan Keluarganya Membuat Saya Terpapar dan Diintubasi"},"excerpt":{"rendered":"<p>Akibat kebohongan satu orang, sedikitnya tujuh orang tim medis dan non-medis di RS rujukan COVID-19 di Yogyakarta terinfeksi. </p>\\n","protected":false},"author":2},{"id":1365,"date_gmt":"2020-07-23T04:53:42","modified_gmt":"2021-03-01T08:12:34","slug":"kumpulan-cerita-penyintas-covid-19","type":"post","title":{"rendered":"Kumpulan Cerita Penyintas COVID-19"},"excerpt":{"rendered":"<p>Berikut kisah penyintas COVID-19 yang berhasil kami kumpulkan selama ini.</p>\\n","protected":false},"author":2},{"id":1359,"date_gmt":"2020-07-22T14:49:14","modified_gmt":"2021-03-01T02:49:48","slug":"seri-penyintas-covid-19-tiga-bulan-bergumul-dengan-covid-19","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Tiga Bulan Bergumul dengan COVID-19"},"excerpt":{"rendered":"<p>Sepulang dari Inggris, penulis mengalami anosmia (kehilangan indera penciuman). Selama tiga bulan lamanya, ia dinyatakan positif COVID-19 dengan total 10 tes swab.</p>\\n","protected":false},"author":2},{"id":1356,"date_gmt":"2020-07-22T14:23:01","modified_gmt":"2021-03-01T02:49:55","slug":"gambaran-penggunaan-ventilator-bagi-pasien-covid-19-kritis","type":"post","title":{"rendered":"Gambaran Penggunaan Ventilator bagi Pasien COVID-19 Kritis"},"excerpt":{"rendered":"<p>Inilah ilustrasi penggunaan ventilator bagi pasien COVID-19 dengan kondisi kritis.</p>\\n","protected":false},"author":2},{"id":1354,"date_gmt":"2020-07-22T14:19:11","modified_gmt":"2021-03-01T02:50:03","slug":"seri-penyintas-covid-19-virus-tidak-kenal-profesi-dan-usia","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Virus Tidak Kenal Profesi dan Usia"},"excerpt":{"rendered":"<p>Seorang dokter di usia produktif di Bali terpapar COVID-19 dengan kondisi kritis. Kisahnya menyadarkan bahwa seseorang yang tahu betul soal dunia medis dan berusia relatif muda tidak serta merta kebal dari virus.</p>\\n","protected":false},"author":2},{"id":1349,"date_gmt":"2020-07-21T03:33:53","modified_gmt":"2021-03-01T02:50:10","slug":"kisah-dania-berjuang-sembuh-dengan-diagnosa-tidak-pasti","type":"post","title":{"rendered":"Kisah Dania: Berjuang Sembuh dengan Diagnosa Tidak Pasti"},"excerpt":{"rendered":"<p>Benarkah Rumah Sakit mempositifkan banyak orang demi mendapat insentif pemerintah?</p>\\n","protected":false},"author":2},{"id":1347,"date_gmt":"2020-07-21T03:25:38","modified_gmt":"2021-03-01T02:50:21","slug":"kisah-mila-perjuangan-di-ruang-isolasi-dengan-status-pdp","type":"post","title":{"rendered":"Kisah Mila*: Perjuangan di Ruang Isolasi dengan Status PDP"},"excerpt":{"rendered":"<p>Benarkah Rumah Sakit mempositifkan banyak orang demi mendapat insentif pemerintah?</p>\\n","protected":false},"author":2},{"id":1278,"date_gmt":"2020-06-12T12:47:02","modified_gmt":"2021-03-01T02:50:31","slug":"edukasi-benarkah-otg-tidak-menular","type":"post","title":{"rendered":"[EDUKASI] Benarkah OTG tidak menular?"},"excerpt":{"rendered":"<p>Meluruskan kesimpangsiuran tentang risiko OTG menularkan COVID-19</p>\\n","protected":false},"author":62},{"id":1225,"date_gmt":"2020-05-08T07:38:04","modified_gmt":"2021-03-01T02:50:40","slug":"seri-garda-terdepan-bertugas-sebagai-dokter-di-rs-darurat-covid-19","type":"post","title":{"rendered":"Seri Pengawal Pagebluk: Bertugas sebagai Dokter di RS Darurat COVID-19"},"excerpt":{"rendered":"<p>Seorang dokter yang ditugaskan di Rumah Sakit Darurat COVID-19 Wisma Atlet Kemayoran, Jakarta, menceritakan kesehariannya selama dua minggu pertama bertugas.</p>\\n","protected":false},"author":2},{"id":1192,"date_gmt":"2020-04-28T12:08:52","modified_gmt":"2021-03-01T02:50:50","slug":"seri-penyintas-covid-19-tidak-bergejala-serius-bukan-berarti-tidak-terinfeksi","type":"post","title":{"rendered":"Seri Penyintas COVID-19: Tidak Bergejala Serius Bukan Berarti Tidak Terinfeksi"},"excerpt":{"rendered":"<p>Seorang penyintas COVID-19 tanpa gejala serius menceritakan hari-hari selama isolasi dan pesan pentingnya bagi pasien lain.  </p>\\n","protected":false},"author":2},{"id":1190,"date_gmt":"2020-04-28T12:08:07","modified_gmt":"2021-03-01T02:51:01","slug":"bertahan-saja-sudah-cukup","type":"post","title":{"rendered":"Bertahan Saja Sudah Cukup"},"excerpt":{"rendered":"<p>Cerita dan saran bagaimana mengatasi rasa cemas karena bipolar disorder yang dapat diterapkan untuk mengatasi rasa cemas karena pandemi.</p>\\n","protected":false},"author":2},{"id":1181,"date_gmt":"2020-04-27T07:46:27","modified_gmt":"2021-03-01T02:51:10","slug":"tiga-hal-yang-penting-untuk-kebijakan-mitigasi-wabah-covid-19-berdasarkan-data-indonesia","type":"post","title":{"rendered":"Tiga Hal yang Penting untuk Kebijakan Mitigasi Wabah COVID-19 Berdasarkan Data Indonesia"},"excerpt":{"rendered":"<p>Mari simak pola-pola pasien COVID-19 di Indonesia berdasarkan data dan bagaimana kebijakan mitigasi yang tepat.</p>\\n","protected":false},"author":2},{"id":1179,"date_gmt":"2020-04-27T07:35:01","modified_gmt":"2021-03-01T02:51:20","slug":"belajar-dari-singapura-no-one-is-safe-until-everyone-is-safe","type":"post","title":{"rendered":"Belajar dari Singapura: No One is Safe Until Everyone is Safe"},"excerpt":{"rendered":"<p>Kasus baru COVID-19 di Singapura melonjak di bulan April 2020, jumlah penambahan kasus harian di Singapura. Apa yang terjadi di Singapura dalam beberapa minggu terakhir?</p>\\n","protected":false},"author":2},{"id":1120,"date_gmt":"2020-04-20T03:20:49","modified_gmt":"2021-03-01T02:51:37","slug":"indonesia-mandiri-masker","type":"post","title":{"rendered":"Indonesia Mandiri Masker"},"excerpt":{"rendered":"<p>Yuk simak data penelitian faktual dan tervalidasi terkait manfaat masker kain buatan sendiri untuk mengurangi penularan virus penyebab COVID-19. </p>\\n","protected":false},"author":2},{"id":1094,"date_gmt":"2020-04-19T11:15:40","modified_gmt":"2021-03-01T02:51:46","slug":"saya-sudah-kehilangan-ayah-beberapa-anggota-keluarga-besar-dan-11-teman","type":"post","title":{"rendered":"Saya Sudah Kehilangan Ayah, Beberapa Anggota Keluarga Besar, dan 11 Teman"},"excerpt":{"rendered":"<p>Kisah nyata dari relawan KawalCovid19.</p>\\n","protected":false},"author":2},{"id":1006,"date_gmt":"2020-04-10T08:11:49","modified_gmt":"2021-03-02T04:47:32","slug":"cerita-dari-jerman-pengalaman-dua-wni-di-bochum-dan-frankfurt","type":"post","title":{"rendered":"Cerita dari Jerman: Pengalaman Dua WNI di Bochum dan Frankfurt"},"excerpt":{"rendered":"<p>Seorang pelajar dan seorang pekerja asal Indonesia yang tinggal di Jerman membagikan kisah penanganan pandemi oleh pemerintah Jerman</p>\\n","protected":false},"author":2},{"id":992,"date_gmt":"2020-04-10T08:07:59","modified_gmt":"2021-03-02T04:47:39","slug":"cerita-dari-taiwan-respons-tepat-taiwan-dalam-menghadapi-sars-cov-2-dan-covid-19","type":"post","title":{"rendered":"Cerita dari Taiwan: Respons Tepat Taiwan dalam Menghadapi SARS COV-2 dan COVID-19"},"excerpt":{"rendered":"<p>Taiwan disebut-sebut sebagai negara yang mengantisipasi penyebaran COVID-19 dengan baik sebelum wabah memburuk. Artikel ini merangkum hal-hal baik yang dilakukan oleh Taiwan dan yang dapat dijadikan contoh.</p>\\n","protected":false},"author":2},{"id":966,"date_gmt":"2020-04-07T04:35:32","modified_gmt":"2021-03-01T02:52:44","slug":"tips-agar-tetap-positif-selama-bekerja-dari-rumah","type":"post","title":{"rendered":"Tips Agar Tetap Positif Selama Bekerja dari Rumah"},"excerpt":{"rendered":"<p>Jenuh bekerja dari rumah? Simak tips berikut bagi tenaga profesional dan pekerja lainnya agar pikiran tetap positif selama #DiRumahAja.</p>\\n","protected":false},"author":2},{"id":964,"date_gmt":"2020-04-07T04:33:51","modified_gmt":"2021-03-01T02:52:53","slug":"bertahan-dari-hubungan-tidak-sehat-selama-pandemi-covid-19","type":"post","title":{"rendered":"Waspadai Kekerasan Dalam Rumah Tangga saat Isolasi Mandiri"},"excerpt":{"rendered":"<p>Himbauan #DiRumahAja membawa permasalahan tersendiri bagi mereka yang terlibat dalam hubungan tidak sehat (toxic relationship) di rumah. Jika Anda salah satunya, simak tips untuk mengendalikan situasi dan menyelamatkan diri.</p>\\n","protected":false},"author":2},{"id":856,"date_gmt":"2020-04-01T05:16:29","modified_gmt":"2021-03-01T02:53:01","slug":"belajar-dari-vietnam","type":"post","title":{"rendered":"Belajar dari Vietnam"},"excerpt":{"rendered":"<p>Dengan sumber daya terbatas dibandingkan Korea Selatan, Vietnam mampu mengatasi pandemi dengan langkah-langkah cepat dan tepat.</p>\\n","protected":false},"author":125},{"id":839,"date_gmt":"2020-03-30T12:09:12","modified_gmt":"2021-03-01T02:53:54","slug":"polemik-penggunaan-vitamin-dan-suplemen-kesehatan","type":"post","title":{"rendered":"Polemik Penggunaan Vitamin dan Suplemen Kesehatan"},"excerpt":{"rendered":"<p> Di tengah-tengah wabah COVID-19, banyak informasi mengenai vitamin dan suplemen kesehatan yang kita terima baik dari pesan berantai WhatsApp, maupun nasihat dari teman-teman. Kami ingin Anda lebih mengerti tentang vitamin dan suplemen kesehatan, beserta penggunaannya bagi kesehatan Anda </p>\\n","protected":false},"author":2},{"id":820,"date_gmt":"2020-03-29T04:45:03","modified_gmt":"2021-03-01T02:53:45","slug":"lockdown-bukan-berarti-ekonomi-berhenti-begini-caranya","type":"post","title":{"rendered":"Lockdown? Bukan berarti ekonomi berhenti. Begini caranya!"},"excerpt":{"rendered":"<p>New York sudah menerapkan lockdown. Kebijakan yang tadinya dikhawatirkan akan mengganggu stabilitas ekonomi ternyata hanya mengubah jenis mata pencaharian yang tersedia berkat dukungan dan intervensi pemerintah serta perusahaan-perusahaan besar.</p>\\n","protected":false},"author":2},{"id":803,"date_gmt":"2020-03-28T15:33:36","modified_gmt":"2021-03-01T02:54:02","slug":"karantina-wilayah","type":"post","title":{"rendered":"Karantina Wilayah"},"excerpt":{"rendered":"<p>&#8230; a brief to the President</p>\\n","protected":false},"author":2},{"id":796,"date_gmt":"2020-03-28T02:21:59","modified_gmt":"2021-03-01T02:54:11","slug":"dari-de-epidemie-ke-wajah-abad-ini-menghadapi-wabah","type":"post","title":{"rendered":"Dari \u201CDe Epidemie\u201D ke Wajah Abad ini Menghadapi Wabah"},"excerpt":{"rendered":"<p>COVID-19 bukan pandemi pertama yang Indonesia hadapi sepanjang sejarah. Seabad yang lalu, Hindia Belanda sebutan Indonesia di kala itu) mengalami Pandemi Flu. Artikel ini menelusuri fakta-fakta sejarah yang relevan dengan kondisi Indonesia di masa kini sebagai  pelajaran berharga.</p>\\n","protected":false},"author":2},{"id":786,"date_gmt":"2020-03-27T09:08:54","modified_gmt":"2021-03-01T02:54:22","slug":"ingat-italia-4-minggu-di-depan-indonesia","type":"post","title":{"rendered":"Ingat Italia (4 Minggu di Depan Indonesia)"},"excerpt":{"rendered":"<p>Tulisan ini menjabarkan analisis tentang intervensi yang dilakukan pemerintah Italia untuk menekan laju jumlah kasus terkonfimasi positif COVID-19 di Italia dan dampaknya.</p>\\n","protected":false},"author":125},{"id":778,"date_gmt":"2020-03-26T12:32:20","modified_gmt":"2021-03-01T02:59:39","slug":"cerita-dari-filipina-menjalani-karantina-wilayah-lockdown-sebagai-diaspora","type":"post","title":{"rendered":"Cerita dari Filipina: Menjalani Karantina wilayah (lockdown) sebagai Diaspora"},"excerpt":{"rendered":"<p>Sepulang dari Indonesia dan tiba kembali di Filipina, koresponden kami disambut dengan karantina wilayah (lockdown) oleh pemerintah setempat. Simak pengalamannya menjalani hal tersebut sebagai diaspora Indonesia di Manila.</p>\\n","protected":false},"author":2},{"id":764,"date_gmt":"2020-03-25T02:37:19","modified_gmt":"2021-03-01T02:59:49","slug":"catatan-dari-wuhan-part-1","type":"post","title":{"rendered":"Cerita dari Tiongkok: Catatan dari Wuhan"},"excerpt":{"rendered":"<p>Pengalaman tinggal di Wuhan, Cina di tengah pandemik COVID-19</p>\\n","protected":false},"author":2},{"id":745,"date_gmt":"2020-03-24T06:29:26","modified_gmt":"2021-03-01T02:59:57","slug":"cerita-dari-italia-a-cautionary-tale-peringatan-untuk-kita-semua","type":"post","title":{"rendered":"Cerita dari Italia: A Cautionary Tale (Peringatan untuk Kita Semua)"},"excerpt":{"rendered":"<p>Seorang mahasiswa S3 asal Indonesia membagikan pengalaman dan observasinya selama tinggal di Trieste, Italia di tengah pandemi COVID-19. Artikel ini penting untuk menjadi bahan renungan bagi masyarakat di Indonesia agar yang terjadi di Italia tidak perlu terulang di negara kita.</p>\\n","protected":false},"author":2},{"id":698,"date_gmt":"2020-03-21T17:38:31","modified_gmt":"2021-03-01T03:00:08","slug":"mencegah-dan-menangani-stigma-sosial-seputar-covid-19","type":"post","title":{"rendered":"Mencegah dan Menangani Stigma Sosial Seputar COVID-19"},"excerpt":{"rendered":"<p>Pandemi COVID-19 muncul bersamaan dengan stigma sosial di tengah masyarakat. Namun, hal ini dapat dicegah dan ditangani bersama oleh individu maupun pihak-pihak terkait.</p>\\n","protected":false},"author":2},{"id":679,"date_gmt":"2020-03-21T17:27:08","modified_gmt":"2021-03-01T03:00:17","slug":"cerita-dari-singapura-belajar-menjaga-diri-sendiri-dari-sekolah","type":"post","title":{"rendered":"Cerita dari Singapura: Belajar Menjaga Diri Sendiri dari Sekolah"},"excerpt":{"rendered":"<p>Dina Kharisma, seorang guru SD di Singapura, membagikan pengalamannya soal langkah-langkah yang dilakukan di sekolah ketika COVID-19 datang ke negeri singa tersebut.</p>\\n","protected":false},"author":2},{"id":685,"date_gmt":"2020-03-21T17:25:08","modified_gmt":"2021-03-01T03:00:25","slug":"tips-menjaga-kesehatan-jiwa-saat-jaga-jarak","type":"post","title":{"rendered":"Tips Menjaga Kesehatan Jiwa Saat Jaga Jarak"},"excerpt":{"rendered":"<p>Tips untuk menjaga kesehatan jiwa pada saat masa karantina dan jaga jarak dulu.</p>\\n","protected":false},"author":2},{"id":676,"date_gmt":"2020-03-21T17:22:38","modified_gmt":"2021-03-01T03:00:36","slug":"10-tips-meringankan-beban-tenaga-medis-di-lapangan","type":"post","title":{"rendered":"10 Tips Meringankan Beban Tenaga Medis di Lapangan"},"excerpt":{"rendered":"<p>Selain diam di rumah, bantu juga tenaga medis dengan melakukan hal-hal berikut ini.</p>\\n","protected":false},"author":2},{"id":650,"date_gmt":"2020-03-21T04:51:36","modified_gmt":"2021-03-01T03:00:45","slug":"bagaimana-virus-corona-menyerang-tubuh","type":"post","title":{"rendered":"Bagaimana Virus Corona Menyerang Tubuh?"},"excerpt":{"rendered":"<p>Bagaimana SARS-CoV-2 menginfeksi dan menyerang tubuh, dan apa dampaknya pada tubuh selain paru-paru. </p>\\n","protected":false},"author":2},{"id":628,"date_gmt":"2020-03-20T12:37:25","modified_gmt":"2021-03-01T03:00:54","slug":"vaksin-dan-covid-19","type":"post","title":{"rendered":"Vaksin dan COVID-19"},"excerpt":{"rendered":"<p>Vaksin COVID-19 sudah ada atau belum sih? Mari kita cari tahu kebenarannya.</p>\\n","protected":false},"author":2},{"id":592,"date_gmt":"2020-03-18T12:43:56","modified_gmt":"2021-03-01T03:01:10","slug":"siapkan-anak-anda-menghadapi-wabah-koronavirus-covid-19","type":"post","title":{"rendered":"Siapkan Anak Anda Menghadapi Wabah Koronavirus (COVID-19)"},"excerpt":{"rendered":"<p>Checklist untuk orang tua agar dapat mempersiapkan anak menghadapi wabah COVID-19</p>\\n","protected":false},"author":2},{"id":594,"date_gmt":"2020-03-18T12:38:44","modified_gmt":"2021-03-01T03:01:25","slug":"wuhan-virus-korona-dan-kewaspadaan-kita","type":"post","title":{"rendered":"Wuhan, Virus Korona, dan Kewaspadaan Kita"},"excerpt":{"rendered":"<p>Bagaimana Cina meningkatkan kewaspadaan terhadap virus korona yang mewabah</p>\\n","protected":false},"author":2},{"id":548,"date_gmt":"2020-03-17T05:43:50","modified_gmt":"2021-03-01T03:01:35","slug":"dirjen-who-virus-covid-19-adalah-virus-yang-unik-dengan-karakteristik-yang-unik-pula","type":"post","title":{"rendered":"Dirjen WHO: \u201DVirus COVID-19 adalah Virus yang Unik dengan Karakteristik yang Unik Pula&#8221;"},"excerpt":{"rendered":"<p>Berikut penjelasan beberapa perbedaan karakteristik virus penyebab COVID-19 dan influenza.</p>\\n","protected":false},"author":2},{"id":535,"date_gmt":"2020-03-16T13:32:39","modified_gmt":"2021-03-01T03:01:45","slug":"kegiatan-belajar-dan-bermain-di-rumah-untuk-anak-balita-dan-taman-kanak-kanak","type":"post","title":{"rendered":"Kegiatan Belajar dan Bermain di Rumah untuk Anak Balita dan Taman Kanak-Kanak"},"excerpt":{"rendered":"<p>Sekolah anak libur selama 2 minggu? Jangan panik! Kami sudah menyiapkan kegiatan yang dapat dilakukan bersama anak saat libur.</p>\\n","protected":false},"author":2},{"id":524,"date_gmt":"2020-03-16T12:45:55","modified_gmt":"2021-03-01T03:33:59","slug":"siapkan-anak-anda-menghadapi-wabah-koronavirus","type":"post","title":{"rendered":"Siapkan Anak Anda Menghadapi Wabah Koronavirus"},"excerpt":{"rendered":"<p>Berbicara dengan Anak tentang COVID-19</p>\\n","protected":false},"author":2},{"id":349,"date_gmt":"2020-03-12T23:22:02","modified_gmt":"2021-03-01T03:36:33","slug":"cerita-dari-korea-selatan-pengalaman-ngantor-di-tengah-wabah","type":"post","title":{"rendered":"Cerita dari Korea Selatan: Pengalaman Ngantor di Tengah Wabah"},"excerpt":{"rendered":"<p>Pengaruh coronavirus terhadap kondisi kerja di Seoul, Korea.</p>\\n","protected":false},"author":2},{"id":302,"date_gmt":"2020-03-10T04:27:20","modified_gmt":"2021-03-01T03:36:42","slug":"superspreader-setiap-orang-bisa-cegah-penularan-lebih-lanjut","type":"post","title":{"rendered":"Superspreader: Setiap Orang Bisa Cegah Penularan Lebih Lanjut"},"excerpt":{"rendered":"<p>Indonesia bisa belajar dari penyebaran luas COVID-19 di negara-negara lain yang bermula dari satu orang saja.</p>\\n","protected":false},"author":82},{"id":2192,"date_gmt":"2021-10-05T14:16:46","modified_gmt":"2021-10-05T14:22:35","slug":"pentingnya-vaksinasi-untuk-sekolah-tatap-muka","type":"post","title":{"rendered":"Pentingnya Vaksinasi Untuk Sekolah Tatap Muka"},"excerpt":{"rendered":"<p>Pembukaan sekolah sudah mulai berjalan. Namun pertanyaannya yang sama juga masih bergaung, \u201CAmankah?\u201D</p>","protected":false},"author":2},{"id":2135,"date_gmt":"2021-07-24T03:35:57","modified_gmt":"2021-07-24T03:36:26","slug":"varian-delta-yang-perlu-anda-ketahui","type":"post","title":{"rendered":"Varian Delta: Yang Perlu Anda Ketahui"},"excerpt":{"rendered":"<p>Simak rangkuman tentang varian delta yang perlu anda ketahui</p>","protected":false},"author":2},{"id":2066,"date_gmt":"2021-07-16T12:15:49","modified_gmt":"2021-07-21T01:03:43","slug":"panduan-menyambut-ibadah-idul-adha-2021","type":"post","title":{"rendered":"Panduan Menyambut Ibadah Idul Adha 2021 :"},"excerpt":{"rendered":"<p>Simak panduan berikut untuk menyambut ibadah Idul Adha 2021 yang dikeluarkan oleh Kementrian Agama</p>","protected":false},"author":2},{"id":1964,"date_gmt":"2021-06-19T07:04:06","modified_gmt":"2021-06-19T07:49:26","slug":"10-cara-indonesia-tangguh-melawan-covid-19","type":"post","title":{"rendered":"10 Cara Indonesia Tangguh Melawan COVID-19"},"excerpt":{"rendered":"<p>Wabah COVID19 kembali memuncak. Naiknya mobilitas masyarakat, mengendornya prosedur dan ketaatan akan protokol kesehatan di semua lini, dan masuknya varian Alfa dan Delta yang lebih cepat penyebarannya menyebabkan kasus positif harian terus meninggi. </p>","protected":false},"author":2},{"id":1960,"date_gmt":"2021-06-18T14:14:17","modified_gmt":"2021-06-18T14:15:06","slug":"e-participation-against-covid-19-case-of-kawalcovid-19-id","type":"post","title":{"rendered":"E-Participation against COVID-19: Case of KawalCOVID-19.id"},"excerpt":{"rendered":"","protected":false},"author":2},{"id":1956,"date_gmt":"2021-06-14T09:22:43","modified_gmt":"2021-06-14T09:23:42","slug":"vaksin-untuk-penyintas-covid-19-perlu-atau-tidak","type":"post","title":{"rendered":"Vaksin untuk Penyintas COVID-19, Perlu atau Tidak?"},"excerpt":{"rendered":"<p>Vaksinasi untuk penyintas COVID-19 apakah diperlukan? Simak bahasan berikut ini.</p>","protected":false},"author":2},{"id":1931,"date_gmt":"2021-05-31T02:44:59","modified_gmt":"2021-07-03T09:34:24","slug":"cara-isolasi-mandiri-yang-benar","type":"post","title":{"rendered":"Cara Isolasi Mandiri yang Benar"},"excerpt":{"rendered":"<p>Tim KawalCOVID-19 berbincang dengan dr. Sayuri Suwandi, SpPD dan dr. Dirga Sakti Rambe, SpPD, untuk menjawab pertanyaan seputar cara isolasi mandiri (isoman) yang benar. Berikut ringkasan dari dua sesi Instagram Live yang bisa dilihat di sini.</p>","protected":false},"author":2},{"id":1928,"date_gmt":"2021-05-12T15:22:00","modified_gmt":"2021-05-12T15:24:39","slug":"mengenal-dan-mencegah-varian-baru-virus-sars-cov-2","type":"post","title":{"rendered":"Mengenal dan Mencegah Varian Baru Virus SARS-CoV-2"},"excerpt":{"rendered":"<p>Virus SARS-CoV-2, yang menjadi penyebab munculnya COVID-19, telah bermutasi dan menyebar ke seluruh dunia. Mutasi menghasilkan beberapa varian baru, satu di antaranya ialah B.1.1.7 yang terdeteksi pertama kali di Inggris Raya pada September 2020.</p>","protected":false},"author":2},{"id":1913,"date_gmt":"2021-04-29T01:25:03","modified_gmt":"2021-04-29T01:25:42","slug":"ramadhan-2021-tetap-waspada-menjaga-3m-dan-bersiap-untuk-tidak-mudik","type":"post","title":{"rendered":"Ramadhan 2021: Tetap Waspada, Menjaga 3M dan Bersiap untuk Tidak Mudik."},"excerpt":{"rendered":"<p>Refleksi di Ramadhan 2021 terkait kondisi pandemi COVID-19</p>","protected":false},"author":2},{"id":1906,"date_gmt":"2021-04-19T00:54:15","modified_gmt":"2021-04-27T01:32:31","slug":"gangguan-stres-pascatrauma-pada-penyintas-covid-19","type":"post","title":{"rendered":"Gangguan Stres Pascatrauma pada Penyintas COVID-19"},"excerpt":{"rendered":"<p>Dinyatakan sembuh dari COVID-19 tidak serta merta membuat para penyintas kembali hidup normal. Ada risiko penurunan kondisi fisik, dan juga kesehatan mental. Artikel ini membahas gangguan stres pasca trauma pada penyintas COVID-19</p>","protected":false},"author":2},{"id":1904,"date_gmt":"2021-04-19T00:53:13","modified_gmt":"2021-04-19T01:01:02","slug":"satu-tahun-covid-19-di-indonesia-waspadai-pandemic-fatigue","type":"post","title":{"rendered":"Satu Tahun COVID-19 di Indonesia, Waspadai Pandemic Fatigue!"},"excerpt":{"rendered":"<p>Berbagai adaptasi terhadap kebiasaan baru dan pembatasan yang terjadi selama satu tahun ini telah membuat sebagian besar dari kita merasa kelelahan. Artikel ini akan membahas tentang kelelahan pandemi (pandemic fatigue), dampak yang dapat ditimbulkan, dan kiat yang dapat kita lakukan bersama untuk mengatasinya.</p>","protected":false},"author":2},{"id":1902,"date_gmt":"2021-04-19T00:51:49","modified_gmt":"2021-04-19T01:00:29","slug":"kipi-atau-reaksi-kecemasan-terkait-vaksinasi","type":"post","title":{"rendered":"KIPI atau Reaksi Kecemasan Terkait Vaksinasi?"},"excerpt":{"rendered":"<p>Hendaknya kita tidak perlu terlalu panik dan terburu-buru melabeli setiap keluhan yang muncul ketika atau setelah vaksinasi sebagai efek samping vaksin atau efek prosedur vaksinasi. Bisa jadi, itu adalah reaksi kecemasan terkait vaksinasi. Artikel ini menjelaskan berbagai jenis KIPI, cara membedakan, dan kiat mengatasinya baik dari sisi tenaga kesehatan yang bertugas maupun masyarakat penerima vaksin.</p>","protected":false},"author":2},{"id":1879,"date_gmt":"2021-04-15T02:48:10","modified_gmt":"2021-06-25T09:40:22","slug":"satgas-kesehatan-di-sekolah-untuk-apa","type":"post","title":{"rendered":"Satgas Kesehatan di Sekolah, Untuk Apa?"},"excerpt":{"rendered":"<p>Per 24 Februari 2021, sudah ada wacana membuka kembali sekolah setelah vaksinasi guru rampung di bulan Juni. Di medio 2021, belum tentu pandemi sudah terkendali, apalagi berakhir. Karenanya, selain harus bersiap untuk mencegah penularan, sekolah juga harus bersiap diri untuk menangani adanya penularan di sekolah, sehingga tidak bingung dan menangani dengan serabutan ketika ada kasus. [&hellip;]</p>","protected":false},"author":2},{"id":1828,"date_gmt":"2021-04-05T14:44:30","modified_gmt":"2021-04-05T14:44:51","slug":"benarkah-covid-19-memicu-penyakit-ginjal","type":"post","title":{"rendered":"Benarkah COVID-19 Memicu Penyakit Ginjal?"},"excerpt":{"rendered":"<p>COVID-19 menimbulkan berbagai komplikasi penyakit, salah satunya penyakit ginjal. Beberapa penelitian menunjukkan bahwa pasien COVID-19 dapat menderita sakit ginjal, spesifiknya cedera ginjal akut. </p>","protected":false},"author":2},{"id":1818,"date_gmt":"2021-04-01T03:05:23","modified_gmt":"2021-07-03T09:03:10","slug":"interaksi-guru-murid-yang-minim-risiko","type":"post","title":{"rendered":"Interaksi Guru-Murid Yang Minim Risiko"},"excerpt":{"rendered":"<p>Per 24 Februari 2021, sudah ada wacana bahwa pemerintah akan membuka sekolah setelah vaksinasi guru rampung di bulan Juni. Di medio 2021, belum tentu pandemi terkendali, apalagi berakhir. Karenanya, penting bagi pendidik untuk melengkapi diri dengan cara aman melakukan berinteraksi dengan anak didik.&nbsp; COVID-19 menyebar lewat droplet seperti air liur dan ingus, dua hal yang [&hellip;]</p>","protected":false},"author":2},{"id":1669,"date_gmt":"2021-03-18T14:44:28","modified_gmt":"2021-04-05T14:51:50","slug":"tb-dan-covid-19","type":"post","title":{"rendered":"TB dan COVID-19"},"excerpt":{"rendered":"<p>Penulis: Nabila Hana Wardhani Tuberkulosis dan COVID-19 memiliki gejala yang serupa tapi tak sama seperti adanya batuk, demam dan sesak napas. Penyebab dan pengobatan dari kedua penyakit tersebut juga berbeda. Apabila keduanya diidap oleh seseorang, perkiraan perjalanan COVID-19 seseorang akan menjadi lebih buruk. Selain itu pandemi membawa problematika baru bagi TB, seperti melonjaknya kasus resistensi [&hellip;]</p>","protected":false},"author":2},{"id":1660,"date_gmt":"2021-02-27T02:28:10","modified_gmt":"2021-04-05T14:53:18","slug":"vaksin-covid-19","type":"post","title":{"rendered":"Vaksin COVID-19"},"excerpt":{"rendered":"<p>Penjelasan singkat tentang vaksin COVID-19</p>","protected":false},"author":2},{"id":1645,"date_gmt":"2021-02-20T05:39:49","modified_gmt":"2021-07-03T09:03:19","slug":"seri-covid-19-artikel-2-sebelum-buka-sekolah-apa-yang-harus-dikomunikasikan","type":"post","title":{"rendered":"Sebelum Buka Sekolah, Apa yang Harus Dikomunikasikan?"},"excerpt":{"rendered":"<p>Kebanyakan sekolah mengerti bahwa ada protokol kesehatan yang harus disiapkan sebelum membuka sekolah di masa pandemi. Tapi dari berbagai input yang disampaikan oleh guru, murid, orang tua maupun administrator sekolah, tidak ada pedoman bagaimana mengkomunikasikan pembukaan sekolah dan perilaku seperti apa yang sekolah minta dari para guru, siswa dan orang tua murid.</p>","protected":false},"author":2},{"id":1642,"date_gmt":"2021-02-20T05:35:56","modified_gmt":"2021-04-07T10:24:29","slug":"infrastruktur-apa-yang-perlu-disiapkan-sekolah-new-normal","type":"post","title":{"rendered":"Infrastruktur Apa yang Perlu Disiapkan Sekolah New Normal?"},"excerpt":{"rendered":"<p>Di satu titik, sekolah akan tatap muka lagi. Berapa lama lagi, kita belum tahu. Tapi sekolah perlu menyiapkan infrastruktur new normal mulai sekarang agar ketika nanti sekolah dibuka, semua pihak sudah mengerti apa yang harus dilakukan.</p>","protected":false},"author":2},{"id":1612,"date_gmt":"2021-01-14T02:21:49","modified_gmt":"2021-03-02T04:52:49","slug":"pertimbangan-untuk-langkah-langkah-kesehatan-masyarakat-terkait-sekolah-dalam-konteks-covid-19","type":"post","title":{"rendered":"Pertimbangan untuk Langkah-Langkah Kesehatan Masyarakat Terkait Sekolah dalam Konteks COVID-19"},"excerpt":{"rendered":"","protected":false},"author":2},{"id":2206,"date_gmt":"2020-12-29T13:34:00","modified_gmt":"2022-02-07T23:32:45","slug":"laporan-donasi-dana-tahap-kedua-infrastruktur-kawalcovid19-id-di-azure-cloud","type":"post","title":{"rendered":"Laporan Donasi Dana Tahap Kedua Infrastruktur KawalCOVID19.id di Azure Cloud"},"excerpt":{"rendered":"<p>Tim KawalCOVID19.id menerima Donasi Tahap Kedua dari Program IEG Peduli COVID-19 Yayasan Indika. Donasi digunakan seutuhnya untuk pendanaan infrastruktur teknologi website KawalCOVID19.id yang menggunakan Azure Cloud. Rincian data donasi terlampir dan dapat diunduh (download) di sini.</p>","protected":false},"author":2},{"id":1558,"date_gmt":"2020-12-22T15:15:43","modified_gmt":"2021-03-02T04:36:10","slug":"pandemic-fatigue","type":"post","title":{"rendered":"Pandemic Fatigue"},"excerpt":{"rendered":"<p>Bosan dengar masalah Covid? Inilah kenapa anda mengalami kelelahan pandemi atau pandemic fatigue</p>","protected":false},"author":2},{"id":1541,"date_gmt":"2020-11-26T02:03:54","modified_gmt":"2021-03-02T04:36:21","slug":"penapisan-covid-19-bagi-petugas-pilkada","type":"post","title":{"rendered":"Penapisan COVID-19 bagi Petugas Pilkada"},"excerpt":{"rendered":"<p>Tes antibodi saja tidak bisa diandalkan untuk mencegah penularan COVID-19 selama Pilkada. Artikel ini menjabarkan strategi pemilahan kelompok sesuai hasil tes PCR dan langkah selanjutnya yang perlu diambil.</p>","protected":false},"author":2},{"id":2201,"date_gmt":"2020-09-22T15:37:00","modified_gmt":"2022-02-07T23:31:52","slug":"laporan-donasi-dana-tahap-pertama-infrastruktur-kawalcovid19-id-di-azure-cloud","type":"post","title":{"rendered":"Laporan Donasi Dana Tahap Pertama Infrastruktur KawalCOVID19.id di Azure Cloud"},"excerpt":{"rendered":"<p>Tim KawalCOVID19.id menerima Donasi Tahap Pertama dari Program IEG Peduli COVID-19 Yayasan Indika. Donasi digunakan seutuhnya untuk pendanaan infrastruktur teknologi website KawalCOVID19.id yang menggunakan Azure Cloud. Rincian data donasi terlampir dan bisa diunduh (download) di sini.</p>","protected":false},"author":2},{"id":1466,"date_gmt":"2020-09-17T05:27:39","modified_gmt":"2021-03-02T04:36:37","slug":"rendahnya-pelacakan-kontak-dan-tingginya-tingkat-positivitas-tes-latar-belakang-dan-prospek-psbb-ii-dki-jakarta","type":"post","title":{"rendered":"Rendahnya Pelacakan Kontak dan Tingginya Tingkat Positivitas Tes: Latar Belakang dan Prospek PSBB II DKI Jakarta"},"excerpt":{"rendered":"<p>Kami menjabarkan tiga tren penting yang menjelaskan lonjakan kasus di DKI Jakarta, yakni (1) memburuknya pelacakan, (2) meningkatnya tingkat positivitas tes meskipun jumlah tesnya bertambah dan (3) inefisiensi tes mandiri. Rekomendasi kami bagi Pemprov DKI agar PSBB kedua berhasil mengendalikan wabah: 1) tingkatkan rasio lacak isolasi hingga 30 kontak erat per 1 kasus baru, 2) pekerjakan tim pelacak kontak khusus, 3) lampaui protokol revisi ke-5 dan haruskan semua kontak erat dites usap meskipun tidak bergejala ketika dikarantina di fasilitas terpusat, 4) kurangi tes mandiri yang tidak perlu dan 5) pertimbangkan pendekatan \u201Cstick and carrot\u201D.</p>","protected":false},"author":2},{"id":1361,"date_gmt":"2020-07-22T14:56:02","modified_gmt":"2021-03-02T04:36:44","slug":"serial-data-virus-corona-4-cara-memperbaiki-indeks-kewaspadaan","type":"post","title":{"rendered":"Serial Data Virus Corona 4: Cara Memperbaiki Indeks Kewaspadaan"},"excerpt":{"rendered":"<p>Serial data virus corona ke-4 ini menjelaskan bagaimana cara memperbaiki indeks kewaspadaan</p>","protected":false},"author":2},{"id":1330,"date_gmt":"2020-07-09T12:09:26","modified_gmt":"2021-03-02T04:36:53","slug":"serial-data-virus-korona-3-indeks-kewaspadaan","type":"post","title":{"rendered":"Serial Data Virus Korona 3: Indeks Kewaspadaan"},"excerpt":{"rendered":"<p>Serial data virus korona 3 ini merupakan kelanjutan dari serial data 1 dan 2 yang menggambarkan indeks kewaspadaan daerah pengidap positif COVID-19. Dengan adanya indeks kewaspadaan ini, dapat dapat terlihat gambaran relatif berapa besar kemungkinan terjadi transmisi COVID-19 di daerah domisili Anda.</p>","protected":false},"author":2},{"id":1294,"date_gmt":"2020-07-04T14:02:35","modified_gmt":"2021-03-02T04:37:01","slug":"serial-data-virus-korona-2-rasio-lacak-isolasi-rli-dan-korelasinya-dengan-kematian-kumulatif","type":"post","title":{"rendered":"Serial Data Virus Korona 2: Rasio Lacak &#8211; Isolasi (RLI) dan Korelasinya dengan Kematian Kumulatif"},"excerpt":{"rendered":"<p>Serial data kedua ini merupakan kelanjutan dari serial data pertama yang memmbahas tentang rasio lacak-isolasi dan hubungannya dengan jumlah kematian</p>","protected":false},"author":2},{"id":1288,"date_gmt":"2020-07-04T14:00:18","modified_gmt":"2021-03-02T04:37:11","slug":"serial-data-virus-korona-1-3t-trace-test-treat","type":"post","title":{"rendered":"Serial Data Virus Korona 1: 3T (Trace, Test, Treat)"},"excerpt":{"rendered":"<p>Serial data pertama ini menyajikan bagaimana menurunkan penyebaran COVID-19  melalui 3T (Trace, Test, Treat)</p>","protected":false},"author":2},{"id":1284,"date_gmt":"2020-06-15T15:45:44","modified_gmt":"2021-03-02T04:53:16","slug":"mpasi-anak-dalam-kondisi-darurat","type":"post","title":{"rendered":"MPASI Anak dalam Kondisi Darurat"},"excerpt":{"rendered":"<p>Menjaga asupan gizi anak penting di tengah pandemi dan mudah dilakukan dengan memberikan Menu 4 Bintang.</p>","protected":false},"author":2},{"id":1268,"date_gmt":"2020-05-15T10:11:37","modified_gmt":"2021-03-16T17:30:39","slug":"ramadan-psbb-dan-mcdonalds","type":"post","title":{"rendered":"Ramadan, PSBB dan McDonalds"},"excerpt":{"rendered":"<p>Berikut beberapa contoh kejadian yang dapat meningkatkan penyebaran virus korona.</p>","protected":false},"author":2},{"id":1215,"date_gmt":"2020-05-03T12:38:09","modified_gmt":"2021-03-02T04:45:12","slug":"tips-pengolahan-makanan-dengan-penanak-nasi","type":"post","title":{"rendered":"Tips Pengolahan Makanan dengan Penanak Nasi"},"excerpt":{"rendered":"<p>Tips ini berisi cara memasak setiap kelompok bahan makanan menggunakan penanak nasi (rice cooker) untuk mempertahankan nilai gizi dengan menghindari pemanasan terlalu tinggi dalam waktu lama.</p>","protected":false},"author":2},{"id":1183,"date_gmt":"2020-04-27T07:52:40","modified_gmt":"2021-03-02T04:45:22","slug":"rapid-test-atau-swab-test-apa-bedanya-mana-yang-lebih-baik","type":"post","title":{"rendered":"Rapid test atau swab test: Apa bedanya? Mana yang lebih baik?"},"excerpt":{"rendered":"<p>Perbandingan metode rapid test dan swab test dalam pendeteksian COVID-19.</p>","protected":false},"author":2},{"id":1177,"date_gmt":"2020-04-27T07:33:49","modified_gmt":"2021-03-02T04:53:36","slug":"imunisasi-rutin-selama-pandemi-covid-19","type":"post","title":{"rendered":"Imunisasi Rutin Selama Pandemi COVID-19"},"excerpt":{"rendered":"<p>Panduan untuk imunisasi rutin selama adanya pandemi COVID-19.</p>","protected":false},"author":2},{"id":1090,"date_gmt":"2020-04-17T12:36:06","modified_gmt":"2021-03-02T04:46:02","slug":"hoax-dan-misinformasi-seputar-covid-19-apa-yang-bisa-kita-lakukan","type":"post","title":{"rendered":"Hoax dan Misinformasi Seputar COVID-19; Apa yang Bisa Kita Lakukan?"},"excerpt":{"rendered":"<p>Perkembangan Terkini Seputar Hoax COVID-19</p>","protected":false},"author":2},{"id":1079,"date_gmt":"2020-04-15T05:47:19","modified_gmt":"2021-03-02T04:53:52","slug":"himbauan-untuk-vaksinasi","type":"post","title":{"rendered":"Himbauan untuk Vaksinasi"},"excerpt":{"rendered":"<p>Dokumen terkait himbauan untuk pelaksanaan vaksinasi anak selama pandemi COVID-19.</p>","protected":false},"author":2},{"id":1021,"date_gmt":"2020-04-11T12:43:35","modified_gmt":"2021-03-02T04:47:08","slug":"apakah-penyemprotan-disinfektan-efektif-membunuh-sars-cov-2","type":"post","title":{"rendered":"Apakah Penyemprotan Disinfektan Efektif Membunuh SARS-COV-2?"},"excerpt":{"rendered":"<p>Beberapa hal yang harus diketahui tentang penyemprotan cairan disinfektan.</p>","protected":false},"author":2},{"id":1006,"date_gmt":"2020-04-10T08:11:49","modified_gmt":"2021-03-02T04:47:32","slug":"cerita-dari-jerman-pengalaman-dua-wni-di-bochum-dan-frankfurt","type":"post","title":{"rendered":"Cerita dari Jerman: Pengalaman Dua WNI di Bochum dan Frankfurt"},"excerpt":{"rendered":"<p>Seorang pelajar dan seorang pekerja asal Indonesia yang tinggal di Jerman membagikan kisah penanganan pandemi oleh pemerintah Jerman</p>","protected":false},"author":2},{"id":992,"date_gmt":"2020-04-10T08:07:59","modified_gmt":"2021-03-02T04:47:39","slug":"cerita-dari-taiwan-respons-tepat-taiwan-dalam-menghadapi-sars-cov-2-dan-covid-19","type":"post","title":{"rendered":"Cerita dari Taiwan: Respons Tepat Taiwan dalam Menghadapi SARS COV-2 dan COVID-19"},"excerpt":{"rendered":"<p>Taiwan disebut-sebut sebagai negara yang mengantisipasi penyebaran COVID-19 dengan baik sebelum wabah memburuk. Artikel ini merangkum hal-hal baik yang dilakukan oleh Taiwan dan yang dapat dijadikan contoh.</p>","protected":false},"author":2},{"id":972,"date_gmt":"2020-04-07T11:23:11","modified_gmt":"2021-03-02T04:47:48","slug":"cerita-dari-swedia-dont-try-this-at-home-jangan-terapkan-di-indonesia","type":"post","title":{"rendered":"Cerita dari Swedia: Don\u2019t try this at home! (Jangan Terapkan di Indonesia!)"},"excerpt":{"rendered":"<p>Swedia dan Indonesia memiliki kondisi sosial dan budaya yang berbeda. Maka, kebijakan pemerintah Swedia tidak semerta-merta dapat diterapkan di Indonesia karena perbedaan konteks memerlukan penanganan yang berbeda pula.</p>","protected":false},"author":2},{"id":950,"date_gmt":"2020-04-05T07:22:31","modified_gmt":"2021-03-02T04:47:59","slug":"edukasi-saya-pengidap-asma-apa-yang-harus-saya-persiapkan","type":"post","title":{"rendered":"[EDUKASI] Saya pengidap asma. Apa yang harus saya persiapkan?"},"excerpt":{"rendered":"<p>Yuk simak beberapa saran yang harus Anda lakukan jika mengidap kondisi medis kronis.</p>","protected":false},"author":2},{"id":880,"date_gmt":"2020-04-03T05:37:16","modified_gmt":"2021-03-02T04:48:08","slug":"komunikasi-risiko-covid-19-untuk-fasilitas-pelayanan-kesehatan","type":"post","title":{"rendered":"Komunikasi Risiko COVID-19 untuk Fasilitas Pelayanan Kesehatan"},"excerpt":{"rendered":"<p>Materi ini memberikan gambaran langkah-langkah utama menjaga keselamatan dan kesehatan di tempat kerja untuk manajemen fasilitas pelayanan kesehatan dan tenaga kesehatan.</p>","protected":false},"author":2},{"id":843,"date_gmt":"2020-03-31T04:43:23","modified_gmt":"2021-03-02T04:48:26","slug":"dunia-dalam-berita-covid-19","type":"post","title":{"rendered":"Dunia dalam Berita COVID-19"},"excerpt":{"rendered":"<p>Rangkuman berita terkini seputar Covid-19, termasuk Fatwa MUI terkait pengurusan jenazah.</p>","protected":false},"author":2},{"id":800,"date_gmt":"2020-03-28T05:43:05","modified_gmt":"2021-03-02T04:48:44","slug":"informasi-terkini-28-maret-2020","type":"post","title":{"rendered":"Informasi terkini &#8211; 28 Maret 2020"},"excerpt":{"rendered":"<p>Monitor pemberitaan media per-harinya terkait covid-19</p>","protected":false},"author":2},{"id":724,"date_gmt":"2020-03-21T18:24:53","modified_gmt":"2021-03-02T04:48:54","slug":"tips-hidup-sehat-agar-tubuh-lebih-tahan-terhadap-penyakit","type":"post","title":{"rendered":"Tips Hidup Sehat Agar Tubuh Lebih Tahan terhadap Penyakit"},"excerpt":{"rendered":"<p>Kekebalan tubuh memegang peran penting dalam menjaga tubuh dari penyakit.</p>","protected":false},"author":2},{"id":639,"date_gmt":"2020-03-20T13:18:03","modified_gmt":"2021-03-02T04:49:15","slug":"polemik-penggunaan-ibuprofen","type":"post","title":{"rendered":"Polemik penggunaan Ibuprofen"},"excerpt":{"rendered":"<p>Apakah ibuprofen memperburuk infeksi COVID-19? &#8211; Bagaimana dengan obat penawar rasa sakit yang lainnya?</p>","protected":false},"author":2},{"id":721,"date_gmt":"2020-03-18T18:15:00","modified_gmt":"2021-03-02T04:49:24","slug":"penanganan-jenazah-yang-terduga-odp-kemungkinan-pdp-dan-terkonfirmasi-positif-terinfeksi-covid-19","type":"post","title":{"rendered":"Penanganan Jenazah yang Terduga (ODP) / Kemungkinan (PDP) dan Terkonfirmasi (Positif) Terinfeksi COVID-19"},"excerpt":{"rendered":"<p>Meskipun belum ada korban COVID-19, pemerintah Singapura sudah mempersiapkan panduan penanganan jenazah untuk pemakaman dan kremasi</p>","protected":false},"author":2},{"id":546,"date_gmt":"2020-03-17T05:37:28","modified_gmt":"2021-03-02T04:49:32","slug":"coronavirus-covid-19-bagaimana-mempersiapkan-keluarga-anda","type":"post","title":{"rendered":"Coronavirus (COVID-19): Bagaimana Mempersiapkan Keluarga Anda?"},"excerpt":{"rendered":"<p>Beberapa hal yang dapat dipersiapkan untuk keluarga Anda dalam menghadapi COVID-19.</p>","protected":false},"author":2},{"id":510,"date_gmt":"2020-03-16T10:01:50","modified_gmt":"2021-03-02T04:49:40","slug":"dos-and-donts-dalam-social-distancing","type":"post","title":{"rendered":"Do&#8217;s and Don&#8217;ts dalam Social Distancing"},"excerpt":{"rendered":"<p>Kuncinya hanya satu: Apakah kondisi tubuh kita sehat dan apakah kita punya gejala sakit? </p>","protected":false},"author":2},{"id":463,"date_gmt":"2020-03-16T07:17:28","modified_gmt":"2021-03-02T04:49:50","slug":"protokol-isolasi-mandiri-home-quarantine","type":"post","title":{"rendered":"Protokol Isolasi Mandiri (Home Quarantine)"},"excerpt":{"rendered":"<p>Langkah-langkah yang dapat dilakukan ketika isolasi mandiri untuk mencegah penularan</p>","protected":false},"author":2},{"id":466,"date_gmt":"2020-03-16T06:55:29","modified_gmt":"2021-03-02T04:49:58","slug":"tips-menghadapi-karantina-di-rumah","type":"post","title":{"rendered":"Tips Menghadapi Karantina di Rumah"},"excerpt":{"rendered":"<p>Karantina membantu memperlambat penyebaran infeksi. Siapkan sebuah Perencanaan Karantina Rumah</p>","protected":false},"author":2},{"id":464,"date_gmt":"2020-03-16T06:48:58","modified_gmt":"2021-03-02T04:50:06","slug":"apa-beda-orang-dalam-pemantauan-odp-dengan-pasien-dalam-pengawasan-pdp","type":"post","title":{"rendered":"Apa Beda Orang Dalam Pemantauan (ODP) dengan Pasien Dalam Pengawasan (PDP)?"},"excerpt":{"rendered":"<p>Baca artikel ini supaya lebih tahu tentang Orang Dalam Pemantauan dan Pasien Dalam Pengawasan!</p>","protected":false},"author":2},{"id":450,"date_gmt":"2020-03-16T00:27:00","modified_gmt":"2021-03-02T04:50:13","slug":"hampir-700-wni-hadiri-acara-di-pusat-penyebaran-covid-19-apa-respon-pemerintah","type":"post","title":{"rendered":"Hampir 700 WNI hadiri acara di pusat penyebaran COVID-19: Apa respon pemerintah?"},"excerpt":{"rendered":"<p>Dampak adanya acara besar terhadap penyebaran COVID-19 </p>","protected":false},"author":2},{"id":431,"date_gmt":"2020-03-14T12:11:00","modified_gmt":"2021-03-02T04:50:22","slug":"pencegahan-covid-19-di-lingkungan-institusi-pendidikan","type":"post","title":{"rendered":"Pencegahan COVID-19 di Lingkungan Institusi Pendidikan \uFEFF"},"excerpt":{"rendered":"<p>Beberapa hal yang dapat dilakukan untuk mencegah penularan COVID-19 di lingkungan pendidikan.</p>","protected":false},"author":2},{"id":416,"date_gmt":"2020-03-14T10:53:45","modified_gmt":"2021-03-02T04:50:29","slug":"do-dont-and-minimize-untuk-acara-besar","type":"post","title":{"rendered":"Do, Don&#8217;t and Minimize untuk Acara Besar"},"excerpt":{"rendered":"<p>Panduan untuk Mengurangi Risiko dalam Acara Besar</p>","protected":false},"author":2},{"id":360,"date_gmt":"2020-03-13T03:52:52","modified_gmt":"2021-03-02T04:50:36","slug":"covid-19-mengapa-kita-harus-bertindak-sekarang","type":"post","title":{"rendered":"Covid-19: Mengapa Kita Harus Bertindak Sekarang!"},"excerpt":{"rendered":"<p>Dengan semua kejadian terkait Covid-19, saat ini, tentunya anda akan menghadapi kesulitan untuk mengambil keputusan hari ini. Apakah perlu menunggu informasi lebih lanjut atau melakukan sesuatu hari ini?</p>","protected":false},"author":2},{"id":346,"date_gmt":"2020-03-12T15:33:23","modified_gmt":"2021-03-02T04:50:43","slug":"coronavirus-apa-yang-bisa-dilakukan-anak-anak","type":"post","title":{"rendered":"Coronavirus: Apa yang Bisa Dilakukan Anak-Anak?"},"excerpt":{"rendered":"<p>Yuk, simak hal apa saja yang dapat dilakukan anak-anak terkait coronavirus!</p>","protected":false},"author":2},{"id":337,"date_gmt":"2020-03-12T09:37:29","modified_gmt":"2021-03-02T04:50:51","slug":"cara-gampang-membunuh-virus","type":"post","title":{"rendered":"Cara Gampang Membunuh Virus"},"excerpt":{"rendered":"<p>Alasan pentingnya rajin mencuci tangan dengan sabun.</p>","protected":false},"author":2},{"id":334,"date_gmt":"2020-03-12T03:46:37","modified_gmt":"2021-03-02T04:50:58","slug":"mengapa-kita-tidak-bisa-meremehkan-covid-19","type":"post","title":{"rendered":"Mengapa Kita Tidak Bisa Meremehkan COVID-19?"},"excerpt":{"rendered":"<p>Beberapa hal yang membuat kita harus penuh kewaspadaan dalam menghadapi COVID-19</p>","protected":false},"author":2},{"id":282,"date_gmt":"2020-03-07T17:30:00","modified_gmt":"2021-07-21T12:59:17","slug":"kawalcovid19-id-untuk-mengurai-derasnya-informasi-seputar-covid-19","type":"post","title":{"rendered":"KawalCOVID19 untuk mengurai derasnya informasi seputar COVID-19"},"excerpt":{"rendered":"<p>Website kawalcovid19.id beserta akun-akun media sosialnya akan dimutakhirkan berkala dengan esensi Informasi, Verifikasi, dan Edukasi.</p>","protected":false},"author":2},{"id":2,"date_gmt":"2020-03-05T03:10:00","modified_gmt":"2021-03-02T04:51:15","slug":"faq","type":"post","title":{"rendered":"Tanya Jawab Seputar COVID-19"},"excerpt":{"rendered":"<p>Yang perlu Anda ketahui seputar COVID-19.</p>","protected":false},"author":2},{"id":1485,"date_gmt":"2020-10-01T14:19:43","modified_gmt":"2020-10-01T14:20:17","slug":"bahan-bahan-memperkenalkan-covid-19-ke-anak-usia-dini","type":"post","title":{"rendered":"Bahan-bahan Memperkenalkan Covid-19 ke Anak Usia Dini"},"excerpt":{"rendered":"<p>Memperkenalkan COVID-19 ke anak-anak usia dini (3-6 tahun) sangat penting. Di bawah ini adalah beberapa resources berupa link, video, infografika, printables yang bisa diprint untuk semua. 3M&nbsp; Apa itu Covid :&nbsp; eBook :&nbsp; Cerita si Korona karangan Watiek Ideo https://online.fliphtml5.com/nwyyb/grdh/#p=1&nbsp; Gara-gara si Korona karangan Watiek Ideo https://online.fliphtml5.com/nwyyb/csin/#p=1&nbsp; Perjalanan si Korona karangan Watiek Ideo https://online.fliphtml5.com/nwyyb/lnjo/#p=10&nbsp; Video [&hellip;]</p>\\n","protected":false},"author":2},{"id":817,"date_gmt":"2020-03-29T03:25:00","modified_gmt":"2021-07-03T09:03:48","slug":"daftar-layanan-konseling-online-se-indonesia","type":"post","title":{"rendered":"Daftar Layanan Konseling Online Se-Indonesia"},"excerpt":{"rendered":"<p>Kami mengumpulkan berbagai poster informasi tentang layanan konseling online yang tersebar di berbagai wilayah.</p>\\n","protected":false},"author":2},{"id":644,"date_gmt":"2020-03-21T03:51:30","modified_gmt":"2020-04-06T10:04:12","slug":"daftar-gereja-dengan-ibadah-online","type":"post","title":{"rendered":"Daftar Gereja dengan Ibadah Online"},"excerpt":{"rendered":"<p>Kami mengajak semua umat Nasrani ikut berpartisipasi dalam mencegah penyebaran COVID-19 dengan melakukan #JagaJarakDulu dan #DiamDiRumah.</p>\\n","protected":false},"author":2},{"id":492,"date_gmt":"2020-03-18T13:25:00","modified_gmt":"2020-04-03T14:05:04","slug":"jadwal-harian-covid-19-usia-sd","type":"post","title":{"rendered":"Jadwal Harian COVID-19 Usia SD"},"excerpt":{"rendered":"<p>Kegiatan harian yang dapat dilakukan anak untuk usia SD.</p>\\n","protected":false},"author":2},{"id":2137,"date_gmt":"2021-07-24T03:51:55","modified_gmt":"2021-07-24T03:59:47","slug":"revisi-panduan-tata-laksana-covid-19-di-indonesia","type":"post","title":{"rendered":"Revisi Panduan Tata Laksana COVID-19 di Indonesia"},"excerpt":{"rendered":"<p>Pada tanggal 14 Juli 2021, organisasi profesi dokter di Indonesia, yaitu Perhimpunan Dokter Paru Indonesia (PDPI), Perhimpunan Dokter Spesialis Kardiovaskular Indonesia (PERKI), Perhimpunan Dokter Spesialis Penyakit Dalam Indonesia (PAPDI), Perhimpunan Dokter Spesialis Anestesiologi dan Terapi Intensif (PERDATIN), dan Ikatan Dokter Anak Indonesia (IDAI) merevisi rekomendasi panduan tata laksana COVID-19 di Indonesia. Revisi ini ditujukan untuk [&hellip;]</p>\\n","protected":false},"author":2},{"id":1931,"date_gmt":"2021-05-31T02:44:59","modified_gmt":"2021-07-03T09:34:24","slug":"cara-isolasi-mandiri-yang-benar","type":"post","title":{"rendered":"Cara Isolasi Mandiri yang Benar"},"excerpt":{"rendered":"<p>Tim KawalCOVID-19 berbincang dengan dr. Sayuri Suwandi, SpPD dan dr. Dirga Sakti Rambe, SpPD, untuk menjawab pertanyaan seputar cara isolasi mandiri (isoman) yang benar. Berikut ringkasan dari dua sesi Instagram Live yang bisa dilihat di sini.</p>\\n","protected":false},"author":2},{"id":1879,"date_gmt":"2021-04-15T02:48:10","modified_gmt":"2021-06-25T09:40:22","slug":"satgas-kesehatan-di-sekolah-untuk-apa","type":"post","title":{"rendered":"Satgas Kesehatan di Sekolah, Untuk Apa?"},"excerpt":{"rendered":"<p>Per 24 Februari 2021, sudah ada wacana membuka kembali sekolah setelah vaksinasi guru rampung di bulan Juni. Di medio 2021, belum tentu pandemi sudah terkendali, apalagi berakhir. Karenanya, selain harus bersiap untuk mencegah penularan, sekolah juga harus bersiap diri untuk menangani adanya penularan di sekolah, sehingga tidak bingung dan menangani dengan serabutan ketika ada kasus. [&hellip;]</p>\\n","protected":false},"author":2},{"id":1818,"date_gmt":"2021-04-01T03:05:23","modified_gmt":"2021-07-03T09:03:10","slug":"interaksi-guru-murid-yang-minim-risiko","type":"post","title":{"rendered":"Interaksi Guru-Murid Yang Minim Risiko"},"excerpt":{"rendered":"<p>Per 24 Februari 2021, sudah ada wacana bahwa pemerintah akan membuka sekolah setelah vaksinasi guru rampung di bulan Juni. Di medio 2021, belum tentu pandemi terkendali, apalagi berakhir. Karenanya, penting bagi pendidik untuk melengkapi diri dengan cara aman melakukan berinteraksi dengan anak didik.&nbsp; COVID-19 menyebar lewat droplet seperti air liur dan ingus, dua hal yang [&hellip;]</p>\\n","protected":false},"author":2},{"id":1645,"date_gmt":"2021-02-20T05:39:49","modified_gmt":"2021-07-03T09:03:19","slug":"seri-covid-19-artikel-2-sebelum-buka-sekolah-apa-yang-harus-dikomunikasikan","type":"post","title":{"rendered":"Sebelum Buka Sekolah, Apa yang Harus Dikomunikasikan?"},"excerpt":{"rendered":"<p>Kebanyakan sekolah mengerti bahwa ada protokol kesehatan yang harus disiapkan sebelum membuka sekolah di masa pandemi. Tapi dari berbagai input yang disampaikan oleh guru, murid, orang tua maupun administrator sekolah, tidak ada pedoman bagaimana mengkomunikasikan pembukaan sekolah dan perilaku seperti apa yang sekolah minta dari para guru, siswa dan orang tua murid.</p>\\n","protected":false},"author":2},{"id":1642,"date_gmt":"2021-02-20T05:35:56","modified_gmt":"2021-04-07T10:24:29","slug":"infrastruktur-apa-yang-perlu-disiapkan-sekolah-new-normal","type":"post","title":{"rendered":"Infrastruktur Apa yang Perlu Disiapkan Sekolah New Normal?"},"excerpt":{"rendered":"<p>Di satu titik, sekolah akan tatap muka lagi. Berapa lama lagi, kita belum tahu. Tapi sekolah perlu menyiapkan infrastruktur new normal mulai sekarang agar ketika nanti sekolah dibuka, semua pihak sudah mengerti apa yang harus dilakukan.</p>\\n","protected":false},"author":2},{"id":1612,"date_gmt":"2021-01-14T02:21:49","modified_gmt":"2021-03-02T04:52:49","slug":"pertimbangan-untuk-langkah-langkah-kesehatan-masyarakat-terkait-sekolah-dalam-konteks-covid-19","type":"post","title":{"rendered":"Pertimbangan untuk Langkah-Langkah Kesehatan Masyarakat Terkait Sekolah dalam Konteks COVID-19"},"excerpt":{"rendered":"","protected":false},"author":2},{"id":1550,"date_gmt":"2020-12-07T14:27:32","modified_gmt":"2021-03-02T04:52:56","slug":"panduan-perawatan-di-rumah-untuk-suspek-dan-positif-covid-19-dengan-gejala-ringan-atau-tanpa-gejala","type":"post","title":{"rendered":"Panduan Perawatan di Rumah untuk Suspek dan Positif- COVID-19 dengan Gejala Ringan atau Tanpa Gejala"},"excerpt":{"rendered":"<p>Proses hasil PCR yang lambat, makin banyaknya kasus positif sehingga RS hanya mampu melayani pasien dengan gejala sedang/berat, sehingga isolasi mandiri adalah pilihan buat pasien positif dengan gejala ringan atau untuk suspek COVID-19. Panduan ini diharapkan dapat membantu perawatan mandiri.</p>\\n","protected":false},"author":2},{"id":1522,"date_gmt":"2020-11-01T02:49:47","modified_gmt":"2021-03-02T04:53:06","slug":"isolasi-mandiri-untuk-ibu-menyusui","type":"post","title":{"rendered":"Isolasi Mandiri untuk Ibu Menyusui"},"excerpt":{"rendered":"<p>Rangkuman panduan yang harus dilakukan jika ibu menyusui terpapar COVID-19.</p>\\n","protected":false},"author":2},{"id":1284,"date_gmt":"2020-06-15T15:45:44","modified_gmt":"2021-03-02T04:53:16","slug":"mpasi-anak-dalam-kondisi-darurat","type":"post","title":{"rendered":"MPASI Anak dalam Kondisi Darurat"},"excerpt":{"rendered":"<p>Menjaga asupan gizi anak penting di tengah pandemi dan mudah dilakukan dengan memberikan Menu 4 Bintang.</p>\\n","protected":false},"author":2},{"id":1211,"date_gmt":"2020-04-30T08:49:24","modified_gmt":"2021-03-02T04:53:24","slug":"menyikapi-kedukaan-dan-kehilangan-saat-pandemi","type":"post","title":{"rendered":"Menyikapi Kedukaan dan Kehilangan Saat Pandemi"},"excerpt":{"rendered":"<p>Kehilangan orang tercinta bukan hal yang mudah dihadapi, apalagi di tengah pandemi. Dalam situasi sulit ini, bila memungkinkan, gunakan Internet dan solusi virtual lainnya untuk menjaga silaturahmi dengan keluarga dan teman untuk berbagi rasa kehilangan, serta untuk melaksanakan keinginan terakhir almarhum/almarhumah.</p>\\n","protected":false},"author":2},{"id":1177,"date_gmt":"2020-04-27T07:33:49","modified_gmt":"2021-03-02T04:53:36","slug":"imunisasi-rutin-selama-pandemi-covid-19","type":"post","title":{"rendered":"Imunisasi Rutin Selama Pandemi COVID-19"},"excerpt":{"rendered":"<p>Panduan untuk imunisasi rutin selama adanya pandemi COVID-19.</p>\\n","protected":false},"author":2},{"id":1171,"date_gmt":"2020-04-26T13:53:08","modified_gmt":"2021-03-02T04:53:43","slug":"panduan-menerima-dan-memberikan-bantuan-sosial-%ef%bb%bf","type":"post","title":{"rendered":"Panduan Menerima dan Memberikan Bantuan Sosial \uFEFF"},"excerpt":{"rendered":"<p>Saat ini, pembagian bantuan sosial, baik berupa paket sembako, uang, maupun keduanya, sudah banyak berlangsung. Hal ini adalah inisiatif yang baik untuk membantu masyarakat yang membutuhkan di tengah wabah COVID-19. Namun, ada beberapa hal yang perlu dipersiapkan oleh pemberi dan penerima bantuan.</p>\\n","protected":false},"author":2},{"id":1079,"date_gmt":"2020-04-15T05:47:19","modified_gmt":"2021-03-02T04:53:52","slug":"himbauan-untuk-vaksinasi","type":"post","title":{"rendered":"Himbauan untuk Vaksinasi"},"excerpt":{"rendered":"<p>Dokumen terkait himbauan untuk pelaksanaan vaksinasi anak selama pandemi COVID-19.</p>\\n","protected":false},"author":2},{"id":1063,"date_gmt":"2020-04-14T13:15:05","modified_gmt":"2021-03-02T04:54:09","slug":"tips-siaga-bagi-pasangan-yang-menunggu-kelahiran","type":"post","title":{"rendered":"Tips Siaga Bagi Pasangan yang Menunggu Kelahiran"},"excerpt":{"rendered":"<p>Lebih dari 200 juta wanita hamil di seluruh dunia berpotensi terinfeksi coronavirus. Beberapa penelitian mulai menguak bahaya virus SARS-CoV-2 ini pada wanita hamil dan bayinya, namun hasilnya&#8230;</p>\\n","protected":false},"author":2},{"id":969,"date_gmt":"2020-04-07T10:47:14","modified_gmt":"2021-03-02T04:54:17","slug":"seputar-penghantaran-dan-atau-penerimaan-gofood-gosend","type":"post","title":{"rendered":"Panduan Higienis Pengiriman dan/atau Penerimaan Barang/Makanan saat Pandemi"},"excerpt":{"rendered":"<p>Panduan apa yang sebaiknya dilakukan saat menerima atau mengirim barang melalui ojek online.</p>\\n","protected":false},"author":2},{"id":962,"date_gmt":"2020-04-07T04:31:11","modified_gmt":"2021-03-02T04:54:24","slug":"rt-dan-desa-mandiri-lawan-korona","type":"post","title":{"rendered":"RT dan Desa Mandiri Lawan Korona"},"excerpt":{"rendered":"<p>Simak tulisan berikut ini untuk mengetahui panduan bagi RT dan desa dalam melawan koronavirus.</p>\\n","protected":false},"author":2},{"id":960,"date_gmt":"2020-04-06T14:30:12","modified_gmt":"2021-03-02T04:54:32","slug":"prosedur-mendirikan-pusat-karantina-di-luar-fasilitas-kesehatan","type":"post","title":{"rendered":"Prosedur Mendirikan Pusat Karantina Di Luar Fasilitas Kesehatan"},"excerpt":{"rendered":"<p>Saat jumlah kasus positif COVID-19 meningkat sangat drastis melebihi kemampuan rumah sakit untuk merawat penderita, maka pemerintah setempat&#8230;.</p>\\n","protected":false},"author":2},{"id":850,"date_gmt":"2020-03-31T09:59:48","modified_gmt":"2021-03-02T04:54:40","slug":"panduan-membuat-masker-kain-sendiri","type":"post","title":{"rendered":"Panduan Membuat Masker Kain Sendiri"},"excerpt":{"rendered":"<p>Saat ini, masker sulit ditemukan. Kalau pun tersedia, masker bedah lebih dibutuhkan oleh tenaga medis daripada masyarakat umum. Tapi jangan khawatir, untuk melindungi diri sendiri dan orang di sekitar, kita bisa, kok, membuat masker sendiri untuk kita dan keluarga. Simak tulisan berikut ini. </p>\\n","protected":false},"author":2},{"id":846,"date_gmt":"2020-03-31T05:20:53","modified_gmt":"2021-03-02T04:54:49","slug":"panduan-menjaga-diri-dan-orang-lain-bila-terlanjur-mudik","type":"post","title":{"rendered":"Panduan Menjaga Diri dan Orang Lain Bila Terlanjur Mudik"},"excerpt":{"rendered":"<p>Bepergian ke luar kota, apalagi ke luar negeri, sangat tidak dianjurkan di tengah wabah. Namun, jika terlanjur mudik, ada hal-hal yang perlu dilakukan untuk menjaga diri dan orang di sekitar kita.</p>\\n","protected":false},"author":2},{"id":715,"date_gmt":"2020-03-21T18:12:47","modified_gmt":"2021-03-02T04:54:57","slug":"panduan-penanganan-jenazah-terduga-kemungkinan-terkonfirmasi-covid-19","type":"post","title":{"rendered":"Panduan Penanganan Jenazah Terduga / Kemungkinan / Terkonfirmasi COVID-19"},"excerpt":{"rendered":"<p>Ikuti panduan ini untuk penanganan jenazah Terduga atau Positif COVID-19</p>\\n","protected":false},"author":2},{"id":563,"date_gmt":"2020-03-17T09:27:09","modified_gmt":"2021-03-02T04:55:06","slug":"panduan-naik-ojek-motor-mobil-untuk-pengemudi-dan-penumpang","type":"post","title":{"rendered":"Panduan Naik Ojek Motor/Mobil untuk Pengemudi dan Penumpang"},"excerpt":{"rendered":"<p>Ikuti panduan ini yuk untuk berkendara aman dengan Ojek Motor/Mobil di masa pandemi COVID-19 ini.</p>\\n","protected":false},"author":2}]}}');





async function $388b617130f03bd4$var$main() {
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("html, body").animate({
        scrollTop: 0
    }, 1000);
    (0, $cc1723ee964ba41d$export$cb45b08d97cdc4fd).bind("[data-fancybox]", {});
    // if (location.pathname == "/vaksin.html") {
    //   $("#popup, #popup-mobile").hide();
    // }
    // Fetching and displaying latest articles
    const latestArticles = (0, (/*@__PURE__*/$parcel$interopDefault($c31cf161124fb2c8$exports)))?.pageProps?.posts ?? [];
    [
        ...latestArticles.filter((article)=>article.excerpt.rendered.length > 150)
    ].slice(0, 5).forEach(function(article) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".news-carousel").append(`<div class="carousel-cell p-4 w-full md:w-1/2"><div class="hover:shadow transition rounded-lg overflow-hidden h-full"><img src=${(0, {})} class="w-full" alt="${article.slug}" /><a href="#" class="flex flex-1 flex-col p-4 gap-4 h-full"><span class="text-lg font-medium hover:text-primary hover:underline">${(0, $a6df9c40ba402dc9$export$cf2683946e25dd6c)(article.title.rendered, 27)}</span><div class="flex">${(0, $a6df9c40ba402dc9$export$cf2683946e25dd6c)(article.excerpt.rendered, 150)}</div></a></div></div>`);
    });
    // Fetching and displaying suggested news
    const suggestedNews = (0, (/*@__PURE__*/$parcel$interopDefault($a96fc9b2ca5532ff$exports))).pageProps.posts ?? [];
    [
        ...(0, $a6df9c40ba402dc9$export$bd9529c9fe839a6e)(suggestedNews, "date_gmt", "desc")
    ].slice(0, 5).forEach(function(news) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".news-suggest").append(`<li class="text-primary opacity-75 hover:opacity-100 transition-colors py-4 px-6 border-t"><a href="#" class="flex justify-between items-center gap-4 news-link capitalize">${news.title.rendered}<i class="fa-solid fa-arrow-right"></i></a></li>`);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".hamburger").click(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".hamburger").toggleClass("is-active"), setTimeout(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").toggleClass("sidebar-open"), 25), setTimeout(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").removeClass("search-open"), 25);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".btn-search").click(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".hamburger").removeClass("is-active"), (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("input#search").focus().select(), setTimeout(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").addClass("search-open"), 25), setTimeout(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").removeClass("sidebar-open"), 25);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".close-search").click(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".hamburger").removeClass("is-active"), setTimeout(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").toggleClass("search-open"), 25), setTimeout(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").removeClass("sidebar-open"), 25);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(document).click(function(t) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(t.target).closest(".hamburger").length || (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(t.target).closest("nav").length || (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(t.target).closest(".sidebar").length || ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").removeClass("sidebar-open"), (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".hamburger").removeClass("is-active")), (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(t.target).closest(".btn-search").length || (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(t.target).closest(".search-box").length || (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body, html").removeClass("search-open");
    });
    // Initializing mouse movement tracking for symptoms grid
    const mouseState = {
        x: 0,
        y: 0,
        dir: "left"
    };
    mouseState.dir = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).width() > 768 ? "left" : "down";
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".symptoms-grid").mousemove(function(event) {
        mouseState.dir = (0, $a6df9c40ba402dc9$export$ec7c9cb9653b3275)(event, mouseState.x, mouseState.y, mouseState.dir);
        mouseState.x = event.pageX;
        mouseState.y = event.pageY;
    });
    // Handling card hover effects
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".card").hover(function(event) {
        mouseState.dir = (0, $a6df9c40ba402dc9$export$ec7c9cb9653b3275)(event, mouseState.x, mouseState.y, mouseState.dir);
        mouseState.x = event.pageX;
        mouseState.y = event.pageY;
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("class", "card");
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).addClass(`card-slide-${mouseState.dir}`).addClass("card");
    }, function(event) {
        mouseState.dir = (0, $a6df9c40ba402dc9$export$ec7c9cb9653b3275)(event, mouseState.x, mouseState.y, mouseState.dir);
        mouseState.x = event.pageX;
        mouseState.y = event.pageY;
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("class", "card");
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).addClass(`card-slide-${mouseState.dir}`).addClass("card");
    });
    // Handling navigation links and sidebar behavior
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".side-link").each(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).css("transition-delay", 0.1 * (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).index() + 0.2 + "s");
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("href") == location.pathname && (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).addClass("active");
        "/" == location.pathname && (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[href="/index.html"]').addClass("active");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".nav-link").each(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("href") == location.pathname && (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).addClass("active");
        "/" == location.pathname && (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[href="/index.html"]').addClass("active");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".scroll-top").fadeOut(0);
    // Handling scroll behavior
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).scroll(function() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#popup").is(":hidden")) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".navbar").css("filter", "none");
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).scrollTop() >= (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".navbar").offset().top) {
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".navbar").addClass("animate");
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".bg-line").addClass("md:pt-20");
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".navbar").removeClass("animate");
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".bg-line").removeClass("md:pt-20");
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).scrollTop() >= (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").height() - (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("body").height() / 4) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".scroll-top").fadeIn(100);
        else (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".scroll-top").fadeOut(300);
    });
    // Initializing smooth scroll for scroll-to-top button
    new (0, (/*@__PURE__*/$parcel$interopDefault($e0442f89a2161822$exports)))().animateScroll((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#top"), (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".scroll-top"), {
        speed: 3000,
        easing: "easeInOutCubic"
    });
    // Handling accordion behavior
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(window).width() > 768 && (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".accordion li").first().addClass("open");
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".accordion-header").click(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).next().slideToggle(50);
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).parent().toggleClass("open");
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".accordion-body").not((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).next()).slideUp(0).parent().removeClass("open");
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).find("i").toggleClass("fa-plus").toggleClass("fa-minus");
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).parent().siblings().find("i").removeClass("fa-minus").addClass("fa-plus");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".accordion li").each(function() {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).hasClass("open")) {
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).find(".accordion-body").slideDown(0);
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).find(".accordion-header i").addClass("fa-minus").removeClass("fa-plus");
        }
    });
    // Handling category and order change events
    let currentCategory = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('input[name="category"]').val() ?? "artikel";
    let currentOrder = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('input[name="order"]').val() ?? "desc";
    $388b617130f03bd4$var$fetchPosts(currentCategory, currentOrder);
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('input[name="category"]').change(function() {
        currentCategory = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).val();
        $388b617130f03bd4$var$fetchPosts((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).val(), currentOrder);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('input[name="order"]').change(function() {
        currentOrder = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).val();
        $388b617130f03bd4$var$fetchPosts(currentCategory, (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).val());
    });
    try {
        // Fetching and displaying COVID-19 statistics
        const covidData = await $388b617130f03bd4$export$23f83e165e686241("https://apicovid19indonesia-v2.vercel.app/");
        for(let key in covidData){
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".counter").each(function() {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("data-target") == key) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("data-count", covidData[key]);
            });
            $388b617130f03bd4$var$animateCount(`.counter[data-target="${key}"]`);
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".last-update").text(`* Last updated: ${(0, $a6df9c40ba402dc9$export$3ae94a2503e890a1)(covidData?.lastUpdate ?? Date.now())} Indonesia Time`);
    } catch (error) {
        console.error("error", error);
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".last-update").text("* Mohon maaf, terjadi kesalahan.Mohon coba lagi.");
    }
    try {
        // Fetching and displaying vaccination statistics
        const vaccinationData = await $388b617130f03bd4$export$23f83e165e686241("https://vaksincovid19-api.vercel.app/api/vaksin");
        for(let key in vaccinationData){
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".counter").each(function() {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("data-target") == key) (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("data-count", vaccinationData[key]);
            });
            $388b617130f03bd4$var$animateCount(`.counter[data-target="${key}"]`);
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".last-update-vaksin").text(`* Last updated: ${(0, $a6df9c40ba402dc9$export$3ae94a2503e890a1)(vaccinationData.lastUpdate)} Indonesia Time`);
    } catch (error) {
        console.error("error", error);
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".last-update-vaksin").text("* Mohon maaf, terjadi kesalahan.Mohon coba lagi.");
    }
    // Handling search form submission
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".search-form").submit(function(event) {
        event.preventDefault();
        const searchTerm = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).serializeArray()[0].value;
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#search").attr("value", searchTerm);
        if (searchTerm.length > 0) {
            const searchData = (0, (/*@__PURE__*/$parcel$interopDefault($e85b07ce865bb499$exports))).pageProps.posts;
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".search-form").next().empty();
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".search-form").next().append('<span class="inset-0 m-auto h-max w-max absolute">Not found</span>');
            searchData.forEach(function(result) {
                const { title: title, excerpt: excerpt } = result;
                let content = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports))).trim((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(excerpt.rendered).text()).toLowerCase();
                const index = content.indexOf(searchTerm);
                if (index >= 0) {
                    content = content.substring(0, index) + `<span class='highlight'>${content.substring(index, index + searchTerm.length)}</span>` + content.substring(index + searchTerm.length);
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".search-form").next().append(`<li class="opacity-75 transition-colors py-4 px-6 border-b"><a href="#" class="hover:text-primary flex justify-start capitalize items-center font-medium">${title.rendered}</a><p>${content}</p></li>`);
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".search-form").next().find("span.absolute").remove();
                }
            });
        } else {
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".search-form").next().empty();
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".search-form").next().append('<span class="inset-0 m-auto h-max w-max absolute">Not found</span>');
        }
    });
    try {
        // Displaying category counts
        const { posts: artikelCount } = (0, (/*@__PURE__*/$parcel$interopDefault($c31cf161124fb2c8$exports)))?.pageProps;
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-category="artikel"]').text(artikelCount.length);
        const { posts: bacaanCount } = (0, (/*@__PURE__*/$parcel$interopDefault($91a039895cb85b0e$exports)))?.pageProps;
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-category="bacaan"]').text(bacaanCount.length);
        const { posts: panduanCount } = (0, (/*@__PURE__*/$parcel$interopDefault($a96fc9b2ca5532ff$exports)))?.pageProps;
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-category="panduan"]').text(panduanCount.length);
        const { posts: checklistCount } = (0, (/*@__PURE__*/$parcel$interopDefault($b7255525513ab909$exports)))?.pageProps;
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))('[data-category="checklist"]').text(checklistCount.length);
    } catch (error) {
        console.error("error", error);
    }
    const flickityElement = document.querySelector(".news-carousel");
    if (flickityElement) new (0, (/*@__PURE__*/$parcel$interopDefault($6466308c71ced2f5$exports)))(flickityElement, {
        cellAlign: "left",
        fullscreen: true,
        prevNextButtons: false,
        autoPlay: true
    });
}
(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))($388b617130f03bd4$var$main);
function $388b617130f03bd4$var$fetchPosts(category = "artikel", order = "desc") {
    const source = {
        artikel: (/*@__PURE__*/$parcel$interopDefault($c31cf161124fb2c8$exports)),
        panduan: (/*@__PURE__*/$parcel$interopDefault($a96fc9b2ca5532ff$exports)),
        bacaan: (/*@__PURE__*/$parcel$interopDefault($91a039895cb85b0e$exports)),
        checklist: (/*@__PURE__*/$parcel$interopDefault($b7255525513ab909$exports))
    };
    const data = source?.[category];
    if (!data) return;
    const posts = data?.pageProps?.posts;
    const pageCategory = data?.pageProps?.category;
    if ("/informasi.html" == location.pathname) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("title").text(`PanduCovid - ${pageCategory.description}`);
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".inform-title").html(`<strong class="font-semibold">${pageCategory.name}</strong> <span class="hidden md:flex">-</span> ${pageCategory.description}`);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".inform-col").empty();
    [
        ...(0, $a6df9c40ba402dc9$export$bd9529c9fe839a6e)(posts, "date_gmt", order)
    ].forEach(function(post) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(".inform-col").append(`<div class="hover:shadow transition rounded-lg overflow-hidden h-full mb-6"><img src=${(0, {})} class="w-full" alt="${post.slug}" /><a href="#" class="bg-white flex flex-1 flex-col p-4 gap-4 h-full"><span class="text-sm opacity-75">${(0, $a6df9c40ba402dc9$export$3ae94a2503e890a1)(post.date_gmt)}</span><span class="text-lg font-medium hover:text-primary hover:underline -mt-3">${post.title.rendered}</span><div class="flex">${(0, $a6df9c40ba402dc9$export$cf2683946e25dd6c)(post.excerpt.rendered, 200)}</div></a></div>`);
    });
}
function $388b617130f03bd4$var$animateCount(element) {
    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(element).each(function() {
        const count = parseInt((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).attr("data-count"));
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).text();
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).animate({
            countNum: count
        }, {
            duration: 3000,
            easing: "linear",
            step: function() {
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).text(Math.floor(this.countNum));
                (0, $a6df9c40ba402dc9$export$feb80e120a50087f)(this);
            },
            complete: function() {
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(this).text(this.countNum);
                (0, $a6df9c40ba402dc9$export$feb80e120a50087f)(this);
            }
        });
    });
}
async function $388b617130f03bd4$export$23f83e165e686241(url, options = {}) {
    const response = await fetch(url, options);
    return await response.json();
}


//# sourceMappingURL=panducovid.01cb2484.js.map
